import { GraphQLClient } from 'graphql-request';
import { GraphQLClientRequestHeaders } from 'graphql-request/build/cjs/types';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

/** A shell command was issued over ADB via “adb shell command”. */
export type AdbShellCommandEventInputSchema = {
  /** Shell command that was issued over ADB via "adb shell command". Redacted to empty string on organization-owned managed profile devices. */
  shellCmd?: InputMaybe<Scalars['String']['input']>;
};

export type AdbShellCommandEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A shell command was issued over ADB via “adb shell command”. */
export type AdbShellCommandEventSchema = {
  __typename?: 'AdbShellCommandEventSchema';
  /** Shell command that was issued over ADB via "adb shell command". Redacted to empty string on organization-owned managed profile devices. */
  shellCmd?: Maybe<Scalars['String']['output']>;
};

/** An ADB interactive shell was opened via “adb shell”. Intentionally empty. */
export type AdbShellInteractiveEventInputSchema = {
  /** Placeholder field to prevent empty schema. */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type AdbShellInteractiveEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** An ADB interactive shell was opened via “adb shell”. Intentionally empty. */
export type AdbShellInteractiveEventSchema = {
  __typename?: 'AdbShellInteractiveEventSchema';
  /** Placeholder field to prevent empty schema. */
  _?: Maybe<Scalars['String']['output']>;
};

export enum AdvancedSecurityOverridesCommonCriteriaMode {
  /** Default. Disables Common Criteria Mode. */
  CommonCriteriaModeDisabled = 'COMMON_CRITERIA_MODE_DISABLED',
  /** Enables Common Criteria Mode. */
  CommonCriteriaModeEnabled = 'COMMON_CRITERIA_MODE_ENABLED',
  /** Unspecified. Defaults to COMMON_CRITERIA_MODE_DISABLED. */
  CommonCriteriaModeUnspecified = 'COMMON_CRITERIA_MODE_UNSPECIFIED'
}

export enum AdvancedSecurityOverridesDeveloperSettings {
  /** Allows all developer settings. The user can access and optionally configure the settings. */
  DeveloperSettingsAllowed = 'DEVELOPER_SETTINGS_ALLOWED',
  /** Default. Disables all developer settings and prevents the user from accessing them. */
  DeveloperSettingsDisabled = 'DEVELOPER_SETTINGS_DISABLED',
  /** Unspecified. Defaults to DEVELOPER_SETTINGS_DISABLED. */
  DeveloperSettingsUnspecified = 'DEVELOPER_SETTINGS_UNSPECIFIED'
}

export enum AdvancedSecurityOverridesGooglePlayProtectVerifyApps {
  /** Unspecified. Defaults to VERIFY_APPS_ENFORCED. */
  GooglePlayProtectVerifyAppsUnspecified = 'GOOGLE_PLAY_PROTECT_VERIFY_APPS_UNSPECIFIED',
  /** Default. Force-enables app verification. */
  VerifyAppsEnforced = 'VERIFY_APPS_ENFORCED',
  /** Allows the user to choose whether to enable app verification. */
  VerifyAppsUserChoice = 'VERIFY_APPS_USER_CHOICE'
}

/** Security policies set to secure values by default. To maintain the security posture of a device, we don't recommend overriding any of the default values. */
export type AdvancedSecurityOverridesInputSchema = {
  /** Controls Common Criteria Mode—security standards defined in the Common Criteria for Information Technology Security Evaluation (https://www.commoncriteriaportal.org/) (CC). Enabling Common Criteria Mode increases certain security components on a device, including AES-GCM encryption of Bluetooth Long Term Keys, and Wi-Fi configuration stores.Warning: Common Criteria Mode enforces a strict security model typically only required for IT products used in national security systems and other highly sensitive organizations. Standard device use may be affected. Only enabled if required. */
  commonCriteriaMode?: InputMaybe<AdvancedSecurityOverridesCommonCriteriaMode>;
  /** Controls access to developer settings: developer options and safe boot. Replaces safeBootDisabled (deprecated) and debuggingFeaturesAllowed (deprecated). */
  developerSettings?: InputMaybe<AdvancedSecurityOverridesDeveloperSettings>;
  /** Whether Google Play Protect verification (https://support.google.com/accounts/answer/2812853) is enforced. Replaces ensureVerifyAppsEnabled (deprecated). */
  googlePlayProtectVerifyApps?: InputMaybe<AdvancedSecurityOverridesGooglePlayProtectVerifyApps>;
  /** Personal apps that can read work profile notifications using a NotificationListenerService (https://developer.android.com/reference/android/service/notification/NotificationListenerService). By default, no personal apps (aside from system apps) can read work notifications. Each value in the list must be a package name. */
  personalAppsThatCanReadWorkNotifications?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The policy for untrusted apps (apps from unknown sources) enforced on the device. Replaces install_unknown_sources_allowed (deprecated). */
  untrustedAppsPolicy?: InputMaybe<AdvancedSecurityOverridesUntrustedAppsPolicy>;
};

export type AdvancedSecurityOverridesQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Security policies set to secure values by default. To maintain the security posture of a device, we don't recommend overriding any of the default values. */
export type AdvancedSecurityOverridesSchema = {
  __typename?: 'AdvancedSecurityOverridesSchema';
  /** Controls Common Criteria Mode—security standards defined in the Common Criteria for Information Technology Security Evaluation (https://www.commoncriteriaportal.org/) (CC). Enabling Common Criteria Mode increases certain security components on a device, including AES-GCM encryption of Bluetooth Long Term Keys, and Wi-Fi configuration stores.Warning: Common Criteria Mode enforces a strict security model typically only required for IT products used in national security systems and other highly sensitive organizations. Standard device use may be affected. Only enabled if required. */
  commonCriteriaMode?: Maybe<AdvancedSecurityOverridesCommonCriteriaMode>;
  /** Controls access to developer settings: developer options and safe boot. Replaces safeBootDisabled (deprecated) and debuggingFeaturesAllowed (deprecated). */
  developerSettings?: Maybe<AdvancedSecurityOverridesDeveloperSettings>;
  /** Whether Google Play Protect verification (https://support.google.com/accounts/answer/2812853) is enforced. Replaces ensureVerifyAppsEnabled (deprecated). */
  googlePlayProtectVerifyApps?: Maybe<AdvancedSecurityOverridesGooglePlayProtectVerifyApps>;
  /** Personal apps that can read work profile notifications using a NotificationListenerService (https://developer.android.com/reference/android/service/notification/NotificationListenerService). By default, no personal apps (aside from system apps) can read work notifications. Each value in the list must be a package name. */
  personalAppsThatCanReadWorkNotifications?: Maybe<Array<Scalars['String']['output']>>;
  /** The policy for untrusted apps (apps from unknown sources) enforced on the device. Replaces install_unknown_sources_allowed (deprecated). */
  untrustedAppsPolicy?: Maybe<AdvancedSecurityOverridesUntrustedAppsPolicy>;
};

export enum AdvancedSecurityOverridesUntrustedAppsPolicy {
  /** Allow untrusted app installs on entire device. */
  AllowInstallDeviceWide = 'ALLOW_INSTALL_DEVICE_WIDE',
  /** For devices with work profiles, allow untrusted app installs in the device's personal profile only. */
  AllowInstallInPersonalProfileOnly = 'ALLOW_INSTALL_IN_PERSONAL_PROFILE_ONLY',
  /** Default. Disallow untrusted app installs on entire device. */
  DisallowInstall = 'DISALLOW_INSTALL',
  /** Unspecified. Defaults to DISALLOW_INSTALL. */
  UntrustedAppsPolicyUnspecified = 'UNTRUSTED_APPS_POLICY_UNSPECIFIED'
}

/** Configuration for an always-on VPN connection. */
export type AlwaysOnVpnPackageInputSchema = {
  /** Disallows networking when the VPN is not connected. */
  lockdownEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The package name of the VPN app. */
  packageName?: InputMaybe<Scalars['String']['input']>;
};

export type AlwaysOnVpnPackageQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Configuration for an always-on VPN connection. */
export type AlwaysOnVpnPackageSchema = {
  __typename?: 'AlwaysOnVpnPackageSchema';
  /** Disallows networking when the VPN is not connected. */
  lockdownEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The package name of the VPN app. */
  packageName?: Maybe<Scalars['String']['output']>;
};

/** A compliance rule condition which is satisfied if the Android Framework API level on the device doesn't meet a minimum requirement. There can only be one rule with this type of condition per policy. */
export type ApiLevelConditionInputSchema = {
  /** The minimum desired Android Framework API level. If the device doesn't meet the minimum requirement, this condition is satisfied. Must be greater than zero. */
  minApiLevel?: InputMaybe<Scalars['Int']['input']>;
};

export type ApiLevelConditionQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A compliance rule condition which is satisfied if the Android Framework API level on the device doesn't meet a minimum requirement. There can only be one rule with this type of condition per policy. */
export type ApiLevelConditionSchema = {
  __typename?: 'ApiLevelConditionSchema';
  /** The minimum desired Android Framework API level. If the device doesn't meet the minimum requirement, this condition is satisfied. Must be greater than zero. */
  minApiLevel?: Maybe<Scalars['Int']['output']>;
};

/** Information about a process. It contains process name, start time, app Uid, app Pid, seinfo tag, hash of the base APK. */
export type AppProcessInfoInputSchema = {
  /** SHA-256 hash of the base APK, in hexadecimal format. */
  apkSha256Hash?: InputMaybe<Scalars['String']['input']>;
  /** Package names of all packages that are associated with the particular user ID. In most cases, this will be a single package name, the package that has been assigned that user ID. If multiple application share a UID then all packages sharing UID will be included. */
  packageNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Process ID. */
  pid?: InputMaybe<Scalars['Int']['input']>;
  /** Process name. */
  processName?: InputMaybe<Scalars['String']['input']>;
  /** SELinux policy info. */
  seinfo?: InputMaybe<Scalars['String']['input']>;
  /** Process start time. */
  startTime?: InputMaybe<Scalars['String']['input']>;
  /** UID of the package. */
  uid?: InputMaybe<Scalars['Int']['input']>;
};

export type AppProcessInfoQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Information about a process. It contains process name, start time, app Uid, app Pid, seinfo tag, hash of the base APK. */
export type AppProcessInfoSchema = {
  __typename?: 'AppProcessInfoSchema';
  /** SHA-256 hash of the base APK, in hexadecimal format. */
  apkSha256Hash?: Maybe<Scalars['String']['output']>;
  /** Package names of all packages that are associated with the particular user ID. In most cases, this will be a single package name, the package that has been assigned that user ID. If multiple application share a UID then all packages sharing UID will be included. */
  packageNames?: Maybe<Array<Scalars['String']['output']>>;
  /** Process ID. */
  pid?: Maybe<Scalars['Int']['output']>;
  /** Process name. */
  processName?: Maybe<Scalars['String']['output']>;
  /** SELinux policy info. */
  seinfo?: Maybe<Scalars['String']['output']>;
  /** Process start time. */
  startTime?: Maybe<Scalars['String']['output']>;
  /** UID of the package. */
  uid?: Maybe<Scalars['Int']['output']>;
};

/** An app process was started. This is available device-wide on fully managed devices and within the work profile on organization-owned devices with a work profile. */
export type AppProcessStartEventInputSchema = {
  /** Information about a process. */
  processInfo?: InputMaybe<AppProcessInfoInputSchema>;
};

export type AppProcessStartEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** An app process was started. This is available device-wide on fully managed devices and within the work profile on organization-owned devices with a work profile. */
export type AppProcessStartEventSchema = {
  __typename?: 'AppProcessStartEventSchema';
  /** Information about a process. */
  processInfo?: Maybe<AppProcessInfoSchema>;
};

/** Id to name association of a app track. */
export type AppTrackInfoInputSchema = {
  /** The track name associated with the trackId, set in the Play Console. The name is modifiable from Play Console. */
  trackAlias?: InputMaybe<Scalars['String']['input']>;
  /** The unmodifiable unique track identifier, taken from the releaseTrackId in the URL of the Play Console page that displays the app’s track information. */
  trackId?: InputMaybe<Scalars['String']['input']>;
};

export type AppTrackInfoQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Id to name association of a app track. */
export type AppTrackInfoSchema = {
  __typename?: 'AppTrackInfoSchema';
  /** The track name associated with the trackId, set in the Play Console. The name is modifiable from Play Console. */
  trackAlias?: Maybe<Scalars['String']['output']>;
  /** The unmodifiable unique track identifier, taken from the releaseTrackId in the URL of the Play Console page that displays the app’s track information. */
  trackId?: Maybe<Scalars['String']['output']>;
};

/** This represents a single version of the app. */
export type AppVersionInputSchema = {
  /** If the value is True, it indicates that this version is a production track. */
  production?: InputMaybe<Scalars['Boolean']['input']>;
  /** Track identifiers that the app version is published in. This does not include the production track (see production instead). */
  trackIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Unique increasing identifier for the app version. */
  versionCode?: InputMaybe<Scalars['Int']['input']>;
  /** The string used in the Play store by the app developer to identify the version. The string is not necessarily unique or localized (for example, the string could be "1.4"). */
  versionString?: InputMaybe<Scalars['String']['input']>;
};

export type AppVersionQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** This represents a single version of the app. */
export type AppVersionSchema = {
  __typename?: 'AppVersionSchema';
  /** If the value is True, it indicates that this version is a production track. */
  production?: Maybe<Scalars['Boolean']['output']>;
  /** Track identifiers that the app version is published in. This does not include the production track (see production instead). */
  trackIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Unique increasing identifier for the app version. */
  versionCode?: Maybe<Scalars['Int']['output']>;
  /** The string used in the Play store by the app developer to identify the version. The string is not necessarily unique or localized (for example, the string could be "1.4"). */
  versionString?: Maybe<Scalars['String']['output']>;
};

export enum ApplicationAppPricing {
  /** Unknown pricing, used to denote an approved app that is not generally available. */
  AppPricingUnspecified = 'APP_PRICING_UNSPECIFIED',
  /** The app is free. */
  Free = 'FREE',
  /** The app is free, but offers in-app purchases. */
  FreeWithInAppPurchase = 'FREE_WITH_IN_APP_PURCHASE',
  /** The app is paid. */
  Paid = 'PAID'
}

export enum ApplicationContentRating {
  /** Unspecified. */
  ContentRatingUnspecified = 'CONTENT_RATING_UNSPECIFIED',
  /** Content suitable for ages 18 and above only. */
  EighteenYears = 'EIGHTEEN_YEARS',
  /** Content suitable for ages 7 and above only. */
  SevenYears = 'SEVEN_YEARS',
  /** Content suitable for ages 16 and above only. */
  SixteenYears = 'SIXTEEN_YEARS',
  /** Content suitable for ages 3 and above only. */
  ThreeYears = 'THREE_YEARS',
  /** Content suitable for ages 12 and above only. */
  TwelveYears = 'TWELVE_YEARS'
}

export enum ApplicationDistributionChannel {
  /** Unspecified. */
  DistributionChannelUnspecified = 'DISTRIBUTION_CHANNEL_UNSPECIFIED',
  /** Package is a private app (restricted to an enterprise) but hosted by Google. */
  PrivateGoogleHosted = 'PRIVATE_GOOGLE_HOSTED',
  /** Private app (restricted to an enterprise) and is privately hosted. */
  PrivateSelfHosted = 'PRIVATE_SELF_HOSTED',
  /** Package is available through the Play store and not restricted to a specific enterprise. */
  PublicGoogleHosted = 'PUBLIC_GOOGLE_HOSTED'
}

export enum ApplicationEventEventType {
  /** This value is disallowed. */
  ApplicationEventTypeUnspecified = 'APPLICATION_EVENT_TYPE_UNSPECIFIED',
  /** The app was changed, for example, a component was enabled or disabled. */
  Changed = 'CHANGED',
  /** The app data was cleared. */
  DataCleared = 'DATA_CLEARED',
  /** The app was installed. */
  Installed = 'INSTALLED',
  /** The app was pinned to the foreground. */
  Pinned = 'PINNED',
  /** The app was removed. */
  Removed = 'REMOVED',
  /** A new version of the app has been installed, replacing the old version. */
  Replaced = 'REPLACED',
  /** The app was restarted. */
  Restarted = 'RESTARTED',
  /** The app was unpinned. */
  Unpinned = 'UNPINNED'
}

/** An app-related event. */
export type ApplicationEventInputSchema = {
  /** The creation time of the event. */
  createTime?: InputMaybe<Scalars['String']['input']>;
  /** App event type. */
  eventType?: InputMaybe<ApplicationEventEventType>;
};

export type ApplicationEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** An app-related event. */
export type ApplicationEventSchema = {
  __typename?: 'ApplicationEventSchema';
  /** The creation time of the event. */
  createTime?: Maybe<Scalars['String']['output']>;
  /** App event type. */
  eventType?: Maybe<ApplicationEventEventType>;
};

export enum ApplicationFeatures {
  /** Unspecified. */
  AppFeatureUnspecified = 'APP_FEATURE_UNSPECIFIED',
  /** The app is a VPN. */
  VpnApp = 'VPN_APP'
}

/** Information about an app. */
export type ApplicationInputSchema = {
  /** Whether this app is free, free with in-app purchases, or paid. If the pricing is unspecified, this means the app is not generally available anymore (even though it might still be available to people who own it). */
  appPricing?: InputMaybe<ApplicationAppPricing>;
  /** Application tracks visible to the enterprise. */
  appTracks?: InputMaybe<Array<AppTrackInfoInputSchema>>;
  /** Versions currently available for this app. */
  appVersions?: InputMaybe<Array<AppVersionInputSchema>>;
  /** The name of the author of the apps (for example, the app developer). */
  author?: InputMaybe<Scalars['String']['input']>;
  /** The countries which this app is available in as per ISO 3166-1 alpha-2. */
  availableCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The app category (e.g. RACING, SOCIAL, etc.) */
  category?: InputMaybe<Scalars['String']['input']>;
  /** The content rating for this app. */
  contentRating?: InputMaybe<ApplicationContentRating>;
  /** The localized promotional description, if available. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** How and to whom the package is made available. */
  distributionChannel?: InputMaybe<ApplicationDistributionChannel>;
  /** Noteworthy features (if any) of this app. */
  features?: InputMaybe<Array<ApplicationFeatures>>;
  /** Full app description, if available. */
  fullDescription?: InputMaybe<Scalars['String']['input']>;
  /** A link to an image that can be used as an icon for the app. This image is suitable for use up to a pixel size of 512 x 512. */
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  /** The set of managed properties available to be pre-configured for the app. */
  managedProperties?: InputMaybe<Array<ManagedPropertyInputSchema>>;
  /** The minimum Android SDK necessary to run the app. */
  minAndroidSdkVersion?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the app in the form enterprises/{enterprise}/applications/{package_name}. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The permissions required by the app. */
  permissions?: InputMaybe<Array<ApplicationPermissionInputSchema>>;
  /** A link to the (consumer) Google Play details page for the app. */
  playStoreUrl?: InputMaybe<Scalars['String']['input']>;
  /** A localised description of the recent changes made to the app. */
  recentChanges?: InputMaybe<Scalars['String']['input']>;
  /** A list of screenshot links representing the app. */
  screenshotUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A link to a smaller image that can be used as an icon for the app. This image is suitable for use up to a pixel size of 128 x 128. */
  smallIconUrl?: InputMaybe<Scalars['String']['input']>;
  /** The title of the app. Localized. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Output only. The approximate time (within 7 days) the app was last published. */
  updateTime?: InputMaybe<Scalars['String']['input']>;
};

/** A permission required by the app. */
export type ApplicationPermissionInputSchema = {
  /** A longer description of the permission, providing more detail on what it affects. Localized. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the permission. Localized. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** An opaque string uniquely identifying the permission. Not localized. */
  permissionId?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationPermissionQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A permission required by the app. */
export type ApplicationPermissionSchema = {
  __typename?: 'ApplicationPermissionSchema';
  /** A longer description of the permission, providing more detail on what it affects. Localized. */
  description?: Maybe<Scalars['String']['output']>;
  /** The name of the permission. Localized. */
  name?: Maybe<Scalars['String']['output']>;
  /** An opaque string uniquely identifying the permission. Not localized. */
  permissionId?: Maybe<Scalars['String']['output']>;
};

export enum ApplicationPolicyAlwaysOnVpnLockdownExemption {
  /** Unspecified. Defaults to VPN_LOCKDOWN_ENFORCED. */
  AlwaysOnVpnLockdownExemptionUnspecified = 'ALWAYS_ON_VPN_LOCKDOWN_EXEMPTION_UNSPECIFIED',
  /** The app respects the always-on VPN lockdown setting. */
  VpnLockdownEnforced = 'VPN_LOCKDOWN_ENFORCED',
  /** The app is exempt from the always-on VPN lockdown setting. */
  VpnLockdownExemption = 'VPN_LOCKDOWN_EXEMPTION'
}

export enum ApplicationPolicyAutoUpdateMode {
  /** The app is automatically updated with low priority to minimize the impact on the user.The app is updated when all of the following constraints are met: The device is not actively used. The device is connected to an unmetered network. The device is charging.The device is notified about a new update within 24 hours after it is published by the developer, after which the app is updated the next time the constraints above are met. */
  AutoUpdateDefault = 'AUTO_UPDATE_DEFAULT',
  /** The app is updated as soon as possible. No constraints are applied.The device is notified immediately about a new update after it becomes available. */
  AutoUpdateHighPriority = 'AUTO_UPDATE_HIGH_PRIORITY',
  /** Unspecified. Defaults to AUTO_UPDATE_DEFAULT. */
  AutoUpdateModeUnspecified = 'AUTO_UPDATE_MODE_UNSPECIFIED',
  /** The app is not automatically updated for a maximum of 90 days after the app becomes out of date.90 days after the app becomes out of date, the latest available version is installed automatically with low priority (see AUTO_UPDATE_DEFAULT). After the app is updated it is not automatically updated again until 90 days after it becomes out of date again.The user can still manually update the app from the Play Store at any time. */
  AutoUpdatePostponed = 'AUTO_UPDATE_POSTPONED'
}

export enum ApplicationPolicyConnectedWorkAndPersonalApp {
  /** Allows the app to communicate across profiles after receiving user consent. */
  ConnectedWorkAndPersonalAppAllowed = 'CONNECTED_WORK_AND_PERSONAL_APP_ALLOWED',
  /** Default. Prevents the app from communicating cross-profile. */
  ConnectedWorkAndPersonalAppDisallowed = 'CONNECTED_WORK_AND_PERSONAL_APP_DISALLOWED',
  /** Unspecified. Defaults to CONNECTED_WORK_AND_PERSONAL_APPS_DISALLOWED. */
  ConnectedWorkAndPersonalAppUnspecified = 'CONNECTED_WORK_AND_PERSONAL_APP_UNSPECIFIED'
}

export enum ApplicationPolicyDefaultPermissionPolicy {
  /** Automatically deny a permission. */
  Deny = 'DENY',
  /** Automatically grant a permission. */
  Grant = 'GRANT',
  /** Policy not specified. If no policy is specified for a permission at any level, then the PROMPT behavior is used by default. */
  PermissionPolicyUnspecified = 'PERMISSION_POLICY_UNSPECIFIED',
  /** Prompt the user to grant a permission. */
  Prompt = 'PROMPT'
}

export enum ApplicationPolicyDelegatedScopes {
  /** Grants access to blocking uninstallation. */
  BlockUninstall = 'BLOCK_UNINSTALL',
  /** Grants access to certificate installation and management. */
  CertInstall = 'CERT_INSTALL',
  /** No delegation scope specified. */
  DelegatedScopeUnspecified = 'DELEGATED_SCOPE_UNSPECIFIED',
  /** Grants access for enabling system apps. */
  EnableSystemApp = 'ENABLE_SYSTEM_APP',
  /** Grants access to managed configurations management. */
  ManagedConfigurations = 'MANAGED_CONFIGURATIONS',
  /** Grants access to network activity logs. Allows the delegated application to call setNetworkLoggingEnabled (https://developer.android.com/reference/android/app/admin/DevicePolicyManager#setNetworkLoggingEnabled%28android.content.ComponentName,%20boolean%29), isNetworkLoggingEnabled (https://developer.android.com/reference/android/app/admin/DevicePolicyManager#isNetworkLoggingEnabled%28android.content.ComponentName%29) and retrieveNetworkLogs (https://developer.android.com/reference/android/app/admin/DevicePolicyManager#retrieveNetworkLogs%28android.content.ComponentName,%20long%29) methods. This scope can be delegated to at most one application. Supported for fully managed devices on Android 10 and above. Supported for a work profile on Android 12 and above. When delegation is supported and set, NETWORK_ACTIVITY_LOGS is ignored. */
  NetworkActivityLogs = 'NETWORK_ACTIVITY_LOGS',
  /** Grants access to package access state. */
  PackageAccess = 'PACKAGE_ACCESS',
  /** Grants access to permission policy and permission grant state. */
  PermissionGrant = 'PERMISSION_GRANT',
  /** Grants access to security logs. Allows the delegated application to call setSecurityLoggingEnabled (https://developer.android.com/reference/android/app/admin/DevicePolicyManager#setSecurityLoggingEnabled%28android.content.ComponentName,%20boolean%29), isSecurityLoggingEnabled (https://developer.android.com/reference/android/app/admin/DevicePolicyManager#isSecurityLoggingEnabled%28android.content.ComponentName%29), retrieveSecurityLogs (https://developer.android.com/reference/android/app/admin/DevicePolicyManager#retrieveSecurityLogs%28android.content.ComponentName%29) and retrievePreRebootSecurityLogs (https://developer.android.com/reference/android/app/admin/DevicePolicyManager#retrievePreRebootSecurityLogs%28android.content.ComponentName%29) methods. This scope can be delegated to at most one application. Supported for fully managed devices and company-owned devices with a work profile on Android 12 and above. When delegation is supported and set, SECURITY_LOGS is ignored. */
  SecurityLogs = 'SECURITY_LOGS'
}

/** Policy for an individual app. */
export type ApplicationPolicyInputSchema = {
  /** List of the app’s track IDs that a device belonging to the enterprise can access. If the list contains multiple track IDs, devices receive the latest version among all accessible tracks. If the list contains no track IDs, devices only have access to the app’s production track. More details about each track are available in AppTrackInfo. */
  accessibleTrackIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Specifies whether the app is allowed networking when the VPN is not connected and alwaysOnVpnPackage.lockdownEnabled is enabled. If set to VPN_LOCKDOWN_ENFORCED, the app is not allowed networking, and if set to VPN_LOCKDOWN_EXEMPTION, the app is allowed networking. Only supported on devices running Android 10 and above. If this is not supported by the device, the device will contain a NonComplianceDetail with non_compliance_reason set to API_LEVEL and a fieldPath. If this is not applicable to the app, the device will contain a NonComplianceDetail with non_compliance_reason set to UNSUPPORTED and a fieldPath. The fieldPath is set to applications[i].alwaysOnVpnLockdownExemption, where i is the index of the package in the applications policy. */
  alwaysOnVpnLockdownExemption?: InputMaybe<ApplicationPolicyAlwaysOnVpnLockdownExemption>;
  /** Controls the auto-update mode for the app. */
  autoUpdateMode?: InputMaybe<ApplicationPolicyAutoUpdateMode>;
  /** Controls whether the app can communicate with itself across a device’s work and personal profiles, subject to user consent. */
  connectedWorkAndPersonalApp?: InputMaybe<ApplicationPolicyConnectedWorkAndPersonalApp>;
  /** The default policy for all permissions requested by the app. If specified, this overrides the policy-level default_permission_policy which applies to all apps. It does not override the permission_grants which applies to all apps. */
  defaultPermissionPolicy?: InputMaybe<ApplicationPolicyDefaultPermissionPolicy>;
  /** The scopes delegated to the app from Android Device Policy. */
  delegatedScopes?: InputMaybe<Array<ApplicationPolicyDelegatedScopes>>;
  /** Whether the app is disabled. When disabled, the app data is still preserved. */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Configuration to enable this app as an extension app, with the capability of interacting with Android Device Policy offline.This field can be set for at most one app. */
  extensionConfig?: InputMaybe<ExtensionConfigInputSchema>;
  /** The type of installation to perform. */
  installType?: InputMaybe<ApplicationPolicyInstallType>;
  /** Whether the app is allowed to lock itself in full-screen mode. DEPRECATED. Use InstallType KIOSK or kioskCustomLauncherEnabled to configure a dedicated device. */
  lockTaskAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Managed configuration applied to the app. The format for the configuration is dictated by the ManagedProperty values supported by the app. Each field name in the managed configuration must match the key field of the ManagedProperty. The field value must be compatible with the type of the ManagedProperty: *type* *JSON value* BOOL true or false STRING string INTEGER number CHOICE string MULTISELECT array of strings HIDDEN string BUNDLE_ARRAY array of objects  */
  managedConfiguration?: InputMaybe<Scalars['JSON']['input']>;
  /** The managed configurations template for the app, saved from the managed configurations iframe. This field is ignored if managed_configuration is set. */
  managedConfigurationTemplate?: InputMaybe<ManagedConfigurationTemplateInputSchema>;
  /** The minimum version of the app that runs on the device. If set, the device attempts to update the app to at least this version code. If the app is not up-to-date, the device will contain a NonComplianceDetail with non_compliance_reason set to APP_NOT_UPDATED. The app must already be published to Google Play with a version code greater than or equal to this value. At most 20 apps may specify a minimum version code per policy. */
  minimumVersionCode?: InputMaybe<Scalars['Int']['input']>;
  /** The package name of the app. For example, com.google.android.youtube for the YouTube app. */
  packageName?: InputMaybe<Scalars['String']['input']>;
  /** Explicit permission grants or denials for the app. These values override the default_permission_policy and permission_grants which apply to all apps. */
  permissionGrants?: InputMaybe<Array<PermissionGrantInputSchema>>;
  /** Specifies whether the app installed in the work profile is allowed to add widgets to the home screen. */
  workProfileWidgets?: InputMaybe<ApplicationPolicyWorkProfileWidgets>;
};

export enum ApplicationPolicyInstallType {
  /** The app is available to install. */
  Available = 'AVAILABLE',
  /** The app is blocked and can't be installed. If the app was installed under a previous policy, it will be uninstalled. */
  Blocked = 'BLOCKED',
  /** The app is automatically installed and can't be removed by the user. */
  ForceInstalled = 'FORCE_INSTALLED',
  /** Unspecified. Defaults to AVAILABLE. */
  InstallTypeUnspecified = 'INSTALL_TYPE_UNSPECIFIED',
  /** The app is automatically installed in kiosk mode: it's set as the preferred home intent and whitelisted for lock task mode. Device setup won't complete until the app is installed. After installation, users won't be able to remove the app. You can only set this installType for one app per policy. When this is present in the policy, status bar will be automatically disabled. */
  Kiosk = 'KIOSK',
  /** The app is automatically installed and can be removed by the user. */
  Preinstalled = 'PREINSTALLED',
  /** The app is automatically installed and can't be removed by the user and will prevent setup from completion until installation is complete. */
  RequiredForSetup = 'REQUIRED_FOR_SETUP'
}

export type ApplicationPolicyQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Policy for an individual app. */
export type ApplicationPolicySchema = {
  __typename?: 'ApplicationPolicySchema';
  /** List of the app’s track IDs that a device belonging to the enterprise can access. If the list contains multiple track IDs, devices receive the latest version among all accessible tracks. If the list contains no track IDs, devices only have access to the app’s production track. More details about each track are available in AppTrackInfo. */
  accessibleTrackIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Specifies whether the app is allowed networking when the VPN is not connected and alwaysOnVpnPackage.lockdownEnabled is enabled. If set to VPN_LOCKDOWN_ENFORCED, the app is not allowed networking, and if set to VPN_LOCKDOWN_EXEMPTION, the app is allowed networking. Only supported on devices running Android 10 and above. If this is not supported by the device, the device will contain a NonComplianceDetail with non_compliance_reason set to API_LEVEL and a fieldPath. If this is not applicable to the app, the device will contain a NonComplianceDetail with non_compliance_reason set to UNSUPPORTED and a fieldPath. The fieldPath is set to applications[i].alwaysOnVpnLockdownExemption, where i is the index of the package in the applications policy. */
  alwaysOnVpnLockdownExemption?: Maybe<ApplicationPolicyAlwaysOnVpnLockdownExemption>;
  /** Controls the auto-update mode for the app. */
  autoUpdateMode?: Maybe<ApplicationPolicyAutoUpdateMode>;
  /** Controls whether the app can communicate with itself across a device’s work and personal profiles, subject to user consent. */
  connectedWorkAndPersonalApp?: Maybe<ApplicationPolicyConnectedWorkAndPersonalApp>;
  /** The default policy for all permissions requested by the app. If specified, this overrides the policy-level default_permission_policy which applies to all apps. It does not override the permission_grants which applies to all apps. */
  defaultPermissionPolicy?: Maybe<ApplicationPolicyDefaultPermissionPolicy>;
  /** The scopes delegated to the app from Android Device Policy. */
  delegatedScopes?: Maybe<Array<ApplicationPolicyDelegatedScopes>>;
  /** Whether the app is disabled. When disabled, the app data is still preserved. */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** Configuration to enable this app as an extension app, with the capability of interacting with Android Device Policy offline.This field can be set for at most one app. */
  extensionConfig?: Maybe<ExtensionConfigSchema>;
  /** The type of installation to perform. */
  installType?: Maybe<ApplicationPolicyInstallType>;
  /** Whether the app is allowed to lock itself in full-screen mode. DEPRECATED. Use InstallType KIOSK or kioskCustomLauncherEnabled to configure a dedicated device. */
  lockTaskAllowed?: Maybe<Scalars['Boolean']['output']>;
  /** Managed configuration applied to the app. The format for the configuration is dictated by the ManagedProperty values supported by the app. Each field name in the managed configuration must match the key field of the ManagedProperty. The field value must be compatible with the type of the ManagedProperty: *type* *JSON value* BOOL true or false STRING string INTEGER number CHOICE string MULTISELECT array of strings HIDDEN string BUNDLE_ARRAY array of objects  */
  managedConfiguration?: Maybe<Scalars['JSON']['output']>;
  /** The managed configurations template for the app, saved from the managed configurations iframe. This field is ignored if managed_configuration is set. */
  managedConfigurationTemplate?: Maybe<ManagedConfigurationTemplateSchema>;
  /** The minimum version of the app that runs on the device. If set, the device attempts to update the app to at least this version code. If the app is not up-to-date, the device will contain a NonComplianceDetail with non_compliance_reason set to APP_NOT_UPDATED. The app must already be published to Google Play with a version code greater than or equal to this value. At most 20 apps may specify a minimum version code per policy. */
  minimumVersionCode?: Maybe<Scalars['Int']['output']>;
  /** The package name of the app. For example, com.google.android.youtube for the YouTube app. */
  packageName?: Maybe<Scalars['String']['output']>;
  /** Explicit permission grants or denials for the app. These values override the default_permission_policy and permission_grants which apply to all apps. */
  permissionGrants?: Maybe<Array<PermissionGrantSchema>>;
  /** Specifies whether the app installed in the work profile is allowed to add widgets to the home screen. */
  workProfileWidgets?: Maybe<ApplicationPolicyWorkProfileWidgets>;
};

export enum ApplicationPolicyWorkProfileWidgets {
  /** Work profile widgets are allowed. This means the application will be able to add widgets to the home screen. */
  WorkProfileWidgetsAllowed = 'WORK_PROFILE_WIDGETS_ALLOWED',
  /** Work profile widgets are disallowed. This means the application will not be able to add widgets to the home screen. */
  WorkProfileWidgetsDisallowed = 'WORK_PROFILE_WIDGETS_DISALLOWED',
  /** Unspecified. Defaults to work_profile_widgets_default */
  WorkProfileWidgetsUnspecified = 'WORK_PROFILE_WIDGETS_UNSPECIFIED'
}

export type ApplicationQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

export enum ApplicationReportApplicationSource {
  /** The app was sideloaded from an unspecified source. */
  ApplicationSourceUnspecified = 'APPLICATION_SOURCE_UNSPECIFIED',
  /** The app was installed from the Google Play Store. */
  InstalledFromPlayStore = 'INSTALLED_FROM_PLAY_STORE',
  /** This is a system app from the device's factory image. */
  SystemAppFactoryVersion = 'SYSTEM_APP_FACTORY_VERSION',
  /** This is an updated system app. */
  SystemAppUpdatedVersion = 'SYSTEM_APP_UPDATED_VERSION'
}

/** Information reported about an installed app. */
export type ApplicationReportInputSchema = {
  /** The source of the package. */
  applicationSource?: InputMaybe<ApplicationReportApplicationSource>;
  /** The display name of the app. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** The list of app events which have occurred in the last 30 hours. */
  events?: InputMaybe<Array<ApplicationEventInputSchema>>;
  /** The package name of the app that installed this app. */
  installerPackageName?: InputMaybe<Scalars['String']['input']>;
  /** List of keyed app states reported by the app. */
  keyedAppStates?: InputMaybe<Array<KeyedAppStateInputSchema>>;
  /** Package name of the app. */
  packageName?: InputMaybe<Scalars['String']['input']>;
  /** The SHA-256 hash of the app's APK file, which can be used to verify the app hasn't been modified. Each byte of the hash value is represented as a two-digit hexadecimal number. */
  packageSha256Hash?: InputMaybe<Scalars['String']['input']>;
  /** The SHA-1 hash of each android.content.pm.Signature (https://developer.android.com/reference/android/content/pm/Signature.html) associated with the app package. Each byte of each hash value is represented as a two-digit hexadecimal number. */
  signingKeyCertFingerprints?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Application state. */
  state?: InputMaybe<ApplicationReportState>;
  /** The app version code, which can be used to determine whether one version is more recent than another. */
  versionCode?: InputMaybe<Scalars['Int']['input']>;
  /** The app version as displayed to the user. */
  versionName?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationReportQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Information reported about an installed app. */
export type ApplicationReportSchema = {
  __typename?: 'ApplicationReportSchema';
  /** The source of the package. */
  applicationSource?: Maybe<ApplicationReportApplicationSource>;
  /** The display name of the app. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The list of app events which have occurred in the last 30 hours. */
  events?: Maybe<Array<ApplicationEventSchema>>;
  /** The package name of the app that installed this app. */
  installerPackageName?: Maybe<Scalars['String']['output']>;
  /** List of keyed app states reported by the app. */
  keyedAppStates?: Maybe<Array<KeyedAppStateSchema>>;
  /** Package name of the app. */
  packageName?: Maybe<Scalars['String']['output']>;
  /** The SHA-256 hash of the app's APK file, which can be used to verify the app hasn't been modified. Each byte of the hash value is represented as a two-digit hexadecimal number. */
  packageSha256Hash?: Maybe<Scalars['String']['output']>;
  /** The SHA-1 hash of each android.content.pm.Signature (https://developer.android.com/reference/android/content/pm/Signature.html) associated with the app package. Each byte of each hash value is represented as a two-digit hexadecimal number. */
  signingKeyCertFingerprints?: Maybe<Array<Scalars['String']['output']>>;
  /** Application state. */
  state?: Maybe<ApplicationReportState>;
  /** The app version code, which can be used to determine whether one version is more recent than another. */
  versionCode?: Maybe<Scalars['Int']['output']>;
  /** The app version as displayed to the user. */
  versionName?: Maybe<Scalars['String']['output']>;
};

export enum ApplicationReportState {
  /** App state is unspecified */
  ApplicationStateUnspecified = 'APPLICATION_STATE_UNSPECIFIED',
  /** App is installed on the device */
  Installed = 'INSTALLED',
  /** App was removed from the device */
  Removed = 'REMOVED'
}

/** Settings controlling the behavior of application reports. */
export type ApplicationReportingSettingsInputSchema = {
  /** Whether removed apps are included in application reports. */
  includeRemovedApps?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApplicationReportingSettingsQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Settings controlling the behavior of application reports. */
export type ApplicationReportingSettingsSchema = {
  __typename?: 'ApplicationReportingSettingsSchema';
  /** Whether removed apps are included in application reports. */
  includeRemovedApps?: Maybe<Scalars['Boolean']['output']>;
};

/** Information about an app. */
export type ApplicationSchema = {
  __typename?: 'ApplicationSchema';
  /** Whether this app is free, free with in-app purchases, or paid. If the pricing is unspecified, this means the app is not generally available anymore (even though it might still be available to people who own it). */
  appPricing?: Maybe<ApplicationAppPricing>;
  /** Application tracks visible to the enterprise. */
  appTracks?: Maybe<Array<AppTrackInfoSchema>>;
  /** Versions currently available for this app. */
  appVersions?: Maybe<Array<AppVersionSchema>>;
  /** The name of the author of the apps (for example, the app developer). */
  author?: Maybe<Scalars['String']['output']>;
  /** The countries which this app is available in as per ISO 3166-1 alpha-2. */
  availableCountries?: Maybe<Array<Scalars['String']['output']>>;
  /** The app category (e.g. RACING, SOCIAL, etc.) */
  category?: Maybe<Scalars['String']['output']>;
  /** The content rating for this app. */
  contentRating?: Maybe<ApplicationContentRating>;
  /** The localized promotional description, if available. */
  description?: Maybe<Scalars['String']['output']>;
  /** How and to whom the package is made available. */
  distributionChannel?: Maybe<ApplicationDistributionChannel>;
  /** Noteworthy features (if any) of this app. */
  features?: Maybe<Array<ApplicationFeatures>>;
  /** Full app description, if available. */
  fullDescription?: Maybe<Scalars['String']['output']>;
  /** A link to an image that can be used as an icon for the app. This image is suitable for use up to a pixel size of 512 x 512. */
  iconUrl?: Maybe<Scalars['String']['output']>;
  /** The set of managed properties available to be pre-configured for the app. */
  managedProperties?: Maybe<Array<ManagedPropertySchema>>;
  /** The minimum Android SDK necessary to run the app. */
  minAndroidSdkVersion?: Maybe<Scalars['Int']['output']>;
  /** The name of the app in the form enterprises/{enterprise}/applications/{package_name}. */
  name?: Maybe<Scalars['String']['output']>;
  /** The permissions required by the app. */
  permissions?: Maybe<Array<ApplicationPermissionSchema>>;
  /** A link to the (consumer) Google Play details page for the app. */
  playStoreUrl?: Maybe<Scalars['String']['output']>;
  /** A localised description of the recent changes made to the app. */
  recentChanges?: Maybe<Scalars['String']['output']>;
  /** A list of screenshot links representing the app. */
  screenshotUrls?: Maybe<Array<Scalars['String']['output']>>;
  /** A link to a smaller image that can be used as an icon for the app. This image is suitable for use up to a pixel size of 128 x 128. */
  smallIconUrl?: Maybe<Scalars['String']['output']>;
  /** The title of the app. Localized. */
  title?: Maybe<Scalars['String']['output']>;
  /** Output only. The approximate time (within 7 days) the app was last published. */
  updateTime?: Maybe<Scalars['String']['output']>;
};

/** A device owned by an enterprise. Unless otherwise noted, all fields are read-only and can't be modified by enterprises.devices.patch. */
export type BaseDeviceInputSchema = {
  /** The API level of the Android platform version running on the device. */
  apiLevel?: InputMaybe<Scalars['Int']['input']>;
  /** Reports for apps installed on the device. This information is only available when application_reports_enabled is true in the device's policy. */
  applicationReports?: InputMaybe<Array<ApplicationReportInputSchema>>;
  /** The password requirements currently applied to the device. The applied requirements may be slightly different from those specified in passwordPolicies in some cases. fieldPath is set based on passwordPolicies. */
  appliedPasswordPolicies?: InputMaybe<Array<PasswordRequirementsInputSchema>>;
  /** The name of the policy currently applied to the device. */
  appliedPolicyName?: InputMaybe<Scalars['String']['input']>;
  /** The version of the policy currently applied to the device. */
  appliedPolicyVersion?: InputMaybe<Scalars['String']['input']>;
  /** The state currently applied to the device. */
  appliedState?: InputMaybe<DeviceAppliedState>;
  /** Information about Common Criteria Mode—security standards defined in the Common Criteria for Information Technology Security Evaluation (https://www.commoncriteriaportal.org/) (CC).This information is only available if statusReportingSettings.commonCriteriaModeEnabled is true in the device's policy. */
  commonCriteriaModeInfo?: InputMaybe<CommonCriteriaModeInfoInputSchema>;
  /** Device settings information. This information is only available if deviceSettingsEnabled is true in the device's policy. */
  deviceSettings?: InputMaybe<DeviceSettingsInputSchema>;
  /** If the device state is DISABLED, an optional message that is displayed on the device indicating the reason the device is disabled. This field can be modified by a patch request. */
  disabledReason?: InputMaybe<UserFacingMessageInputSchema>;
  /** Detailed information about displays on the device. This information is only available if displayInfoEnabled is true in the device's policy. */
  displays?: InputMaybe<Array<DisplayInputSchema>>;
  /** The time of device enrollment. */
  enrollmentTime?: InputMaybe<Scalars['String']['input']>;
  /** If the device was enrolled with an enrollment token with additional data provided, this field contains that data. */
  enrollmentTokenData?: InputMaybe<Scalars['String']['input']>;
  /** If the device was enrolled with an enrollment token, this field contains the name of the token. */
  enrollmentTokenName?: InputMaybe<Scalars['String']['input']>;
  /** Detailed information about the device hardware. */
  hardwareInfo?: InputMaybe<HardwareInfoInputSchema>;
  /** Hardware status samples in chronological order. This information is only available if hardwareStatusEnabled is true in the device's policy. */
  hardwareStatusSamples?: InputMaybe<Array<HardwareStatusInputSchema>>;
  /** Deprecated. */
  lastPolicyComplianceReportTime?: InputMaybe<Scalars['String']['input']>;
  /** The last time the device fetched its policy. */
  lastPolicySyncTime?: InputMaybe<Scalars['String']['input']>;
  /** The last time the device sent a status report. */
  lastStatusReportTime?: InputMaybe<Scalars['String']['input']>;
  /** The type of management mode Android Device Policy takes on the device. This influences which policy settings are supported. */
  managementMode?: InputMaybe<DeviceManagementMode>;
  /** Events related to memory and storage measurements in chronological order. This information is only available if memoryInfoEnabled is true in the device's policy. */
  memoryEvents?: InputMaybe<Array<MemoryEventInputSchema>>;
  /** Memory information: contains information about device memory and storage. */
  memoryInfo?: InputMaybe<MemoryInfoInputSchema>;
  /** The name of the device in the form enterprises/{enterpriseId}/devices/{deviceId}. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Device network information. This information is only available if networkInfoEnabled is true in the device's policy. */
  networkInfo?: InputMaybe<NetworkInfoInputSchema>;
  /** Details about policy settings that the device is not compliant with. */
  nonComplianceDetails?: InputMaybe<Array<NonComplianceDetailInputSchema>>;
  /** Ownership of the managed device. */
  ownership?: InputMaybe<DeviceOwnership>;
  /** Whether the device is compliant with its policy. */
  policyCompliant?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the policy applied to the device, in the form enterprises/{enterpriseId}/policies/{policyId}. If not specified, the policy_name for the device's user is applied. This field can be modified by a patch request. You can specify only the policyId when calling enterprises.devices.patch, as long as the policyId doesn’t contain any slashes. The rest of the policy name is inferred. */
  policyName?: InputMaybe<Scalars['String']['input']>;
  /** Power management events on the device in chronological order. This information is only available if powerManagementEventsEnabled is true in the device's policy. */
  powerManagementEvents?: InputMaybe<Array<PowerManagementEventInputSchema>>;
  /** If the same physical device has been enrolled multiple times, this field contains its previous device names. The serial number is used as the unique identifier to determine if the same physical device has enrolled previously. The names are in chronological order. */
  previousDeviceNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Device's security posture value that reflects how secure the device is. */
  securityPosture?: InputMaybe<SecurityPostureInputSchema>;
  /** Detailed information about the device software. This information is only available if softwareInfoEnabled is true in the device's policy. */
  softwareInfo?: InputMaybe<SoftwareInfoInputSchema>;
  /** The state to be applied to the device. This field can be modified by a patch request. Note that when calling enterprises.devices.patch, ACTIVE and DISABLED are the only allowable values. To enter the device into a DELETED state, call enterprises.devices.delete. */
  state?: InputMaybe<DeviceState>;
  /** Map of selected system properties name and value related to the device. This information is only available if systemPropertiesEnabled is true in the device's policy. */
  systemProperties?: InputMaybe<Scalars['JSON']['input']>;
  /** The user who owns the device. */
  user?: InputMaybe<UserInputSchema>;
  /** The resource name of the user that owns this device in the form enterprises/{enterpriseId}/users/{userId}. */
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type BaseDeviceQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A device owned by an enterprise. Unless otherwise noted, all fields are read-only and can't be modified by enterprises.devices.patch. */
export type BaseDeviceSchema = {
  __typename?: 'BaseDeviceSchema';
  /** The API level of the Android platform version running on the device. */
  apiLevel?: Maybe<Scalars['Int']['output']>;
  /** Reports for apps installed on the device. This information is only available when application_reports_enabled is true in the device's policy. */
  applicationReports?: Maybe<Array<ApplicationReportSchema>>;
  /** The password requirements currently applied to the device. The applied requirements may be slightly different from those specified in passwordPolicies in some cases. fieldPath is set based on passwordPolicies. */
  appliedPasswordPolicies?: Maybe<Array<PasswordRequirementsSchema>>;
  /** The name of the policy currently applied to the device. */
  appliedPolicyName?: Maybe<Scalars['String']['output']>;
  /** The version of the policy currently applied to the device. */
  appliedPolicyVersion?: Maybe<Scalars['String']['output']>;
  /** The state currently applied to the device. */
  appliedState?: Maybe<DeviceAppliedState>;
  /** Information about Common Criteria Mode—security standards defined in the Common Criteria for Information Technology Security Evaluation (https://www.commoncriteriaportal.org/) (CC).This information is only available if statusReportingSettings.commonCriteriaModeEnabled is true in the device's policy. */
  commonCriteriaModeInfo?: Maybe<CommonCriteriaModeInfoSchema>;
  /** Device settings information. This information is only available if deviceSettingsEnabled is true in the device's policy. */
  deviceSettings?: Maybe<DeviceSettingsSchema>;
  /** If the device state is DISABLED, an optional message that is displayed on the device indicating the reason the device is disabled. This field can be modified by a patch request. */
  disabledReason?: Maybe<UserFacingMessageSchema>;
  /** Detailed information about displays on the device. This information is only available if displayInfoEnabled is true in the device's policy. */
  displays?: Maybe<Array<DisplaySchema>>;
  /** The time of device enrollment. */
  enrollmentTime?: Maybe<Scalars['String']['output']>;
  /** If the device was enrolled with an enrollment token with additional data provided, this field contains that data. */
  enrollmentTokenData?: Maybe<Scalars['String']['output']>;
  /** If the device was enrolled with an enrollment token, this field contains the name of the token. */
  enrollmentTokenName?: Maybe<Scalars['String']['output']>;
  /** Detailed information about the device hardware. */
  hardwareInfo?: Maybe<HardwareInfoSchema>;
  /** Hardware status samples in chronological order. This information is only available if hardwareStatusEnabled is true in the device's policy. */
  hardwareStatusSamples?: Maybe<Array<HardwareStatusSchema>>;
  /** Deprecated. */
  lastPolicyComplianceReportTime?: Maybe<Scalars['String']['output']>;
  /** The last time the device fetched its policy. */
  lastPolicySyncTime?: Maybe<Scalars['String']['output']>;
  /** The last time the device sent a status report. */
  lastStatusReportTime?: Maybe<Scalars['String']['output']>;
  /** The type of management mode Android Device Policy takes on the device. This influences which policy settings are supported. */
  managementMode?: Maybe<DeviceManagementMode>;
  /** Events related to memory and storage measurements in chronological order. This information is only available if memoryInfoEnabled is true in the device's policy. */
  memoryEvents?: Maybe<Array<MemoryEventSchema>>;
  /** Memory information: contains information about device memory and storage. */
  memoryInfo?: Maybe<MemoryInfoSchema>;
  /** The name of the device in the form enterprises/{enterpriseId}/devices/{deviceId}. */
  name?: Maybe<Scalars['String']['output']>;
  /** Device network information. This information is only available if networkInfoEnabled is true in the device's policy. */
  networkInfo?: Maybe<NetworkInfoSchema>;
  /** Details about policy settings that the device is not compliant with. */
  nonComplianceDetails?: Maybe<Array<NonComplianceDetailSchema>>;
  /** Ownership of the managed device. */
  ownership?: Maybe<DeviceOwnership>;
  /** Whether the device is compliant with its policy. */
  policyCompliant?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the policy applied to the device, in the form enterprises/{enterpriseId}/policies/{policyId}. If not specified, the policy_name for the device's user is applied. This field can be modified by a patch request. You can specify only the policyId when calling enterprises.devices.patch, as long as the policyId doesn’t contain any slashes. The rest of the policy name is inferred. */
  policyName?: Maybe<Scalars['String']['output']>;
  /** Power management events on the device in chronological order. This information is only available if powerManagementEventsEnabled is true in the device's policy. */
  powerManagementEvents?: Maybe<Array<PowerManagementEventSchema>>;
  /** If the same physical device has been enrolled multiple times, this field contains its previous device names. The serial number is used as the unique identifier to determine if the same physical device has enrolled previously. The names are in chronological order. */
  previousDeviceNames?: Maybe<Array<Scalars['String']['output']>>;
  /** Device's security posture value that reflects how secure the device is. */
  securityPosture?: Maybe<SecurityPostureSchema>;
  /** Detailed information about the device software. This information is only available if softwareInfoEnabled is true in the device's policy. */
  softwareInfo?: Maybe<SoftwareInfoSchema>;
  /** The state to be applied to the device. This field can be modified by a patch request. Note that when calling enterprises.devices.patch, ACTIVE and DISABLED are the only allowable values. To enter the device into a DELETED state, call enterprises.devices.delete. */
  state?: Maybe<DeviceState>;
  /** Map of selected system properties name and value related to the device. This information is only available if systemPropertiesEnabled is true in the device's policy. */
  systemProperties?: Maybe<Scalars['JSON']['output']>;
  /** The user who owns the device. */
  user?: Maybe<UserSchema>;
  /** The resource name of the user that owns this device in the form enterprises/{enterpriseId}/users/{userId}. */
  userName?: Maybe<Scalars['String']['output']>;
};

/** An enrollment token. */
export type BaseEnrollmentTokenInputSchema = {
  /** Optional, arbitrary data associated with the enrollment token. This could contain, for example, the ID of an org unit the device is assigned to after enrollment. After a device enrolls with the token, this data will be exposed in the enrollment_token_data field of the Device resource. The data must be 1024 characters or less; otherwise, the creation request will fail. */
  additionalData?: InputMaybe<Scalars['String']['input']>;
  /** Controls whether personal usage is allowed on a device provisioned with this enrollment token.For company-owned devices: Enabling personal usage allows the user to set up a work profile on the device. Disabling personal usage requires the user provision the device as a fully managed device.For personally-owned devices: Enabling personal usage allows the user to set up a work profile on the device. Disabling personal usage will prevent the device from provisioning. Personal usage cannot be disabled on personally-owned device. */
  allowPersonalUsage?: InputMaybe<EnrollmentTokenAllowPersonalUsage>;
  /** The length of time the enrollment token is valid, ranging from 1 minute to Durations.MAX_VALUE (https://developers.google.com/protocol-buffers/docs/reference/java/com/google/protobuf/util/Durations.html#MAX_VALUE), approximately 10,000 years. If not specified, the default duration is 1 hour. Please note that if requested duration causes the resulting expiration_timestamp to exceed Timestamps.MAX_VALUE (https://developers.google.com/protocol-buffers/docs/reference/java/com/google/protobuf/util/Timestamps.html#MAX_VALUE), then expiration_timestamp is coerced to Timestamps.MAX_VALUE. */
  duration?: InputMaybe<Scalars['String']['input']>;
  /** The expiration time of the token. This is a read-only field generated by the server. */
  expirationTimestamp?: InputMaybe<Scalars['String']['input']>;
  /** The name of the enrollment token, which is generated by the server during creation, in the form enterprises/{enterpriseId}/enrollmentTokens/{enrollmentTokenId}. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Whether the enrollment token is for one time use only. If the flag is set to true, only one device can use it for registration. */
  oneTimeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the policy initially applied to the enrolled device, in the form enterprises/{enterpriseId}/policies/{policyId}. If not specified, the policy_name for the device’s user is applied. If user_name is also not specified, enterprises/{enterpriseId}/policies/default is applied by default. When updating this field, you can specify only the policyId as long as the policyId doesn’t contain any slashes. The rest of the policy name will be inferred. */
  policyName?: InputMaybe<Scalars['String']['input']>;
  /** A JSON string whose UTF-8 representation can be used to generate a QR code to enroll a device with this enrollment token. To enroll a device using NFC, the NFC record must contain a serialized java.util.Properties representation of the properties in the JSON. */
  qrCode?: InputMaybe<Scalars['String']['input']>;
  /** The user associated with this enrollment token. If it's specified when the enrollment token is created and the user does not exist, the user will be created. This field must not contain personally identifiable information. Only the account_identifier field needs to be set. */
  user?: InputMaybe<UserInputSchema>;
  /** The token value that's passed to the device and authorizes the device to enroll. This is a read-only field generated by the server. */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type BaseEnrollmentTokenQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** An enrollment token. */
export type BaseEnrollmentTokenSchema = {
  __typename?: 'BaseEnrollmentTokenSchema';
  /** Optional, arbitrary data associated with the enrollment token. This could contain, for example, the ID of an org unit the device is assigned to after enrollment. After a device enrolls with the token, this data will be exposed in the enrollment_token_data field of the Device resource. The data must be 1024 characters or less; otherwise, the creation request will fail. */
  additionalData?: Maybe<Scalars['String']['output']>;
  /** Controls whether personal usage is allowed on a device provisioned with this enrollment token.For company-owned devices: Enabling personal usage allows the user to set up a work profile on the device. Disabling personal usage requires the user provision the device as a fully managed device.For personally-owned devices: Enabling personal usage allows the user to set up a work profile on the device. Disabling personal usage will prevent the device from provisioning. Personal usage cannot be disabled on personally-owned device. */
  allowPersonalUsage?: Maybe<EnrollmentTokenAllowPersonalUsage>;
  /** The length of time the enrollment token is valid, ranging from 1 minute to Durations.MAX_VALUE (https://developers.google.com/protocol-buffers/docs/reference/java/com/google/protobuf/util/Durations.html#MAX_VALUE), approximately 10,000 years. If not specified, the default duration is 1 hour. Please note that if requested duration causes the resulting expiration_timestamp to exceed Timestamps.MAX_VALUE (https://developers.google.com/protocol-buffers/docs/reference/java/com/google/protobuf/util/Timestamps.html#MAX_VALUE), then expiration_timestamp is coerced to Timestamps.MAX_VALUE. */
  duration?: Maybe<Scalars['String']['output']>;
  /** The expiration time of the token. This is a read-only field generated by the server. */
  expirationTimestamp?: Maybe<Scalars['String']['output']>;
  /** The name of the enrollment token, which is generated by the server during creation, in the form enterprises/{enterpriseId}/enrollmentTokens/{enrollmentTokenId}. */
  name?: Maybe<Scalars['String']['output']>;
  /** Whether the enrollment token is for one time use only. If the flag is set to true, only one device can use it for registration. */
  oneTimeOnly?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the policy initially applied to the enrolled device, in the form enterprises/{enterpriseId}/policies/{policyId}. If not specified, the policy_name for the device’s user is applied. If user_name is also not specified, enterprises/{enterpriseId}/policies/default is applied by default. When updating this field, you can specify only the policyId as long as the policyId doesn’t contain any slashes. The rest of the policy name will be inferred. */
  policyName?: Maybe<Scalars['String']['output']>;
  /** A JSON string whose UTF-8 representation can be used to generate a QR code to enroll a device with this enrollment token. To enroll a device using NFC, the NFC record must contain a serialized java.util.Properties representation of the properties in the JSON. */
  qrCode?: Maybe<Scalars['String']['output']>;
  /** The user associated with this enrollment token. If it's specified when the enrollment token is created and the user does not exist, the user will be created. This field must not contain personally identifiable information. Only the account_identifier field needs to be set. */
  user?: Maybe<UserSchema>;
  /** The token value that's passed to the device and authorizes the device to enroll. This is a read-only field generated by the server. */
  value?: Maybe<Scalars['String']['output']>;
};

/** The configuration applied to an enterprise. */
export type BaseEnterpriseInputSchema = {
  /** Deprecated and unused. */
  appAutoApprovalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The enterprise contact info of an EMM-managed enterprise. */
  contactInfo?: InputMaybe<ContactInfoInputSchema>;
  /** The types of Google Pub/Sub notifications enabled for the enterprise. */
  enabledNotificationTypes?: InputMaybe<Array<EnterpriseEnabledNotificationTypes>>;
  /** The name of the enterprise displayed to users. This field has a maximum length of 100 characters. */
  enterpriseDisplayName?: InputMaybe<Scalars['String']['input']>;
  /** An image displayed as a logo during device provisioning. Supported types are: image/bmp, image/gif, image/x-ico, image/jpeg, image/png, image/webp, image/vnd.wap.wbmp, image/x-adobe-dng. */
  logo?: InputMaybe<ExternalDataInputSchema>;
  /** The name of the enterprise which is generated by the server during creation, in the form enterprises/{enterpriseId}. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** A color in RGB format that indicates the predominant color to display in the device management app UI. The color components are stored as follows: (red << 16) | (green << 8) | blue, where the value of each component is between 0 and 255, inclusive. */
  primaryColor?: InputMaybe<Scalars['Int']['input']>;
  /** The topic which Pub/Sub notifications are published to, in the form projects/{project}/topics/{topic}. This field is only required if Pub/Sub notifications are enabled. */
  pubsubTopic?: InputMaybe<Scalars['String']['input']>;
  /** Sign-in details of the enterprise. */
  signinDetails?: InputMaybe<Array<SigninDetailInputSchema>>;
  /** Terms and conditions that must be accepted when provisioning a device for this enterprise. A page of terms is generated for each value in this list. */
  termsAndConditions?: InputMaybe<Array<TermsAndConditionsInputSchema>>;
};

export type BaseEnterpriseQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** The configuration applied to an enterprise. */
export type BaseEnterpriseSchema = {
  __typename?: 'BaseEnterpriseSchema';
  /** Deprecated and unused. */
  appAutoApprovalEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The enterprise contact info of an EMM-managed enterprise. */
  contactInfo?: Maybe<ContactInfoSchema>;
  /** The types of Google Pub/Sub notifications enabled for the enterprise. */
  enabledNotificationTypes?: Maybe<Array<EnterpriseEnabledNotificationTypes>>;
  /** The name of the enterprise displayed to users. This field has a maximum length of 100 characters. */
  enterpriseDisplayName?: Maybe<Scalars['String']['output']>;
  /** An image displayed as a logo during device provisioning. Supported types are: image/bmp, image/gif, image/x-ico, image/jpeg, image/png, image/webp, image/vnd.wap.wbmp, image/x-adobe-dng. */
  logo?: Maybe<ExternalDataSchema>;
  /** The name of the enterprise which is generated by the server during creation, in the form enterprises/{enterpriseId}. */
  name?: Maybe<Scalars['String']['output']>;
  /** A color in RGB format that indicates the predominant color to display in the device management app UI. The color components are stored as follows: (red << 16) | (green << 8) | blue, where the value of each component is between 0 and 255, inclusive. */
  primaryColor?: Maybe<Scalars['Int']['output']>;
  /** The topic which Pub/Sub notifications are published to, in the form projects/{project}/topics/{topic}. This field is only required if Pub/Sub notifications are enabled. */
  pubsubTopic?: Maybe<Scalars['String']['output']>;
  /** Sign-in details of the enterprise. */
  signinDetails?: Maybe<Array<SigninDetailSchema>>;
  /** Terms and conditions that must be accepted when provisioning a device for this enterprise. A page of terms is generated for each value in this list. */
  termsAndConditions?: Maybe<Array<TermsAndConditionsSchema>>;
};

/** A policy resource represents a group of settings that govern the behavior of a managed device and the apps installed on it. */
export type BasePolicyInputSchema = {
  /** Account types that can't be managed by the user. */
  accountTypesWithManagementDisabled?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether adding new users and profiles is disabled. */
  addUserDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether adjusting the master volume is disabled. Also mutes the device. */
  adjustVolumeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Security policies set to secure values by default. To maintain the security posture of a device, we don't recommend overriding any of the default values. */
  advancedSecurityOverrides?: InputMaybe<AdvancedSecurityOverridesInputSchema>;
  /** Configuration for an always-on VPN connection. Use with vpn_config_disabled to prevent modification of this setting. */
  alwaysOnVpnPackage?: InputMaybe<AlwaysOnVpnPackageInputSchema>;
  /** The app tracks for Android Device Policy the device can access. The device receives the latest version among all accessible tracks. If no tracks are specified, then the device only uses the production track. */
  androidDevicePolicyTracks?: InputMaybe<Array<PolicyAndroidDevicePolicyTracks>>;
  /** Recommended alternative: autoUpdateMode which is set per app, provides greater flexibility around update frequency.When autoUpdateMode is set to AUTO_UPDATE_POSTPONED or AUTO_UPDATE_HIGH_PRIORITY, this field has no effect.The app auto update policy, which controls when automatic app updates can be applied. */
  appAutoUpdatePolicy?: InputMaybe<PolicyAppAutoUpdatePolicy>;
  /** Policy applied to apps. */
  applications?: InputMaybe<Array<ApplicationPolicyInputSchema>>;
  /** Whether auto date, time, and time zone are enabled on a company-owned device. If this is set, then autoTimeRequired is ignored. */
  autoDateAndTimeZone?: InputMaybe<PolicyAutoDateAndTimeZone>;
  /** Whether auto time is required, which prevents the user from manually setting the date and time. If autoDateAndTimeZone is set, this field is ignored. */
  autoTimeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether applications other than the ones configured in applications are blocked from being installed. When set, applications that were installed under a previous policy but no longer appear in the policy are automatically uninstalled. */
  blockApplicationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether configuring bluetooth is disabled. */
  bluetoothConfigDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether bluetooth contact sharing is disabled. */
  bluetoothContactSharingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether bluetooth is disabled. Prefer this setting over bluetooth_config_disabled because bluetooth_config_disabled can be bypassed by the user. */
  bluetoothDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Controls the use of the camera and whether the user has access to the camera access toggle. */
  cameraAccess?: InputMaybe<PolicyCameraAccess>;
  /** If camera_access is set to any value other than CAMERA_ACCESS_UNSPECIFIED, this has no effect. Otherwise this field controls whether cameras are disabled: If true, all cameras are disabled, otherwise they are available. For fully managed devices this field applies for all apps on the device. For work profiles, this field applies only to apps in the work profile, and the camera access of apps outside the work profile is unaffected. */
  cameraDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether configuring cell broadcast is disabled. */
  cellBroadcastsConfigDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Rules for determining apps' access to private keys. See ChoosePrivateKeyRule for details. */
  choosePrivateKeyRules?: InputMaybe<Array<ChoosePrivateKeyRuleInputSchema>>;
  /** Rules declaring which mitigating actions to take when a device is not compliant with its policy. When the conditions for multiple rules are satisfied, all of the mitigating actions for the rules are taken. There is a maximum limit of 100 rules. Use policy enforcement rules instead. */
  complianceRules?: InputMaybe<Array<ComplianceRuleInputSchema>>;
  /** Whether creating windows besides app windows is disabled. */
  createWindowsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether configuring user credentials is disabled. */
  credentialsConfigDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Cross-profile policies applied on the device. */
  crossProfilePolicies?: InputMaybe<CrossProfilePoliciesInputSchema>;
  /** Whether roaming data services are disabled. */
  dataRoamingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user is allowed to enable debugging features. */
  debuggingFeaturesAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The default permission policy for runtime permission requests. */
  defaultPermissionPolicy?: InputMaybe<PolicyDefaultPermissionPolicy>;
  /** Covers controls for device connectivity such as Wi-Fi, USB data access, keyboard/mouse connections, and more. */
  deviceConnectivityManagement?: InputMaybe<DeviceConnectivityManagementInputSchema>;
  /** The device owner information to be shown on the lock screen. */
  deviceOwnerLockScreenInfo?: InputMaybe<UserFacingMessageInputSchema>;
  /** Whether encryption is enabled */
  encryptionPolicy?: InputMaybe<PolicyEncryptionPolicy>;
  /** Whether app verification is force-enabled. */
  ensureVerifyAppsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether factory resetting from settings is disabled. */
  factoryResetDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Email addresses of device administrators for factory reset protection. When the device is factory reset, it will require one of these admins to log in with the Google account email and password to unlock the device. If no admins are specified, the device won't provide factory reset protection. */
  frpAdminEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether the user is allowed to have fun. Controls whether the Easter egg game in Settings is disabled. */
  funDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether user installation of apps is disabled. */
  installAppsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** This field has no effect. */
  installUnknownSourcesAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, this disables the Lock Screen (https://source.android.com/docs/core/display/multi_display/lock-screen) for primary and/or secondary displays. */
  keyguardDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disabled keyguard customizations, such as widgets. */
  keyguardDisabledFeatures?: InputMaybe<Array<PolicyKeyguardDisabledFeatures>>;
  /** Whether the kiosk custom launcher is enabled. This replaces the home screen with a launcher that locks down the device to the apps installed via the applications setting. Apps appear on a single page in alphabetical order. Use kioskCustomization to further configure the kiosk device behavior. */
  kioskCustomLauncherEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Settings controlling the behavior of a device in kiosk mode. To enable kiosk mode, set kioskCustomLauncherEnabled to true or specify an app in the policy with installType KIOSK. */
  kioskCustomization?: InputMaybe<KioskCustomizationInputSchema>;
  /** The degree of location detection enabled. */
  locationMode?: InputMaybe<PolicyLocationMode>;
  /** A message displayed to the user in the device administators settings screen. */
  longSupportMessage?: InputMaybe<UserFacingMessageInputSchema>;
  /** Maximum time in milliseconds for user activity until the device locks. A value of 0 means there is no restriction. */
  maximumTimeToLock?: InputMaybe<Scalars['String']['input']>;
  /** Controls the use of the microphone and whether the user has access to the microphone access toggle. This applies only on fully managed devices. */
  microphoneAccess?: InputMaybe<PolicyMicrophoneAccess>;
  /** The minimum allowed Android API level. */
  minimumApiLevel?: InputMaybe<Scalars['Int']['input']>;
  /** Whether configuring mobile networks is disabled. */
  mobileNetworksConfigDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether adding or removing accounts is disabled. */
  modifyAccountsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user mounting physical external media is disabled. */
  mountPhysicalMediaDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the policy in the form enterprises/{enterpriseId}/policies/{policyId}. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Whether the network escape hatch is enabled. If a network connection can't be made at boot time, the escape hatch prompts the user to temporarily connect to a network in order to refresh the device policy. After applying policy, the temporary network will be forgotten and the device will continue booting. This prevents being unable to connect to a network if there is no suitable network in the last policy and the device boots into an app in lock task mode, or the user is otherwise unable to reach device settings.Note: Setting wifiConfigDisabled to true will override this setting under specific circumstances. Please see wifiConfigDisabled for further details. */
  networkEscapeHatchEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether resetting network settings is disabled. */
  networkResetDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** This feature is not generally available. */
  oncCertificateProviders?: InputMaybe<Array<OncCertificateProviderInputSchema>>;
  /** Network configuration for the device. See configure networks for more information. */
  openNetworkConfiguration?: InputMaybe<Scalars['JSON']['input']>;
  /** Whether using NFC to beam data from apps is disabled. */
  outgoingBeamDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether outgoing calls are disabled. */
  outgoingCallsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Password requirement policies. Different policies can be set for work profile or fully managed devices by setting the password_scope field in the policy. */
  passwordPolicies?: InputMaybe<Array<PasswordRequirementsInputSchema>>;
  /** Password requirements. The field password_requirements.require_password_unlock must not be set. DEPRECATED - Use passwordPolicies.Note:Complexity-based values of PasswordQuality, that is, COMPLEXITY_LOW, COMPLEXITY_MEDIUM, and COMPLEXITY_HIGH, cannot be used here. unified_lock_settings cannot be used here. */
  passwordRequirements?: InputMaybe<PasswordRequirementsInputSchema>;
  /** Explicit permission or group grants or denials for all apps. These values override the default_permission_policy. */
  permissionGrants?: InputMaybe<Array<PermissionGrantInputSchema>>;
  /** Specifies permitted accessibility services. If the field is not set, any accessibility service can be used. If the field is set, only the accessibility services in this list and the system's built-in accessibility service can be used. In particular, if the field is set to empty, only the system's built-in accessibility servicess can be used. This can be set on fully managed devices and on work profiles. When applied to a work profile, this affects both the personal profile and the work profile. */
  permittedAccessibilityServices?: InputMaybe<PackageNameListInputSchema>;
  /** If present, only the input methods provided by packages in this list are permitted. If this field is present, but the list is empty, then only system input methods are permitted. */
  permittedInputMethods?: InputMaybe<PackageNameListInputSchema>;
  /** Default intent handler activities. */
  persistentPreferredActivities?: InputMaybe<Array<PersistentPreferredActivityInputSchema>>;
  /** Policies managing personal usage on a company-owned device. */
  personalUsagePolicies?: InputMaybe<PersonalUsagePoliciesInputSchema>;
  /** This mode controls which apps are available to the user in the Play Store and the behavior on the device when apps are removed from the policy. */
  playStoreMode?: InputMaybe<PolicyPlayStoreMode>;
  /** Rules that define the behavior when a particular policy can not be applied on device */
  policyEnforcementRules?: InputMaybe<Array<PolicyEnforcementRuleInputSchema>>;
  /** Controls whether preferential network service is enabled on the work profile. For example, an organization may have an agreement with a carrier that all of the work data from its employees' devices will be sent via a network service dedicated for enterprise use. An example of a supported preferential network service is the enterprise slice on 5G networks. This has no effect on fully managed devices. */
  preferentialNetworkService?: InputMaybe<PolicyPreferentialNetworkService>;
  /** Allows showing UI on a device for a user to choose a private key alias if there are no matching rules in ChoosePrivateKeyRules. For devices below Android P, setting this may leave enterprise keys vulnerable. */
  privateKeySelectionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The network-independent global HTTP proxy. Typically proxies should be configured per-network in open_network_configuration. However for unusual configurations like general internal filtering a global HTTP proxy may be useful. If the proxy is not accessible, network access may break. The global proxy is only a recommendation and some apps may ignore it. */
  recommendedGlobalProxy?: InputMaybe<ProxyInfoInputSchema>;
  /** Whether removing other users is disabled. */
  removeUserDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether rebooting the device into safe boot is disabled. */
  safeBootDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether screen capture is disabled. */
  screenCaptureDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether changing the user icon is disabled. */
  setUserIconDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether changing the wallpaper is disabled. */
  setWallpaperDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Action to take during the setup process. At most one action may be specified. */
  setupActions?: InputMaybe<Array<SetupActionInputSchema>>;
  /** Whether location sharing is disabled. share_location_disabled is supported for both fully managed devices and personally owned work profiles. */
  shareLocationDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** A message displayed to the user in the settings screen wherever functionality has been disabled by the admin. If the message is longer than 200 characters it may be truncated. */
  shortSupportMessage?: InputMaybe<UserFacingMessageInputSchema>;
  /** Flag to skip hints on the first use. Enterprise admin can enable the system recommendation for apps to skip their user tutorial and other introductory hints on first start-up. */
  skipFirstUseHintsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether sending and receiving SMS messages is disabled. */
  smsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the status bar is disabled. This disables notifications, quick settings, and other screen overlays that allow escape from full-screen mode. DEPRECATED. To disable the status bar on a kiosk device, use InstallType KIOSK or kioskCustomLauncherEnabled. */
  statusBarDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Status reporting settings */
  statusReportingSettings?: InputMaybe<StatusReportingSettingsInputSchema>;
  /** The battery plugged in modes for which the device stays on. When using this setting, it is recommended to clear maximum_time_to_lock so that the device doesn't lock itself while it stays on. */
  stayOnPluggedModes?: InputMaybe<Array<PolicyStayOnPluggedModes>>;
  /** The system update policy, which controls how OS updates are applied. If the update type is WINDOWED, the update window will automatically apply to Play app updates as well. */
  systemUpdate?: InputMaybe<SystemUpdateInputSchema>;
  /** Whether configuring tethering and portable hotspots is disabled. */
  tetheringConfigDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether user uninstallation of applications is disabled. This prevents apps from being uninstalled, even those removed using applications */
  uninstallAppsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If microphone_access is set to any value other than MICROPHONE_ACCESS_UNSPECIFIED, this has no effect. Otherwise this field controls whether microphones are disabled: If true, all microphones are disabled, otherwise they are available. This is available only on fully managed devices. */
  unmuteMicrophoneDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Configuration of device activity logging. */
  usageLog?: InputMaybe<UsageLogInputSchema>;
  /** Whether transferring files over USB is disabled. This is supported only on company-owned devices. */
  usbFileTransferDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether USB storage is enabled. Deprecated. */
  usbMassStorageEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The version of the policy. This is a read-only field. The version is incremented each time the policy is updated. */
  version?: InputMaybe<Scalars['String']['input']>;
  /** Whether configuring VPN is disabled. */
  vpnConfigDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether configuring Wi-Fi networks is disabled. Supported on fully managed devices and work profiles on company-owned devices. For fully managed devices, setting this to true removes all configured networks and retains only the networks configured using openNetworkConfiguration. For work profiles on company-owned devices, existing configured networks are not affected and the user is not allowed to add, remove, or modify Wi-Fi networks. Note: If a network connection can't be made at boot time and configuring Wi-Fi is disabled then network escape hatch will be shown in order to refresh the device policy (see networkEscapeHatchEnabled). */
  wifiConfigDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** DEPRECATED - Use wifi_config_disabled. */
  wifiConfigsLockdownEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BasePolicyQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A policy resource represents a group of settings that govern the behavior of a managed device and the apps installed on it. */
export type BasePolicySchema = {
  __typename?: 'BasePolicySchema';
  /** Account types that can't be managed by the user. */
  accountTypesWithManagementDisabled?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether adding new users and profiles is disabled. */
  addUserDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether adjusting the master volume is disabled. Also mutes the device. */
  adjustVolumeDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Security policies set to secure values by default. To maintain the security posture of a device, we don't recommend overriding any of the default values. */
  advancedSecurityOverrides?: Maybe<AdvancedSecurityOverridesSchema>;
  /** Configuration for an always-on VPN connection. Use with vpn_config_disabled to prevent modification of this setting. */
  alwaysOnVpnPackage?: Maybe<AlwaysOnVpnPackageSchema>;
  /** The app tracks for Android Device Policy the device can access. The device receives the latest version among all accessible tracks. If no tracks are specified, then the device only uses the production track. */
  androidDevicePolicyTracks?: Maybe<Array<PolicyAndroidDevicePolicyTracks>>;
  /** Recommended alternative: autoUpdateMode which is set per app, provides greater flexibility around update frequency.When autoUpdateMode is set to AUTO_UPDATE_POSTPONED or AUTO_UPDATE_HIGH_PRIORITY, this field has no effect.The app auto update policy, which controls when automatic app updates can be applied. */
  appAutoUpdatePolicy?: Maybe<PolicyAppAutoUpdatePolicy>;
  /** Policy applied to apps. */
  applications?: Maybe<Array<ApplicationPolicySchema>>;
  /** Whether auto date, time, and time zone are enabled on a company-owned device. If this is set, then autoTimeRequired is ignored. */
  autoDateAndTimeZone?: Maybe<PolicyAutoDateAndTimeZone>;
  /** Whether auto time is required, which prevents the user from manually setting the date and time. If autoDateAndTimeZone is set, this field is ignored. */
  autoTimeRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Whether applications other than the ones configured in applications are blocked from being installed. When set, applications that were installed under a previous policy but no longer appear in the policy are automatically uninstalled. */
  blockApplicationsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether configuring bluetooth is disabled. */
  bluetoothConfigDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether bluetooth contact sharing is disabled. */
  bluetoothContactSharingDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether bluetooth is disabled. Prefer this setting over bluetooth_config_disabled because bluetooth_config_disabled can be bypassed by the user. */
  bluetoothDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the use of the camera and whether the user has access to the camera access toggle. */
  cameraAccess?: Maybe<PolicyCameraAccess>;
  /** If camera_access is set to any value other than CAMERA_ACCESS_UNSPECIFIED, this has no effect. Otherwise this field controls whether cameras are disabled: If true, all cameras are disabled, otherwise they are available. For fully managed devices this field applies for all apps on the device. For work profiles, this field applies only to apps in the work profile, and the camera access of apps outside the work profile is unaffected. */
  cameraDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether configuring cell broadcast is disabled. */
  cellBroadcastsConfigDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Rules for determining apps' access to private keys. See ChoosePrivateKeyRule for details. */
  choosePrivateKeyRules?: Maybe<Array<ChoosePrivateKeyRuleSchema>>;
  /** Rules declaring which mitigating actions to take when a device is not compliant with its policy. When the conditions for multiple rules are satisfied, all of the mitigating actions for the rules are taken. There is a maximum limit of 100 rules. Use policy enforcement rules instead. */
  complianceRules?: Maybe<Array<ComplianceRuleSchema>>;
  /** Whether creating windows besides app windows is disabled. */
  createWindowsDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether configuring user credentials is disabled. */
  credentialsConfigDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Cross-profile policies applied on the device. */
  crossProfilePolicies?: Maybe<CrossProfilePoliciesSchema>;
  /** Whether roaming data services are disabled. */
  dataRoamingDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user is allowed to enable debugging features. */
  debuggingFeaturesAllowed?: Maybe<Scalars['Boolean']['output']>;
  /** The default permission policy for runtime permission requests. */
  defaultPermissionPolicy?: Maybe<PolicyDefaultPermissionPolicy>;
  /** Covers controls for device connectivity such as Wi-Fi, USB data access, keyboard/mouse connections, and more. */
  deviceConnectivityManagement?: Maybe<DeviceConnectivityManagementSchema>;
  /** The device owner information to be shown on the lock screen. */
  deviceOwnerLockScreenInfo?: Maybe<UserFacingMessageSchema>;
  /** Whether encryption is enabled */
  encryptionPolicy?: Maybe<PolicyEncryptionPolicy>;
  /** Whether app verification is force-enabled. */
  ensureVerifyAppsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether factory resetting from settings is disabled. */
  factoryResetDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Email addresses of device administrators for factory reset protection. When the device is factory reset, it will require one of these admins to log in with the Google account email and password to unlock the device. If no admins are specified, the device won't provide factory reset protection. */
  frpAdminEmails?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the user is allowed to have fun. Controls whether the Easter egg game in Settings is disabled. */
  funDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether user installation of apps is disabled. */
  installAppsDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** This field has no effect. */
  installUnknownSourcesAllowed?: Maybe<Scalars['Boolean']['output']>;
  /** If true, this disables the Lock Screen (https://source.android.com/docs/core/display/multi_display/lock-screen) for primary and/or secondary displays. */
  keyguardDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Disabled keyguard customizations, such as widgets. */
  keyguardDisabledFeatures?: Maybe<Array<PolicyKeyguardDisabledFeatures>>;
  /** Whether the kiosk custom launcher is enabled. This replaces the home screen with a launcher that locks down the device to the apps installed via the applications setting. Apps appear on a single page in alphabetical order. Use kioskCustomization to further configure the kiosk device behavior. */
  kioskCustomLauncherEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Settings controlling the behavior of a device in kiosk mode. To enable kiosk mode, set kioskCustomLauncherEnabled to true or specify an app in the policy with installType KIOSK. */
  kioskCustomization?: Maybe<KioskCustomizationSchema>;
  /** The degree of location detection enabled. */
  locationMode?: Maybe<PolicyLocationMode>;
  /** A message displayed to the user in the device administators settings screen. */
  longSupportMessage?: Maybe<UserFacingMessageSchema>;
  /** Maximum time in milliseconds for user activity until the device locks. A value of 0 means there is no restriction. */
  maximumTimeToLock?: Maybe<Scalars['String']['output']>;
  /** Controls the use of the microphone and whether the user has access to the microphone access toggle. This applies only on fully managed devices. */
  microphoneAccess?: Maybe<PolicyMicrophoneAccess>;
  /** The minimum allowed Android API level. */
  minimumApiLevel?: Maybe<Scalars['Int']['output']>;
  /** Whether configuring mobile networks is disabled. */
  mobileNetworksConfigDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether adding or removing accounts is disabled. */
  modifyAccountsDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user mounting physical external media is disabled. */
  mountPhysicalMediaDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the policy in the form enterprises/{enterpriseId}/policies/{policyId}. */
  name?: Maybe<Scalars['String']['output']>;
  /** Whether the network escape hatch is enabled. If a network connection can't be made at boot time, the escape hatch prompts the user to temporarily connect to a network in order to refresh the device policy. After applying policy, the temporary network will be forgotten and the device will continue booting. This prevents being unable to connect to a network if there is no suitable network in the last policy and the device boots into an app in lock task mode, or the user is otherwise unable to reach device settings.Note: Setting wifiConfigDisabled to true will override this setting under specific circumstances. Please see wifiConfigDisabled for further details. */
  networkEscapeHatchEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether resetting network settings is disabled. */
  networkResetDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** This feature is not generally available. */
  oncCertificateProviders?: Maybe<Array<OncCertificateProviderSchema>>;
  /** Network configuration for the device. See configure networks for more information. */
  openNetworkConfiguration?: Maybe<Scalars['JSON']['output']>;
  /** Whether using NFC to beam data from apps is disabled. */
  outgoingBeamDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether outgoing calls are disabled. */
  outgoingCallsDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Password requirement policies. Different policies can be set for work profile or fully managed devices by setting the password_scope field in the policy. */
  passwordPolicies?: Maybe<Array<PasswordRequirementsSchema>>;
  /** Password requirements. The field password_requirements.require_password_unlock must not be set. DEPRECATED - Use passwordPolicies.Note:Complexity-based values of PasswordQuality, that is, COMPLEXITY_LOW, COMPLEXITY_MEDIUM, and COMPLEXITY_HIGH, cannot be used here. unified_lock_settings cannot be used here. */
  passwordRequirements?: Maybe<PasswordRequirementsSchema>;
  /** Explicit permission or group grants or denials for all apps. These values override the default_permission_policy. */
  permissionGrants?: Maybe<Array<PermissionGrantSchema>>;
  /** Specifies permitted accessibility services. If the field is not set, any accessibility service can be used. If the field is set, only the accessibility services in this list and the system's built-in accessibility service can be used. In particular, if the field is set to empty, only the system's built-in accessibility servicess can be used. This can be set on fully managed devices and on work profiles. When applied to a work profile, this affects both the personal profile and the work profile. */
  permittedAccessibilityServices?: Maybe<PackageNameListSchema>;
  /** If present, only the input methods provided by packages in this list are permitted. If this field is present, but the list is empty, then only system input methods are permitted. */
  permittedInputMethods?: Maybe<PackageNameListSchema>;
  /** Default intent handler activities. */
  persistentPreferredActivities?: Maybe<Array<PersistentPreferredActivitySchema>>;
  /** Policies managing personal usage on a company-owned device. */
  personalUsagePolicies?: Maybe<PersonalUsagePoliciesSchema>;
  /** This mode controls which apps are available to the user in the Play Store and the behavior on the device when apps are removed from the policy. */
  playStoreMode?: Maybe<PolicyPlayStoreMode>;
  /** Rules that define the behavior when a particular policy can not be applied on device */
  policyEnforcementRules?: Maybe<Array<PolicyEnforcementRuleSchema>>;
  /** Controls whether preferential network service is enabled on the work profile. For example, an organization may have an agreement with a carrier that all of the work data from its employees' devices will be sent via a network service dedicated for enterprise use. An example of a supported preferential network service is the enterprise slice on 5G networks. This has no effect on fully managed devices. */
  preferentialNetworkService?: Maybe<PolicyPreferentialNetworkService>;
  /** Allows showing UI on a device for a user to choose a private key alias if there are no matching rules in ChoosePrivateKeyRules. For devices below Android P, setting this may leave enterprise keys vulnerable. */
  privateKeySelectionEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The network-independent global HTTP proxy. Typically proxies should be configured per-network in open_network_configuration. However for unusual configurations like general internal filtering a global HTTP proxy may be useful. If the proxy is not accessible, network access may break. The global proxy is only a recommendation and some apps may ignore it. */
  recommendedGlobalProxy?: Maybe<ProxyInfoSchema>;
  /** Whether removing other users is disabled. */
  removeUserDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether rebooting the device into safe boot is disabled. */
  safeBootDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether screen capture is disabled. */
  screenCaptureDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether changing the user icon is disabled. */
  setUserIconDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether changing the wallpaper is disabled. */
  setWallpaperDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Action to take during the setup process. At most one action may be specified. */
  setupActions?: Maybe<Array<SetupActionSchema>>;
  /** Whether location sharing is disabled. share_location_disabled is supported for both fully managed devices and personally owned work profiles. */
  shareLocationDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** A message displayed to the user in the settings screen wherever functionality has been disabled by the admin. If the message is longer than 200 characters it may be truncated. */
  shortSupportMessage?: Maybe<UserFacingMessageSchema>;
  /** Flag to skip hints on the first use. Enterprise admin can enable the system recommendation for apps to skip their user tutorial and other introductory hints on first start-up. */
  skipFirstUseHintsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether sending and receiving SMS messages is disabled. */
  smsDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the status bar is disabled. This disables notifications, quick settings, and other screen overlays that allow escape from full-screen mode. DEPRECATED. To disable the status bar on a kiosk device, use InstallType KIOSK or kioskCustomLauncherEnabled. */
  statusBarDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Status reporting settings */
  statusReportingSettings?: Maybe<StatusReportingSettingsSchema>;
  /** The battery plugged in modes for which the device stays on. When using this setting, it is recommended to clear maximum_time_to_lock so that the device doesn't lock itself while it stays on. */
  stayOnPluggedModes?: Maybe<Array<PolicyStayOnPluggedModes>>;
  /** The system update policy, which controls how OS updates are applied. If the update type is WINDOWED, the update window will automatically apply to Play app updates as well. */
  systemUpdate?: Maybe<SystemUpdateSchema>;
  /** Whether configuring tethering and portable hotspots is disabled. */
  tetheringConfigDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether user uninstallation of applications is disabled. This prevents apps from being uninstalled, even those removed using applications */
  uninstallAppsDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** If microphone_access is set to any value other than MICROPHONE_ACCESS_UNSPECIFIED, this has no effect. Otherwise this field controls whether microphones are disabled: If true, all microphones are disabled, otherwise they are available. This is available only on fully managed devices. */
  unmuteMicrophoneDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Configuration of device activity logging. */
  usageLog?: Maybe<UsageLogSchema>;
  /** Whether transferring files over USB is disabled. This is supported only on company-owned devices. */
  usbFileTransferDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether USB storage is enabled. Deprecated. */
  usbMassStorageEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The version of the policy. This is a read-only field. The version is incremented each time the policy is updated. */
  version?: Maybe<Scalars['String']['output']>;
  /** Whether configuring VPN is disabled. */
  vpnConfigDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether configuring Wi-Fi networks is disabled. Supported on fully managed devices and work profiles on company-owned devices. For fully managed devices, setting this to true removes all configured networks and retains only the networks configured using openNetworkConfiguration. For work profiles on company-owned devices, existing configured networks are not affected and the user is not allowed to add, remove, or modify Wi-Fi networks. Note: If a network connection can't be made at boot time and configuring Wi-Fi is disabled then network escape hatch will be shown in order to refresh the device policy (see networkEscapeHatchEnabled). */
  wifiConfigDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** DEPRECATED - Use wifi_config_disabled. */
  wifiConfigsLockdownEnabled?: Maybe<Scalars['Boolean']['output']>;
};

/** A web token used to access the managed Google Play iframe. */
export type BaseWebTokenInputSchema = {
  /** The features to enable. Use this if you want to control exactly which feature(s) will be activated; leave empty to allow all features.Restrictions / things to note: - If no features are listed here, all features are enabled — this is the default behavior where you give access to all features to your admins. - This must not contain any FEATURE_UNSPECIFIED values. - Repeated values are ignored  */
  enabledFeatures?: InputMaybe<Array<WebTokenEnabledFeatures>>;
  /** The name of the web token, which is generated by the server during creation in the form enterprises/{enterpriseId}/webTokens/{webTokenId}. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The URL of the parent frame hosting the iframe with the embedded UI. To prevent XSS, the iframe may not be hosted at other URLs. The URL must use the https scheme. */
  parentFrameUrl?: InputMaybe<Scalars['String']['input']>;
  /** Permissions available to an admin in the embedded UI. An admin must have all of these permissions in order to view the UI. This field is deprecated. */
  permissions?: InputMaybe<Array<WebTokenPermissions>>;
  /** The token value which is used in the hosting page to generate the iframe with the embedded UI. This is a read-only field generated by the server. */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type BaseWebTokenQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A web token used to access the managed Google Play iframe. */
export type BaseWebTokenSchema = {
  __typename?: 'BaseWebTokenSchema';
  /** The features to enable. Use this if you want to control exactly which feature(s) will be activated; leave empty to allow all features.Restrictions / things to note: - If no features are listed here, all features are enabled — this is the default behavior where you give access to all features to your admins. - This must not contain any FEATURE_UNSPECIFIED values. - Repeated values are ignored  */
  enabledFeatures?: Maybe<Array<WebTokenEnabledFeatures>>;
  /** The name of the web token, which is generated by the server during creation in the form enterprises/{enterpriseId}/webTokens/{webTokenId}. */
  name?: Maybe<Scalars['String']['output']>;
  /** The URL of the parent frame hosting the iframe with the embedded UI. To prevent XSS, the iframe may not be hosted at other URLs. The URL must use the https scheme. */
  parentFrameUrl?: Maybe<Scalars['String']['output']>;
  /** Permissions available to an admin in the embedded UI. An admin must have all of these permissions in order to view the UI. This field is deprecated. */
  permissions?: Maybe<Array<WebTokenPermissions>>;
  /** The token value which is used in the hosting page to generate the iframe with the embedded UI. This is a read-only field generated by the server. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Batched event logs of events from the device. */
export type BatchUsageLogEventsInputSchema = {
  /** The name of the device in the form ‘enterprises/{enterpriseId}/devices/{deviceId}’ */
  device?: InputMaybe<Scalars['String']['input']>;
  /** The device timestamp when the batch of events were collected from the device. */
  retrievalTime?: InputMaybe<Scalars['String']['input']>;
  /** The list of UsageLogEvent that were reported by the device, sorted chronologically by the event time. */
  usageLogEvents?: InputMaybe<Array<UsageLogEventInputSchema>>;
  /** The resource name of the user that owns this device in the form ‘enterprises/{enterpriseId}/users/{userId}’. */
  user?: InputMaybe<Scalars['String']['input']>;
};

export type BatchUsageLogEventsQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Batched event logs of events from the device. */
export type BatchUsageLogEventsSchema = {
  __typename?: 'BatchUsageLogEventsSchema';
  /** The name of the device in the form ‘enterprises/{enterpriseId}/devices/{deviceId}’ */
  device?: Maybe<Scalars['String']['output']>;
  /** The device timestamp when the batch of events were collected from the device. */
  retrievalTime?: Maybe<Scalars['String']['output']>;
  /** The list of UsageLogEvent that were reported by the device, sorted chronologically by the event time. */
  usageLogEvents?: Maybe<Array<UsageLogEventSchema>>;
  /** The resource name of the user that owns this device in the form ‘enterprises/{enterpriseId}/users/{userId}’. */
  user?: Maybe<Scalars['String']['output']>;
};

export enum BlockActionBlockScope {
  /** Block action is applied to the entire device, including apps in the personal profile. */
  BlockScopeDevice = 'BLOCK_SCOPE_DEVICE',
  /** Unspecified. Defaults to BLOCK_SCOPE_WORK_PROFILE. */
  BlockScopeUnspecified = 'BLOCK_SCOPE_UNSPECIFIED',
  /** Block action is only applied to apps in the work profile. Apps in the personal profile are unaffected. */
  BlockScopeWorkProfile = 'BLOCK_SCOPE_WORK_PROFILE'
}

/** An action to block access to apps and data on a fully managed device or in a work profile. This action also triggers a device or work profile to displays a user-facing notification with information (where possible) on how to correct the compliance issue. Note: wipeAction must also be specified. */
export type BlockActionInputSchema = {
  /** Number of days the policy is non-compliant before the device or work profile is blocked. To block access immediately, set to 0. blockAfterDays must be less than wipeAfterDays. */
  blockAfterDays?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies the scope of this BlockAction. Only applicable to devices that are company-owned. */
  blockScope?: InputMaybe<BlockActionBlockScope>;
};

export type BlockActionQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** An action to block access to apps and data on a fully managed device or in a work profile. This action also triggers a device or work profile to displays a user-facing notification with information (where possible) on how to correct the compliance issue. Note: wipeAction must also be specified. */
export type BlockActionSchema = {
  __typename?: 'BlockActionSchema';
  /** Number of days the policy is non-compliant before the device or work profile is blocked. To block access immediately, set to 0. blockAfterDays must be less than wipeAfterDays. */
  blockAfterDays?: Maybe<Scalars['Int']['output']>;
  /** Specifies the scope of this BlockAction. Only applicable to devices that are company-owned. */
  blockScope?: Maybe<BlockActionBlockScope>;
};

/** A new root certificate was installed into the system's trusted credential storage. This is available device-wide on fully managed devices and within the work profile on organization-owned devices with a work profile. */
export type CertAuthorityInstalledEventInputSchema = {
  /** Subject of the certificate. */
  certificate?: InputMaybe<Scalars['String']['input']>;
  /** Whether the installation event succeeded. */
  success?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user in which the certificate install event happened. Only available for devices running Android 11 and above. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type CertAuthorityInstalledEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A new root certificate was installed into the system's trusted credential storage. This is available device-wide on fully managed devices and within the work profile on organization-owned devices with a work profile. */
export type CertAuthorityInstalledEventSchema = {
  __typename?: 'CertAuthorityInstalledEventSchema';
  /** Subject of the certificate. */
  certificate?: Maybe<Scalars['String']['output']>;
  /** Whether the installation event succeeded. */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** The user in which the certificate install event happened. Only available for devices running Android 11 and above. */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** A root certificate was removed from the system's trusted credential storage. This is available device-wide on fully managed devices and within the work profile on organization-owned devices with a work profile. */
export type CertAuthorityRemovedEventInputSchema = {
  /** Subject of the certificate. */
  certificate?: InputMaybe<Scalars['String']['input']>;
  /** Whether the removal succeeded. */
  success?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user in which the certificate removal event occurred. Only available for devices running Android 11 and above. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type CertAuthorityRemovedEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A root certificate was removed from the system's trusted credential storage. This is available device-wide on fully managed devices and within the work profile on organization-owned devices with a work profile. */
export type CertAuthorityRemovedEventSchema = {
  __typename?: 'CertAuthorityRemovedEventSchema';
  /** Subject of the certificate. */
  certificate?: Maybe<Scalars['String']['output']>;
  /** Whether the removal succeeded. */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** The user in which the certificate removal event occurred. Only available for devices running Android 11 and above. */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** An X.509v3 certificate failed to validate, currently this validation is performed on the Wi-FI access point and failure may be due to a mismatch upon server certificate validation. However it may in the future include other validation events of an X.509v3 certificate. */
export type CertValidationFailureEventInputSchema = {
  /** The reason why certification validation failed. */
  failureReason?: InputMaybe<Scalars['String']['input']>;
};

export type CertValidationFailureEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** An X.509v3 certificate failed to validate, currently this validation is performed on the Wi-FI access point and failure may be due to a mismatch upon server certificate validation. However it may in the future include other validation events of an X.509v3 certificate. */
export type CertValidationFailureEventSchema = {
  __typename?: 'CertValidationFailureEventSchema';
  /** The reason why certification validation failed. */
  failureReason?: Maybe<Scalars['String']['output']>;
};

/** Controls apps' access to private keys. The rule determines which private key, if any, Android Device Policy grants to the specified app. Access is granted either when the app calls KeyChain.choosePrivateKeyAlias (https://developer.android.com/reference/android/security/KeyChain#choosePrivateKeyAlias%28android.app.Activity,%20android.security.KeyChainAliasCallback,%20java.lang.String[],%20java.security.Principal[],%20java.lang.String,%20int,%20java.lang.String%29) (or any overloads) to request a private key alias for a given URL, or for rules that are not URL-specific (that is, if urlPattern is not set, or set to the empty string or .*) on Android 11 and above, directly so that the app can call KeyChain.getPrivateKey (https://developer.android.com/reference/android/security/KeyChain#getPrivateKey%28android.content.Context,%20java.lang.String%29), without first having to call KeyChain.choosePrivateKeyAlias.When an app calls KeyChain.choosePrivateKeyAlias if more than one choosePrivateKeyRules matches, the last matching rule defines which key alias to return. */
export type ChoosePrivateKeyRuleInputSchema = {
  /** The package names to which this rule applies. The hash of the signing certificate for each app is verified against the hash provided by Play. If no package names are specified, then the alias is provided to all apps that call KeyChain.choosePrivateKeyAlias (https://developer.android.com/reference/android/security/KeyChain#choosePrivateKeyAlias%28android.app.Activity,%20android.security.KeyChainAliasCallback,%20java.lang.String[],%20java.security.Principal[],%20java.lang.String,%20int,%20java.lang.String%29) or any overloads (but not without calling KeyChain.choosePrivateKeyAlias, even on Android 11 and above). Any app with the same Android UID as a package specified here will have access when they call KeyChain.choosePrivateKeyAlias. */
  packageNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The alias of the private key to be used. */
  privateKeyAlias?: InputMaybe<Scalars['String']['input']>;
  /** The URL pattern to match against the URL of the request. If not set or empty, it matches all URLs. This uses the regular expression syntax of java.util.regex.Pattern. */
  urlPattern?: InputMaybe<Scalars['String']['input']>;
};

export type ChoosePrivateKeyRuleQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Controls apps' access to private keys. The rule determines which private key, if any, Android Device Policy grants to the specified app. Access is granted either when the app calls KeyChain.choosePrivateKeyAlias (https://developer.android.com/reference/android/security/KeyChain#choosePrivateKeyAlias%28android.app.Activity,%20android.security.KeyChainAliasCallback,%20java.lang.String[],%20java.security.Principal[],%20java.lang.String,%20int,%20java.lang.String%29) (or any overloads) to request a private key alias for a given URL, or for rules that are not URL-specific (that is, if urlPattern is not set, or set to the empty string or .*) on Android 11 and above, directly so that the app can call KeyChain.getPrivateKey (https://developer.android.com/reference/android/security/KeyChain#getPrivateKey%28android.content.Context,%20java.lang.String%29), without first having to call KeyChain.choosePrivateKeyAlias.When an app calls KeyChain.choosePrivateKeyAlias if more than one choosePrivateKeyRules matches, the last matching rule defines which key alias to return. */
export type ChoosePrivateKeyRuleSchema = {
  __typename?: 'ChoosePrivateKeyRuleSchema';
  /** The package names to which this rule applies. The hash of the signing certificate for each app is verified against the hash provided by Play. If no package names are specified, then the alias is provided to all apps that call KeyChain.choosePrivateKeyAlias (https://developer.android.com/reference/android/security/KeyChain#choosePrivateKeyAlias%28android.app.Activity,%20android.security.KeyChainAliasCallback,%20java.lang.String[],%20java.security.Principal[],%20java.lang.String,%20int,%20java.lang.String%29) or any overloads (but not without calling KeyChain.choosePrivateKeyAlias, even on Android 11 and above). Any app with the same Android UID as a package specified here will have access when they call KeyChain.choosePrivateKeyAlias. */
  packageNames?: Maybe<Array<Scalars['String']['output']>>;
  /** The alias of the private key to be used. */
  privateKeyAlias?: Maybe<Scalars['String']['output']>;
  /** The URL pattern to match against the URL of the request. If not set or empty, it matches all URLs. This uses the regular expression syntax of java.util.regex.Pattern. */
  urlPattern?: Maybe<Scalars['String']['output']>;
};

/** Parameters associated with the CLEAR_APP_DATA command to clear the data of specified apps from the device. */
export type ClearAppsDataParamsInputSchema = {
  /** The package names of the apps whose data will be cleared when the command is executed. */
  packageNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ClearAppsDataParamsQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Parameters associated with the CLEAR_APP_DATA command to clear the data of specified apps from the device. */
export type ClearAppsDataParamsSchema = {
  __typename?: 'ClearAppsDataParamsSchema';
  /** The package names of the apps whose data will be cleared when the command is executed. */
  packageNames?: Maybe<Array<Scalars['String']['output']>>;
};

/** Status of the CLEAR_APP_DATA command to clear the data of specified apps from the device. */
export type ClearAppsDataStatusInputSchema = {
  /** The per-app results, a mapping from package names to the respective clearing result. */
  results?: InputMaybe<Scalars['JSON']['input']>;
};

export type ClearAppsDataStatusQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Status of the CLEAR_APP_DATA command to clear the data of specified apps from the device. */
export type ClearAppsDataStatusSchema = {
  __typename?: 'ClearAppsDataStatusSchema';
  /** The per-app results, a mapping from package names to the respective clearing result. */
  results?: Maybe<Scalars['JSON']['output']>;
};

export enum CommandErrorCode {
  /** The API level of the device does not support this command. */
  ApiLevel = 'API_LEVEL',
  /** There was no error. */
  CommandErrorCodeUnspecified = 'COMMAND_ERROR_CODE_UNSPECIFIED',
  /** The command has an invalid parameter value. */
  InvalidValue = 'INVALID_VALUE',
  /** The management mode (profile owner, device owner, etc.) does not support the command. */
  ManagementMode = 'MANAGEMENT_MODE',
  /** An unknown error occurred. */
  Unknown = 'UNKNOWN',
  /** The device doesn't support the command. Updating Android Device Policy to the latest version may resolve the issue. */
  Unsupported = 'UNSUPPORTED'
}

/** A command. */
export type CommandInputSchema = {
  /** Parameters for the CLEAR_APP_DATA command to clear the data of specified apps from the device. See ClearAppsDataParams. If this is set, then it is suggested that type should not be set. In this case, the server automatically sets it to CLEAR_APP_DATA. It is also acceptable to explicitly set type to CLEAR_APP_DATA. */
  clearAppsDataParams?: InputMaybe<ClearAppsDataParamsInputSchema>;
  /** Output only. Status of the CLEAR_APP_DATA command to clear the data of specified apps from the device. See ClearAppsDataStatus. */
  clearAppsDataStatus?: InputMaybe<ClearAppsDataStatusInputSchema>;
  /** The timestamp at which the command was created. The timestamp is automatically generated by the server. */
  createTime?: InputMaybe<Scalars['String']['input']>;
  /** The duration for which the command is valid. The command will expire if not executed by the device during this time. The default duration if unspecified is ten minutes. There is no maximum duration. */
  duration?: InputMaybe<Scalars['String']['input']>;
  /** If the command failed, an error code explaining the failure. This is not set when the command is cancelled by the caller. */
  errorCode?: InputMaybe<CommandErrorCode>;
  /** For commands of type RESET_PASSWORD, optionally specifies the new password. */
  newPassword?: InputMaybe<Scalars['String']['input']>;
  /** For commands of type RESET_PASSWORD, optionally specifies flags. */
  resetPasswordFlags?: InputMaybe<Array<CommandResetPasswordFlags>>;
  /** The type of the command. */
  type?: InputMaybe<CommandType>;
  /** The resource name of the user that owns the device in the form enterprises/{enterpriseId}/users/{userId}. This is automatically generated by the server based on the device the command is sent to. */
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type CommandQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

export enum CommandResetPasswordFlags {
  /** Don't ask for user credentials on device boot. */
  DoNotAskCredentialsOnBoot = 'DO_NOT_ASK_CREDENTIALS_ON_BOOT',
  /** Lock the device after password reset. */
  LockNow = 'LOCK_NOW',
  /** Don't allow other admins to change the password again until the user has entered it. */
  RequireEntry = 'REQUIRE_ENTRY',
  /** This value is ignored. */
  ResetPasswordFlagUnspecified = 'RESET_PASSWORD_FLAG_UNSPECIFIED'
}

/** A command. */
export type CommandSchema = {
  __typename?: 'CommandSchema';
  /** Parameters for the CLEAR_APP_DATA command to clear the data of specified apps from the device. See ClearAppsDataParams. If this is set, then it is suggested that type should not be set. In this case, the server automatically sets it to CLEAR_APP_DATA. It is also acceptable to explicitly set type to CLEAR_APP_DATA. */
  clearAppsDataParams?: Maybe<ClearAppsDataParamsSchema>;
  /** Output only. Status of the CLEAR_APP_DATA command to clear the data of specified apps from the device. See ClearAppsDataStatus. */
  clearAppsDataStatus?: Maybe<ClearAppsDataStatusSchema>;
  /** The timestamp at which the command was created. The timestamp is automatically generated by the server. */
  createTime?: Maybe<Scalars['String']['output']>;
  /** The duration for which the command is valid. The command will expire if not executed by the device during this time. The default duration if unspecified is ten minutes. There is no maximum duration. */
  duration?: Maybe<Scalars['String']['output']>;
  /** If the command failed, an error code explaining the failure. This is not set when the command is cancelled by the caller. */
  errorCode?: Maybe<CommandErrorCode>;
  /** For commands of type RESET_PASSWORD, optionally specifies the new password. */
  newPassword?: Maybe<Scalars['String']['output']>;
  /** For commands of type RESET_PASSWORD, optionally specifies flags. */
  resetPasswordFlags?: Maybe<Array<CommandResetPasswordFlags>>;
  /** The type of the command. */
  type?: Maybe<CommandType>;
  /** The resource name of the user that owns the device in the form enterprises/{enterpriseId}/users/{userId}. This is automatically generated by the server based on the device the command is sent to. */
  userName?: Maybe<Scalars['String']['output']>;
};

export enum CommandType {
  /** Clears the application data of specified apps. This is supported on Android 9 and above. Note that an application can store data outside of its application data, for example in external storage or in a user dictionary. See also clear_apps_data_params. */
  ClearAppData = 'CLEAR_APP_DATA',
  /** This value is disallowed. */
  CommandTypeUnspecified = 'COMMAND_TYPE_UNSPECIFIED',
  /** Lock the device, as if the lock screen timeout had expired. */
  Lock = 'LOCK',
  /** Reboot the device. Only supported on fully managed devices running Android 7.0 (API level 24) or higher. */
  Reboot = 'REBOOT',
  /** Removes the work profile and all policies from a company-owned Android 8.0+ device, relinquishing the device for personal use. Apps and data associated with the personal profile(s) are preserved. The device will be deleted from the server after it acknowledges the command. */
  RelinquishOwnership = 'RELINQUISH_OWNERSHIP',
  /** Reset the user's password. */
  ResetPassword = 'RESET_PASSWORD'
}

export enum CommonCriteriaModeInfoCommonCriteriaModeStatus {
  /** Common Criteria Mode is currently disabled. */
  CommonCriteriaModeDisabled = 'COMMON_CRITERIA_MODE_DISABLED',
  /** Common Criteria Mode is currently enabled. */
  CommonCriteriaModeEnabled = 'COMMON_CRITERIA_MODE_ENABLED',
  /** Unknown status. */
  CommonCriteriaModeStatusUnknown = 'COMMON_CRITERIA_MODE_STATUS_UNKNOWN'
}

/** Information about Common Criteria Mode—security standards defined in the Common Criteria for Information Technology Security Evaluation (https://www.commoncriteriaportal.org/) (CC).This information is only available if statusReportingSettings.commonCriteriaModeEnabled is true in the device's policy. */
export type CommonCriteriaModeInfoInputSchema = {
  /** Whether Common Criteria Mode is enabled. */
  commonCriteriaModeStatus?: InputMaybe<CommonCriteriaModeInfoCommonCriteriaModeStatus>;
};

export type CommonCriteriaModeInfoQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Information about Common Criteria Mode—security standards defined in the Common Criteria for Information Technology Security Evaluation (https://www.commoncriteriaportal.org/) (CC).This information is only available if statusReportingSettings.commonCriteriaModeEnabled is true in the device's policy. */
export type CommonCriteriaModeInfoSchema = {
  __typename?: 'CommonCriteriaModeInfoSchema';
  /** Whether Common Criteria Mode is enabled. */
  commonCriteriaModeStatus?: Maybe<CommonCriteriaModeInfoCommonCriteriaModeStatus>;
};

/** A rule declaring which mitigating actions to take when a device is not compliant with its policy. For every rule, there is always an implicit mitigating action to set policy_compliant to false for the Device resource, and display a message on the device indicating that the device is not compliant with its policy. Other mitigating actions may optionally be taken as well, depending on the field values in the rule. */
export type ComplianceRuleInputSchema = {
  /** A condition which is satisfied if the Android Framework API level on the device doesn't meet a minimum requirement. */
  apiLevelCondition?: InputMaybe<ApiLevelConditionInputSchema>;
  /** If set to true, the rule includes a mitigating action to disable apps so that the device is effectively disabled, but app data is preserved. If the device is running an app in locked task mode, the app will be closed and a UI showing the reason for non-compliance will be displayed. */
  disableApps?: InputMaybe<Scalars['Boolean']['input']>;
  /** A condition which is satisfied if there exists any matching NonComplianceDetail for the device. */
  nonComplianceDetailCondition?: InputMaybe<NonComplianceDetailConditionInputSchema>;
  /** If set, the rule includes a mitigating action to disable apps specified in the list, but app data is preserved. */
  packageNamesToDisable?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ComplianceRuleQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A rule declaring which mitigating actions to take when a device is not compliant with its policy. For every rule, there is always an implicit mitigating action to set policy_compliant to false for the Device resource, and display a message on the device indicating that the device is not compliant with its policy. Other mitigating actions may optionally be taken as well, depending on the field values in the rule. */
export type ComplianceRuleSchema = {
  __typename?: 'ComplianceRuleSchema';
  /** A condition which is satisfied if the Android Framework API level on the device doesn't meet a minimum requirement. */
  apiLevelCondition?: Maybe<ApiLevelConditionSchema>;
  /** If set to true, the rule includes a mitigating action to disable apps so that the device is effectively disabled, but app data is preserved. If the device is running an app in locked task mode, the app will be closed and a UI showing the reason for non-compliance will be displayed. */
  disableApps?: Maybe<Scalars['Boolean']['output']>;
  /** A condition which is satisfied if there exists any matching NonComplianceDetail for the device. */
  nonComplianceDetailCondition?: Maybe<NonComplianceDetailConditionSchema>;
  /** If set, the rule includes a mitigating action to disable apps specified in the list, but app data is preserved. */
  packageNamesToDisable?: Maybe<Array<Scalars['String']['output']>>;
};

/** A TCP connect event was initiated through the standard network stack. */
export type ConnectEventInputSchema = {
  /** The destination IP address of the connect call. */
  destinationIpAddress?: InputMaybe<Scalars['String']['input']>;
  /** The destination port of the connect call. */
  destinationPort?: InputMaybe<Scalars['Int']['input']>;
  /** The package name of the UID that performed the connect call. */
  packageName?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A TCP connect event was initiated through the standard network stack. */
export type ConnectEventSchema = {
  __typename?: 'ConnectEventSchema';
  /** The destination IP address of the connect call. */
  destinationIpAddress?: Maybe<Scalars['String']['output']>;
  /** The destination port of the connect call. */
  destinationPort?: Maybe<Scalars['Int']['output']>;
  /** The package name of the UID that performed the connect call. */
  packageName?: Maybe<Scalars['String']['output']>;
};

/** Contact details for managed Google Play enterprises. */
export type ContactInfoInputSchema = {
  /** Email address for a point of contact, which will be used to send important announcements related to managed Google Play. */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  /** The email of the data protection officer. The email is validated but not verified. */
  dataProtectionOfficerEmail?: InputMaybe<Scalars['String']['input']>;
  /** The name of the data protection officer. */
  dataProtectionOfficerName?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the data protection officer The phone number is validated but not verified. */
  dataProtectionOfficerPhone?: InputMaybe<Scalars['String']['input']>;
  /** The email of the EU representative. The email is validated but not verified. */
  euRepresentativeEmail?: InputMaybe<Scalars['String']['input']>;
  /** The name of the EU representative. */
  euRepresentativeName?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the EU representative. The phone number is validated but not verified. */
  euRepresentativePhone?: InputMaybe<Scalars['String']['input']>;
};

export type ContactInfoQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Contact details for managed Google Play enterprises. */
export type ContactInfoSchema = {
  __typename?: 'ContactInfoSchema';
  /** Email address for a point of contact, which will be used to send important announcements related to managed Google Play. */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** The email of the data protection officer. The email is validated but not verified. */
  dataProtectionOfficerEmail?: Maybe<Scalars['String']['output']>;
  /** The name of the data protection officer. */
  dataProtectionOfficerName?: Maybe<Scalars['String']['output']>;
  /** The phone number of the data protection officer The phone number is validated but not verified. */
  dataProtectionOfficerPhone?: Maybe<Scalars['String']['output']>;
  /** The email of the EU representative. The email is validated but not verified. */
  euRepresentativeEmail?: Maybe<Scalars['String']['output']>;
  /** The name of the EU representative. */
  euRepresentativeName?: Maybe<Scalars['String']['output']>;
  /** The phone number of the EU representative. The phone number is validated but not verified. */
  euRepresentativePhone?: Maybe<Scalars['String']['output']>;
};

/** This feature is not generally available. */
export type ContentProviderEndpointInputSchema = {
  /** This feature is not generally available. */
  packageName?: InputMaybe<Scalars['String']['input']>;
  /** Required. This feature is not generally available. */
  signingCertsSha256?: InputMaybe<Array<Scalars['String']['input']>>;
  /** This feature is not generally available. */
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type ContentProviderEndpointQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** This feature is not generally available. */
export type ContentProviderEndpointSchema = {
  __typename?: 'ContentProviderEndpointSchema';
  /** This feature is not generally available. */
  packageName?: Maybe<Scalars['String']['output']>;
  /** Required. This feature is not generally available. */
  signingCertsSha256?: Maybe<Array<Scalars['String']['output']>>;
  /** This feature is not generally available. */
  uri?: Maybe<Scalars['String']['output']>;
};

export type CountByGroupSchema = {
  __typename?: 'CountByGroupSchema';
  count: Scalars['Int']['output'];
  group?: Maybe<Scalars['String']['output']>;
};

export enum CrossProfilePoliciesCrossProfileCopyPaste {
  /** Default. Prevents users from pasting into the personal profile text copied from the work profile. Text copied from the personal profile can be pasted into the work profile, and text copied from the work profile can be pasted into the work profile. */
  CopyFromWorkToPersonalDisallowed = 'COPY_FROM_WORK_TO_PERSONAL_DISALLOWED',
  /** Text copied in either profile can be pasted in the other profile. */
  CrossProfileCopyPasteAllowed = 'CROSS_PROFILE_COPY_PASTE_ALLOWED',
  /** Unspecified. Defaults to COPY_FROM_WORK_TO_PERSONAL_DISALLOWED */
  CrossProfileCopyPasteUnspecified = 'CROSS_PROFILE_COPY_PASTE_UNSPECIFIED'
}

export enum CrossProfilePoliciesCrossProfileDataSharing {
  /** Data from either profile can be shared with the other profile. */
  CrossProfileDataSharingAllowed = 'CROSS_PROFILE_DATA_SHARING_ALLOWED',
  /** Prevents data from being shared from both the personal profile to the work profile and the work profile to the personal profile. */
  CrossProfileDataSharingDisallowed = 'CROSS_PROFILE_DATA_SHARING_DISALLOWED',
  /** Unspecified. Defaults to DATA_SHARING_FROM_WORK_TO_PERSONAL_DISALLOWED. */
  CrossProfileDataSharingUnspecified = 'CROSS_PROFILE_DATA_SHARING_UNSPECIFIED',
  /** Default. Prevents users from sharing data from the work profile to apps in the personal profile. Personal data can be shared with work apps. */
  DataSharingFromWorkToPersonalDisallowed = 'DATA_SHARING_FROM_WORK_TO_PERSONAL_DISALLOWED'
}

/** Cross-profile policies applied on the device. */
export type CrossProfilePoliciesInputSchema = {
  /** Whether text copied from one profile (personal or work) can be pasted in the other profile. */
  crossProfileCopyPaste?: InputMaybe<CrossProfilePoliciesCrossProfileCopyPaste>;
  /** Whether data from one profile (personal or work) can be shared with apps in the other profile. Specifically controls simple data sharing via intents. Management of other cross-profile communication channels, such as contact search, copy/paste, or connected work & personal apps, are configured separately. */
  crossProfileDataSharing?: InputMaybe<CrossProfilePoliciesCrossProfileDataSharing>;
  /** Whether contacts stored in the work profile can be shown in personal profile contact searches and incoming calls. */
  showWorkContactsInPersonalProfile?: InputMaybe<CrossProfilePoliciesShowWorkContactsInPersonalProfile>;
  /** Specifies the default behaviour for work profile widgets. If the policy does not specify work_profile_widgets for a specific application, it will behave according to the value specified here. */
  workProfileWidgetsDefault?: InputMaybe<CrossProfilePoliciesWorkProfileWidgetsDefault>;
};

export type CrossProfilePoliciesQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Cross-profile policies applied on the device. */
export type CrossProfilePoliciesSchema = {
  __typename?: 'CrossProfilePoliciesSchema';
  /** Whether text copied from one profile (personal or work) can be pasted in the other profile. */
  crossProfileCopyPaste?: Maybe<CrossProfilePoliciesCrossProfileCopyPaste>;
  /** Whether data from one profile (personal or work) can be shared with apps in the other profile. Specifically controls simple data sharing via intents. Management of other cross-profile communication channels, such as contact search, copy/paste, or connected work & personal apps, are configured separately. */
  crossProfileDataSharing?: Maybe<CrossProfilePoliciesCrossProfileDataSharing>;
  /** Whether contacts stored in the work profile can be shown in personal profile contact searches and incoming calls. */
  showWorkContactsInPersonalProfile?: Maybe<CrossProfilePoliciesShowWorkContactsInPersonalProfile>;
  /** Specifies the default behaviour for work profile widgets. If the policy does not specify work_profile_widgets for a specific application, it will behave according to the value specified here. */
  workProfileWidgetsDefault?: Maybe<CrossProfilePoliciesWorkProfileWidgetsDefault>;
};

export enum CrossProfilePoliciesShowWorkContactsInPersonalProfile {
  /** Default. Allows work profile contacts to appear in personal profile contact searches and incoming calls */
  ShowWorkContactsInPersonalProfileAllowed = 'SHOW_WORK_CONTACTS_IN_PERSONAL_PROFILE_ALLOWED',
  /** Prevents work profile contacts from appearing in personal profile contact searches and incoming calls */
  ShowWorkContactsInPersonalProfileDisallowed = 'SHOW_WORK_CONTACTS_IN_PERSONAL_PROFILE_DISALLOWED',
  /** Unspecified. Defaults to SHOW_WORK_CONTACTS_IN_PERSONAL_PROFILE_ALLOWED. */
  ShowWorkContactsInPersonalProfileUnspecified = 'SHOW_WORK_CONTACTS_IN_PERSONAL_PROFILE_UNSPECIFIED'
}

export enum CrossProfilePoliciesWorkProfileWidgetsDefault {
  /** Work profile widgets are allowed by default. This means that if the policy does not specify work_profile_widgets as WORK_PROFILE_WIDGETS_DISALLOWED for the application, it will be able to add widgets to the home screen. */
  WorkProfileWidgetsDefaultAllowed = 'WORK_PROFILE_WIDGETS_DEFAULT_ALLOWED',
  /** Work profile widgets are disallowed by default. This means that if the policy does not specify work_profile_widgets as WORK_PROFILE_WIDGETS_ALLOWED for the application, it will be unable to add widgets to the home screen. */
  WorkProfileWidgetsDefaultDisallowed = 'WORK_PROFILE_WIDGETS_DEFAULT_DISALLOWED',
  /** Unspecified. Defaults to WORK_PROFILE_WIDGETS_DEFAULT_DISALLOWED. */
  WorkProfileWidgetsDefaultUnspecified = 'WORK_PROFILE_WIDGETS_DEFAULT_UNSPECIFIED'
}

/** Validates whether Android’s built-in cryptographic library (BoringSSL) is valid. Should always succeed on device boot, if it fails, the device should be considered untrusted. */
export type CryptoSelfTestCompletedEventInputSchema = {
  /** Whether the test succeeded. */
  success?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CryptoSelfTestCompletedEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Validates whether Android’s built-in cryptographic library (BoringSSL) is valid. Should always succeed on device boot, if it fails, the device should be considered untrusted. */
export type CryptoSelfTestCompletedEventSchema = {
  __typename?: 'CryptoSelfTestCompletedEventSchema';
  /** Whether the test succeeded. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents a whole or partial calendar date, such as a birthday. The time of day and time zone are either specified elsewhere or are insignificant. The date is relative to the Gregorian Calendar. This can represent one of the following: A full date, with non-zero year, month, and day values. A month and day, with a zero year (for example, an anniversary). A year on its own, with a zero month and a zero day. A year and month, with a zero day (for example, a credit card expiration date).Related types: google.type.TimeOfDay google.type.DateTime google.protobuf.Timestamp */
export type DateInputSchema = {
  /** Day of a month. Must be from 1 to 31 and valid for the year and month, or 0 to specify a year by itself or a year and month where the day isn't significant. */
  day?: InputMaybe<Scalars['Int']['input']>;
  /** Month of a year. Must be from 1 to 12, or 0 to specify a year without a month and day. */
  month?: InputMaybe<Scalars['Int']['input']>;
  /** Year of the date. Must be from 1 to 9999, or 0 to specify a date without a year. */
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type DateQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Represents a whole or partial calendar date, such as a birthday. The time of day and time zone are either specified elsewhere or are insignificant. The date is relative to the Gregorian Calendar. This can represent one of the following: A full date, with non-zero year, month, and day values. A month and day, with a zero year (for example, an anniversary). A year on its own, with a zero month and a zero day. A year and month, with a zero day (for example, a credit card expiration date).Related types: google.type.TimeOfDay google.type.DateTime google.protobuf.Timestamp */
export type DateSchema = {
  __typename?: 'DateSchema';
  /** Day of a month. Must be from 1 to 31 and valid for the year and month, or 0 to specify a year by itself or a year and month where the day isn't significant. */
  day?: Maybe<Scalars['Int']['output']>;
  /** Month of a year. Must be from 1 to 12, or 0 to specify a year without a month and day. */
  month?: Maybe<Scalars['Int']['output']>;
  /** Year of the date. Must be from 1 to 9999, or 0 to specify a date without a year. */
  year?: Maybe<Scalars['Int']['output']>;
};

export enum DeviceAppliedState {
  /** The device is active. */
  Active = 'ACTIVE',
  /** The device was deleted. This state is never returned by an API call, but is used in the final status report when the device acknowledges the deletion. If the device is deleted via the API call, this state is published to Pub/Sub. If the user deletes the work profile or resets the device, the device state will remain unknown to the server. */
  Deleted = 'DELETED',
  /** This value is disallowed. */
  DeviceStateUnspecified = 'DEVICE_STATE_UNSPECIFIED',
  /** The device is disabled. */
  Disabled = 'DISABLED',
  /** The device is being provisioned. Newly enrolled devices are in this state until they have a policy applied. */
  Provisioning = 'PROVISIONING'
}

/** Covers controls for device connectivity such as Wi-Fi, USB data access, keyboard/mouse connections, and more. */
export type DeviceConnectivityManagementInputSchema = {
  /** Controls what can be transferred via USB, files and/or data. This is supported only on company-owned devices. */
  usbDataAccess?: InputMaybe<DeviceConnectivityManagementUsbDataAccess>;
};

export type DeviceConnectivityManagementQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Covers controls for device connectivity such as Wi-Fi, USB data access, keyboard/mouse connections, and more. */
export type DeviceConnectivityManagementSchema = {
  __typename?: 'DeviceConnectivityManagementSchema';
  /** Controls what can be transferred via USB, files and/or data. This is supported only on company-owned devices. */
  usbDataAccess?: Maybe<DeviceConnectivityManagementUsbDataAccess>;
};

export enum DeviceConnectivityManagementUsbDataAccess {
  /** All types of USB data transfers are allowed. usbFileTransferDisabled is ignored. */
  AllowUsbDataTransfer = 'ALLOW_USB_DATA_TRANSFER',
  /** When set, all types of USB data transfers are prohibited. Supported for devices running Android 12 or above with USB HAL 1.3 or above. If the setting is not supported, DISALLOW_USB_FILE_TRANSFER will be set. A nonComplianceDetail with API_LEVEL is reported if the Android version is less than 12. A nonComplianceDetail with DEVICE_INCOMPATIBLE is reported if the device does not have USB HAL 1.3 or above. usbFileTransferDisabled is ignored. */
  DisallowUsbDataTransfer = 'DISALLOW_USB_DATA_TRANSFER',
  /** Transferring files over USB is disallowed. Other types of USB data connections, such as mouse and keyboard connection, are allowed. usbFileTransferDisabled is ignored. */
  DisallowUsbFileTransfer = 'DISALLOW_USB_FILE_TRANSFER',
  /** Unspecified. Defaults to ALLOW_USB_DATA_TRANSFER, unless usbFileTransferDisabled is set to true. If usbFileTransferDisabled is set to true, this is equivalent to DISALLOW_USB_FILE_TRANSFER. */
  UsbDataAccessUnspecified = 'USB_DATA_ACCESS_UNSPECIFIED'
}

export type DeviceInputSchema = {
  /** The API level of the Android platform version running on the device. */
  apiLevel?: InputMaybe<Scalars['Int']['input']>;
  /** Reports for apps installed on the device. This information is only available when application_reports_enabled is true in the device's policy. */
  applicationReports?: InputMaybe<Array<ApplicationReportInputSchema>>;
  /** The password requirements currently applied to the device. The applied requirements may be slightly different from those specified in passwordPolicies in some cases. fieldPath is set based on passwordPolicies. */
  appliedPasswordPolicies?: InputMaybe<Array<PasswordRequirementsInputSchema>>;
  /** The name of the policy currently applied to the device. */
  appliedPolicyName?: InputMaybe<Scalars['String']['input']>;
  /** The version of the policy currently applied to the device. */
  appliedPolicyVersion?: InputMaybe<Scalars['String']['input']>;
  /** The state currently applied to the device. */
  appliedState?: InputMaybe<DeviceAppliedState>;
  /** Information about Common Criteria Mode—security standards defined in the Common Criteria for Information Technology Security Evaluation (https://www.commoncriteriaportal.org/) (CC).This information is only available if statusReportingSettings.commonCriteriaModeEnabled is true in the device's policy. */
  commonCriteriaModeInfo?: InputMaybe<CommonCriteriaModeInfoInputSchema>;
  /** Device settings information. This information is only available if deviceSettingsEnabled is true in the device's policy. */
  deviceSettings?: InputMaybe<DeviceSettingsInputSchema>;
  /** If the device state is DISABLED, an optional message that is displayed on the device indicating the reason the device is disabled. This field can be modified by a patch request. */
  disabledReason?: InputMaybe<UserFacingMessageInputSchema>;
  /** Detailed information about displays on the device. This information is only available if displayInfoEnabled is true in the device's policy. */
  displays?: InputMaybe<Array<DisplayInputSchema>>;
  /** The time of device enrollment. */
  enrollmentTime?: InputMaybe<Scalars['String']['input']>;
  /** If the device was enrolled with an enrollment token with additional data provided, this field contains that data. */
  enrollmentTokenData?: InputMaybe<Scalars['String']['input']>;
  /** If the device was enrolled with an enrollment token, this field contains the name of the token. */
  enrollmentTokenName?: InputMaybe<Scalars['String']['input']>;
  enterprise?: InputMaybe<EnterpriseInputSchema>;
  /** Detailed information about the device hardware. */
  hardwareInfo?: InputMaybe<HardwareInfoInputSchema>;
  /** Hardware status samples in chronological order. This information is only available if hardwareStatusEnabled is true in the device's policy. */
  hardwareStatusSamples?: InputMaybe<Array<HardwareStatusInputSchema>>;
  /** Alias for the name field to preserve madhatter compatibility */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated. */
  lastPolicyComplianceReportTime?: InputMaybe<Scalars['String']['input']>;
  /** The last time the device fetched its policy. */
  lastPolicySyncTime?: InputMaybe<Scalars['String']['input']>;
  /** The last time the device sent a status report. */
  lastStatusReportTime?: InputMaybe<Scalars['String']['input']>;
  /** The type of management mode Android Device Policy takes on the device. This influences which policy settings are supported. */
  managementMode?: InputMaybe<DeviceManagementMode>;
  /** Events related to memory and storage measurements in chronological order. This information is only available if memoryInfoEnabled is true in the device's policy. */
  memoryEvents?: InputMaybe<Array<MemoryEventInputSchema>>;
  /** Memory information: contains information about device memory and storage. */
  memoryInfo?: InputMaybe<MemoryInfoInputSchema>;
  /** The name of the device in the form enterprises/{enterpriseId}/devices/{deviceId}. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Device network information. This information is only available if networkInfoEnabled is true in the device's policy. */
  networkInfo?: InputMaybe<NetworkInfoInputSchema>;
  /** Details about policy settings that the device is not compliant with. */
  nonComplianceDetails?: InputMaybe<Array<NonComplianceDetailInputSchema>>;
  /** Ownership of the managed device. */
  ownership?: InputMaybe<DeviceOwnership>;
  /** Whether the device is compliant with its policy. */
  policyCompliant?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the policy applied to the device, in the form enterprises/{enterpriseId}/policies/{policyId}. If not specified, the policy_name for the device's user is applied. This field can be modified by a patch request. You can specify only the policyId when calling enterprises.devices.patch, as long as the policyId doesn’t contain any slashes. The rest of the policy name is inferred. */
  policyName?: InputMaybe<Scalars['String']['input']>;
  /** Power management events on the device in chronological order. This information is only available if powerManagementEventsEnabled is true in the device's policy. */
  powerManagementEvents?: InputMaybe<Array<PowerManagementEventInputSchema>>;
  /** If the same physical device has been enrolled multiple times, this field contains its previous device names. The serial number is used as the unique identifier to determine if the same physical device has enrolled previously. The names are in chronological order. */
  previousDeviceNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Device's security posture value that reflects how secure the device is. */
  securityPosture?: InputMaybe<SecurityPostureInputSchema>;
  /** Detailed information about the device software. This information is only available if softwareInfoEnabled is true in the device's policy. */
  softwareInfo?: InputMaybe<SoftwareInfoInputSchema>;
  /** The state to be applied to the device. This field can be modified by a patch request. Note that when calling enterprises.devices.patch, ACTIVE and DISABLED are the only allowable values. To enter the device into a DELETED state, call enterprises.devices.delete. */
  state?: InputMaybe<DeviceState>;
  /** Map of selected system properties name and value related to the device. This information is only available if systemPropertiesEnabled is true in the device's policy. */
  systemProperties?: InputMaybe<Scalars['JSON']['input']>;
  /** The user who owns the device. */
  user?: InputMaybe<UserInputSchema>;
  /** The resource name of the user that owns this device in the form enterprises/{enterpriseId}/users/{userId}. */
  userName?: InputMaybe<Scalars['String']['input']>;
};

export enum DeviceManagementMode {
  /** Device owner. Android Device Policy has full control over the device. */
  DeviceOwner = 'DEVICE_OWNER',
  /** This value is disallowed. */
  ManagementModeUnspecified = 'MANAGEMENT_MODE_UNSPECIFIED',
  /** Profile owner. Android Device Policy has control over a managed profile on the device. */
  ProfileOwner = 'PROFILE_OWNER'
}

export enum DeviceOwnership {
  /** Device is company-owned. */
  CompanyOwned = 'COMPANY_OWNED',
  /** Ownership is unspecified. */
  OwnershipUnspecified = 'OWNERSHIP_UNSPECIFIED',
  /** Device is personally-owned. */
  PersonallyOwned = 'PERSONALLY_OWNED'
}

export type DeviceQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

export type DeviceSchema = {
  __typename?: 'DeviceSchema';
  /** The API level of the Android platform version running on the device. */
  apiLevel?: Maybe<Scalars['Int']['output']>;
  /** Reports for apps installed on the device. This information is only available when application_reports_enabled is true in the device's policy. */
  applicationReports?: Maybe<Array<ApplicationReportSchema>>;
  /** The password requirements currently applied to the device. The applied requirements may be slightly different from those specified in passwordPolicies in some cases. fieldPath is set based on passwordPolicies. */
  appliedPasswordPolicies?: Maybe<Array<PasswordRequirementsSchema>>;
  /** The name of the policy currently applied to the device. */
  appliedPolicyName?: Maybe<Scalars['String']['output']>;
  /** The version of the policy currently applied to the device. */
  appliedPolicyVersion?: Maybe<Scalars['String']['output']>;
  /** The state currently applied to the device. */
  appliedState?: Maybe<DeviceAppliedState>;
  /** Information about Common Criteria Mode—security standards defined in the Common Criteria for Information Technology Security Evaluation (https://www.commoncriteriaportal.org/) (CC).This information is only available if statusReportingSettings.commonCriteriaModeEnabled is true in the device's policy. */
  commonCriteriaModeInfo?: Maybe<CommonCriteriaModeInfoSchema>;
  /** Device settings information. This information is only available if deviceSettingsEnabled is true in the device's policy. */
  deviceSettings?: Maybe<DeviceSettingsSchema>;
  /** If the device state is DISABLED, an optional message that is displayed on the device indicating the reason the device is disabled. This field can be modified by a patch request. */
  disabledReason?: Maybe<UserFacingMessageSchema>;
  /** Detailed information about displays on the device. This information is only available if displayInfoEnabled is true in the device's policy. */
  displays?: Maybe<Array<DisplaySchema>>;
  /** The time of device enrollment. */
  enrollmentTime?: Maybe<Scalars['String']['output']>;
  /** If the device was enrolled with an enrollment token with additional data provided, this field contains that data. */
  enrollmentTokenData?: Maybe<Scalars['String']['output']>;
  /** If the device was enrolled with an enrollment token, this field contains the name of the token. */
  enrollmentTokenName?: Maybe<Scalars['String']['output']>;
  enterprise: EnterpriseSchema;
  /** Detailed information about the device hardware. */
  hardwareInfo?: Maybe<HardwareInfoSchema>;
  /** Hardware status samples in chronological order. This information is only available if hardwareStatusEnabled is true in the device's policy. */
  hardwareStatusSamples?: Maybe<Array<HardwareStatusSchema>>;
  /** Alias for the name field to preserve madhatter compatibility */
  id: Scalars['String']['output'];
  /** Deprecated. */
  lastPolicyComplianceReportTime?: Maybe<Scalars['String']['output']>;
  /** The last time the device fetched its policy. */
  lastPolicySyncTime?: Maybe<Scalars['String']['output']>;
  /** The last time the device sent a status report. */
  lastStatusReportTime?: Maybe<Scalars['String']['output']>;
  /** The type of management mode Android Device Policy takes on the device. This influences which policy settings are supported. */
  managementMode?: Maybe<DeviceManagementMode>;
  /** Events related to memory and storage measurements in chronological order. This information is only available if memoryInfoEnabled is true in the device's policy. */
  memoryEvents?: Maybe<Array<MemoryEventSchema>>;
  /** Memory information: contains information about device memory and storage. */
  memoryInfo?: Maybe<MemoryInfoSchema>;
  /** The name of the device in the form enterprises/{enterpriseId}/devices/{deviceId}. */
  name?: Maybe<Scalars['String']['output']>;
  /** Device network information. This information is only available if networkInfoEnabled is true in the device's policy. */
  networkInfo?: Maybe<NetworkInfoSchema>;
  /** Details about policy settings that the device is not compliant with. */
  nonComplianceDetails?: Maybe<Array<NonComplianceDetailSchema>>;
  /** Ownership of the managed device. */
  ownership?: Maybe<DeviceOwnership>;
  /** Whether the device is compliant with its policy. */
  policyCompliant?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the policy applied to the device, in the form enterprises/{enterpriseId}/policies/{policyId}. If not specified, the policy_name for the device's user is applied. This field can be modified by a patch request. You can specify only the policyId when calling enterprises.devices.patch, as long as the policyId doesn’t contain any slashes. The rest of the policy name is inferred. */
  policyName?: Maybe<Scalars['String']['output']>;
  /** Power management events on the device in chronological order. This information is only available if powerManagementEventsEnabled is true in the device's policy. */
  powerManagementEvents?: Maybe<Array<PowerManagementEventSchema>>;
  /** If the same physical device has been enrolled multiple times, this field contains its previous device names. The serial number is used as the unique identifier to determine if the same physical device has enrolled previously. The names are in chronological order. */
  previousDeviceNames?: Maybe<Array<Scalars['String']['output']>>;
  /** Device's security posture value that reflects how secure the device is. */
  securityPosture?: Maybe<SecurityPostureSchema>;
  /** Detailed information about the device software. This information is only available if softwareInfoEnabled is true in the device's policy. */
  softwareInfo?: Maybe<SoftwareInfoSchema>;
  /** The state to be applied to the device. This field can be modified by a patch request. Note that when calling enterprises.devices.patch, ACTIVE and DISABLED are the only allowable values. To enter the device into a DELETED state, call enterprises.devices.delete. */
  state?: Maybe<DeviceState>;
  /** Map of selected system properties name and value related to the device. This information is only available if systemPropertiesEnabled is true in the device's policy. */
  systemProperties?: Maybe<Scalars['JSON']['output']>;
  /** The user who owns the device. */
  user?: Maybe<UserSchema>;
  /** The resource name of the user that owns this device in the form enterprises/{enterpriseId}/users/{userId}. */
  userName?: Maybe<Scalars['String']['output']>;
};

export enum DeviceSettingsEncryptionStatus {
  /** Encryption is not currently active, but is currently being activated. */
  Activating = 'ACTIVATING',
  /** Encryption is active. */
  Active = 'ACTIVE',
  /** Encryption is active, but an encryption key is not set by the user. */
  ActiveDefaultKey = 'ACTIVE_DEFAULT_KEY',
  /** Encryption is active, and the encryption key is tied to the user profile. */
  ActivePerUser = 'ACTIVE_PER_USER',
  /** Unspecified. No device should have this type. */
  EncryptionStatusUnspecified = 'ENCRYPTION_STATUS_UNSPECIFIED',
  /** Encryption is supported by the device, but is not currently active. */
  Inactive = 'INACTIVE',
  /** Encryption is not supported by the device. */
  Unsupported = 'UNSUPPORTED'
}

/** Information about security related device settings on device. */
export type DeviceSettingsInputSchema = {
  /** Whether ADB (https://developer.android.com/studio/command-line/adb.html) is enabled on the device. */
  adbEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether developer mode is enabled on the device. */
  developmentSettingsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Encryption status from DevicePolicyManager. */
  encryptionStatus?: InputMaybe<DeviceSettingsEncryptionStatus>;
  /** Whether the device is secured with PIN/password. */
  isDeviceSecure?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the storage encryption is enabled. */
  isEncrypted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether installing apps from unknown sources is enabled. */
  unknownSourcesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether Google Play Protect verification (https://support.google.com/accounts/answer/2812853) is enforced on the device. */
  verifyAppsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeviceSettingsQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Information about security related device settings on device. */
export type DeviceSettingsSchema = {
  __typename?: 'DeviceSettingsSchema';
  /** Whether ADB (https://developer.android.com/studio/command-line/adb.html) is enabled on the device. */
  adbEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether developer mode is enabled on the device. */
  developmentSettingsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Encryption status from DevicePolicyManager. */
  encryptionStatus?: Maybe<DeviceSettingsEncryptionStatus>;
  /** Whether the device is secured with PIN/password. */
  isDeviceSecure?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the storage encryption is enabled. */
  isEncrypted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether installing apps from unknown sources is enabled. */
  unknownSourcesEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether Google Play Protect verification (https://support.google.com/accounts/answer/2812853) is enforced on the device. */
  verifyAppsEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export enum DeviceState {
  /** The device is active. */
  Active = 'ACTIVE',
  /** The device was deleted. This state is never returned by an API call, but is used in the final status report when the device acknowledges the deletion. If the device is deleted via the API call, this state is published to Pub/Sub. If the user deletes the work profile or resets the device, the device state will remain unknown to the server. */
  Deleted = 'DELETED',
  /** This value is disallowed. */
  DeviceStateUnspecified = 'DEVICE_STATE_UNSPECIFIED',
  /** The device is disabled. */
  Disabled = 'DISABLED',
  /** The device is being provisioned. Newly enrolled devices are in this state until they have a policy applied. */
  Provisioning = 'PROVISIONING'
}

/** Device display information. */
export type DisplayInputSchema = {
  /** Display density expressed as dots-per-inch. */
  density?: InputMaybe<Scalars['Int']['input']>;
  /** Unique display id. */
  displayId?: InputMaybe<Scalars['Int']['input']>;
  /** Display height in pixels. */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the display. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Refresh rate of the display in frames per second. */
  refreshRate?: InputMaybe<Scalars['Int']['input']>;
  /** State of the display. */
  state?: InputMaybe<DisplayState>;
  /** Display width in pixels. */
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type DisplayQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Device display information. */
export type DisplaySchema = {
  __typename?: 'DisplaySchema';
  /** Display density expressed as dots-per-inch. */
  density?: Maybe<Scalars['Int']['output']>;
  /** Unique display id. */
  displayId?: Maybe<Scalars['Int']['output']>;
  /** Display height in pixels. */
  height?: Maybe<Scalars['Int']['output']>;
  /** Name of the display. */
  name?: Maybe<Scalars['String']['output']>;
  /** Refresh rate of the display in frames per second. */
  refreshRate?: Maybe<Scalars['Int']['output']>;
  /** State of the display. */
  state?: Maybe<DisplayState>;
  /** Display width in pixels. */
  width?: Maybe<Scalars['Int']['output']>;
};

export enum DisplayState {
  /** This value is disallowed. */
  DisplayStateUnspecified = 'DISPLAY_STATE_UNSPECIFIED',
  /** Display is dozing in a low power state */
  Doze = 'DOZE',
  /** Display is off. */
  Off = 'OFF',
  /** Display is on. */
  On = 'ON',
  /** Display is dozing in a suspended low power state. */
  Suspended = 'SUSPENDED'
}

/** A DNS lookup event was initiated through the standard network stack. */
export type DnsEventInputSchema = {
  /** The hostname that was looked up. */
  hostname?: InputMaybe<Scalars['String']['input']>;
  /** The (possibly truncated) list of the IP addresses returned for DNS lookup (max 10 IPv4 or IPv6 addresses). */
  ipAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The package name of the UID that performed the DNS lookup. */
  packageName?: InputMaybe<Scalars['String']['input']>;
  /** The number of IP addresses returned from the DNS lookup event. May be higher than the amount of ip_addresses if there were too many addresses to log. */
  totalIpAddressesReturned?: InputMaybe<Scalars['String']['input']>;
};

export type DnsEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A DNS lookup event was initiated through the standard network stack. */
export type DnsEventSchema = {
  __typename?: 'DnsEventSchema';
  /** The hostname that was looked up. */
  hostname?: Maybe<Scalars['String']['output']>;
  /** The (possibly truncated) list of the IP addresses returned for DNS lookup (max 10 IPv4 or IPv6 addresses). */
  ipAddresses?: Maybe<Array<Scalars['String']['output']>>;
  /** The package name of the UID that performed the DNS lookup. */
  packageName?: Maybe<Scalars['String']['output']>;
  /** The number of IP addresses returned from the DNS lookup event. May be higher than the amount of ip_addresses if there were too many addresses to log. */
  totalIpAddressesReturned?: Maybe<Scalars['String']['output']>;
};

/** A generic empty message that you can re-use to avoid defining duplicated empty messages in your APIs. A typical example is to use it as the request or the response type of an API method. For instance: service Foo { rpc Bar(google.protobuf.Empty) returns (google.protobuf.Empty); }  */
export type EmptyInputSchema = {
  /** Placeholder field to prevent empty schema. */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type EmptyQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A generic empty message that you can re-use to avoid defining duplicated empty messages in your APIs. A typical example is to use it as the request or the response type of an API method. For instance: service Foo { rpc Bar(google.protobuf.Empty) returns (google.protobuf.Empty); }  */
export type EmptySchema = {
  __typename?: 'EmptySchema';
  /** Placeholder field to prevent empty schema. */
  _?: Maybe<Scalars['String']['output']>;
};

export enum EnrollmentTokenAllowPersonalUsage {
  /** Personal usage restriction is not specified */
  AllowPersonalUsageUnspecified = 'ALLOW_PERSONAL_USAGE_UNSPECIFIED',
  /** Personal usage is allowed */
  PersonalUsageAllowed = 'PERSONAL_USAGE_ALLOWED',
  /** Personal usage is disallowed */
  PersonalUsageDisallowed = 'PERSONAL_USAGE_DISALLOWED'
}

export type EnrollmentTokenInputSchema = {
  /** Optional, arbitrary data associated with the enrollment token. This could contain, for example, the ID of an org unit the device is assigned to after enrollment. After a device enrolls with the token, this data will be exposed in the enrollment_token_data field of the Device resource. The data must be 1024 characters or less; otherwise, the creation request will fail. */
  additionalData?: InputMaybe<Scalars['String']['input']>;
  /** Controls whether personal usage is allowed on a device provisioned with this enrollment token.For company-owned devices: Enabling personal usage allows the user to set up a work profile on the device. Disabling personal usage requires the user provision the device as a fully managed device.For personally-owned devices: Enabling personal usage allows the user to set up a work profile on the device. Disabling personal usage will prevent the device from provisioning. Personal usage cannot be disabled on personally-owned device. */
  allowPersonalUsage?: InputMaybe<EnrollmentTokenAllowPersonalUsage>;
  /** The length of time the enrollment token is valid, ranging from 1 minute to Durations.MAX_VALUE (https://developers.google.com/protocol-buffers/docs/reference/java/com/google/protobuf/util/Durations.html#MAX_VALUE), approximately 10,000 years. If not specified, the default duration is 1 hour. Please note that if requested duration causes the resulting expiration_timestamp to exceed Timestamps.MAX_VALUE (https://developers.google.com/protocol-buffers/docs/reference/java/com/google/protobuf/util/Timestamps.html#MAX_VALUE), then expiration_timestamp is coerced to Timestamps.MAX_VALUE. */
  duration?: InputMaybe<Scalars['String']['input']>;
  enterprise?: InputMaybe<EnterpriseInputSchema>;
  /** The expiration time of the token. This is a read-only field generated by the server. */
  expirationTimestamp?: InputMaybe<Scalars['String']['input']>;
  /** Alias for the name field to preserve madhatter compatibility */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The name of the enrollment token, which is generated by the server during creation, in the form enterprises/{enterpriseId}/enrollmentTokens/{enrollmentTokenId}. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Whether the enrollment token is for one time use only. If the flag is set to true, only one device can use it for registration. */
  oneTimeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  policy?: InputMaybe<PolicyInputSchema>;
  /** The name of the policy initially applied to the enrolled device, in the form enterprises/{enterpriseId}/policies/{policyId}. If not specified, the policy_name for the device’s user is applied. If user_name is also not specified, enterprises/{enterpriseId}/policies/default is applied by default. When updating this field, you can specify only the policyId as long as the policyId doesn’t contain any slashes. The rest of the policy name will be inferred. */
  policyName?: InputMaybe<Scalars['String']['input']>;
  /** A JSON string whose UTF-8 representation can be used to generate a QR code to enroll a device with this enrollment token. To enroll a device using NFC, the NFC record must contain a serialized java.util.Properties representation of the properties in the JSON. */
  qrCode?: InputMaybe<Scalars['String']['input']>;
  /** The user associated with this enrollment token. If it's specified when the enrollment token is created and the user does not exist, the user will be created. This field must not contain personally identifiable information. Only the account_identifier field needs to be set. */
  user?: InputMaybe<UserInputSchema>;
  /** The token value that's passed to the device and authorizes the device to enroll. This is a read-only field generated by the server. */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type EnrollmentTokenQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

export type EnrollmentTokenSchema = {
  __typename?: 'EnrollmentTokenSchema';
  /** Optional, arbitrary data associated with the enrollment token. This could contain, for example, the ID of an org unit the device is assigned to after enrollment. After a device enrolls with the token, this data will be exposed in the enrollment_token_data field of the Device resource. The data must be 1024 characters or less; otherwise, the creation request will fail. */
  additionalData?: Maybe<Scalars['String']['output']>;
  /** Controls whether personal usage is allowed on a device provisioned with this enrollment token.For company-owned devices: Enabling personal usage allows the user to set up a work profile on the device. Disabling personal usage requires the user provision the device as a fully managed device.For personally-owned devices: Enabling personal usage allows the user to set up a work profile on the device. Disabling personal usage will prevent the device from provisioning. Personal usage cannot be disabled on personally-owned device. */
  allowPersonalUsage?: Maybe<EnrollmentTokenAllowPersonalUsage>;
  /** The length of time the enrollment token is valid, ranging from 1 minute to Durations.MAX_VALUE (https://developers.google.com/protocol-buffers/docs/reference/java/com/google/protobuf/util/Durations.html#MAX_VALUE), approximately 10,000 years. If not specified, the default duration is 1 hour. Please note that if requested duration causes the resulting expiration_timestamp to exceed Timestamps.MAX_VALUE (https://developers.google.com/protocol-buffers/docs/reference/java/com/google/protobuf/util/Timestamps.html#MAX_VALUE), then expiration_timestamp is coerced to Timestamps.MAX_VALUE. */
  duration?: Maybe<Scalars['String']['output']>;
  /** The expiration time of the token. This is a read-only field generated by the server. */
  expirationTimestamp?: Maybe<Scalars['String']['output']>;
  /** Alias for the name field to preserve madhatter compatibility */
  id: Scalars['String']['output'];
  /** The name of the enrollment token, which is generated by the server during creation, in the form enterprises/{enterpriseId}/enrollmentTokens/{enrollmentTokenId}. */
  name?: Maybe<Scalars['String']['output']>;
  /** Whether the enrollment token is for one time use only. If the flag is set to true, only one device can use it for registration. */
  oneTimeOnly?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the policy initially applied to the enrolled device, in the form enterprises/{enterpriseId}/policies/{policyId}. If not specified, the policy_name for the device’s user is applied. If user_name is also not specified, enterprises/{enterpriseId}/policies/default is applied by default. When updating this field, you can specify only the policyId as long as the policyId doesn’t contain any slashes. The rest of the policy name will be inferred. */
  policyName?: Maybe<Scalars['String']['output']>;
  /** A JSON string whose UTF-8 representation can be used to generate a QR code to enroll a device with this enrollment token. To enroll a device using NFC, the NFC record must contain a serialized java.util.Properties representation of the properties in the JSON. */
  qrCode?: Maybe<Scalars['String']['output']>;
  /** The user associated with this enrollment token. If it's specified when the enrollment token is created and the user does not exist, the user will be created. This field must not contain personally identifiable information. Only the account_identifier field needs to be set. */
  user?: Maybe<UserSchema>;
  /** The token value that's passed to the device and authorizes the device to enroll. This is a read-only field generated by the server. */
  value?: Maybe<Scalars['String']['output']>;
};

export enum EnterpriseEnabledNotificationTypes {
  /** A notification sent when a device command has completed. */
  Command = 'COMMAND',
  /** Deprecated. */
  ComplianceReport = 'COMPLIANCE_REPORT',
  /** A notification sent when a device enrolls. */
  Enrollment = 'ENROLLMENT',
  /** This value is ignored. */
  NotificationTypeUnspecified = 'NOTIFICATION_TYPE_UNSPECIFIED',
  /** A notification sent when a device issues a status report. */
  StatusReport = 'STATUS_REPORT',
  /** A notification sent when device sends BatchUsageLogEvents. */
  UsageLogs = 'USAGE_LOGS'
}

export type EnterpriseInputSchema = {
  /** Deprecated and unused. */
  appAutoApprovalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The enterprise contact info of an EMM-managed enterprise. */
  contactInfo?: InputMaybe<ContactInfoInputSchema>;
  /** The types of Google Pub/Sub notifications enabled for the enterprise. */
  enabledNotificationTypes?: InputMaybe<Array<EnterpriseEnabledNotificationTypes>>;
  /** The name of the enterprise displayed to users. This field has a maximum length of 100 characters. */
  enterpriseDisplayName?: InputMaybe<Scalars['String']['input']>;
  /** Alias for the name field to preserve madhatter compatibility */
  id?: InputMaybe<Scalars['String']['input']>;
  /** An image displayed as a logo during device provisioning. Supported types are: image/bmp, image/gif, image/x-ico, image/jpeg, image/png, image/webp, image/vnd.wap.wbmp, image/x-adobe-dng. */
  logo?: InputMaybe<ExternalDataInputSchema>;
  /** The name of the enterprise which is generated by the server during creation, in the form enterprises/{enterpriseId}. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** A color in RGB format that indicates the predominant color to display in the device management app UI. The color components are stored as follows: (red << 16) | (green << 8) | blue, where the value of each component is between 0 and 255, inclusive. */
  primaryColor?: InputMaybe<Scalars['Int']['input']>;
  /** The topic which Pub/Sub notifications are published to, in the form projects/{project}/topics/{topic}. This field is only required if Pub/Sub notifications are enabled. */
  pubsubTopic?: InputMaybe<Scalars['String']['input']>;
  /** Sign-in details of the enterprise. */
  signinDetails?: InputMaybe<Array<SigninDetailInputSchema>>;
  /** Terms and conditions that must be accepted when provisioning a device for this enterprise. A page of terms is generated for each value in this list. */
  termsAndConditions?: InputMaybe<Array<TermsAndConditionsInputSchema>>;
};

export type EnterpriseQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

export type EnterpriseSchema = {
  __typename?: 'EnterpriseSchema';
  /** Deprecated and unused. */
  appAutoApprovalEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The enterprise contact info of an EMM-managed enterprise. */
  contactInfo?: Maybe<ContactInfoSchema>;
  devices: Array<DeviceSchema>;
  /** The types of Google Pub/Sub notifications enabled for the enterprise. */
  enabledNotificationTypes?: Maybe<Array<EnterpriseEnabledNotificationTypes>>;
  /** The name of the enterprise displayed to users. This field has a maximum length of 100 characters. */
  enterpriseDisplayName?: Maybe<Scalars['String']['output']>;
  /** Alias for the name field to preserve madhatter compatibility */
  id: Scalars['String']['output'];
  /** An image displayed as a logo during device provisioning. Supported types are: image/bmp, image/gif, image/x-ico, image/jpeg, image/png, image/webp, image/vnd.wap.wbmp, image/x-adobe-dng. */
  logo?: Maybe<ExternalDataSchema>;
  /** The name of the enterprise which is generated by the server during creation, in the form enterprises/{enterpriseId}. */
  name?: Maybe<Scalars['String']['output']>;
  policies: Array<PolicySchema>;
  /** A color in RGB format that indicates the predominant color to display in the device management app UI. The color components are stored as follows: (red << 16) | (green << 8) | blue, where the value of each component is between 0 and 255, inclusive. */
  primaryColor?: Maybe<Scalars['Int']['output']>;
  /** The topic which Pub/Sub notifications are published to, in the form projects/{project}/topics/{topic}. This field is only required if Pub/Sub notifications are enabled. */
  pubsubTopic?: Maybe<Scalars['String']['output']>;
  /** Sign-in details of the enterprise. */
  signinDetails?: Maybe<Array<SigninDetailSchema>>;
  /** Terms and conditions that must be accepted when provisioning a device for this enterprise. A page of terms is generated for each value in this list. */
  termsAndConditions?: Maybe<Array<TermsAndConditionsSchema>>;
};

/** Configuration to enable an app as an extension app, with the capability of interacting with Android Device Policy offline. For Android versions 13 and above, extension apps are exempt from battery restrictions so will not be placed into the restricted App Standby Bucket (https://developer.android.com/topic/performance/appstandby#restricted-bucket). Extensions apps are also protected against users clearing their data or force-closing the application, although admins can continue to use the clear app data command (https://developer.android.com/management/reference/rest/v1/enterprises.devices/issueCommand#CommandType) on extension apps if needed for Android 13 and above. */
export type ExtensionConfigInputSchema = {
  /** Fully qualified class name of the receiver service class for Android Device Policy to notify the extension app of any local command status updates. */
  notificationReceiver?: InputMaybe<Scalars['String']['input']>;
  /** Hex-encoded SHA-256 hash of the signing certificate of the extension app. Only hexadecimal string representations of 64 characters are valid.If not specified, the signature for the corresponding package name is obtained from the Play Store instead.If this list is empty, the signature of the extension app on the device must match the signature obtained from the Play Store for the app to be able to communicate with Android Device Policy.If this list is not empty, the signature of the extension app on the device must match one of the entries in this list for the app to be able to communicate with Android Device Policy.In production use cases, it is recommended to leave this empty. */
  signingKeyFingerprintsSha256?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ExtensionConfigQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Configuration to enable an app as an extension app, with the capability of interacting with Android Device Policy offline. For Android versions 13 and above, extension apps are exempt from battery restrictions so will not be placed into the restricted App Standby Bucket (https://developer.android.com/topic/performance/appstandby#restricted-bucket). Extensions apps are also protected against users clearing their data or force-closing the application, although admins can continue to use the clear app data command (https://developer.android.com/management/reference/rest/v1/enterprises.devices/issueCommand#CommandType) on extension apps if needed for Android 13 and above. */
export type ExtensionConfigSchema = {
  __typename?: 'ExtensionConfigSchema';
  /** Fully qualified class name of the receiver service class for Android Device Policy to notify the extension app of any local command status updates. */
  notificationReceiver?: Maybe<Scalars['String']['output']>;
  /** Hex-encoded SHA-256 hash of the signing certificate of the extension app. Only hexadecimal string representations of 64 characters are valid.If not specified, the signature for the corresponding package name is obtained from the Play Store instead.If this list is empty, the signature of the extension app on the device must match the signature obtained from the Play Store for the app to be able to communicate with Android Device Policy.If this list is not empty, the signature of the extension app on the device must match one of the entries in this list for the app to be able to communicate with Android Device Policy.In production use cases, it is recommended to leave this empty. */
  signingKeyFingerprintsSha256?: Maybe<Array<Scalars['String']['output']>>;
};

/** Data hosted at an external location. The data is to be downloaded by Android Device Policy and verified against the hash. */
export type ExternalDataInputSchema = {
  /** The base-64 encoded SHA-256 hash of the content hosted at url. If the content doesn't match this hash, Android Device Policy won't use the data. */
  sha256Hash?: InputMaybe<Scalars['String']['input']>;
  /** The absolute URL to the data, which must use either the http or https scheme. Android Device Policy doesn't provide any credentials in the GET request, so the URL must be publicly accessible. Including a long, random component in the URL may be used to prevent attackers from discovering the URL. */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalDataQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Data hosted at an external location. The data is to be downloaded by Android Device Policy and verified against the hash. */
export type ExternalDataSchema = {
  __typename?: 'ExternalDataSchema';
  /** The base-64 encoded SHA-256 hash of the content hosted at url. If the content doesn't match this hash, Android Device Policy won't use the data. */
  sha256Hash?: Maybe<Scalars['String']['output']>;
  /** The absolute URL to the data, which must use either the http or https scheme. Android Device Policy doesn't provide any credentials in the GET request, so the URL must be publicly accessible. Including a long, random component in the URL may be used to prevent attackers from discovering the URL. */
  url?: Maybe<Scalars['String']['output']>;
};

export type FileArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

export type FileInputSchema = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  extension?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  originalName?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
};

/** A file was downloaded from the device. */
export type FilePulledEventInputSchema = {
  /** The path of the file being pulled. */
  filePath?: InputMaybe<Scalars['String']['input']>;
};

export type FilePulledEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A file was downloaded from the device. */
export type FilePulledEventSchema = {
  __typename?: 'FilePulledEventSchema';
  /** The path of the file being pulled. */
  filePath?: Maybe<Scalars['String']['output']>;
};

/** A file was uploaded onto the device. */
export type FilePushedEventInputSchema = {
  /** The path of the file being pushed. */
  filePath?: InputMaybe<Scalars['String']['input']>;
};

export type FilePushedEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A file was uploaded onto the device. */
export type FilePushedEventSchema = {
  __typename?: 'FilePushedEventSchema';
  /** The path of the file being pushed. */
  filePath?: Maybe<Scalars['String']['output']>;
};

export type FileSchema = {
  __typename?: 'FileSchema';
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  downloadLocation?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  originalName?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['String']['output'];
  uploadLocation?: Maybe<Scalars['String']['output']>;
};

/** A system freeze period. When a device’s clock is within the freeze period, all incoming system updates (including security patches) are blocked and won’t be installed. When a device is outside the freeze period, normal update behavior applies. Leap years are ignored in freeze period calculations, in particular: * If Feb. 29th is set as the start or end date of a freeze period, the freeze period will start or end on Feb. 28th instead. * When a device’s system clock reads Feb. 29th, it’s treated as Feb. 28th. * When calculating the number of days in a freeze period or the time between two freeze periods, Feb. 29th is ignored and not counted as a day.Note: For Freeze Periods to take effect, SystemUpdateType cannot be specified as SYSTEM_UPDATE_TYPE_UNSPECIFIED, because freeze periods require a defined policy to be specified. */
export type FreezePeriodInputSchema = {
  /** The end date (inclusive) of the freeze period. Must be no later than 90 days from the start date. If the end date is earlier than the start date, the freeze period is considered wrapping year-end. Note: year must not be set. For example, {"month": 1,"date": 30}. */
  endDate?: InputMaybe<DateInputSchema>;
  /** The start date (inclusive) of the freeze period. Note: year must not be set. For example, {"month": 1,"date": 30}. */
  startDate?: InputMaybe<DateInputSchema>;
};

export type FreezePeriodQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A system freeze period. When a device’s clock is within the freeze period, all incoming system updates (including security patches) are blocked and won’t be installed. When a device is outside the freeze period, normal update behavior applies. Leap years are ignored in freeze period calculations, in particular: * If Feb. 29th is set as the start or end date of a freeze period, the freeze period will start or end on Feb. 28th instead. * When a device’s system clock reads Feb. 29th, it’s treated as Feb. 28th. * When calculating the number of days in a freeze period or the time between two freeze periods, Feb. 29th is ignored and not counted as a day.Note: For Freeze Periods to take effect, SystemUpdateType cannot be specified as SYSTEM_UPDATE_TYPE_UNSPECIFIED, because freeze periods require a defined policy to be specified. */
export type FreezePeriodSchema = {
  __typename?: 'FreezePeriodSchema';
  /** The end date (inclusive) of the freeze period. Must be no later than 90 days from the start date. If the end date is earlier than the start date, the freeze period is considered wrapping year-end. Note: year must not be set. For example, {"month": 1,"date": 30}. */
  endDate?: Maybe<DateSchema>;
  /** The start date (inclusive) of the freeze period. Note: year must not be set. For example, {"month": 1,"date": 30}. */
  startDate?: Maybe<DateSchema>;
};

/** Information about device hardware. The fields related to temperature thresholds are only available if hardwareStatusEnabled is true in the device's policy. */
export type HardwareInfoInputSchema = {
  /** Battery shutdown temperature thresholds in Celsius for each battery on the device. */
  batteryShutdownTemperatures?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Battery throttling temperature thresholds in Celsius for each battery on the device. */
  batteryThrottlingTemperatures?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Brand of the device. For example, Google. */
  brand?: InputMaybe<Scalars['String']['input']>;
  /** CPU shutdown temperature thresholds in Celsius for each CPU on the device. */
  cpuShutdownTemperatures?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** CPU throttling temperature thresholds in Celsius for each CPU on the device. */
  cpuThrottlingTemperatures?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Baseband version. For example, MDM9625_104662.22.05.34p. */
  deviceBasebandVersion?: InputMaybe<Scalars['String']['input']>;
  /** Output only. ID that uniquely identifies a personally-owned device in a particular organization. On the same physical device when enrolled with the same organization, this ID persists across setups and even factory resets. This ID is available on personally-owned devices with a work profile on devices running Android 12 and above. */
  enterpriseSpecificId?: InputMaybe<Scalars['String']['input']>;
  /** GPU shutdown temperature thresholds in Celsius for each GPU on the device. */
  gpuShutdownTemperatures?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** GPU throttling temperature thresholds in Celsius for each GPU on the device. */
  gpuThrottlingTemperatures?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Name of the hardware. For example, Angler. */
  hardware?: InputMaybe<Scalars['String']['input']>;
  /** Manufacturer. For example, Motorola. */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** The model of the device. For example, Asus Nexus 7. */
  model?: InputMaybe<Scalars['String']['input']>;
  /** The device serial number. */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** Device skin shutdown temperature thresholds in Celsius. */
  skinShutdownTemperatures?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Device skin throttling temperature thresholds in Celsius. */
  skinThrottlingTemperatures?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type HardwareInfoQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Information about device hardware. The fields related to temperature thresholds are only available if hardwareStatusEnabled is true in the device's policy. */
export type HardwareInfoSchema = {
  __typename?: 'HardwareInfoSchema';
  /** Battery shutdown temperature thresholds in Celsius for each battery on the device. */
  batteryShutdownTemperatures?: Maybe<Array<Scalars['Float']['output']>>;
  /** Battery throttling temperature thresholds in Celsius for each battery on the device. */
  batteryThrottlingTemperatures?: Maybe<Array<Scalars['Float']['output']>>;
  /** Brand of the device. For example, Google. */
  brand?: Maybe<Scalars['String']['output']>;
  /** CPU shutdown temperature thresholds in Celsius for each CPU on the device. */
  cpuShutdownTemperatures?: Maybe<Array<Scalars['Float']['output']>>;
  /** CPU throttling temperature thresholds in Celsius for each CPU on the device. */
  cpuThrottlingTemperatures?: Maybe<Array<Scalars['Float']['output']>>;
  /** Baseband version. For example, MDM9625_104662.22.05.34p. */
  deviceBasebandVersion?: Maybe<Scalars['String']['output']>;
  /** Output only. ID that uniquely identifies a personally-owned device in a particular organization. On the same physical device when enrolled with the same organization, this ID persists across setups and even factory resets. This ID is available on personally-owned devices with a work profile on devices running Android 12 and above. */
  enterpriseSpecificId?: Maybe<Scalars['String']['output']>;
  /** GPU shutdown temperature thresholds in Celsius for each GPU on the device. */
  gpuShutdownTemperatures?: Maybe<Array<Scalars['Float']['output']>>;
  /** GPU throttling temperature thresholds in Celsius for each GPU on the device. */
  gpuThrottlingTemperatures?: Maybe<Array<Scalars['Float']['output']>>;
  /** Name of the hardware. For example, Angler. */
  hardware?: Maybe<Scalars['String']['output']>;
  /** Manufacturer. For example, Motorola. */
  manufacturer?: Maybe<Scalars['String']['output']>;
  /** The model of the device. For example, Asus Nexus 7. */
  model?: Maybe<Scalars['String']['output']>;
  /** The device serial number. */
  serialNumber?: Maybe<Scalars['String']['output']>;
  /** Device skin shutdown temperature thresholds in Celsius. */
  skinShutdownTemperatures?: Maybe<Array<Scalars['Float']['output']>>;
  /** Device skin throttling temperature thresholds in Celsius. */
  skinThrottlingTemperatures?: Maybe<Array<Scalars['Float']['output']>>;
};

/** Hardware status. Temperatures may be compared to the temperature thresholds available in hardwareInfo to determine hardware health. */
export type HardwareStatusInputSchema = {
  /** Current battery temperatures in Celsius for each battery on the device. */
  batteryTemperatures?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Current CPU temperatures in Celsius for each CPU on the device. */
  cpuTemperatures?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** CPU usages in percentage for each core available on the device. Usage is 0 for each unplugged core. Empty array implies that CPU usage is not supported in the system. */
  cpuUsages?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** The time the measurements were taken. */
  createTime?: InputMaybe<Scalars['String']['input']>;
  /** Fan speeds in RPM for each fan on the device. Empty array means that there are no fans or fan speed is not supported on the system. */
  fanSpeeds?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Current GPU temperatures in Celsius for each GPU on the device. */
  gpuTemperatures?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Current device skin temperatures in Celsius. */
  skinTemperatures?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type HardwareStatusQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Hardware status. Temperatures may be compared to the temperature thresholds available in hardwareInfo to determine hardware health. */
export type HardwareStatusSchema = {
  __typename?: 'HardwareStatusSchema';
  /** Current battery temperatures in Celsius for each battery on the device. */
  batteryTemperatures?: Maybe<Array<Scalars['Float']['output']>>;
  /** Current CPU temperatures in Celsius for each CPU on the device. */
  cpuTemperatures?: Maybe<Array<Scalars['Float']['output']>>;
  /** CPU usages in percentage for each core available on the device. Usage is 0 for each unplugged core. Empty array implies that CPU usage is not supported in the system. */
  cpuUsages?: Maybe<Array<Scalars['Float']['output']>>;
  /** The time the measurements were taken. */
  createTime?: Maybe<Scalars['String']['output']>;
  /** Fan speeds in RPM for each fan on the device. Empty array means that there are no fans or fan speed is not supported on the system. */
  fanSpeeds?: Maybe<Array<Scalars['Float']['output']>>;
  /** Current GPU temperatures in Celsius for each GPU on the device. */
  gpuTemperatures?: Maybe<Array<Scalars['Float']['output']>>;
  /** Current device skin temperatures in Celsius. */
  skinTemperatures?: Maybe<Array<Scalars['Float']['output']>>;
};

/** Response on issuing a command. This is currently empty as a placeholder. */
export type IssueCommandResponseInputSchema = {
  /** Placeholder field to prevent empty schema. */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type IssueCommandResponseQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Response on issuing a command. This is currently empty as a placeholder. */
export type IssueCommandResponseSchema = {
  __typename?: 'IssueCommandResponseSchema';
  /** Placeholder field to prevent empty schema. */
  _?: Maybe<Scalars['String']['output']>;
};

/** A cryptographic key including user installed, admin installed and system maintained private key is removed from the device either by the user or management. This is available device-wide on fully managed devices and within the work profile on organization-owned devices with a work profile. */
export type KeyDestructionEventInputSchema = {
  /** UID of the application which owns the key. */
  applicationUid?: InputMaybe<Scalars['Int']['input']>;
  /** Alias of the key. */
  keyAlias?: InputMaybe<Scalars['String']['input']>;
  /** Whether the operation was successful. */
  success?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KeyDestructionEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A cryptographic key including user installed, admin installed and system maintained private key is removed from the device either by the user or management. This is available device-wide on fully managed devices and within the work profile on organization-owned devices with a work profile. */
export type KeyDestructionEventSchema = {
  __typename?: 'KeyDestructionEventSchema';
  /** UID of the application which owns the key. */
  applicationUid?: Maybe<Scalars['Int']['output']>;
  /** Alias of the key. */
  keyAlias?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** A cryptographic key including user installed, admin installed and system maintained private key is installed on the device either by the user or management.This is available device-wide on fully managed devices and within the work profile on organization-owned devices with a work profile. */
export type KeyGeneratedEventInputSchema = {
  /** UID of the application which generated the key. */
  applicationUid?: InputMaybe<Scalars['Int']['input']>;
  /** Alias of the key. */
  keyAlias?: InputMaybe<Scalars['String']['input']>;
  /** Whether the operation was successful. */
  success?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KeyGeneratedEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A cryptographic key including user installed, admin installed and system maintained private key is installed on the device either by the user or management.This is available device-wide on fully managed devices and within the work profile on organization-owned devices with a work profile. */
export type KeyGeneratedEventSchema = {
  __typename?: 'KeyGeneratedEventSchema';
  /** UID of the application which generated the key. */
  applicationUid?: Maybe<Scalars['Int']['output']>;
  /** Alias of the key. */
  keyAlias?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** A cryptographic key including user installed, admin installed and system maintained private key is imported on the device either by the user or management. This is available device-wide on fully managed devices and within the work profile on organization-owned devices with a work profile. */
export type KeyImportEventInputSchema = {
  /** UID of the application which imported the key */
  applicationUid?: InputMaybe<Scalars['Int']['input']>;
  /** Alias of the key. */
  keyAlias?: InputMaybe<Scalars['String']['input']>;
  /** Whether the operation was successful. */
  success?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KeyImportEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A cryptographic key including user installed, admin installed and system maintained private key is imported on the device either by the user or management. This is available device-wide on fully managed devices and within the work profile on organization-owned devices with a work profile. */
export type KeyImportEventSchema = {
  __typename?: 'KeyImportEventSchema';
  /** UID of the application which imported the key */
  applicationUid?: Maybe<Scalars['Int']['output']>;
  /** Alias of the key. */
  keyAlias?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** A cryptographic key including user installed, admin installed and system maintained private key is determined to be corrupted due to storage corruption, hardware failure or some OS issue. This is available device-wide on fully managed devices and within the work profile on organization-owned devices with a work profile. */
export type KeyIntegrityViolationEventInputSchema = {
  /** UID of the application which owns the key */
  applicationUid?: InputMaybe<Scalars['Int']['input']>;
  /** Alias of the key. */
  keyAlias?: InputMaybe<Scalars['String']['input']>;
};

export type KeyIntegrityViolationEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A cryptographic key including user installed, admin installed and system maintained private key is determined to be corrupted due to storage corruption, hardware failure or some OS issue. This is available device-wide on fully managed devices and within the work profile on organization-owned devices with a work profile. */
export type KeyIntegrityViolationEventSchema = {
  __typename?: 'KeyIntegrityViolationEventSchema';
  /** UID of the application which owns the key */
  applicationUid?: Maybe<Scalars['Int']['output']>;
  /** Alias of the key. */
  keyAlias?: Maybe<Scalars['String']['output']>;
};

/** Keyed app state reported by the app. */
export type KeyedAppStateInputSchema = {
  /** The creation time of the app state on the device. */
  createTime?: InputMaybe<Scalars['String']['input']>;
  /** Optionally, a machine-readable value to be read by the EMM. For example, setting values that the admin can choose to query against in the EMM console (e.g. “notify me if the battery_warning data < 10”). */
  data?: InputMaybe<Scalars['String']['input']>;
  /** The key for the app state. Acts as a point of reference for what the app is providing state for. For example, when providing managed configuration feedback, this key could be the managed configuration key. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** The time the app state was most recently updated. */
  lastUpdateTime?: InputMaybe<Scalars['String']['input']>;
  /** Optionally, a free-form message string to explain the app state. If the state was triggered by a particular value (e.g. a managed configuration value), it should be included in the message. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** The severity of the app state. */
  severity?: InputMaybe<KeyedAppStateSeverity>;
};

export type KeyedAppStateQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Keyed app state reported by the app. */
export type KeyedAppStateSchema = {
  __typename?: 'KeyedAppStateSchema';
  /** The creation time of the app state on the device. */
  createTime?: Maybe<Scalars['String']['output']>;
  /** Optionally, a machine-readable value to be read by the EMM. For example, setting values that the admin can choose to query against in the EMM console (e.g. “notify me if the battery_warning data < 10”). */
  data?: Maybe<Scalars['String']['output']>;
  /** The key for the app state. Acts as a point of reference for what the app is providing state for. For example, when providing managed configuration feedback, this key could be the managed configuration key. */
  key?: Maybe<Scalars['String']['output']>;
  /** The time the app state was most recently updated. */
  lastUpdateTime?: Maybe<Scalars['String']['output']>;
  /** Optionally, a free-form message string to explain the app state. If the state was triggered by a particular value (e.g. a managed configuration value), it should be included in the message. */
  message?: Maybe<Scalars['String']['output']>;
  /** The severity of the app state. */
  severity?: Maybe<KeyedAppStateSeverity>;
};

export enum KeyedAppStateSeverity {
  /** Error severity level. This should only be set for genuine error conditions that a management organization needs to take action to fix. */
  Error = 'ERROR',
  /** Information severity level. */
  Info = 'INFO',
  /** Unspecified severity level. */
  SeverityUnspecified = 'SEVERITY_UNSPECIFIED'
}

/** An attempt was made to unlock the device. */
export type KeyguardDismissAuthAttemptEventInputSchema = {
  /** Whether a strong form of authentication (password, PIN, or pattern) was used to unlock device. */
  strongAuthMethodUsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the unlock attempt was successful. */
  success?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KeyguardDismissAuthAttemptEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** An attempt was made to unlock the device. */
export type KeyguardDismissAuthAttemptEventSchema = {
  __typename?: 'KeyguardDismissAuthAttemptEventSchema';
  /** Whether a strong form of authentication (password, PIN, or pattern) was used to unlock device. */
  strongAuthMethodUsed?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the unlock attempt was successful. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** The keyguard was dismissed. Intentionally empty. */
export type KeyguardDismissedEventInputSchema = {
  /** Placeholder field to prevent empty schema. */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type KeyguardDismissedEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** The keyguard was dismissed. Intentionally empty. */
export type KeyguardDismissedEventSchema = {
  __typename?: 'KeyguardDismissedEventSchema';
  /** Placeholder field to prevent empty schema. */
  _?: Maybe<Scalars['String']['output']>;
};

/** The device was locked either by user or timeout. Intentionally empty. */
export type KeyguardSecuredEventInputSchema = {
  /** Placeholder field to prevent empty schema. */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type KeyguardSecuredEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** The device was locked either by user or timeout. Intentionally empty. */
export type KeyguardSecuredEventSchema = {
  __typename?: 'KeyguardSecuredEventSchema';
  /** Placeholder field to prevent empty schema. */
  _?: Maybe<Scalars['String']['output']>;
};

export enum KioskCustomizationDeviceSettings {
  /** Unspecified, defaults to SETTINGS_ACCESS_ALLOWED. */
  DeviceSettingsUnspecified = 'DEVICE_SETTINGS_UNSPECIFIED',
  /** Access to the Settings app is allowed in kiosk mode. */
  SettingsAccessAllowed = 'SETTINGS_ACCESS_ALLOWED',
  /** Access to the Settings app is not allowed in kiosk mode. */
  SettingsAccessBlocked = 'SETTINGS_ACCESS_BLOCKED'
}

/** Settings controlling the behavior of a device in kiosk mode. To enable kiosk mode, set kioskCustomLauncherEnabled to true or specify an app in the policy with installType KIOSK. */
export type KioskCustomizationInputSchema = {
  /** Specifies whether the Settings app is allowed in kiosk mode. */
  deviceSettings?: InputMaybe<KioskCustomizationDeviceSettings>;
  /** Sets the behavior of a device in kiosk mode when a user presses and holds (long-presses) the Power button. */
  powerButtonActions?: InputMaybe<KioskCustomizationPowerButtonActions>;
  /** Specifies whether system info and notifications are disabled in kiosk mode. */
  statusBar?: InputMaybe<KioskCustomizationStatusBar>;
  /** Specifies whether system error dialogs for crashed or unresponsive apps are blocked in kiosk mode. When blocked, the system will force-stop the app as if the user chooses the "close app" option on the UI. */
  systemErrorWarnings?: InputMaybe<KioskCustomizationSystemErrorWarnings>;
  /** Specifies which navigation features are enabled (e.g. Home, Overview buttons) in kiosk mode. */
  systemNavigation?: InputMaybe<KioskCustomizationSystemNavigation>;
};

export enum KioskCustomizationPowerButtonActions {
  /** Unspecified, defaults to POWER_BUTTON_AVAILABLE. */
  PowerButtonActionsUnspecified = 'POWER_BUTTON_ACTIONS_UNSPECIFIED',
  /** The power menu (e.g. Power off, Restart) is shown when a user long-presses the Power button of a device in kiosk mode. */
  PowerButtonAvailable = 'POWER_BUTTON_AVAILABLE',
  /** The power menu (e.g. Power off, Restart) is not shown when a user long-presses the Power button of a device in kiosk mode. Note: this may prevent users from turning off the device. */
  PowerButtonBlocked = 'POWER_BUTTON_BLOCKED'
}

export type KioskCustomizationQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Settings controlling the behavior of a device in kiosk mode. To enable kiosk mode, set kioskCustomLauncherEnabled to true or specify an app in the policy with installType KIOSK. */
export type KioskCustomizationSchema = {
  __typename?: 'KioskCustomizationSchema';
  /** Specifies whether the Settings app is allowed in kiosk mode. */
  deviceSettings?: Maybe<KioskCustomizationDeviceSettings>;
  /** Sets the behavior of a device in kiosk mode when a user presses and holds (long-presses) the Power button. */
  powerButtonActions?: Maybe<KioskCustomizationPowerButtonActions>;
  /** Specifies whether system info and notifications are disabled in kiosk mode. */
  statusBar?: Maybe<KioskCustomizationStatusBar>;
  /** Specifies whether system error dialogs for crashed or unresponsive apps are blocked in kiosk mode. When blocked, the system will force-stop the app as if the user chooses the "close app" option on the UI. */
  systemErrorWarnings?: Maybe<KioskCustomizationSystemErrorWarnings>;
  /** Specifies which navigation features are enabled (e.g. Home, Overview buttons) in kiosk mode. */
  systemNavigation?: Maybe<KioskCustomizationSystemNavigation>;
};

export enum KioskCustomizationStatusBar {
  /** System info and notifications are disabled in kiosk mode. */
  NotificationsAndSystemInfoDisabled = 'NOTIFICATIONS_AND_SYSTEM_INFO_DISABLED',
  /** System info and notifications are shown on the status bar in kiosk mode.Note: For this policy to take effect, the device's home button must be enabled using kioskCustomization.systemNavigation. */
  NotificationsAndSystemInfoEnabled = 'NOTIFICATIONS_AND_SYSTEM_INFO_ENABLED',
  /** Unspecified, defaults to INFO_AND_NOTIFICATIONS_DISABLED. */
  StatusBarUnspecified = 'STATUS_BAR_UNSPECIFIED',
  /** Only system info is shown on the status bar. */
  SystemInfoOnly = 'SYSTEM_INFO_ONLY'
}

export enum KioskCustomizationSystemErrorWarnings {
  /** All system error dialogs such as crash and app not responding (ANR) are displayed. */
  ErrorAndWarningsEnabled = 'ERROR_AND_WARNINGS_ENABLED',
  /** All system error dialogs, such as crash and app not responding (ANR) are blocked. When blocked, the system force-stops the app as if the user closes the app from the UI. */
  ErrorAndWarningsMuted = 'ERROR_AND_WARNINGS_MUTED',
  /** Unspecified, defaults to ERROR_AND_WARNINGS_MUTED. */
  SystemErrorWarningsUnspecified = 'SYSTEM_ERROR_WARNINGS_UNSPECIFIED'
}

export enum KioskCustomizationSystemNavigation {
  /** Only the home button is enabled. */
  HomeButtonOnly = 'HOME_BUTTON_ONLY',
  /** The home and Overview buttons are not accessible. */
  NavigationDisabled = 'NAVIGATION_DISABLED',
  /** Home and overview buttons are enabled. */
  NavigationEnabled = 'NAVIGATION_ENABLED',
  /** Unspecified, defaults to NAVIGATION_DISABLED. */
  SystemNavigationUnspecified = 'SYSTEM_NAVIGATION_UNSPECIFIED'
}

/** An action to launch an app. */
export type LaunchAppActionInputSchema = {
  /** Package name of app to be launched */
  packageName?: InputMaybe<Scalars['String']['input']>;
};

export type LaunchAppActionQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** An action to launch an app. */
export type LaunchAppActionSchema = {
  __typename?: 'LaunchAppActionSchema';
  /** Package name of app to be launched */
  packageName?: Maybe<Scalars['String']['output']>;
};

/** Response to a request to list devices for a given enterprise. */
export type ListDevicesResponseInputSchema = {
  /** The list of devices. */
  devices?: InputMaybe<Array<BaseDeviceInputSchema>>;
  /** If there are more results, a token to retrieve next page of results. */
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ListDevicesResponseQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Response to a request to list devices for a given enterprise. */
export type ListDevicesResponseSchema = {
  __typename?: 'ListDevicesResponseSchema';
  /** The list of devices. */
  devices?: Maybe<Array<BaseDeviceSchema>>;
  /** If there are more results, a token to retrieve next page of results. */
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

/** Response to a request to list enrollment tokens for a given enterprise. */
export type ListEnrollmentTokensResponseInputSchema = {
  /** The list of enrollment tokens. */
  enrollmentTokens?: InputMaybe<Array<BaseEnrollmentTokenInputSchema>>;
  /** If there are more results, a token to retrieve next page of results. */
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ListEnrollmentTokensResponseQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Response to a request to list enrollment tokens for a given enterprise. */
export type ListEnrollmentTokensResponseSchema = {
  __typename?: 'ListEnrollmentTokensResponseSchema';
  /** The list of enrollment tokens. */
  enrollmentTokens?: Maybe<Array<BaseEnrollmentTokenSchema>>;
  /** If there are more results, a token to retrieve next page of results. */
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

/** Response to a request to list enterprises. */
export type ListEnterprisesResponseInputSchema = {
  /** The list of enterprises. */
  enterprises?: InputMaybe<Array<BaseEnterpriseInputSchema>>;
  /** If there are more results, a token to retrieve next page of results. */
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ListEnterprisesResponseQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Response to a request to list enterprises. */
export type ListEnterprisesResponseSchema = {
  __typename?: 'ListEnterprisesResponseSchema';
  /** The list of enterprises. */
  enterprises?: Maybe<Array<BaseEnterpriseSchema>>;
  /** If there are more results, a token to retrieve next page of results. */
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

/** The response message for Operations.ListOperations. */
export type ListOperationsResponseInputSchema = {
  /** The standard List next-page token. */
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
  /** A list of operations that matches the specified filter in the request. */
  operations?: InputMaybe<Array<OperationInputSchema>>;
};

export type ListOperationsResponseQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** The response message for Operations.ListOperations. */
export type ListOperationsResponseSchema = {
  __typename?: 'ListOperationsResponseSchema';
  /** The standard List next-page token. */
  nextPageToken?: Maybe<Scalars['String']['output']>;
  /** A list of operations that matches the specified filter in the request. */
  operations?: Maybe<Array<OperationSchema>>;
};

/** Response to a request to list policies for a given enterprise. */
export type ListPoliciesResponseInputSchema = {
  /** If there are more results, a token to retrieve next page of results. */
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
  /** The list of policies. */
  policies?: InputMaybe<Array<BasePolicyInputSchema>>;
};

export type ListPoliciesResponseQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Response to a request to list policies for a given enterprise. */
export type ListPoliciesResponseSchema = {
  __typename?: 'ListPoliciesResponseSchema';
  /** If there are more results, a token to retrieve next page of results. */
  nextPageToken?: Maybe<Scalars['String']['output']>;
  /** The list of policies. */
  policies?: Maybe<Array<BasePolicySchema>>;
};

/** Response to a request to list web apps for a given enterprise. */
export type ListWebAppsResponseInputSchema = {
  /** If there are more results, a token to retrieve next page of results. */
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
  /** The list of web apps. */
  webApps?: InputMaybe<Array<WebAppInputSchema>>;
};

export type ListWebAppsResponseQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Response to a request to list web apps for a given enterprise. */
export type ListWebAppsResponseSchema = {
  __typename?: 'ListWebAppsResponseSchema';
  /** If there are more results, a token to retrieve next page of results. */
  nextPageToken?: Maybe<Scalars['String']['output']>;
  /** The list of web apps. */
  webApps?: Maybe<Array<WebAppSchema>>;
};

/** The usageLog buffer on the device has reached 90% of its capacity, therefore older events may be dropped. Intentionally empty. */
export type LogBufferSizeCriticalEventInputSchema = {
  /** Placeholder field to prevent empty schema. */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type LogBufferSizeCriticalEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** The usageLog buffer on the device has reached 90% of its capacity, therefore older events may be dropped. Intentionally empty. */
export type LogBufferSizeCriticalEventSchema = {
  __typename?: 'LogBufferSizeCriticalEventSchema';
  /** Placeholder field to prevent empty schema. */
  _?: Maybe<Scalars['String']['output']>;
};

/** usageLog policy has been enabled. Intentionally empty. */
export type LoggingStartedEventInputSchema = {
  /** Placeholder field to prevent empty schema. */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type LoggingStartedEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** usageLog policy has been enabled. Intentionally empty. */
export type LoggingStartedEventSchema = {
  __typename?: 'LoggingStartedEventSchema';
  /** Placeholder field to prevent empty schema. */
  _?: Maybe<Scalars['String']['output']>;
};

/** usageLog policy has been disabled. Intentionally empty. */
export type LoggingStoppedEventInputSchema = {
  /** Placeholder field to prevent empty schema. */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type LoggingStoppedEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** usageLog policy has been disabled. Intentionally empty. */
export type LoggingStoppedEventSchema = {
  __typename?: 'LoggingStoppedEventSchema';
  /** Placeholder field to prevent empty schema. */
  _?: Maybe<Scalars['String']['output']>;
};

export enum MadhatterSortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

/** The managed configurations template for the app, saved from the managed configurations iframe. */
export type ManagedConfigurationTemplateInputSchema = {
  /** Optional, a map containing configuration variables defined for the configuration. */
  configurationVariables?: InputMaybe<Scalars['JSON']['input']>;
  /** The ID of the managed configurations template. */
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type ManagedConfigurationTemplateQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** The managed configurations template for the app, saved from the managed configurations iframe. */
export type ManagedConfigurationTemplateSchema = {
  __typename?: 'ManagedConfigurationTemplateSchema';
  /** Optional, a map containing configuration variables defined for the configuration. */
  configurationVariables?: Maybe<Scalars['JSON']['output']>;
  /** The ID of the managed configurations template. */
  templateId?: Maybe<Scalars['String']['output']>;
};

/** An entry of a managed property. */
export type ManagedPropertyEntryInputSchema = {
  /** The human-readable name of the value. Localized. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The machine-readable value of the entry, which should be used in the configuration. Not localized. */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ManagedPropertyEntryQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** An entry of a managed property. */
export type ManagedPropertyEntrySchema = {
  __typename?: 'ManagedPropertyEntrySchema';
  /** The human-readable name of the value. Localized. */
  name?: Maybe<Scalars['String']['output']>;
  /** The machine-readable value of the entry, which should be used in the configuration. Not localized. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Managed property. */
export type ManagedPropertyInputSchema = {
  /** A longer description of the property, providing more detail of what it affects. Localized. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** For CHOICE or MULTISELECT properties, the list of possible entries. */
  entries?: InputMaybe<Array<ManagedPropertyEntryInputSchema>>;
  /** The unique key that the app uses to identify the property, e.g. "com.google.android.gm.fieldname". */
  key?: InputMaybe<Scalars['String']['input']>;
  /** For BUNDLE_ARRAY properties, the list of nested properties. A BUNDLE_ARRAY property is at most two levels deep. */
  nestedProperties?: InputMaybe<Array<ManagedPropertyInputSchema>>;
  /** The name of the property. Localized. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The type of the property. */
  type?: InputMaybe<ManagedPropertyType>;
};

export type ManagedPropertyQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Managed property. */
export type ManagedPropertySchema = {
  __typename?: 'ManagedPropertySchema';
  /** A longer description of the property, providing more detail of what it affects. Localized. */
  description?: Maybe<Scalars['String']['output']>;
  /** For CHOICE or MULTISELECT properties, the list of possible entries. */
  entries?: Maybe<Array<ManagedPropertyEntrySchema>>;
  /** The unique key that the app uses to identify the property, e.g. "com.google.android.gm.fieldname". */
  key?: Maybe<Scalars['String']['output']>;
  /** For BUNDLE_ARRAY properties, the list of nested properties. A BUNDLE_ARRAY property is at most two levels deep. */
  nestedProperties?: Maybe<Array<ManagedPropertySchema>>;
  /** The name of the property. Localized. */
  title?: Maybe<Scalars['String']['output']>;
  /** The type of the property. */
  type?: Maybe<ManagedPropertyType>;
};

export enum ManagedPropertyType {
  /** A property of boolean type. */
  Bool = 'BOOL',
  /** A bundle of properties */
  Bundle = 'BUNDLE',
  /** An array of property bundles. */
  BundleArray = 'BUNDLE_ARRAY',
  /** A choice of one item from a set. */
  Choice = 'CHOICE',
  /** A hidden restriction of string type (the default value can be used to pass along information that can't be modified, such as a version code). */
  Hidden = 'HIDDEN',
  /** A property of integer type. */
  Integer = 'INTEGER',
  /** Not used. */
  ManagedPropertyTypeUnspecified = 'MANAGED_PROPERTY_TYPE_UNSPECIFIED',
  /** A choice of multiple items from a set. */
  Multiselect = 'MULTISELECT',
  /** A property of string type. */
  String = 'STRING'
}

export type MdmApplicationInputSchema = {
  /** Whether this app is free, free with in-app purchases, or paid. If the pricing is unspecified, this means the app is not generally available anymore (even though it might still be available to people who own it). */
  appPricing?: InputMaybe<ApplicationAppPricing>;
  /** Application tracks visible to the enterprise. */
  appTracks?: InputMaybe<Array<AppTrackInfoInputSchema>>;
  /** Versions currently available for this app. */
  appVersions?: InputMaybe<Array<AppVersionInputSchema>>;
  /** The name of the author of the apps (for example, the app developer). */
  author?: InputMaybe<Scalars['String']['input']>;
  /** The countries which this app is available in as per ISO 3166-1 alpha-2. */
  availableCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The app category (e.g. RACING, SOCIAL, etc.) */
  category?: InputMaybe<Scalars['String']['input']>;
  /** The content rating for this app. */
  contentRating?: InputMaybe<ApplicationContentRating>;
  /** The localized promotional description, if available. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** How and to whom the package is made available. */
  distributionChannel?: InputMaybe<ApplicationDistributionChannel>;
  enterprise?: InputMaybe<EnterpriseInputSchema>;
  /** Noteworthy features (if any) of this app. */
  features?: InputMaybe<Array<ApplicationFeatures>>;
  /** Full app description, if available. */
  fullDescription?: InputMaybe<Scalars['String']['input']>;
  /** A link to an image that can be used as an icon for the app. This image is suitable for use up to a pixel size of 512 x 512. */
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  /** Alias for the name field to preserve madhatter compatibility */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The set of managed properties available to be pre-configured for the app. */
  managedProperties?: InputMaybe<Array<ManagedPropertyInputSchema>>;
  /** The minimum Android SDK necessary to run the app. */
  minAndroidSdkVersion?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the app in the form enterprises/{enterprise}/applications/{package_name}. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The permissions required by the app. */
  permissions?: InputMaybe<Array<ApplicationPermissionInputSchema>>;
  /** A link to the (consumer) Google Play details page for the app. */
  playStoreUrl?: InputMaybe<Scalars['String']['input']>;
  /** A localised description of the recent changes made to the app. */
  recentChanges?: InputMaybe<Scalars['String']['input']>;
  /** A list of screenshot links representing the app. */
  screenshotUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A link to a smaller image that can be used as an icon for the app. This image is suitable for use up to a pixel size of 128 x 128. */
  smallIconUrl?: InputMaybe<Scalars['String']['input']>;
  /** The title of the app. Localized. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Output only. The approximate time (within 7 days) the app was last published. */
  updateTime?: InputMaybe<Scalars['String']['input']>;
};

export type MdmApplicationQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

export type MdmApplicationSchema = {
  __typename?: 'MdmApplicationSchema';
  /** Whether this app is free, free with in-app purchases, or paid. If the pricing is unspecified, this means the app is not generally available anymore (even though it might still be available to people who own it). */
  appPricing?: Maybe<ApplicationAppPricing>;
  /** Application tracks visible to the enterprise. */
  appTracks?: Maybe<Array<AppTrackInfoSchema>>;
  /** Versions currently available for this app. */
  appVersions?: Maybe<Array<AppVersionSchema>>;
  /** The name of the author of the apps (for example, the app developer). */
  author?: Maybe<Scalars['String']['output']>;
  /** The countries which this app is available in as per ISO 3166-1 alpha-2. */
  availableCountries?: Maybe<Array<Scalars['String']['output']>>;
  /** The app category (e.g. RACING, SOCIAL, etc.) */
  category?: Maybe<Scalars['String']['output']>;
  /** The content rating for this app. */
  contentRating?: Maybe<ApplicationContentRating>;
  /** The localized promotional description, if available. */
  description?: Maybe<Scalars['String']['output']>;
  /** How and to whom the package is made available. */
  distributionChannel?: Maybe<ApplicationDistributionChannel>;
  enterprise: EnterpriseSchema;
  /** Noteworthy features (if any) of this app. */
  features?: Maybe<Array<ApplicationFeatures>>;
  /** Full app description, if available. */
  fullDescription?: Maybe<Scalars['String']['output']>;
  /** A link to an image that can be used as an icon for the app. This image is suitable for use up to a pixel size of 512 x 512. */
  iconUrl?: Maybe<Scalars['String']['output']>;
  /** Alias for the name field to preserve madhatter compatibility */
  id: Scalars['String']['output'];
  /** The set of managed properties available to be pre-configured for the app. */
  managedProperties?: Maybe<Array<ManagedPropertySchema>>;
  /** The minimum Android SDK necessary to run the app. */
  minAndroidSdkVersion?: Maybe<Scalars['Int']['output']>;
  /** The name of the app in the form enterprises/{enterprise}/applications/{package_name}. */
  name?: Maybe<Scalars['String']['output']>;
  /** The permissions required by the app. */
  permissions?: Maybe<Array<ApplicationPermissionSchema>>;
  /** A link to the (consumer) Google Play details page for the app. */
  playStoreUrl?: Maybe<Scalars['String']['output']>;
  /** A localised description of the recent changes made to the app. */
  recentChanges?: Maybe<Scalars['String']['output']>;
  /** A list of screenshot links representing the app. */
  screenshotUrls?: Maybe<Array<Scalars['String']['output']>>;
  /** A link to a smaller image that can be used as an icon for the app. This image is suitable for use up to a pixel size of 128 x 128. */
  smallIconUrl?: Maybe<Scalars['String']['output']>;
  /** The title of the app. Localized. */
  title?: Maybe<Scalars['String']['output']>;
  /** Output only. The approximate time (within 7 days) the app was last published. */
  updateTime?: Maybe<Scalars['String']['output']>;
};

export type MdmDeviceArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

export type MdmDeviceInputSchema = {
  enrollmentTime?: InputMaybe<Scalars['String']['input']>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  expectedPolicyName?: InputMaybe<Scalars['String']['input']>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imei?: InputMaybe<Scalars['String']['input']>;
  lastPolicySyncTime?: InputMaybe<Scalars['String']['input']>;
  lastStatusReportTime?: InputMaybe<Scalars['String']['input']>;
  policyName?: InputMaybe<Scalars['String']['input']>;
  serial?: InputMaybe<Scalars['String']['input']>;
};

export type MdmDeviceSchema = {
  __typename?: 'MdmDeviceSchema';
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  enrollmentTime?: Maybe<Scalars['String']['output']>;
  enterpriseId: Scalars['String']['output'];
  expectedPolicyName?: Maybe<Scalars['String']['output']>;
  googleId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imei?: Maybe<Scalars['String']['output']>;
  lastPolicySyncTime?: Maybe<Scalars['String']['output']>;
  lastStatusReportTime?: Maybe<Scalars['String']['output']>;
  policyName?: Maybe<Scalars['String']['output']>;
  serial?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type MdmPolicyArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

export type MdmPolicyInputSchema = {
  configGoogleId?: InputMaybe<Scalars['String']['input']>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<MdmPolicyInputSchema>;
};

export type MdmPolicySchema = {
  __typename?: 'MdmPolicySchema';
  configGoogleId: Scalars['String']['output'];
  configPolicy?: Maybe<PolicySchema>;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  enterpriseId: Scalars['String']['output'];
  googleId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<MdmPolicySchema>;
  policy?: Maybe<PolicySchema>;
  updatedAt: Scalars['String']['output'];
};

/** Removable media was mounted. */
export type MediaMountEventInputSchema = {
  /** Mount point. */
  mountPoint?: InputMaybe<Scalars['String']['input']>;
  /** Volume label. Redacted to empty string on organization-owned managed profile devices. */
  volumeLabel?: InputMaybe<Scalars['String']['input']>;
};

export type MediaMountEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Removable media was mounted. */
export type MediaMountEventSchema = {
  __typename?: 'MediaMountEventSchema';
  /** Mount point. */
  mountPoint?: Maybe<Scalars['String']['output']>;
  /** Volume label. Redacted to empty string on organization-owned managed profile devices. */
  volumeLabel?: Maybe<Scalars['String']['output']>;
};

/** Removable media was unmounted. */
export type MediaUnmountEventInputSchema = {
  /** Mount point. */
  mountPoint?: InputMaybe<Scalars['String']['input']>;
  /** Volume label. Redacted to empty string on organization-owned managed profile devices. */
  volumeLabel?: InputMaybe<Scalars['String']['input']>;
};

export type MediaUnmountEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Removable media was unmounted. */
export type MediaUnmountEventSchema = {
  __typename?: 'MediaUnmountEventSchema';
  /** Mount point. */
  mountPoint?: Maybe<Scalars['String']['output']>;
  /** Volume label. Redacted to empty string on organization-owned managed profile devices. */
  volumeLabel?: Maybe<Scalars['String']['output']>;
};

export enum MemoryEventEventType {
  /** A new external storage medium was detected. The reported byte count is the total capacity of the storage medium. */
  ExternalStorageDetected = 'EXTERNAL_STORAGE_DETECTED',
  /** Free space in an external storage medium was measured. */
  ExternalStorageMeasured = 'EXTERNAL_STORAGE_MEASURED',
  /** An external storage medium was removed. The reported byte count is zero. */
  ExternalStorageRemoved = 'EXTERNAL_STORAGE_REMOVED',
  /** Free space in internal storage was measured. */
  InternalStorageMeasured = 'INTERNAL_STORAGE_MEASURED',
  /** Unspecified. No events have this type. */
  MemoryEventTypeUnspecified = 'MEMORY_EVENT_TYPE_UNSPECIFIED',
  /** Free space in RAM was measured. */
  RamMeasured = 'RAM_MEASURED'
}

/** An event related to memory and storage measurements. */
export type MemoryEventInputSchema = {
  /** The number of free bytes in the medium, or for EXTERNAL_STORAGE_DETECTED, the total capacity in bytes of the storage medium. */
  byteCount?: InputMaybe<Scalars['String']['input']>;
  /** The creation time of the event. */
  createTime?: InputMaybe<Scalars['String']['input']>;
  /** Event type. */
  eventType?: InputMaybe<MemoryEventEventType>;
};

export type MemoryEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** An event related to memory and storage measurements. */
export type MemoryEventSchema = {
  __typename?: 'MemoryEventSchema';
  /** The number of free bytes in the medium, or for EXTERNAL_STORAGE_DETECTED, the total capacity in bytes of the storage medium. */
  byteCount?: Maybe<Scalars['String']['output']>;
  /** The creation time of the event. */
  createTime?: Maybe<Scalars['String']['output']>;
  /** Event type. */
  eventType?: Maybe<MemoryEventEventType>;
};

/** Information about device memory and storage. */
export type MemoryInfoInputSchema = {
  /** Total internal storage on device in bytes. */
  totalInternalStorage?: InputMaybe<Scalars['String']['input']>;
  /** Total RAM on device in bytes. */
  totalRam?: InputMaybe<Scalars['String']['input']>;
};

export type MemoryInfoQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Information about device memory and storage. */
export type MemoryInfoSchema = {
  __typename?: 'MemoryInfoSchema';
  /** Total internal storage on device in bytes. */
  totalInternalStorage?: Maybe<Scalars['String']['output']>;
  /** Total RAM on device in bytes. */
  totalRam?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  bulkCreateSwitchDevice: Array<SwitchDeviceSchema>;
  bulkDeleteDevices: Scalars['Boolean']['output'];
  createAdbShellCommandEvent: AdbShellCommandEventSchema;
  createAdbShellInteractiveEvent: AdbShellInteractiveEventSchema;
  createAdvancedSecurityOverrides: AdvancedSecurityOverridesSchema;
  createAlwaysOnVpnPackage: AlwaysOnVpnPackageSchema;
  createApiLevelCondition: ApiLevelConditionSchema;
  createAppProcessInfo: AppProcessInfoSchema;
  createAppProcessStartEvent: AppProcessStartEventSchema;
  createAppTrackInfo: AppTrackInfoSchema;
  createAppVersion: AppVersionSchema;
  createApplication: ApplicationSchema;
  createApplicationEvent: ApplicationEventSchema;
  createApplicationPermission: ApplicationPermissionSchema;
  createApplicationPolicy: ApplicationPolicySchema;
  createApplicationReport: ApplicationReportSchema;
  createApplicationReportingSettings: ApplicationReportingSettingsSchema;
  createBaseDevice: BaseDeviceSchema;
  createBaseEnrollmentToken: BaseEnrollmentTokenSchema;
  createBaseEnterprise: BaseEnterpriseSchema;
  createBasePolicy: BasePolicySchema;
  createBaseWebToken: BaseWebTokenSchema;
  createBatchUsageLogEvents: BatchUsageLogEventsSchema;
  createBlockAction: BlockActionSchema;
  createCertAuthorityInstalledEvent: CertAuthorityInstalledEventSchema;
  createCertAuthorityRemovedEvent: CertAuthorityRemovedEventSchema;
  createCertValidationFailureEvent: CertValidationFailureEventSchema;
  createChoosePrivateKeyRule: ChoosePrivateKeyRuleSchema;
  createClearAppsDataParams: ClearAppsDataParamsSchema;
  createClearAppsDataStatus: ClearAppsDataStatusSchema;
  createCommand: CommandSchema;
  createCommonCriteriaModeInfo: CommonCriteriaModeInfoSchema;
  createComplianceRule: ComplianceRuleSchema;
  createConnectEvent: ConnectEventSchema;
  createContactInfo: ContactInfoSchema;
  createContentProviderEndpoint: ContentProviderEndpointSchema;
  createCrossProfilePolicies: CrossProfilePoliciesSchema;
  createCryptoSelfTestCompletedEvent: CryptoSelfTestCompletedEventSchema;
  createDate: DateSchema;
  createDevice: DeviceSchema;
  createDeviceConnectivityManagement: DeviceConnectivityManagementSchema;
  createDeviceSettings: DeviceSettingsSchema;
  createDisplay: DisplaySchema;
  createDnsEvent: DnsEventSchema;
  createEmpty: EmptySchema;
  createEnrollmentToken: EnrollmentTokenSchema;
  createEnterprise: EnterpriseSchema;
  createExtensionConfig: ExtensionConfigSchema;
  createExternalData: ExternalDataSchema;
  createFile: FileSchema;
  createFilePulledEvent: FilePulledEventSchema;
  createFilePushedEvent: FilePushedEventSchema;
  createFreezePeriod: FreezePeriodSchema;
  createHardwareInfo: HardwareInfoSchema;
  createHardwareStatus: HardwareStatusSchema;
  createIssueCommandResponse: IssueCommandResponseSchema;
  createKeyDestructionEvent: KeyDestructionEventSchema;
  createKeyGeneratedEvent: KeyGeneratedEventSchema;
  createKeyImportEvent: KeyImportEventSchema;
  createKeyIntegrityViolationEvent: KeyIntegrityViolationEventSchema;
  createKeyedAppState: KeyedAppStateSchema;
  createKeyguardDismissAuthAttemptEvent: KeyguardDismissAuthAttemptEventSchema;
  createKeyguardDismissedEvent: KeyguardDismissedEventSchema;
  createKeyguardSecuredEvent: KeyguardSecuredEventSchema;
  createKioskCustomization: KioskCustomizationSchema;
  createLaunchAppAction: LaunchAppActionSchema;
  createListDevicesResponse: ListDevicesResponseSchema;
  createListEnrollmentTokensResponse: ListEnrollmentTokensResponseSchema;
  createListEnterprisesResponse: ListEnterprisesResponseSchema;
  createListOperationsResponse: ListOperationsResponseSchema;
  createListPoliciesResponse: ListPoliciesResponseSchema;
  createListWebAppsResponse: ListWebAppsResponseSchema;
  createLogBufferSizeCriticalEvent: LogBufferSizeCriticalEventSchema;
  createLoggingStartedEvent: LoggingStartedEventSchema;
  createLoggingStoppedEvent: LoggingStoppedEventSchema;
  createManagedConfigurationTemplate: ManagedConfigurationTemplateSchema;
  createManagedProperty: ManagedPropertySchema;
  createManagedPropertyEntry: ManagedPropertyEntrySchema;
  createMdmDevice: MdmDeviceSchema;
  createMdmPolicy: MdmPolicySchema;
  createMediaMountEvent: MediaMountEventSchema;
  createMediaUnmountEvent: MediaUnmountEventSchema;
  createMemoryEvent: MemoryEventSchema;
  createMemoryInfo: MemoryInfoSchema;
  createNetworkInfo: NetworkInfoSchema;
  createNonComplianceDetail: NonComplianceDetailSchema;
  createNonComplianceDetailCondition: NonComplianceDetailConditionSchema;
  createOncCertificateProvider: OncCertificateProviderSchema;
  createOncWifiContext: OncWifiContextSchema;
  createOperation: OperationSchema;
  createOsShutdownEvent: OsShutdownEventSchema;
  createOsStartupEvent: OsStartupEventSchema;
  createPackageNameList: PackageNameListSchema;
  createPasswordPoliciesContext: PasswordPoliciesContextSchema;
  createPasswordRequirements: PasswordRequirementsSchema;
  createPerAppResult: PerAppResultSchema;
  createPermissionGrant: PermissionGrantSchema;
  createPersistentPreferredActivity: PersistentPreferredActivitySchema;
  createPersonalApplicationPolicy: PersonalApplicationPolicySchema;
  createPersonalUsagePolicies: PersonalUsagePoliciesSchema;
  createPolicy: PolicySchema;
  createPolicyEnforcementRule: PolicyEnforcementRuleSchema;
  createPostureDetail: PostureDetailSchema;
  createPowerManagementEvent: PowerManagementEventSchema;
  createProxyInfo: ProxyInfoSchema;
  createRemoteLockEvent: RemoteLockEventSchema;
  createSecurityPosture: SecurityPostureSchema;
  createSetupAction: SetupActionSchema;
  createSigninDetail: SigninDetailSchema;
  createSignupUrl: SignupUrlSchema;
  createSoftwareInfo: SoftwareInfoSchema;
  createSpecificNonComplianceContext: SpecificNonComplianceContextSchema;
  createStatus: StatusSchema;
  createStatusReportingSettings: StatusReportingSettingsSchema;
  createSwitchDevice: SwitchDeviceSchema;
  createSystemUpdate: SystemUpdateSchema;
  createSystemUpdateInfo: SystemUpdateInfoSchema;
  createTelephonyInfo: TelephonyInfoSchema;
  createTermsAndConditions: TermsAndConditionsSchema;
  createUsageLog: UsageLogSchema;
  createUsageLogEvent: UsageLogEventSchema;
  createUser: UserSchema;
  createUserFacingMessage: UserFacingMessageSchema;
  createWebApp: WebAppSchema;
  createWebAppIcon: WebAppIconSchema;
  createWebToken: WebTokenSchema;
  createWipeAction: WipeActionSchema;
  createWipeFailureEvent: WipeFailureEventSchema;
  deleteAdbShellCommandEvent: Scalars['Boolean']['output'];
  deleteAdbShellInteractiveEvent: Scalars['Boolean']['output'];
  deleteAdvancedSecurityOverrides: Scalars['Boolean']['output'];
  deleteAlwaysOnVpnPackage: Scalars['Boolean']['output'];
  deleteApiLevelCondition: Scalars['Boolean']['output'];
  deleteAppProcessInfo: Scalars['Boolean']['output'];
  deleteAppProcessStartEvent: Scalars['Boolean']['output'];
  deleteAppTrackInfo: Scalars['Boolean']['output'];
  deleteAppVersion: Scalars['Boolean']['output'];
  deleteApplication: Scalars['Boolean']['output'];
  deleteApplicationEvent: Scalars['Boolean']['output'];
  deleteApplicationPermission: Scalars['Boolean']['output'];
  deleteApplicationPolicy: Scalars['Boolean']['output'];
  deleteApplicationReport: Scalars['Boolean']['output'];
  deleteApplicationReportingSettings: Scalars['Boolean']['output'];
  deleteBaseDevice: Scalars['Boolean']['output'];
  deleteBaseEnrollmentToken: Scalars['Boolean']['output'];
  deleteBaseEnterprise: Scalars['Boolean']['output'];
  deleteBasePolicy: Scalars['Boolean']['output'];
  deleteBaseWebToken: Scalars['Boolean']['output'];
  deleteBatchUsageLogEvents: Scalars['Boolean']['output'];
  deleteBlockAction: Scalars['Boolean']['output'];
  deleteCertAuthorityInstalledEvent: Scalars['Boolean']['output'];
  deleteCertAuthorityRemovedEvent: Scalars['Boolean']['output'];
  deleteCertValidationFailureEvent: Scalars['Boolean']['output'];
  deleteChoosePrivateKeyRule: Scalars['Boolean']['output'];
  deleteClearAppsDataParams: Scalars['Boolean']['output'];
  deleteClearAppsDataStatus: Scalars['Boolean']['output'];
  deleteCommand: Scalars['Boolean']['output'];
  deleteCommonCriteriaModeInfo: Scalars['Boolean']['output'];
  deleteComplianceRule: Scalars['Boolean']['output'];
  deleteConnectEvent: Scalars['Boolean']['output'];
  deleteContactInfo: Scalars['Boolean']['output'];
  deleteContentProviderEndpoint: Scalars['Boolean']['output'];
  deleteCrossProfilePolicies: Scalars['Boolean']['output'];
  deleteCryptoSelfTestCompletedEvent: Scalars['Boolean']['output'];
  deleteDate: Scalars['Boolean']['output'];
  deleteDevice: Scalars['Boolean']['output'];
  deleteDeviceConnectivityManagement: Scalars['Boolean']['output'];
  deleteDeviceSettings: Scalars['Boolean']['output'];
  deleteDisplay: Scalars['Boolean']['output'];
  deleteDnsEvent: Scalars['Boolean']['output'];
  deleteEmpty: Scalars['Boolean']['output'];
  deleteEnrollmentToken: Scalars['Boolean']['output'];
  deleteEnterprise: Scalars['Boolean']['output'];
  deleteExtensionConfig: Scalars['Boolean']['output'];
  deleteExternalData: Scalars['Boolean']['output'];
  deleteFile: Scalars['Boolean']['output'];
  deleteFilePulledEvent: Scalars['Boolean']['output'];
  deleteFilePushedEvent: Scalars['Boolean']['output'];
  deleteFreezePeriod: Scalars['Boolean']['output'];
  deleteHardwareInfo: Scalars['Boolean']['output'];
  deleteHardwareStatus: Scalars['Boolean']['output'];
  deleteIssueCommandResponse: Scalars['Boolean']['output'];
  deleteKeyDestructionEvent: Scalars['Boolean']['output'];
  deleteKeyGeneratedEvent: Scalars['Boolean']['output'];
  deleteKeyImportEvent: Scalars['Boolean']['output'];
  deleteKeyIntegrityViolationEvent: Scalars['Boolean']['output'];
  deleteKeyedAppState: Scalars['Boolean']['output'];
  deleteKeyguardDismissAuthAttemptEvent: Scalars['Boolean']['output'];
  deleteKeyguardDismissedEvent: Scalars['Boolean']['output'];
  deleteKeyguardSecuredEvent: Scalars['Boolean']['output'];
  deleteKioskCustomization: Scalars['Boolean']['output'];
  deleteLaunchAppAction: Scalars['Boolean']['output'];
  deleteListDevicesResponse: Scalars['Boolean']['output'];
  deleteListEnrollmentTokensResponse: Scalars['Boolean']['output'];
  deleteListEnterprisesResponse: Scalars['Boolean']['output'];
  deleteListOperationsResponse: Scalars['Boolean']['output'];
  deleteListPoliciesResponse: Scalars['Boolean']['output'];
  deleteListWebAppsResponse: Scalars['Boolean']['output'];
  deleteLogBufferSizeCriticalEvent: Scalars['Boolean']['output'];
  deleteLoggingStartedEvent: Scalars['Boolean']['output'];
  deleteLoggingStoppedEvent: Scalars['Boolean']['output'];
  deleteManagedConfigurationTemplate: Scalars['Boolean']['output'];
  deleteManagedProperty: Scalars['Boolean']['output'];
  deleteManagedPropertyEntry: Scalars['Boolean']['output'];
  deleteMdmDevice: Scalars['Boolean']['output'];
  deleteMdmPolicy: Scalars['Boolean']['output'];
  deleteMediaMountEvent: Scalars['Boolean']['output'];
  deleteMediaUnmountEvent: Scalars['Boolean']['output'];
  deleteMemoryEvent: Scalars['Boolean']['output'];
  deleteMemoryInfo: Scalars['Boolean']['output'];
  deleteNetworkInfo: Scalars['Boolean']['output'];
  deleteNonComplianceDetail: Scalars['Boolean']['output'];
  deleteNonComplianceDetailCondition: Scalars['Boolean']['output'];
  deleteOncCertificateProvider: Scalars['Boolean']['output'];
  deleteOncWifiContext: Scalars['Boolean']['output'];
  deleteOperation: Scalars['Boolean']['output'];
  deleteOsShutdownEvent: Scalars['Boolean']['output'];
  deleteOsStartupEvent: Scalars['Boolean']['output'];
  deletePackageNameList: Scalars['Boolean']['output'];
  deletePasswordPoliciesContext: Scalars['Boolean']['output'];
  deletePasswordRequirements: Scalars['Boolean']['output'];
  deletePerAppResult: Scalars['Boolean']['output'];
  deletePermissionGrant: Scalars['Boolean']['output'];
  deletePersistentPreferredActivity: Scalars['Boolean']['output'];
  deletePersonalApplicationPolicy: Scalars['Boolean']['output'];
  deletePersonalUsagePolicies: Scalars['Boolean']['output'];
  deletePolicy: Scalars['Boolean']['output'];
  deletePolicyEnforcementRule: Scalars['Boolean']['output'];
  deletePostureDetail: Scalars['Boolean']['output'];
  deletePowerManagementEvent: Scalars['Boolean']['output'];
  deleteProxyInfo: Scalars['Boolean']['output'];
  deleteRemoteLockEvent: Scalars['Boolean']['output'];
  deleteSecurityPosture: Scalars['Boolean']['output'];
  deleteSetupAction: Scalars['Boolean']['output'];
  deleteSigninDetail: Scalars['Boolean']['output'];
  deleteSignupUrl: Scalars['Boolean']['output'];
  deleteSoftwareInfo: Scalars['Boolean']['output'];
  deleteSpecificNonComplianceContext: Scalars['Boolean']['output'];
  deleteStatus: Scalars['Boolean']['output'];
  deleteStatusReportingSettings: Scalars['Boolean']['output'];
  deleteSwitchDevice: Scalars['Boolean']['output'];
  deleteSystemUpdate: Scalars['Boolean']['output'];
  deleteSystemUpdateInfo: Scalars['Boolean']['output'];
  deleteTelephonyInfo: Scalars['Boolean']['output'];
  deleteTermsAndConditions: Scalars['Boolean']['output'];
  deleteUsageLog: Scalars['Boolean']['output'];
  deleteUsageLogEvent: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  deleteUserFacingMessage: Scalars['Boolean']['output'];
  deleteWebApp: Scalars['Boolean']['output'];
  deleteWebAppIcon: Scalars['Boolean']['output'];
  deleteWebToken: Scalars['Boolean']['output'];
  deleteWipeAction: Scalars['Boolean']['output'];
  deleteWipeFailureEvent: Scalars['Boolean']['output'];
  generateCSVExport: FileSchema;
  sync: Scalars['Boolean']['output'];
  syncImeis: Scalars['Boolean']['output'];
  tempSetToken: Scalars['Boolean']['output'];
  updateAdbShellCommandEvent: AdbShellCommandEventSchema;
  updateAdbShellInteractiveEvent: AdbShellInteractiveEventSchema;
  updateAdvancedSecurityOverrides: AdvancedSecurityOverridesSchema;
  updateAlwaysOnVpnPackage: AlwaysOnVpnPackageSchema;
  updateApiLevelCondition: ApiLevelConditionSchema;
  updateAppProcessInfo: AppProcessInfoSchema;
  updateAppProcessStartEvent: AppProcessStartEventSchema;
  updateAppTrackInfo: AppTrackInfoSchema;
  updateAppVersion: AppVersionSchema;
  updateApplication: ApplicationSchema;
  updateApplicationEvent: ApplicationEventSchema;
  updateApplicationPermission: ApplicationPermissionSchema;
  updateApplicationPolicy: ApplicationPolicySchema;
  updateApplicationReport: ApplicationReportSchema;
  updateApplicationReportingSettings: ApplicationReportingSettingsSchema;
  updateBaseDevice: BaseDeviceSchema;
  updateBaseEnrollmentToken: BaseEnrollmentTokenSchema;
  updateBaseEnterprise: BaseEnterpriseSchema;
  updateBasePolicy: BasePolicySchema;
  updateBaseWebToken: BaseWebTokenSchema;
  updateBatchUsageLogEvents: BatchUsageLogEventsSchema;
  updateBlockAction: BlockActionSchema;
  updateCertAuthorityInstalledEvent: CertAuthorityInstalledEventSchema;
  updateCertAuthorityRemovedEvent: CertAuthorityRemovedEventSchema;
  updateCertValidationFailureEvent: CertValidationFailureEventSchema;
  updateChoosePrivateKeyRule: ChoosePrivateKeyRuleSchema;
  updateClearAppsDataParams: ClearAppsDataParamsSchema;
  updateClearAppsDataStatus: ClearAppsDataStatusSchema;
  updateCommand: CommandSchema;
  updateCommonCriteriaModeInfo: CommonCriteriaModeInfoSchema;
  updateComplianceRule: ComplianceRuleSchema;
  updateConnectEvent: ConnectEventSchema;
  updateContactInfo: ContactInfoSchema;
  updateContentProviderEndpoint: ContentProviderEndpointSchema;
  updateCrossProfilePolicies: CrossProfilePoliciesSchema;
  updateCryptoSelfTestCompletedEvent: CryptoSelfTestCompletedEventSchema;
  updateDate: DateSchema;
  updateDevice: DeviceSchema;
  updateDeviceConnectivityManagement: DeviceConnectivityManagementSchema;
  updateDeviceSettings: DeviceSettingsSchema;
  updateDisplay: DisplaySchema;
  updateDnsEvent: DnsEventSchema;
  updateEmpty: EmptySchema;
  updateEnrollmentToken: EnrollmentTokenSchema;
  updateEnterprise: EnterpriseSchema;
  updateExtensionConfig: ExtensionConfigSchema;
  updateExternalData: ExternalDataSchema;
  updateFile: FileSchema;
  updateFilePulledEvent: FilePulledEventSchema;
  updateFilePushedEvent: FilePushedEventSchema;
  updateFreezePeriod: FreezePeriodSchema;
  updateHardwareInfo: HardwareInfoSchema;
  updateHardwareStatus: HardwareStatusSchema;
  updateIssueCommandResponse: IssueCommandResponseSchema;
  updateKeyDestructionEvent: KeyDestructionEventSchema;
  updateKeyGeneratedEvent: KeyGeneratedEventSchema;
  updateKeyImportEvent: KeyImportEventSchema;
  updateKeyIntegrityViolationEvent: KeyIntegrityViolationEventSchema;
  updateKeyedAppState: KeyedAppStateSchema;
  updateKeyguardDismissAuthAttemptEvent: KeyguardDismissAuthAttemptEventSchema;
  updateKeyguardDismissedEvent: KeyguardDismissedEventSchema;
  updateKeyguardSecuredEvent: KeyguardSecuredEventSchema;
  updateKioskCustomization: KioskCustomizationSchema;
  updateLaunchAppAction: LaunchAppActionSchema;
  updateListDevicesResponse: ListDevicesResponseSchema;
  updateListEnrollmentTokensResponse: ListEnrollmentTokensResponseSchema;
  updateListEnterprisesResponse: ListEnterprisesResponseSchema;
  updateListOperationsResponse: ListOperationsResponseSchema;
  updateListPoliciesResponse: ListPoliciesResponseSchema;
  updateListWebAppsResponse: ListWebAppsResponseSchema;
  updateLogBufferSizeCriticalEvent: LogBufferSizeCriticalEventSchema;
  updateLoggingStartedEvent: LoggingStartedEventSchema;
  updateLoggingStoppedEvent: LoggingStoppedEventSchema;
  updateManagedConfigurationTemplate: ManagedConfigurationTemplateSchema;
  updateManagedProperty: ManagedPropertySchema;
  updateManagedPropertyEntry: ManagedPropertyEntrySchema;
  updateMdmDevice: MdmDeviceSchema;
  updateMdmPolicy: MdmPolicySchema;
  updateMediaMountEvent: MediaMountEventSchema;
  updateMediaUnmountEvent: MediaUnmountEventSchema;
  updateMemoryEvent: MemoryEventSchema;
  updateMemoryInfo: MemoryInfoSchema;
  updateNetworkInfo: NetworkInfoSchema;
  updateNonComplianceDetail: NonComplianceDetailSchema;
  updateNonComplianceDetailCondition: NonComplianceDetailConditionSchema;
  updateOncCertificateProvider: OncCertificateProviderSchema;
  updateOncWifiContext: OncWifiContextSchema;
  updateOperation: OperationSchema;
  updateOsShutdownEvent: OsShutdownEventSchema;
  updateOsStartupEvent: OsStartupEventSchema;
  updatePackageNameList: PackageNameListSchema;
  updatePasswordPoliciesContext: PasswordPoliciesContextSchema;
  updatePasswordRequirements: PasswordRequirementsSchema;
  updatePerAppResult: PerAppResultSchema;
  updatePermissionGrant: PermissionGrantSchema;
  updatePersistentPreferredActivity: PersistentPreferredActivitySchema;
  updatePersonalApplicationPolicy: PersonalApplicationPolicySchema;
  updatePersonalUsagePolicies: PersonalUsagePoliciesSchema;
  updatePolicy: PolicySchema;
  updatePolicyEnforcementRule: PolicyEnforcementRuleSchema;
  updatePostureDetail: PostureDetailSchema;
  updatePowerManagementEvent: PowerManagementEventSchema;
  updateProxyInfo: ProxyInfoSchema;
  updateRemoteLockEvent: RemoteLockEventSchema;
  updateSecurityPosture: SecurityPostureSchema;
  updateSetupAction: SetupActionSchema;
  updateSigninDetail: SigninDetailSchema;
  updateSignupUrl: SignupUrlSchema;
  updateSoftwareInfo: SoftwareInfoSchema;
  updateSpecificNonComplianceContext: SpecificNonComplianceContextSchema;
  updateStatus: StatusSchema;
  updateStatusReportingSettings: StatusReportingSettingsSchema;
  updateSwitchDevice: SwitchDeviceSchema;
  updateSystemUpdate: SystemUpdateSchema;
  updateSystemUpdateInfo: SystemUpdateInfoSchema;
  updateTelephonyInfo: TelephonyInfoSchema;
  updateTermsAndConditions: TermsAndConditionsSchema;
  updateUsageLog: UsageLogSchema;
  updateUsageLogEvent: UsageLogEventSchema;
  updateUser: UserSchema;
  updateUserFacingMessage: UserFacingMessageSchema;
  updateWebApp: WebAppSchema;
  updateWebAppIcon: WebAppIconSchema;
  updateWebToken: WebTokenSchema;
  updateWipeAction: WipeActionSchema;
  updateWipeFailureEvent: WipeFailureEventSchema;
};


export type MutationBulkCreateSwitchDeviceArgs = {
  imeis: Array<Scalars['String']['input']>;
  kioskPolicy: Scalars['String']['input'];
  normalPolicy: Scalars['String']['input'];
};


export type MutationBulkDeleteDevicesArgs = {
  input: Array<Scalars['String']['input']>;
};


export type MutationCreateAdbShellCommandEventArgs = {
  input: AdbShellCommandEventInputSchema;
};


export type MutationCreateAdbShellInteractiveEventArgs = {
  input: AdbShellInteractiveEventInputSchema;
};


export type MutationCreateAdvancedSecurityOverridesArgs = {
  input: AdvancedSecurityOverridesInputSchema;
};


export type MutationCreateAlwaysOnVpnPackageArgs = {
  input: AlwaysOnVpnPackageInputSchema;
};


export type MutationCreateApiLevelConditionArgs = {
  input: ApiLevelConditionInputSchema;
};


export type MutationCreateAppProcessInfoArgs = {
  input: AppProcessInfoInputSchema;
};


export type MutationCreateAppProcessStartEventArgs = {
  input: AppProcessStartEventInputSchema;
};


export type MutationCreateAppTrackInfoArgs = {
  input: AppTrackInfoInputSchema;
};


export type MutationCreateAppVersionArgs = {
  input: AppVersionInputSchema;
};


export type MutationCreateApplicationArgs = {
  input: ApplicationInputSchema;
};


export type MutationCreateApplicationEventArgs = {
  input: ApplicationEventInputSchema;
};


export type MutationCreateApplicationPermissionArgs = {
  input: ApplicationPermissionInputSchema;
};


export type MutationCreateApplicationPolicyArgs = {
  input: ApplicationPolicyInputSchema;
};


export type MutationCreateApplicationReportArgs = {
  input: ApplicationReportInputSchema;
};


export type MutationCreateApplicationReportingSettingsArgs = {
  input: ApplicationReportingSettingsInputSchema;
};


export type MutationCreateBaseDeviceArgs = {
  input: BaseDeviceInputSchema;
};


export type MutationCreateBaseEnrollmentTokenArgs = {
  input: BaseEnrollmentTokenInputSchema;
};


export type MutationCreateBaseEnterpriseArgs = {
  input: BaseEnterpriseInputSchema;
};


export type MutationCreateBasePolicyArgs = {
  input: BasePolicyInputSchema;
};


export type MutationCreateBaseWebTokenArgs = {
  input: BaseWebTokenInputSchema;
};


export type MutationCreateBatchUsageLogEventsArgs = {
  input: BatchUsageLogEventsInputSchema;
};


export type MutationCreateBlockActionArgs = {
  input: BlockActionInputSchema;
};


export type MutationCreateCertAuthorityInstalledEventArgs = {
  input: CertAuthorityInstalledEventInputSchema;
};


export type MutationCreateCertAuthorityRemovedEventArgs = {
  input: CertAuthorityRemovedEventInputSchema;
};


export type MutationCreateCertValidationFailureEventArgs = {
  input: CertValidationFailureEventInputSchema;
};


export type MutationCreateChoosePrivateKeyRuleArgs = {
  input: ChoosePrivateKeyRuleInputSchema;
};


export type MutationCreateClearAppsDataParamsArgs = {
  input: ClearAppsDataParamsInputSchema;
};


export type MutationCreateClearAppsDataStatusArgs = {
  input: ClearAppsDataStatusInputSchema;
};


export type MutationCreateCommandArgs = {
  input: CommandInputSchema;
};


export type MutationCreateCommonCriteriaModeInfoArgs = {
  input: CommonCriteriaModeInfoInputSchema;
};


export type MutationCreateComplianceRuleArgs = {
  input: ComplianceRuleInputSchema;
};


export type MutationCreateConnectEventArgs = {
  input: ConnectEventInputSchema;
};


export type MutationCreateContactInfoArgs = {
  input: ContactInfoInputSchema;
};


export type MutationCreateContentProviderEndpointArgs = {
  input: ContentProviderEndpointInputSchema;
};


export type MutationCreateCrossProfilePoliciesArgs = {
  input: CrossProfilePoliciesInputSchema;
};


export type MutationCreateCryptoSelfTestCompletedEventArgs = {
  input: CryptoSelfTestCompletedEventInputSchema;
};


export type MutationCreateDateArgs = {
  input: DateInputSchema;
};


export type MutationCreateDeviceArgs = {
  input: DeviceInputSchema;
};


export type MutationCreateDeviceConnectivityManagementArgs = {
  input: DeviceConnectivityManagementInputSchema;
};


export type MutationCreateDeviceSettingsArgs = {
  input: DeviceSettingsInputSchema;
};


export type MutationCreateDisplayArgs = {
  input: DisplayInputSchema;
};


export type MutationCreateDnsEventArgs = {
  input: DnsEventInputSchema;
};


export type MutationCreateEmptyArgs = {
  input: EmptyInputSchema;
};


export type MutationCreateEnrollmentTokenArgs = {
  input: EnrollmentTokenInputSchema;
};


export type MutationCreateEnterpriseArgs = {
  input: EnterpriseInputSchema;
};


export type MutationCreateExtensionConfigArgs = {
  input: ExtensionConfigInputSchema;
};


export type MutationCreateExternalDataArgs = {
  input: ExternalDataInputSchema;
};


export type MutationCreateFileArgs = {
  input: FileInputSchema;
};


export type MutationCreateFilePulledEventArgs = {
  input: FilePulledEventInputSchema;
};


export type MutationCreateFilePushedEventArgs = {
  input: FilePushedEventInputSchema;
};


export type MutationCreateFreezePeriodArgs = {
  input: FreezePeriodInputSchema;
};


export type MutationCreateHardwareInfoArgs = {
  input: HardwareInfoInputSchema;
};


export type MutationCreateHardwareStatusArgs = {
  input: HardwareStatusInputSchema;
};


export type MutationCreateIssueCommandResponseArgs = {
  input: IssueCommandResponseInputSchema;
};


export type MutationCreateKeyDestructionEventArgs = {
  input: KeyDestructionEventInputSchema;
};


export type MutationCreateKeyGeneratedEventArgs = {
  input: KeyGeneratedEventInputSchema;
};


export type MutationCreateKeyImportEventArgs = {
  input: KeyImportEventInputSchema;
};


export type MutationCreateKeyIntegrityViolationEventArgs = {
  input: KeyIntegrityViolationEventInputSchema;
};


export type MutationCreateKeyedAppStateArgs = {
  input: KeyedAppStateInputSchema;
};


export type MutationCreateKeyguardDismissAuthAttemptEventArgs = {
  input: KeyguardDismissAuthAttemptEventInputSchema;
};


export type MutationCreateKeyguardDismissedEventArgs = {
  input: KeyguardDismissedEventInputSchema;
};


export type MutationCreateKeyguardSecuredEventArgs = {
  input: KeyguardSecuredEventInputSchema;
};


export type MutationCreateKioskCustomizationArgs = {
  input: KioskCustomizationInputSchema;
};


export type MutationCreateLaunchAppActionArgs = {
  input: LaunchAppActionInputSchema;
};


export type MutationCreateListDevicesResponseArgs = {
  input: ListDevicesResponseInputSchema;
};


export type MutationCreateListEnrollmentTokensResponseArgs = {
  input: ListEnrollmentTokensResponseInputSchema;
};


export type MutationCreateListEnterprisesResponseArgs = {
  input: ListEnterprisesResponseInputSchema;
};


export type MutationCreateListOperationsResponseArgs = {
  input: ListOperationsResponseInputSchema;
};


export type MutationCreateListPoliciesResponseArgs = {
  input: ListPoliciesResponseInputSchema;
};


export type MutationCreateListWebAppsResponseArgs = {
  input: ListWebAppsResponseInputSchema;
};


export type MutationCreateLogBufferSizeCriticalEventArgs = {
  input: LogBufferSizeCriticalEventInputSchema;
};


export type MutationCreateLoggingStartedEventArgs = {
  input: LoggingStartedEventInputSchema;
};


export type MutationCreateLoggingStoppedEventArgs = {
  input: LoggingStoppedEventInputSchema;
};


export type MutationCreateManagedConfigurationTemplateArgs = {
  input: ManagedConfigurationTemplateInputSchema;
};


export type MutationCreateManagedPropertyArgs = {
  input: ManagedPropertyInputSchema;
};


export type MutationCreateManagedPropertyEntryArgs = {
  input: ManagedPropertyEntryInputSchema;
};


export type MutationCreateMdmDeviceArgs = {
  input: MdmDeviceInputSchema;
};


export type MutationCreateMdmPolicyArgs = {
  input: MdmPolicyInputSchema;
};


export type MutationCreateMediaMountEventArgs = {
  input: MediaMountEventInputSchema;
};


export type MutationCreateMediaUnmountEventArgs = {
  input: MediaUnmountEventInputSchema;
};


export type MutationCreateMemoryEventArgs = {
  input: MemoryEventInputSchema;
};


export type MutationCreateMemoryInfoArgs = {
  input: MemoryInfoInputSchema;
};


export type MutationCreateNetworkInfoArgs = {
  input: NetworkInfoInputSchema;
};


export type MutationCreateNonComplianceDetailArgs = {
  input: NonComplianceDetailInputSchema;
};


export type MutationCreateNonComplianceDetailConditionArgs = {
  input: NonComplianceDetailConditionInputSchema;
};


export type MutationCreateOncCertificateProviderArgs = {
  input: OncCertificateProviderInputSchema;
};


export type MutationCreateOncWifiContextArgs = {
  input: OncWifiContextInputSchema;
};


export type MutationCreateOperationArgs = {
  input: OperationInputSchema;
};


export type MutationCreateOsShutdownEventArgs = {
  input: OsShutdownEventInputSchema;
};


export type MutationCreateOsStartupEventArgs = {
  input: OsStartupEventInputSchema;
};


export type MutationCreatePackageNameListArgs = {
  input: PackageNameListInputSchema;
};


export type MutationCreatePasswordPoliciesContextArgs = {
  input: PasswordPoliciesContextInputSchema;
};


export type MutationCreatePasswordRequirementsArgs = {
  input: PasswordRequirementsInputSchema;
};


export type MutationCreatePerAppResultArgs = {
  input: PerAppResultInputSchema;
};


export type MutationCreatePermissionGrantArgs = {
  input: PermissionGrantInputSchema;
};


export type MutationCreatePersistentPreferredActivityArgs = {
  input: PersistentPreferredActivityInputSchema;
};


export type MutationCreatePersonalApplicationPolicyArgs = {
  input: PersonalApplicationPolicyInputSchema;
};


export type MutationCreatePersonalUsagePoliciesArgs = {
  input: PersonalUsagePoliciesInputSchema;
};


export type MutationCreatePolicyArgs = {
  input: PolicyInputSchema;
};


export type MutationCreatePolicyEnforcementRuleArgs = {
  input: PolicyEnforcementRuleInputSchema;
};


export type MutationCreatePostureDetailArgs = {
  input: PostureDetailInputSchema;
};


export type MutationCreatePowerManagementEventArgs = {
  input: PowerManagementEventInputSchema;
};


export type MutationCreateProxyInfoArgs = {
  input: ProxyInfoInputSchema;
};


export type MutationCreateRemoteLockEventArgs = {
  input: RemoteLockEventInputSchema;
};


export type MutationCreateSecurityPostureArgs = {
  input: SecurityPostureInputSchema;
};


export type MutationCreateSetupActionArgs = {
  input: SetupActionInputSchema;
};


export type MutationCreateSigninDetailArgs = {
  input: SigninDetailInputSchema;
};


export type MutationCreateSignupUrlArgs = {
  input: SignupUrlInputSchema;
};


export type MutationCreateSoftwareInfoArgs = {
  input: SoftwareInfoInputSchema;
};


export type MutationCreateSpecificNonComplianceContextArgs = {
  input: SpecificNonComplianceContextInputSchema;
};


export type MutationCreateStatusArgs = {
  input: StatusInputSchema;
};


export type MutationCreateStatusReportingSettingsArgs = {
  input: StatusReportingSettingsInputSchema;
};


export type MutationCreateSwitchDeviceArgs = {
  input: SwitchDeviceInputSchema;
};


export type MutationCreateSystemUpdateArgs = {
  input: SystemUpdateInputSchema;
};


export type MutationCreateSystemUpdateInfoArgs = {
  input: SystemUpdateInfoInputSchema;
};


export type MutationCreateTelephonyInfoArgs = {
  input: TelephonyInfoInputSchema;
};


export type MutationCreateTermsAndConditionsArgs = {
  input: TermsAndConditionsInputSchema;
};


export type MutationCreateUsageLogArgs = {
  input: UsageLogInputSchema;
};


export type MutationCreateUsageLogEventArgs = {
  input: UsageLogEventInputSchema;
};


export type MutationCreateUserArgs = {
  input: UserInputSchema;
};


export type MutationCreateUserFacingMessageArgs = {
  input: UserFacingMessageInputSchema;
};


export type MutationCreateWebAppArgs = {
  input: WebAppInputSchema;
};


export type MutationCreateWebAppIconArgs = {
  input: WebAppIconInputSchema;
};


export type MutationCreateWebTokenArgs = {
  input: WebTokenInputSchema;
};


export type MutationCreateWipeActionArgs = {
  input: WipeActionInputSchema;
};


export type MutationCreateWipeFailureEventArgs = {
  input: WipeFailureEventInputSchema;
};


export type MutationDeleteAdbShellCommandEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteAdbShellInteractiveEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteAdvancedSecurityOverridesArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteAlwaysOnVpnPackageArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteApiLevelConditionArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteAppProcessInfoArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteAppProcessStartEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteAppTrackInfoArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteAppVersionArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteApplicationArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteApplicationEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteApplicationPermissionArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteApplicationPolicyArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteApplicationReportArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteApplicationReportingSettingsArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteBaseDeviceArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteBaseEnrollmentTokenArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteBaseEnterpriseArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteBasePolicyArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteBaseWebTokenArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteBatchUsageLogEventsArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteBlockActionArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteCertAuthorityInstalledEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteCertAuthorityRemovedEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteCertValidationFailureEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteChoosePrivateKeyRuleArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteClearAppsDataParamsArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteClearAppsDataStatusArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteCommandArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteCommonCriteriaModeInfoArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteComplianceRuleArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteConnectEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteContactInfoArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteContentProviderEndpointArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteCrossProfilePoliciesArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteCryptoSelfTestCompletedEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteDateArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteDeviceArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteDeviceConnectivityManagementArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteDeviceSettingsArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteDisplayArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteDnsEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteEmptyArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteEnrollmentTokenArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteEnterpriseArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteExtensionConfigArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteExternalDataArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteFileArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteFilePulledEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteFilePushedEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteFreezePeriodArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteHardwareInfoArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteHardwareStatusArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteIssueCommandResponseArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteKeyDestructionEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteKeyGeneratedEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteKeyImportEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteKeyIntegrityViolationEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteKeyedAppStateArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteKeyguardDismissAuthAttemptEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteKeyguardDismissedEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteKeyguardSecuredEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteKioskCustomizationArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteLaunchAppActionArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteListDevicesResponseArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteListEnrollmentTokensResponseArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteListEnterprisesResponseArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteListOperationsResponseArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteListPoliciesResponseArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteListWebAppsResponseArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteLogBufferSizeCriticalEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteLoggingStartedEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteLoggingStoppedEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteManagedConfigurationTemplateArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteManagedPropertyArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteManagedPropertyEntryArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteMdmDeviceArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteMdmPolicyArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteMediaMountEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteMediaUnmountEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteMemoryEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteMemoryInfoArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteNetworkInfoArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteNonComplianceDetailArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteNonComplianceDetailConditionArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteOncCertificateProviderArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteOncWifiContextArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteOperationArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteOsShutdownEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteOsStartupEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeletePackageNameListArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeletePasswordPoliciesContextArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeletePasswordRequirementsArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeletePerAppResultArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeletePermissionGrantArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeletePersistentPreferredActivityArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeletePersonalApplicationPolicyArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeletePersonalUsagePoliciesArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeletePolicyArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeletePolicyEnforcementRuleArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeletePostureDetailArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeletePowerManagementEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteProxyInfoArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteRemoteLockEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteSecurityPostureArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteSetupActionArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteSigninDetailArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteSignupUrlArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteSoftwareInfoArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteSpecificNonComplianceContextArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteStatusArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteStatusReportingSettingsArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteSwitchDeviceArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteSystemUpdateArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteSystemUpdateInfoArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteTelephonyInfoArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteTermsAndConditionsArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteUsageLogArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteUsageLogEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteUserFacingMessageArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteWebAppArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteWebAppIconArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteWebTokenArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteWipeActionArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteWipeFailureEventArgs = {
  input: Scalars['String']['input'];
};


export type MutationSyncArgs = {
  mdmPolicyId: Scalars['String']['input'];
  preserveSystemApps: Scalars['Boolean']['input'];
};


export type MutationSyncImeisArgs = {
  imeis: Array<Scalars['String']['input']>;
  mdmPolicyId: Scalars['String']['input'];
};


export type MutationTempSetTokenArgs = {
  code: Scalars['String']['input'];
};


export type MutationUpdateAdbShellCommandEventArgs = {
  input: AdbShellCommandEventInputSchema;
};


export type MutationUpdateAdbShellInteractiveEventArgs = {
  input: AdbShellInteractiveEventInputSchema;
};


export type MutationUpdateAdvancedSecurityOverridesArgs = {
  input: AdvancedSecurityOverridesInputSchema;
};


export type MutationUpdateAlwaysOnVpnPackageArgs = {
  input: AlwaysOnVpnPackageInputSchema;
};


export type MutationUpdateApiLevelConditionArgs = {
  input: ApiLevelConditionInputSchema;
};


export type MutationUpdateAppProcessInfoArgs = {
  input: AppProcessInfoInputSchema;
};


export type MutationUpdateAppProcessStartEventArgs = {
  input: AppProcessStartEventInputSchema;
};


export type MutationUpdateAppTrackInfoArgs = {
  input: AppTrackInfoInputSchema;
};


export type MutationUpdateAppVersionArgs = {
  input: AppVersionInputSchema;
};


export type MutationUpdateApplicationArgs = {
  input: ApplicationInputSchema;
};


export type MutationUpdateApplicationEventArgs = {
  input: ApplicationEventInputSchema;
};


export type MutationUpdateApplicationPermissionArgs = {
  input: ApplicationPermissionInputSchema;
};


export type MutationUpdateApplicationPolicyArgs = {
  input: ApplicationPolicyInputSchema;
};


export type MutationUpdateApplicationReportArgs = {
  input: ApplicationReportInputSchema;
};


export type MutationUpdateApplicationReportingSettingsArgs = {
  input: ApplicationReportingSettingsInputSchema;
};


export type MutationUpdateBaseDeviceArgs = {
  input: BaseDeviceInputSchema;
};


export type MutationUpdateBaseEnrollmentTokenArgs = {
  input: BaseEnrollmentTokenInputSchema;
};


export type MutationUpdateBaseEnterpriseArgs = {
  input: BaseEnterpriseInputSchema;
};


export type MutationUpdateBasePolicyArgs = {
  input: BasePolicyInputSchema;
};


export type MutationUpdateBaseWebTokenArgs = {
  input: BaseWebTokenInputSchema;
};


export type MutationUpdateBatchUsageLogEventsArgs = {
  input: BatchUsageLogEventsInputSchema;
};


export type MutationUpdateBlockActionArgs = {
  input: BlockActionInputSchema;
};


export type MutationUpdateCertAuthorityInstalledEventArgs = {
  input: CertAuthorityInstalledEventInputSchema;
};


export type MutationUpdateCertAuthorityRemovedEventArgs = {
  input: CertAuthorityRemovedEventInputSchema;
};


export type MutationUpdateCertValidationFailureEventArgs = {
  input: CertValidationFailureEventInputSchema;
};


export type MutationUpdateChoosePrivateKeyRuleArgs = {
  input: ChoosePrivateKeyRuleInputSchema;
};


export type MutationUpdateClearAppsDataParamsArgs = {
  input: ClearAppsDataParamsInputSchema;
};


export type MutationUpdateClearAppsDataStatusArgs = {
  input: ClearAppsDataStatusInputSchema;
};


export type MutationUpdateCommandArgs = {
  input: CommandInputSchema;
};


export type MutationUpdateCommonCriteriaModeInfoArgs = {
  input: CommonCriteriaModeInfoInputSchema;
};


export type MutationUpdateComplianceRuleArgs = {
  input: ComplianceRuleInputSchema;
};


export type MutationUpdateConnectEventArgs = {
  input: ConnectEventInputSchema;
};


export type MutationUpdateContactInfoArgs = {
  input: ContactInfoInputSchema;
};


export type MutationUpdateContentProviderEndpointArgs = {
  input: ContentProviderEndpointInputSchema;
};


export type MutationUpdateCrossProfilePoliciesArgs = {
  input: CrossProfilePoliciesInputSchema;
};


export type MutationUpdateCryptoSelfTestCompletedEventArgs = {
  input: CryptoSelfTestCompletedEventInputSchema;
};


export type MutationUpdateDateArgs = {
  input: DateInputSchema;
};


export type MutationUpdateDeviceArgs = {
  input: DeviceInputSchema;
};


export type MutationUpdateDeviceConnectivityManagementArgs = {
  input: DeviceConnectivityManagementInputSchema;
};


export type MutationUpdateDeviceSettingsArgs = {
  input: DeviceSettingsInputSchema;
};


export type MutationUpdateDisplayArgs = {
  input: DisplayInputSchema;
};


export type MutationUpdateDnsEventArgs = {
  input: DnsEventInputSchema;
};


export type MutationUpdateEmptyArgs = {
  input: EmptyInputSchema;
};


export type MutationUpdateEnrollmentTokenArgs = {
  input: EnrollmentTokenInputSchema;
};


export type MutationUpdateEnterpriseArgs = {
  input: EnterpriseInputSchema;
};


export type MutationUpdateExtensionConfigArgs = {
  input: ExtensionConfigInputSchema;
};


export type MutationUpdateExternalDataArgs = {
  input: ExternalDataInputSchema;
};


export type MutationUpdateFileArgs = {
  input: FileInputSchema;
};


export type MutationUpdateFilePulledEventArgs = {
  input: FilePulledEventInputSchema;
};


export type MutationUpdateFilePushedEventArgs = {
  input: FilePushedEventInputSchema;
};


export type MutationUpdateFreezePeriodArgs = {
  input: FreezePeriodInputSchema;
};


export type MutationUpdateHardwareInfoArgs = {
  input: HardwareInfoInputSchema;
};


export type MutationUpdateHardwareStatusArgs = {
  input: HardwareStatusInputSchema;
};


export type MutationUpdateIssueCommandResponseArgs = {
  input: IssueCommandResponseInputSchema;
};


export type MutationUpdateKeyDestructionEventArgs = {
  input: KeyDestructionEventInputSchema;
};


export type MutationUpdateKeyGeneratedEventArgs = {
  input: KeyGeneratedEventInputSchema;
};


export type MutationUpdateKeyImportEventArgs = {
  input: KeyImportEventInputSchema;
};


export type MutationUpdateKeyIntegrityViolationEventArgs = {
  input: KeyIntegrityViolationEventInputSchema;
};


export type MutationUpdateKeyedAppStateArgs = {
  input: KeyedAppStateInputSchema;
};


export type MutationUpdateKeyguardDismissAuthAttemptEventArgs = {
  input: KeyguardDismissAuthAttemptEventInputSchema;
};


export type MutationUpdateKeyguardDismissedEventArgs = {
  input: KeyguardDismissedEventInputSchema;
};


export type MutationUpdateKeyguardSecuredEventArgs = {
  input: KeyguardSecuredEventInputSchema;
};


export type MutationUpdateKioskCustomizationArgs = {
  input: KioskCustomizationInputSchema;
};


export type MutationUpdateLaunchAppActionArgs = {
  input: LaunchAppActionInputSchema;
};


export type MutationUpdateListDevicesResponseArgs = {
  input: ListDevicesResponseInputSchema;
};


export type MutationUpdateListEnrollmentTokensResponseArgs = {
  input: ListEnrollmentTokensResponseInputSchema;
};


export type MutationUpdateListEnterprisesResponseArgs = {
  input: ListEnterprisesResponseInputSchema;
};


export type MutationUpdateListOperationsResponseArgs = {
  input: ListOperationsResponseInputSchema;
};


export type MutationUpdateListPoliciesResponseArgs = {
  input: ListPoliciesResponseInputSchema;
};


export type MutationUpdateListWebAppsResponseArgs = {
  input: ListWebAppsResponseInputSchema;
};


export type MutationUpdateLogBufferSizeCriticalEventArgs = {
  input: LogBufferSizeCriticalEventInputSchema;
};


export type MutationUpdateLoggingStartedEventArgs = {
  input: LoggingStartedEventInputSchema;
};


export type MutationUpdateLoggingStoppedEventArgs = {
  input: LoggingStoppedEventInputSchema;
};


export type MutationUpdateManagedConfigurationTemplateArgs = {
  input: ManagedConfigurationTemplateInputSchema;
};


export type MutationUpdateManagedPropertyArgs = {
  input: ManagedPropertyInputSchema;
};


export type MutationUpdateManagedPropertyEntryArgs = {
  input: ManagedPropertyEntryInputSchema;
};


export type MutationUpdateMdmDeviceArgs = {
  input: MdmDeviceInputSchema;
};


export type MutationUpdateMdmPolicyArgs = {
  input: MdmPolicyInputSchema;
};


export type MutationUpdateMediaMountEventArgs = {
  input: MediaMountEventInputSchema;
};


export type MutationUpdateMediaUnmountEventArgs = {
  input: MediaUnmountEventInputSchema;
};


export type MutationUpdateMemoryEventArgs = {
  input: MemoryEventInputSchema;
};


export type MutationUpdateMemoryInfoArgs = {
  input: MemoryInfoInputSchema;
};


export type MutationUpdateNetworkInfoArgs = {
  input: NetworkInfoInputSchema;
};


export type MutationUpdateNonComplianceDetailArgs = {
  input: NonComplianceDetailInputSchema;
};


export type MutationUpdateNonComplianceDetailConditionArgs = {
  input: NonComplianceDetailConditionInputSchema;
};


export type MutationUpdateOncCertificateProviderArgs = {
  input: OncCertificateProviderInputSchema;
};


export type MutationUpdateOncWifiContextArgs = {
  input: OncWifiContextInputSchema;
};


export type MutationUpdateOperationArgs = {
  input: OperationInputSchema;
};


export type MutationUpdateOsShutdownEventArgs = {
  input: OsShutdownEventInputSchema;
};


export type MutationUpdateOsStartupEventArgs = {
  input: OsStartupEventInputSchema;
};


export type MutationUpdatePackageNameListArgs = {
  input: PackageNameListInputSchema;
};


export type MutationUpdatePasswordPoliciesContextArgs = {
  input: PasswordPoliciesContextInputSchema;
};


export type MutationUpdatePasswordRequirementsArgs = {
  input: PasswordRequirementsInputSchema;
};


export type MutationUpdatePerAppResultArgs = {
  input: PerAppResultInputSchema;
};


export type MutationUpdatePermissionGrantArgs = {
  input: PermissionGrantInputSchema;
};


export type MutationUpdatePersistentPreferredActivityArgs = {
  input: PersistentPreferredActivityInputSchema;
};


export type MutationUpdatePersonalApplicationPolicyArgs = {
  input: PersonalApplicationPolicyInputSchema;
};


export type MutationUpdatePersonalUsagePoliciesArgs = {
  input: PersonalUsagePoliciesInputSchema;
};


export type MutationUpdatePolicyArgs = {
  input: PolicyInputSchema;
};


export type MutationUpdatePolicyEnforcementRuleArgs = {
  input: PolicyEnforcementRuleInputSchema;
};


export type MutationUpdatePostureDetailArgs = {
  input: PostureDetailInputSchema;
};


export type MutationUpdatePowerManagementEventArgs = {
  input: PowerManagementEventInputSchema;
};


export type MutationUpdateProxyInfoArgs = {
  input: ProxyInfoInputSchema;
};


export type MutationUpdateRemoteLockEventArgs = {
  input: RemoteLockEventInputSchema;
};


export type MutationUpdateSecurityPostureArgs = {
  input: SecurityPostureInputSchema;
};


export type MutationUpdateSetupActionArgs = {
  input: SetupActionInputSchema;
};


export type MutationUpdateSigninDetailArgs = {
  input: SigninDetailInputSchema;
};


export type MutationUpdateSignupUrlArgs = {
  input: SignupUrlInputSchema;
};


export type MutationUpdateSoftwareInfoArgs = {
  input: SoftwareInfoInputSchema;
};


export type MutationUpdateSpecificNonComplianceContextArgs = {
  input: SpecificNonComplianceContextInputSchema;
};


export type MutationUpdateStatusArgs = {
  input: StatusInputSchema;
};


export type MutationUpdateStatusReportingSettingsArgs = {
  input: StatusReportingSettingsInputSchema;
};


export type MutationUpdateSwitchDeviceArgs = {
  input: SwitchDeviceInputSchema;
};


export type MutationUpdateSystemUpdateArgs = {
  input: SystemUpdateInputSchema;
};


export type MutationUpdateSystemUpdateInfoArgs = {
  input: SystemUpdateInfoInputSchema;
};


export type MutationUpdateTelephonyInfoArgs = {
  input: TelephonyInfoInputSchema;
};


export type MutationUpdateTermsAndConditionsArgs = {
  input: TermsAndConditionsInputSchema;
};


export type MutationUpdateUsageLogArgs = {
  input: UsageLogInputSchema;
};


export type MutationUpdateUsageLogEventArgs = {
  input: UsageLogEventInputSchema;
};


export type MutationUpdateUserArgs = {
  input: UserInputSchema;
};


export type MutationUpdateUserFacingMessageArgs = {
  input: UserFacingMessageInputSchema;
};


export type MutationUpdateWebAppArgs = {
  input: WebAppInputSchema;
};


export type MutationUpdateWebAppIconArgs = {
  input: WebAppIconInputSchema;
};


export type MutationUpdateWebTokenArgs = {
  input: WebTokenInputSchema;
};


export type MutationUpdateWipeActionArgs = {
  input: WipeActionInputSchema;
};


export type MutationUpdateWipeFailureEventArgs = {
  input: WipeFailureEventInputSchema;
};

/** Device network info. */
export type NetworkInfoInputSchema = {
  /** IMEI number of the GSM device. For example, A1000031212. */
  imei?: InputMaybe<Scalars['String']['input']>;
  /** MEID number of the CDMA device. For example, A00000292788E1. */
  meid?: InputMaybe<Scalars['String']['input']>;
  /** Alphabetic name of current registered operator. For example, Vodafone. */
  networkOperatorName?: InputMaybe<Scalars['String']['input']>;
  /** Provides telephony information associated with each SIM card on the device. Only supported on fully managed devices starting from Android API level 23. */
  telephonyInfos?: InputMaybe<Array<TelephonyInfoInputSchema>>;
  /** Wi-Fi MAC address of the device. For example, 7c:11:11:11:11:11. */
  wifiMacAddress?: InputMaybe<Scalars['String']['input']>;
};

export type NetworkInfoQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Device network info. */
export type NetworkInfoSchema = {
  __typename?: 'NetworkInfoSchema';
  /** IMEI number of the GSM device. For example, A1000031212. */
  imei?: Maybe<Scalars['String']['output']>;
  /** MEID number of the CDMA device. For example, A00000292788E1. */
  meid?: Maybe<Scalars['String']['output']>;
  /** Alphabetic name of current registered operator. For example, Vodafone. */
  networkOperatorName?: Maybe<Scalars['String']['output']>;
  /** Provides telephony information associated with each SIM card on the device. Only supported on fully managed devices starting from Android API level 23. */
  telephonyInfos?: Maybe<Array<TelephonyInfoSchema>>;
  /** Wi-Fi MAC address of the device. For example, 7c:11:11:11:11:11. */
  wifiMacAddress?: Maybe<Scalars['String']['output']>;
};

/** A compliance rule condition which is satisfied if there exists any matching NonComplianceDetail for the device. A NonComplianceDetail matches a NonComplianceDetailCondition if all the fields which are set within the NonComplianceDetailCondition match the corresponding NonComplianceDetail fields. */
export type NonComplianceDetailConditionInputSchema = {
  /** The reason the device is not in compliance with the setting. If not set, then this condition matches any reason. */
  nonComplianceReason?: InputMaybe<NonComplianceDetailConditionNonComplianceReason>;
  /** The package name of the app that's out of compliance. If not set, then this condition matches any package name. */
  packageName?: InputMaybe<Scalars['String']['input']>;
  /** The name of the policy setting. This is the JSON field name of a top-level Policy field. If not set, then this condition matches any setting name. */
  settingName?: InputMaybe<Scalars['String']['input']>;
};

export enum NonComplianceDetailConditionNonComplianceReason {
  /** The setting is not supported in the API level of the Android version running on the device. */
  ApiLevel = 'API_LEVEL',
  /** The setting can't be applied to the app because the app doesn't support it, for example because its target SDK version is not high enough. */
  AppIncompatible = 'APP_INCOMPATIBLE',
  /** A blocked app is installed. */
  AppInstalled = 'APP_INSTALLED',
  /** The app required to implement the policy is not installed. */
  AppNotInstalled = 'APP_NOT_INSTALLED',
  /** The app is installed, but it hasn't been updated to the minimum version code specified by policy. */
  AppNotUpdated = 'APP_NOT_UPDATED',
  /** The device is incompatible with the policy requirements. */
  DeviceIncompatible = 'DEVICE_INCOMPATIBLE',
  /** The setting has an invalid value. */
  InvalidValue = 'INVALID_VALUE',
  /** The management mode (profile owner, device owner, etc.) doesn't support the setting. */
  ManagementMode = 'MANAGEMENT_MODE',
  /** This value is disallowed. */
  NonComplianceReasonUnspecified = 'NON_COMPLIANCE_REASON_UNSPECIFIED',
  /** The setting hasn't been applied at the time of the report, but is expected to be applied shortly. */
  Pending = 'PENDING',
  /** The policy is not supported by the version of Android Device Policy on the device. */
  Unsupported = 'UNSUPPORTED',
  /** The user has not taken required action to comply with the setting. */
  UserAction = 'USER_ACTION'
}

export type NonComplianceDetailConditionQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A compliance rule condition which is satisfied if there exists any matching NonComplianceDetail for the device. A NonComplianceDetail matches a NonComplianceDetailCondition if all the fields which are set within the NonComplianceDetailCondition match the corresponding NonComplianceDetail fields. */
export type NonComplianceDetailConditionSchema = {
  __typename?: 'NonComplianceDetailConditionSchema';
  /** The reason the device is not in compliance with the setting. If not set, then this condition matches any reason. */
  nonComplianceReason?: Maybe<NonComplianceDetailConditionNonComplianceReason>;
  /** The package name of the app that's out of compliance. If not set, then this condition matches any package name. */
  packageName?: Maybe<Scalars['String']['output']>;
  /** The name of the policy setting. This is the JSON field name of a top-level Policy field. If not set, then this condition matches any setting name. */
  settingName?: Maybe<Scalars['String']['output']>;
};

/** Provides detail about non-compliance with a policy setting. */
export type NonComplianceDetailInputSchema = {
  /** For settings with nested fields, if a particular nested field is out of compliance, this specifies the full path to the offending field. The path is formatted in the same way the policy JSON field would be referenced in JavaScript, that is: 1) For object-typed fields, the field name is followed by a dot then by a subfield name. 2) For array-typed fields, the field name is followed by the array index enclosed in brackets. For example, to indicate a problem with the url field in the externalData field in the 3rd application, the path would be applications[2].externalData.url */
  fieldPath?: InputMaybe<Scalars['String']['input']>;
  /** If package_name is set and the non-compliance reason is APP_NOT_INSTALLED or APP_NOT_UPDATED, the detailed reason the app can't be installed or updated. */
  installationFailureReason?: InputMaybe<NonComplianceDetailInstallationFailureReason>;
  /** The reason the device is not in compliance with the setting. */
  nonComplianceReason?: InputMaybe<NonComplianceDetailNonComplianceReason>;
  /** The package name indicating which app is out of compliance, if applicable. */
  packageName?: InputMaybe<Scalars['String']['input']>;
  /** The name of the policy setting. This is the JSON field name of a top-level Policy field. */
  settingName?: InputMaybe<Scalars['String']['input']>;
  /** Additional context for specific_non_compliance_reason. */
  specificNonComplianceContext?: InputMaybe<SpecificNonComplianceContextInputSchema>;
  /** The policy-specific reason the device is not in compliance with the setting. */
  specificNonComplianceReason?: InputMaybe<NonComplianceDetailSpecificNonComplianceReason>;
};

export enum NonComplianceDetailInstallationFailureReason {
  /** An unknown condition is preventing the app from being installed. Some potential reasons are that the device doesn't have enough storage, the device network connection is unreliable, or the installation is taking longer than expected. The installation will be retried automatically. */
  InstallationFailureReasonUnknown = 'INSTALLATION_FAILURE_REASON_UNKNOWN',
  /** This value is disallowed. */
  InstallationFailureReasonUnspecified = 'INSTALLATION_FAILURE_REASON_UNSPECIFIED',
  /** The installation is still in progress. */
  InProgress = 'IN_PROGRESS',
  /** The app has not been approved by the admin. */
  NotApproved = 'NOT_APPROVED',
  /** The app is not available in the user's country. */
  NotAvailableInCountry = 'NOT_AVAILABLE_IN_COUNTRY',
  /** The app is incompatible with the device. */
  NotCompatibleWithDevice = 'NOT_COMPATIBLE_WITH_DEVICE',
  /** The enterprise is no longer enrolled with Managed Google Play or the admin has not accepted the latest Managed Google Play Terms of Service. */
  NotEnrolled = 'NOT_ENROLLED',
  /** The app was not found in Play. */
  NotFound = 'NOT_FOUND',
  /** There are no licenses available to assign to the user. */
  NoLicensesRemaining = 'NO_LICENSES_REMAINING',
  /** The app has new permissions that have not been accepted by the admin. */
  PermissionsNotAccepted = 'PERMISSIONS_NOT_ACCEPTED',
  /** The user is no longer valid. The user may have been deleted or disabled. */
  UserInvalid = 'USER_INVALID'
}

export enum NonComplianceDetailNonComplianceReason {
  /** The setting is not supported in the API level of the Android version running on the device. */
  ApiLevel = 'API_LEVEL',
  /** The setting can't be applied to the app because the app doesn't support it, for example because its target SDK version is not high enough. */
  AppIncompatible = 'APP_INCOMPATIBLE',
  /** A blocked app is installed. */
  AppInstalled = 'APP_INSTALLED',
  /** The app required to implement the policy is not installed. */
  AppNotInstalled = 'APP_NOT_INSTALLED',
  /** The app is installed, but it hasn't been updated to the minimum version code specified by policy. */
  AppNotUpdated = 'APP_NOT_UPDATED',
  /** The device is incompatible with the policy requirements. */
  DeviceIncompatible = 'DEVICE_INCOMPATIBLE',
  /** The setting has an invalid value. */
  InvalidValue = 'INVALID_VALUE',
  /** The management mode (profile owner, device owner, etc.) doesn't support the setting. */
  ManagementMode = 'MANAGEMENT_MODE',
  /** This value is disallowed. */
  NonComplianceReasonUnspecified = 'NON_COMPLIANCE_REASON_UNSPECIFIED',
  /** The setting hasn't been applied at the time of the report, but is expected to be applied shortly. */
  Pending = 'PENDING',
  /** The policy is not supported by the version of Android Device Policy on the device. */
  Unsupported = 'UNSUPPORTED',
  /** The user has not taken required action to comply with the setting. */
  UserAction = 'USER_ACTION'
}

export type NonComplianceDetailQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Provides detail about non-compliance with a policy setting. */
export type NonComplianceDetailSchema = {
  __typename?: 'NonComplianceDetailSchema';
  /** For settings with nested fields, if a particular nested field is out of compliance, this specifies the full path to the offending field. The path is formatted in the same way the policy JSON field would be referenced in JavaScript, that is: 1) For object-typed fields, the field name is followed by a dot then by a subfield name. 2) For array-typed fields, the field name is followed by the array index enclosed in brackets. For example, to indicate a problem with the url field in the externalData field in the 3rd application, the path would be applications[2].externalData.url */
  fieldPath?: Maybe<Scalars['String']['output']>;
  /** If package_name is set and the non-compliance reason is APP_NOT_INSTALLED or APP_NOT_UPDATED, the detailed reason the app can't be installed or updated. */
  installationFailureReason?: Maybe<NonComplianceDetailInstallationFailureReason>;
  /** The reason the device is not in compliance with the setting. */
  nonComplianceReason?: Maybe<NonComplianceDetailNonComplianceReason>;
  /** The package name indicating which app is out of compliance, if applicable. */
  packageName?: Maybe<Scalars['String']['output']>;
  /** The name of the policy setting. This is the JSON field name of a top-level Policy field. */
  settingName?: Maybe<Scalars['String']['output']>;
  /** Additional context for specific_non_compliance_reason. */
  specificNonComplianceContext?: Maybe<SpecificNonComplianceContextSchema>;
  /** The policy-specific reason the device is not in compliance with the setting. */
  specificNonComplianceReason?: Maybe<NonComplianceDetailSpecificNonComplianceReason>;
};

export enum NonComplianceDetailSpecificNonComplianceReason {
  /** The ONC Wi-Fi setting is not supported in the API level of the Android version running on the device. fieldPath specifies which field value is not supported. oncWifiContext is set. nonComplianceReason is set to API_LEVEL. */
  OncWifiApiLevel = 'ONC_WIFI_API_LEVEL',
  /** There is an incorrect value in ONC Wi-Fi configuration. fieldPath specifies which field value is incorrect. oncWifiContext is set. nonComplianceReason is set to INVALID_VALUE. */
  OncWifiInvalidValue = 'ONC_WIFI_INVALID_VALUE',
  /** The device or profile password has expired. passwordPoliciesContext is set. nonComplianceReason is set to USER_ACTION. */
  PasswordPoliciesPasswordExpired = 'PASSWORD_POLICIES_PASSWORD_EXPIRED',
  /** The device password does not satisfy password requirements. passwordPoliciesContext is set. nonComplianceReason is set to USER_ACTION. */
  PasswordPoliciesPasswordNotSufficient = 'PASSWORD_POLICIES_PASSWORD_NOT_SUFFICIENT',
  /** User needs to confirm credentials by entering the screen lock. Fields in specific_non_compliance_context are not set. nonComplianceReason is set to USER_ACTION. */
  PasswordPoliciesUserCredentialsConfirmationRequired = 'PASSWORD_POLICIES_USER_CREDENTIALS_CONFIRMATION_REQUIRED',
  /** Specific non-compliance reason is not specified. Fields in specific_non_compliance_context are not set. */
  SpecificNonComplianceReasonUnspecified = 'SPECIFIC_NON_COMPLIANCE_REASON_UNSPECIFIED'
}

/** This feature is not generally available. */
export type OncCertificateProviderInputSchema = {
  /** This feature is not generally available. */
  certificateReferences?: InputMaybe<Array<Scalars['String']['input']>>;
  /** This feature is not generally available. */
  contentProviderEndpoint?: InputMaybe<ContentProviderEndpointInputSchema>;
};

export type OncCertificateProviderQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** This feature is not generally available. */
export type OncCertificateProviderSchema = {
  __typename?: 'OncCertificateProviderSchema';
  /** This feature is not generally available. */
  certificateReferences?: Maybe<Array<Scalars['String']['output']>>;
  /** This feature is not generally available. */
  contentProviderEndpoint?: Maybe<ContentProviderEndpointSchema>;
};

/** Additional context for non-compliance related to Wi-Fi configuration. */
export type OncWifiContextInputSchema = {
  /** The GUID of non-compliant Wi-Fi configuration. */
  wifiGuid?: InputMaybe<Scalars['String']['input']>;
};

export type OncWifiContextQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Additional context for non-compliance related to Wi-Fi configuration. */
export type OncWifiContextSchema = {
  __typename?: 'OncWifiContextSchema';
  /** The GUID of non-compliant Wi-Fi configuration. */
  wifiGuid?: Maybe<Scalars['String']['output']>;
};

/** This resource represents a long-running operation that is the result of a network API call. */
export type OperationInputSchema = {
  /** If the value is false, it means the operation is still in progress. If true, the operation is completed, and either error or response is available. */
  done?: InputMaybe<Scalars['Boolean']['input']>;
  /** The error result of the operation in case of failure or cancellation. */
  error?: InputMaybe<StatusInputSchema>;
  /** Service-specific metadata associated with the operation. It typically contains progress information and common metadata such as create time. Some services might not provide such metadata. Any method that returns a long-running operation should document the metadata type, if any. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The server-assigned name, which is only unique within the same service that originally returns it. If you use the default HTTP mapping, the name should be a resource name ending with operations/{unique_id}. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The normal response of the operation in case of success. If the original method returns no data on success, such as Delete, the response is google.protobuf.Empty. If the original method is standard Get/Create/Update, the response should be the resource. For other methods, the response should have the type XxxResponse, where Xxx is the original method name. For example, if the original method name is TakeSnapshot(), the inferred response type is TakeSnapshotResponse. */
  response?: InputMaybe<Scalars['JSON']['input']>;
};

export type OperationQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** This resource represents a long-running operation that is the result of a network API call. */
export type OperationSchema = {
  __typename?: 'OperationSchema';
  /** If the value is false, it means the operation is still in progress. If true, the operation is completed, and either error or response is available. */
  done?: Maybe<Scalars['Boolean']['output']>;
  /** The error result of the operation in case of failure or cancellation. */
  error?: Maybe<StatusSchema>;
  /** Service-specific metadata associated with the operation. It typically contains progress information and common metadata such as create time. Some services might not provide such metadata. Any method that returns a long-running operation should document the metadata type, if any. */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** The server-assigned name, which is only unique within the same service that originally returns it. If you use the default HTTP mapping, the name should be a resource name ending with operations/{unique_id}. */
  name?: Maybe<Scalars['String']['output']>;
  /** The normal response of the operation in case of success. If the original method returns no data on success, such as Delete, the response is google.protobuf.Empty. If the original method is standard Get/Create/Update, the response should be the resource. For other methods, the response should have the type XxxResponse, where Xxx is the original method name. For example, if the original method name is TakeSnapshot(), the inferred response type is TakeSnapshotResponse. */
  response?: Maybe<Scalars['JSON']['output']>;
};

/** Device was shutdown. Intentionally empty. */
export type OsShutdownEventInputSchema = {
  /** Placeholder field to prevent empty schema. */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type OsShutdownEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Device was shutdown. Intentionally empty. */
export type OsShutdownEventSchema = {
  __typename?: 'OsShutdownEventSchema';
  /** Placeholder field to prevent empty schema. */
  _?: Maybe<Scalars['String']['output']>;
};

/** Device was started. */
export type OsStartupEventInputSchema = {
  /** Verified Boot state. */
  verifiedBootState?: InputMaybe<OsStartupEventVerifiedBootState>;
  /** dm-verity mode. */
  verityMode?: InputMaybe<OsStartupEventVerityMode>;
};

export type OsStartupEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Device was started. */
export type OsStartupEventSchema = {
  __typename?: 'OsStartupEventSchema';
  /** Verified Boot state. */
  verifiedBootState?: Maybe<OsStartupEventVerifiedBootState>;
  /** dm-verity mode. */
  verityMode?: Maybe<OsStartupEventVerityMode>;
};

export enum OsStartupEventVerifiedBootState {
  /** Indicates that there is a full chain of trust extending from the bootloader to verified partitions including the bootloader, boot partition, and all verified partitions. */
  Green = 'GREEN',
  /** Indicates that the device may be freely modified. Device integrity is left to the user to verify out-of-band. */
  Orange = 'ORANGE',
  /** Unknown value. */
  VerifiedBootStateUnspecified = 'VERIFIED_BOOT_STATE_UNSPECIFIED',
  /** Indicates that the boot partition has been verified using the embedded certificate and the signature is valid. */
  Yellow = 'YELLOW'
}

export enum OsStartupEventVerityMode {
  /** Indicates that dm-verity is disabled on device. */
  Disabled = 'DISABLED',
  /** Unknown value. */
  DmVerityModeUnspecified = 'DM_VERITY_MODE_UNSPECIFIED',
  /** Indicates that the device will be restarted when corruption is detected. */
  Enforcing = 'ENFORCING',
  /** Indicates that an I/O error will be returned for an attempt to read corrupted data blocks (also known as eio boot state). */
  IoError = 'IO_ERROR'
}

/** A list of package names. */
export type PackageNameListInputSchema = {
  /** A list of package names. */
  packageNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PackageNameListQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A list of package names. */
export type PackageNameListSchema = {
  __typename?: 'PackageNameListSchema';
  /** A list of package names. */
  packageNames?: Maybe<Array<Scalars['String']['output']>>;
};

/** Additional context for non-compliance related to password policies. */
export type PasswordPoliciesContextInputSchema = {
  /** The scope of non-compliant password. */
  passwordPolicyScope?: InputMaybe<PasswordPoliciesContextPasswordPolicyScope>;
};

export enum PasswordPoliciesContextPasswordPolicyScope {
  /** The password requirements are only applied to the device. */
  ScopeDevice = 'SCOPE_DEVICE',
  /** The password requirements are only applied to the work profile. */
  ScopeProfile = 'SCOPE_PROFILE',
  /** The scope is unspecified. The password requirements are applied to the work profile for work profile devices and the whole device for fully managed or dedicated devices. */
  ScopeUnspecified = 'SCOPE_UNSPECIFIED'
}

export type PasswordPoliciesContextQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Additional context for non-compliance related to password policies. */
export type PasswordPoliciesContextSchema = {
  __typename?: 'PasswordPoliciesContextSchema';
  /** The scope of non-compliant password. */
  passwordPolicyScope?: Maybe<PasswordPoliciesContextPasswordPolicyScope>;
};

/** Requirements for the password used to unlock a device. */
export type PasswordRequirementsInputSchema = {
  /** Number of incorrect device-unlock passwords that can be entered before a device is wiped. A value of 0 means there is no restriction. */
  maximumFailedPasswordsForWipe?: InputMaybe<Scalars['Int']['input']>;
  /** Password expiration timeout. */
  passwordExpirationTimeout?: InputMaybe<Scalars['String']['input']>;
  /** The length of the password history. After setting this field, the user won't be able to enter a new password that is the same as any password in the history. A value of 0 means there is no restriction. */
  passwordHistoryLength?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum allowed password length. A value of 0 means there is no restriction. Only enforced when password_quality is NUMERIC, NUMERIC_COMPLEX, ALPHABETIC, ALPHANUMERIC, or COMPLEX. */
  passwordMinimumLength?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum number of letters required in the password. Only enforced when password_quality is COMPLEX. */
  passwordMinimumLetters?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum number of lower case letters required in the password. Only enforced when password_quality is COMPLEX. */
  passwordMinimumLowerCase?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum number of non-letter characters (numerical digits or symbols) required in the password. Only enforced when password_quality is COMPLEX. */
  passwordMinimumNonLetter?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum number of numerical digits required in the password. Only enforced when password_quality is COMPLEX. */
  passwordMinimumNumeric?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum number of symbols required in the password. Only enforced when password_quality is COMPLEX. */
  passwordMinimumSymbols?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum number of upper case letters required in the password. Only enforced when password_quality is COMPLEX. */
  passwordMinimumUpperCase?: InputMaybe<Scalars['Int']['input']>;
  /** The required password quality. */
  passwordQuality?: InputMaybe<PasswordRequirementsPasswordQuality>;
  /** The scope that the password requirement applies to. */
  passwordScope?: InputMaybe<PasswordRequirementsPasswordScope>;
  /** The length of time after a device or work profile is unlocked using a strong form of authentication (password, PIN, pattern) that it can be unlocked using any other authentication method (e.g. fingerprint, trust agents, face). After the specified time period elapses, only strong forms of authentication can be used to unlock the device or work profile. */
  requirePasswordUnlock?: InputMaybe<PasswordRequirementsRequirePasswordUnlock>;
  /** Controls whether a unified lock is allowed for the device and the work profile, on devices running Android 9 and above with a work profile. This can be set only if password_scope is set to SCOPE_PROFILE, the policy will be rejected otherwise. If user has not set a separate work lock and this field is set to REQUIRE_SEPARATE_WORK_LOCK, a NonComplianceDetail is reported with nonComplianceReason set to USER_ACTION. */
  unifiedLockSettings?: InputMaybe<PasswordRequirementsUnifiedLockSettings>;
};

export enum PasswordRequirementsPasswordQuality {
  /** The password must contain alphabetic (or symbol) characters.This, when applied on personally owned work profile devices on Android 12 device-scoped, will be treated as COMPLEXITY_HIGH for application. See PasswordQuality for details. */
  Alphabetic = 'ALPHABETIC',
  /** The password must contain both numeric and alphabetic (or symbol) characters.This, when applied on personally owned work profile devices on Android 12 device-scoped, will be treated as COMPLEXITY_HIGH for application. See PasswordQuality for details. */
  Alphanumeric = 'ALPHANUMERIC',
  /** The device must be secured with a low-security biometric recognition technology, at minimum. This includes technologies that can recognize the identity of an individual that are roughly equivalent to a 3-digit PIN (false detection is less than 1 in 1,000).This, when applied on personally owned work profile devices on Android 12 device-scoped, will be treated as COMPLEXITY_LOW for application. See PasswordQuality for details. */
  BiometricWeak = 'BIOMETRIC_WEAK',
  /** The password must meet the minimum requirements specified in passwordMinimumLength, passwordMinimumLetters, passwordMinimumSymbols, etc. For example, if passwordMinimumSymbols is 2, the password must contain at least two symbols.This, when applied on personally owned work profile devices on Android 12 device-scoped, will be treated as COMPLEXITY_HIGH for application. In this case, the requirements in passwordMinimumLength, passwordMinimumLetters, passwordMinimumSymbols, etc are not applied. See PasswordQuality for details. */
  Complex = 'COMPLEX',
  /** Define the high password complexity band as:On Android 12 and above: PIN with no repeating (4444) or ordered (1234, 4321, 2468) sequences, length at least 8 alphabetic, length at least 6 alphanumeric, length at least 6This sets the minimum complexity band which the password must meet.Enforcement varies among different Android versions, management modes and password scopes. See PasswordQuality for details. */
  ComplexityHigh = 'COMPLEXITY_HIGH',
  /** Define the low password complexity band as: pattern PIN with repeating (4444) or ordered (1234, 4321, 2468) sequencesThis sets the minimum complexity band which the password must meet.Enforcement varies among different Android versions, management modes and password scopes. See PasswordQuality for details. */
  ComplexityLow = 'COMPLEXITY_LOW',
  /** Define the medium password complexity band as: PIN with no repeating (4444) or ordered (1234, 4321, 2468) sequences, length at least 4 alphabetic, length at least 4 alphanumeric, length at least 4This sets the minimum complexity band which the password must meet.Enforcement varies among different Android versions, management modes and password scopes. See PasswordQuality for details. */
  ComplexityMedium = 'COMPLEXITY_MEDIUM',
  /** The password must contain numeric characters.This, when applied on personally owned work profile devices on Android 12 device-scoped, will be treated as COMPLEXITY_MEDIUM for application. See PasswordQuality for details. */
  Numeric = 'NUMERIC',
  /** The password must contain numeric characters with no repeating (4444) or ordered (1234, 4321, 2468) sequences.This, when applied on personally owned work profile devices on Android 12 device-scoped, will be treated as COMPLEXITY_MEDIUM for application. See PasswordQuality for details. */
  NumericComplex = 'NUMERIC_COMPLEX',
  /** There are no password requirements. */
  PasswordQualityUnspecified = 'PASSWORD_QUALITY_UNSPECIFIED',
  /** A password is required, but there are no restrictions on what the password must contain.This, when applied on personally owned work profile devices on Android 12 device-scoped, will be treated as COMPLEXITY_LOW for application. See PasswordQuality for details. */
  Something = 'SOMETHING'
}

export enum PasswordRequirementsPasswordScope {
  /** The password requirements are only applied to the device. */
  ScopeDevice = 'SCOPE_DEVICE',
  /** The password requirements are only applied to the work profile. */
  ScopeProfile = 'SCOPE_PROFILE',
  /** The scope is unspecified. The password requirements are applied to the work profile for work profile devices and the whole device for fully managed or dedicated devices. */
  ScopeUnspecified = 'SCOPE_UNSPECIFIED'
}

export type PasswordRequirementsQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

export enum PasswordRequirementsRequirePasswordUnlock {
  /** The timeout period is set to 24 hours. */
  RequireEveryDay = 'REQUIRE_EVERY_DAY',
  /** Unspecified. Defaults to USE_DEFAULT_DEVICE_TIMEOUT. */
  RequirePasswordUnlockUnspecified = 'REQUIRE_PASSWORD_UNLOCK_UNSPECIFIED',
  /** The timeout period is set to the device’s default. */
  UseDefaultDeviceTimeout = 'USE_DEFAULT_DEVICE_TIMEOUT'
}

/** Requirements for the password used to unlock a device. */
export type PasswordRequirementsSchema = {
  __typename?: 'PasswordRequirementsSchema';
  /** Number of incorrect device-unlock passwords that can be entered before a device is wiped. A value of 0 means there is no restriction. */
  maximumFailedPasswordsForWipe?: Maybe<Scalars['Int']['output']>;
  /** Password expiration timeout. */
  passwordExpirationTimeout?: Maybe<Scalars['String']['output']>;
  /** The length of the password history. After setting this field, the user won't be able to enter a new password that is the same as any password in the history. A value of 0 means there is no restriction. */
  passwordHistoryLength?: Maybe<Scalars['Int']['output']>;
  /** The minimum allowed password length. A value of 0 means there is no restriction. Only enforced when password_quality is NUMERIC, NUMERIC_COMPLEX, ALPHABETIC, ALPHANUMERIC, or COMPLEX. */
  passwordMinimumLength?: Maybe<Scalars['Int']['output']>;
  /** Minimum number of letters required in the password. Only enforced when password_quality is COMPLEX. */
  passwordMinimumLetters?: Maybe<Scalars['Int']['output']>;
  /** Minimum number of lower case letters required in the password. Only enforced when password_quality is COMPLEX. */
  passwordMinimumLowerCase?: Maybe<Scalars['Int']['output']>;
  /** Minimum number of non-letter characters (numerical digits or symbols) required in the password. Only enforced when password_quality is COMPLEX. */
  passwordMinimumNonLetter?: Maybe<Scalars['Int']['output']>;
  /** Minimum number of numerical digits required in the password. Only enforced when password_quality is COMPLEX. */
  passwordMinimumNumeric?: Maybe<Scalars['Int']['output']>;
  /** Minimum number of symbols required in the password. Only enforced when password_quality is COMPLEX. */
  passwordMinimumSymbols?: Maybe<Scalars['Int']['output']>;
  /** Minimum number of upper case letters required in the password. Only enforced when password_quality is COMPLEX. */
  passwordMinimumUpperCase?: Maybe<Scalars['Int']['output']>;
  /** The required password quality. */
  passwordQuality?: Maybe<PasswordRequirementsPasswordQuality>;
  /** The scope that the password requirement applies to. */
  passwordScope?: Maybe<PasswordRequirementsPasswordScope>;
  /** The length of time after a device or work profile is unlocked using a strong form of authentication (password, PIN, pattern) that it can be unlocked using any other authentication method (e.g. fingerprint, trust agents, face). After the specified time period elapses, only strong forms of authentication can be used to unlock the device or work profile. */
  requirePasswordUnlock?: Maybe<PasswordRequirementsRequirePasswordUnlock>;
  /** Controls whether a unified lock is allowed for the device and the work profile, on devices running Android 9 and above with a work profile. This can be set only if password_scope is set to SCOPE_PROFILE, the policy will be rejected otherwise. If user has not set a separate work lock and this field is set to REQUIRE_SEPARATE_WORK_LOCK, a NonComplianceDetail is reported with nonComplianceReason set to USER_ACTION. */
  unifiedLockSettings?: Maybe<PasswordRequirementsUnifiedLockSettings>;
};

export enum PasswordRequirementsUnifiedLockSettings {
  /** A common lock for the device and the work profile is allowed. */
  AllowUnifiedWorkAndPersonalLock = 'ALLOW_UNIFIED_WORK_AND_PERSONAL_LOCK',
  /** A separate lock for the work profile is required. */
  RequireSeparateWorkLock = 'REQUIRE_SEPARATE_WORK_LOCK',
  /** Unspecified. Defaults to ALLOW_UNIFIED_WORK_AND_PERSONAL_LOCK. */
  UnifiedLockSettingsUnspecified = 'UNIFIED_LOCK_SETTINGS_UNSPECIFIED'
}

export enum PerAppResultClearingResult {
  /** This app’s data could not be cleared because the device API level does not support this command. */
  ApiLevel = 'API_LEVEL',
  /** This app’s data could not be cleared because the app was not found. */
  AppNotFound = 'APP_NOT_FOUND',
  /** This app’s data could not be cleared because the app is protected. For example, this may apply to apps critical to the functioning of the device, such as Google Play Store. */
  AppProtected = 'APP_PROTECTED',
  /** Unspecified result. */
  ClearingResultUnspecified = 'CLEARING_RESULT_UNSPECIFIED',
  /** This app’s data was successfully cleared. */
  Success = 'SUCCESS'
}

/** The result of an attempt to clear the data of a single app. */
export type PerAppResultInputSchema = {
  /** The result of an attempt to clear the data of a single app. */
  clearingResult?: InputMaybe<PerAppResultClearingResult>;
};

export type PerAppResultQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** The result of an attempt to clear the data of a single app. */
export type PerAppResultSchema = {
  __typename?: 'PerAppResultSchema';
  /** The result of an attempt to clear the data of a single app. */
  clearingResult?: Maybe<PerAppResultClearingResult>;
};

/** Configuration for an Android permission and its grant state. */
export type PermissionGrantInputSchema = {
  /** The Android permission or group, e.g. android.permission.READ_CALENDAR or android.permission_group.CALENDAR. */
  permission?: InputMaybe<Scalars['String']['input']>;
  /** The policy for granting the permission. */
  policy?: InputMaybe<PermissionGrantPolicy>;
};

export enum PermissionGrantPolicy {
  /** Automatically deny a permission. */
  Deny = 'DENY',
  /** Automatically grant a permission. */
  Grant = 'GRANT',
  /** Policy not specified. If no policy is specified for a permission at any level, then the PROMPT behavior is used by default. */
  PermissionPolicyUnspecified = 'PERMISSION_POLICY_UNSPECIFIED',
  /** Prompt the user to grant a permission. */
  Prompt = 'PROMPT'
}

export type PermissionGrantQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Configuration for an Android permission and its grant state. */
export type PermissionGrantSchema = {
  __typename?: 'PermissionGrantSchema';
  /** The Android permission or group, e.g. android.permission.READ_CALENDAR or android.permission_group.CALENDAR. */
  permission?: Maybe<Scalars['String']['output']>;
  /** The policy for granting the permission. */
  policy?: Maybe<PermissionGrantPolicy>;
};

/** A default activity for handling intents that match a particular intent filter. Note: To set up a kiosk, use InstallType to KIOSK rather than use persistent preferred activities. */
export type PersistentPreferredActivityInputSchema = {
  /** The intent actions to match in the filter. If any actions are included in the filter, then an intent's action must be one of those values for it to match. If no actions are included, the intent action is ignored. */
  actions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The intent categories to match in the filter. An intent includes the categories that it requires, all of which must be included in the filter in order to match. In other words, adding a category to the filter has no impact on matching unless that category is specified in the intent. */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The activity that should be the default intent handler. This should be an Android component name, e.g. com.android.enterprise.app/.MainActivity. Alternatively, the value may be the package name of an app, which causes Android Device Policy to choose an appropriate activity from the app to handle the intent. */
  receiverActivity?: InputMaybe<Scalars['String']['input']>;
};

export type PersistentPreferredActivityQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A default activity for handling intents that match a particular intent filter. Note: To set up a kiosk, use InstallType to KIOSK rather than use persistent preferred activities. */
export type PersistentPreferredActivitySchema = {
  __typename?: 'PersistentPreferredActivitySchema';
  /** The intent actions to match in the filter. If any actions are included in the filter, then an intent's action must be one of those values for it to match. If no actions are included, the intent action is ignored. */
  actions?: Maybe<Array<Scalars['String']['output']>>;
  /** The intent categories to match in the filter. An intent includes the categories that it requires, all of which must be included in the filter in order to match. In other words, adding a category to the filter has no impact on matching unless that category is specified in the intent. */
  categories?: Maybe<Array<Scalars['String']['output']>>;
  /** The activity that should be the default intent handler. This should be an Android component name, e.g. com.android.enterprise.app/.MainActivity. Alternatively, the value may be the package name of an app, which causes Android Device Policy to choose an appropriate activity from the app to handle the intent. */
  receiverActivity?: Maybe<Scalars['String']['output']>;
};

/** Policies for apps in the personal profile of a company-owned device with a work profile. */
export type PersonalApplicationPolicyInputSchema = {
  /** The type of installation to perform. */
  installType?: InputMaybe<PersonalApplicationPolicyInstallType>;
  /** The package name of the application. */
  packageName?: InputMaybe<Scalars['String']['input']>;
};

export enum PersonalApplicationPolicyInstallType {
  /** The app is available to install in the personal profile. */
  Available = 'AVAILABLE',
  /** The app is blocked and can't be installed in the personal profile. */
  Blocked = 'BLOCKED',
  /** Unspecified. Defaults to AVAILABLE. */
  InstallTypeUnspecified = 'INSTALL_TYPE_UNSPECIFIED'
}

export type PersonalApplicationPolicyQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Policies for apps in the personal profile of a company-owned device with a work profile. */
export type PersonalApplicationPolicySchema = {
  __typename?: 'PersonalApplicationPolicySchema';
  /** The type of installation to perform. */
  installType?: Maybe<PersonalApplicationPolicyInstallType>;
  /** The package name of the application. */
  packageName?: Maybe<Scalars['String']['output']>;
};

/** Policies controlling personal usage on a company-owned device with a work profile. */
export type PersonalUsagePoliciesInputSchema = {
  /** Account types that can't be managed by the user. */
  accountTypesWithManagementDisabled?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true, the camera is disabled on the personal profile. */
  cameraDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Controls how long the work profile can stay off. The duration must be at least 3 days. */
  maxDaysWithWorkOff?: InputMaybe<Scalars['Int']['input']>;
  /** Policy applied to applications in the personal profile. */
  personalApplications?: InputMaybe<Array<PersonalApplicationPolicyInputSchema>>;
  /** Used together with personalApplications to control how apps in the personal profile are allowed or blocked. */
  personalPlayStoreMode?: InputMaybe<PersonalUsagePoliciesPersonalPlayStoreMode>;
  /** If true, screen capture is disabled for all users. */
  screenCaptureDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PersonalUsagePoliciesPersonalPlayStoreMode {
  /** Only apps explicitly specified in personalApplications with installType set to AVAILABLE are allowed to be installed in the personal profile. */
  Allowlist = 'ALLOWLIST',
  /** All Play Store apps are available for installation in the personal profile, except those whose installType is BLOCKED in personalApplications. */
  Blacklist = 'BLACKLIST',
  /** All Play Store apps are available for installation in the personal profile, except those whose installType is BLOCKED in personalApplications. */
  Blocklist = 'BLOCKLIST',
  /** Unspecified. Defaults to BLOCKLIST. */
  PlayStoreModeUnspecified = 'PLAY_STORE_MODE_UNSPECIFIED'
}

export type PersonalUsagePoliciesQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Policies controlling personal usage on a company-owned device with a work profile. */
export type PersonalUsagePoliciesSchema = {
  __typename?: 'PersonalUsagePoliciesSchema';
  /** Account types that can't be managed by the user. */
  accountTypesWithManagementDisabled?: Maybe<Array<Scalars['String']['output']>>;
  /** If true, the camera is disabled on the personal profile. */
  cameraDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Controls how long the work profile can stay off. The duration must be at least 3 days. */
  maxDaysWithWorkOff?: Maybe<Scalars['Int']['output']>;
  /** Policy applied to applications in the personal profile. */
  personalApplications?: Maybe<Array<PersonalApplicationPolicySchema>>;
  /** Used together with personalApplications to control how apps in the personal profile are allowed or blocked. */
  personalPlayStoreMode?: Maybe<PersonalUsagePoliciesPersonalPlayStoreMode>;
  /** If true, screen capture is disabled for all users. */
  screenCaptureDisabled?: Maybe<Scalars['Boolean']['output']>;
};

export enum PolicyAndroidDevicePolicyTracks {
  /** This value is ignored. */
  AppTrackUnspecified = 'APP_TRACK_UNSPECIFIED',
  /** The beta track, which provides the latest beta release. */
  Beta = 'BETA',
  /** The production track, which provides the latest stable release. */
  Production = 'PRODUCTION'
}

export enum PolicyAppAutoUpdatePolicy {
  /** Apps are auto-updated at any time. Data charges may apply. */
  Always = 'ALWAYS',
  /** The auto-update policy is not set. Equivalent to CHOICE_TO_THE_USER. */
  AppAutoUpdatePolicyUnspecified = 'APP_AUTO_UPDATE_POLICY_UNSPECIFIED',
  /** The user can control auto-updates. */
  ChoiceToTheUser = 'CHOICE_TO_THE_USER',
  /** Apps are never auto-updated. */
  Never = 'NEVER',
  /** Apps are auto-updated over Wi-Fi only. */
  WifiOnly = 'WIFI_ONLY'
}

export enum PolicyAutoDateAndTimeZone {
  /** Enforce auto date, time, and time zone on the device. */
  AutoDateAndTimeZoneEnforced = 'AUTO_DATE_AND_TIME_ZONE_ENFORCED',
  /** Unspecified. Defaults to AUTO_DATE_AND_TIME_ZONE_USER_CHOICE. */
  AutoDateAndTimeZoneUnspecified = 'AUTO_DATE_AND_TIME_ZONE_UNSPECIFIED',
  /** Auto date, time, and time zone are left to user's choice. */
  AutoDateAndTimeZoneUserChoice = 'AUTO_DATE_AND_TIME_ZONE_USER_CHOICE'
}

export enum PolicyCameraAccess {
  /** The field camera_disabled is ignored. All cameras on the device are disabled (for fully managed devices, this applies device-wide and for work profiles this applies only to the work profile).There are no explicit restrictions placed on the camera access toggle on Android 12 and above: on fully managed devices, the camera access toggle has no effect as all cameras are disabled. On devices with a work profile, this toggle has no effect on apps in the work profile, but it affects apps outside the work profile. */
  CameraAccessDisabled = 'CAMERA_ACCESS_DISABLED',
  /** The field camera_disabled is ignored. All cameras on the device are available. On fully managed devices running Android 12 and above, the user is unable to use the camera access toggle. On devices which are not fully managed or which run Android 11 or below, this is equivalent to CAMERA_ACCESS_USER_CHOICE. */
  CameraAccessEnforced = 'CAMERA_ACCESS_ENFORCED',
  /** If camera_disabled is true, this is equivalent to CAMERA_ACCESS_DISABLED. Otherwise, this is equivalent to CAMERA_ACCESS_USER_CHOICE. */
  CameraAccessUnspecified = 'CAMERA_ACCESS_UNSPECIFIED',
  /** The field camera_disabled is ignored. This is the default device behaviour: all cameras on the device are available. On Android 12 and above, the user can use the camera access toggle. */
  CameraAccessUserChoice = 'CAMERA_ACCESS_USER_CHOICE'
}

export enum PolicyDefaultPermissionPolicy {
  /** Automatically deny a permission. */
  Deny = 'DENY',
  /** Automatically grant a permission. */
  Grant = 'GRANT',
  /** Policy not specified. If no policy is specified for a permission at any level, then the PROMPT behavior is used by default. */
  PermissionPolicyUnspecified = 'PERMISSION_POLICY_UNSPECIFIED',
  /** Prompt the user to grant a permission. */
  Prompt = 'PROMPT'
}

export enum PolicyEncryptionPolicy {
  /** Encryption required but no password required to boot */
  EnabledWithoutPassword = 'ENABLED_WITHOUT_PASSWORD',
  /** Encryption required with password required to boot */
  EnabledWithPassword = 'ENABLED_WITH_PASSWORD',
  /** This value is ignored, i.e. no encryption required */
  EncryptionPolicyUnspecified = 'ENCRYPTION_POLICY_UNSPECIFIED'
}

/** A rule that defines the actions to take if a device or work profile is not compliant with the policy specified in settingName. */
export type PolicyEnforcementRuleInputSchema = {
  /** An action to block access to apps and data on a company owned device or in a work profile. This action also triggers a user-facing notification with information (where possible) on how to correct the compliance issue. Note: wipeAction must also be specified. */
  blockAction?: InputMaybe<BlockActionInputSchema>;
  /** The top-level policy to enforce. For example, applications or passwordPolicies. */
  settingName?: InputMaybe<Scalars['String']['input']>;
  /** An action to reset a company owned device or delete a work profile. Note: blockAction must also be specified. */
  wipeAction?: InputMaybe<WipeActionInputSchema>;
};

export type PolicyEnforcementRuleQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A rule that defines the actions to take if a device or work profile is not compliant with the policy specified in settingName. */
export type PolicyEnforcementRuleSchema = {
  __typename?: 'PolicyEnforcementRuleSchema';
  /** An action to block access to apps and data on a company owned device or in a work profile. This action also triggers a user-facing notification with information (where possible) on how to correct the compliance issue. Note: wipeAction must also be specified. */
  blockAction?: Maybe<BlockActionSchema>;
  /** The top-level policy to enforce. For example, applications or passwordPolicies. */
  settingName?: Maybe<Scalars['String']['output']>;
  /** An action to reset a company owned device or delete a work profile. Note: blockAction must also be specified. */
  wipeAction?: Maybe<WipeActionSchema>;
};

export type PolicyInputSchema = {
  /** Account types that can't be managed by the user. */
  accountTypesWithManagementDisabled?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether adding new users and profiles is disabled. */
  addUserDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether adjusting the master volume is disabled. Also mutes the device. */
  adjustVolumeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Security policies set to secure values by default. To maintain the security posture of a device, we don't recommend overriding any of the default values. */
  advancedSecurityOverrides?: InputMaybe<AdvancedSecurityOverridesInputSchema>;
  /** Configuration for an always-on VPN connection. Use with vpn_config_disabled to prevent modification of this setting. */
  alwaysOnVpnPackage?: InputMaybe<AlwaysOnVpnPackageInputSchema>;
  /** The app tracks for Android Device Policy the device can access. The device receives the latest version among all accessible tracks. If no tracks are specified, then the device only uses the production track. */
  androidDevicePolicyTracks?: InputMaybe<Array<PolicyAndroidDevicePolicyTracks>>;
  /** Recommended alternative: autoUpdateMode which is set per app, provides greater flexibility around update frequency.When autoUpdateMode is set to AUTO_UPDATE_POSTPONED or AUTO_UPDATE_HIGH_PRIORITY, this field has no effect.The app auto update policy, which controls when automatic app updates can be applied. */
  appAutoUpdatePolicy?: InputMaybe<PolicyAppAutoUpdatePolicy>;
  /** Policy applied to apps. */
  applications?: InputMaybe<Array<ApplicationPolicyInputSchema>>;
  /** Whether auto date, time, and time zone are enabled on a company-owned device. If this is set, then autoTimeRequired is ignored. */
  autoDateAndTimeZone?: InputMaybe<PolicyAutoDateAndTimeZone>;
  /** Whether auto time is required, which prevents the user from manually setting the date and time. If autoDateAndTimeZone is set, this field is ignored. */
  autoTimeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether applications other than the ones configured in applications are blocked from being installed. When set, applications that were installed under a previous policy but no longer appear in the policy are automatically uninstalled. */
  blockApplicationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether configuring bluetooth is disabled. */
  bluetoothConfigDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether bluetooth contact sharing is disabled. */
  bluetoothContactSharingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether bluetooth is disabled. Prefer this setting over bluetooth_config_disabled because bluetooth_config_disabled can be bypassed by the user. */
  bluetoothDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Controls the use of the camera and whether the user has access to the camera access toggle. */
  cameraAccess?: InputMaybe<PolicyCameraAccess>;
  /** If camera_access is set to any value other than CAMERA_ACCESS_UNSPECIFIED, this has no effect. Otherwise this field controls whether cameras are disabled: If true, all cameras are disabled, otherwise they are available. For fully managed devices this field applies for all apps on the device. For work profiles, this field applies only to apps in the work profile, and the camera access of apps outside the work profile is unaffected. */
  cameraDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether configuring cell broadcast is disabled. */
  cellBroadcastsConfigDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Rules for determining apps' access to private keys. See ChoosePrivateKeyRule for details. */
  choosePrivateKeyRules?: InputMaybe<Array<ChoosePrivateKeyRuleInputSchema>>;
  /** Rules declaring which mitigating actions to take when a device is not compliant with its policy. When the conditions for multiple rules are satisfied, all of the mitigating actions for the rules are taken. There is a maximum limit of 100 rules. Use policy enforcement rules instead. */
  complianceRules?: InputMaybe<Array<ComplianceRuleInputSchema>>;
  /** Whether creating windows besides app windows is disabled. */
  createWindowsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether configuring user credentials is disabled. */
  credentialsConfigDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Cross-profile policies applied on the device. */
  crossProfilePolicies?: InputMaybe<CrossProfilePoliciesInputSchema>;
  /** Whether roaming data services are disabled. */
  dataRoamingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user is allowed to enable debugging features. */
  debuggingFeaturesAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The default permission policy for runtime permission requests. */
  defaultPermissionPolicy?: InputMaybe<PolicyDefaultPermissionPolicy>;
  /** Covers controls for device connectivity such as Wi-Fi, USB data access, keyboard/mouse connections, and more. */
  deviceConnectivityManagement?: InputMaybe<DeviceConnectivityManagementInputSchema>;
  /** The device owner information to be shown on the lock screen. */
  deviceOwnerLockScreenInfo?: InputMaybe<UserFacingMessageInputSchema>;
  /** Whether encryption is enabled */
  encryptionPolicy?: InputMaybe<PolicyEncryptionPolicy>;
  /** Whether app verification is force-enabled. */
  ensureVerifyAppsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  enterprise?: InputMaybe<EnterpriseInputSchema>;
  /** Whether factory resetting from settings is disabled. */
  factoryResetDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Email addresses of device administrators for factory reset protection. When the device is factory reset, it will require one of these admins to log in with the Google account email and password to unlock the device. If no admins are specified, the device won't provide factory reset protection. */
  frpAdminEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether the user is allowed to have fun. Controls whether the Easter egg game in Settings is disabled. */
  funDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Alias for the name field to preserve madhatter compatibility */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Whether user installation of apps is disabled. */
  installAppsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** This field has no effect. */
  installUnknownSourcesAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, this disables the Lock Screen (https://source.android.com/docs/core/display/multi_display/lock-screen) for primary and/or secondary displays. */
  keyguardDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disabled keyguard customizations, such as widgets. */
  keyguardDisabledFeatures?: InputMaybe<Array<PolicyKeyguardDisabledFeatures>>;
  /** Whether the kiosk custom launcher is enabled. This replaces the home screen with a launcher that locks down the device to the apps installed via the applications setting. Apps appear on a single page in alphabetical order. Use kioskCustomization to further configure the kiosk device behavior. */
  kioskCustomLauncherEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Settings controlling the behavior of a device in kiosk mode. To enable kiosk mode, set kioskCustomLauncherEnabled to true or specify an app in the policy with installType KIOSK. */
  kioskCustomization?: InputMaybe<KioskCustomizationInputSchema>;
  /** The degree of location detection enabled. */
  locationMode?: InputMaybe<PolicyLocationMode>;
  /** A message displayed to the user in the device administators settings screen. */
  longSupportMessage?: InputMaybe<UserFacingMessageInputSchema>;
  /** Maximum time in milliseconds for user activity until the device locks. A value of 0 means there is no restriction. */
  maximumTimeToLock?: InputMaybe<Scalars['String']['input']>;
  /** Controls the use of the microphone and whether the user has access to the microphone access toggle. This applies only on fully managed devices. */
  microphoneAccess?: InputMaybe<PolicyMicrophoneAccess>;
  /** The minimum allowed Android API level. */
  minimumApiLevel?: InputMaybe<Scalars['Int']['input']>;
  /** Whether configuring mobile networks is disabled. */
  mobileNetworksConfigDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether adding or removing accounts is disabled. */
  modifyAccountsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user mounting physical external media is disabled. */
  mountPhysicalMediaDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the policy in the form enterprises/{enterpriseId}/policies/{policyId}. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Whether the network escape hatch is enabled. If a network connection can't be made at boot time, the escape hatch prompts the user to temporarily connect to a network in order to refresh the device policy. After applying policy, the temporary network will be forgotten and the device will continue booting. This prevents being unable to connect to a network if there is no suitable network in the last policy and the device boots into an app in lock task mode, or the user is otherwise unable to reach device settings.Note: Setting wifiConfigDisabled to true will override this setting under specific circumstances. Please see wifiConfigDisabled for further details. */
  networkEscapeHatchEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether resetting network settings is disabled. */
  networkResetDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** This feature is not generally available. */
  oncCertificateProviders?: InputMaybe<Array<OncCertificateProviderInputSchema>>;
  /** Network configuration for the device. See configure networks for more information. */
  openNetworkConfiguration?: InputMaybe<Scalars['JSON']['input']>;
  /** Whether using NFC to beam data from apps is disabled. */
  outgoingBeamDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether outgoing calls are disabled. */
  outgoingCallsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Password requirement policies. Different policies can be set for work profile or fully managed devices by setting the password_scope field in the policy. */
  passwordPolicies?: InputMaybe<Array<PasswordRequirementsInputSchema>>;
  /** Password requirements. The field password_requirements.require_password_unlock must not be set. DEPRECATED - Use passwordPolicies.Note:Complexity-based values of PasswordQuality, that is, COMPLEXITY_LOW, COMPLEXITY_MEDIUM, and COMPLEXITY_HIGH, cannot be used here. unified_lock_settings cannot be used here. */
  passwordRequirements?: InputMaybe<PasswordRequirementsInputSchema>;
  /** Explicit permission or group grants or denials for all apps. These values override the default_permission_policy. */
  permissionGrants?: InputMaybe<Array<PermissionGrantInputSchema>>;
  /** Specifies permitted accessibility services. If the field is not set, any accessibility service can be used. If the field is set, only the accessibility services in this list and the system's built-in accessibility service can be used. In particular, if the field is set to empty, only the system's built-in accessibility servicess can be used. This can be set on fully managed devices and on work profiles. When applied to a work profile, this affects both the personal profile and the work profile. */
  permittedAccessibilityServices?: InputMaybe<PackageNameListInputSchema>;
  /** If present, only the input methods provided by packages in this list are permitted. If this field is present, but the list is empty, then only system input methods are permitted. */
  permittedInputMethods?: InputMaybe<PackageNameListInputSchema>;
  /** Default intent handler activities. */
  persistentPreferredActivities?: InputMaybe<Array<PersistentPreferredActivityInputSchema>>;
  /** Policies managing personal usage on a company-owned device. */
  personalUsagePolicies?: InputMaybe<PersonalUsagePoliciesInputSchema>;
  /** This mode controls which apps are available to the user in the Play Store and the behavior on the device when apps are removed from the policy. */
  playStoreMode?: InputMaybe<PolicyPlayStoreMode>;
  /** Rules that define the behavior when a particular policy can not be applied on device */
  policyEnforcementRules?: InputMaybe<Array<PolicyEnforcementRuleInputSchema>>;
  /** Controls whether preferential network service is enabled on the work profile. For example, an organization may have an agreement with a carrier that all of the work data from its employees' devices will be sent via a network service dedicated for enterprise use. An example of a supported preferential network service is the enterprise slice on 5G networks. This has no effect on fully managed devices. */
  preferentialNetworkService?: InputMaybe<PolicyPreferentialNetworkService>;
  /** Allows showing UI on a device for a user to choose a private key alias if there are no matching rules in ChoosePrivateKeyRules. For devices below Android P, setting this may leave enterprise keys vulnerable. */
  privateKeySelectionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The network-independent global HTTP proxy. Typically proxies should be configured per-network in open_network_configuration. However for unusual configurations like general internal filtering a global HTTP proxy may be useful. If the proxy is not accessible, network access may break. The global proxy is only a recommendation and some apps may ignore it. */
  recommendedGlobalProxy?: InputMaybe<ProxyInfoInputSchema>;
  /** Whether removing other users is disabled. */
  removeUserDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether rebooting the device into safe boot is disabled. */
  safeBootDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether screen capture is disabled. */
  screenCaptureDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether changing the user icon is disabled. */
  setUserIconDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether changing the wallpaper is disabled. */
  setWallpaperDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Action to take during the setup process. At most one action may be specified. */
  setupActions?: InputMaybe<Array<SetupActionInputSchema>>;
  /** Whether location sharing is disabled. share_location_disabled is supported for both fully managed devices and personally owned work profiles. */
  shareLocationDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** A message displayed to the user in the settings screen wherever functionality has been disabled by the admin. If the message is longer than 200 characters it may be truncated. */
  shortSupportMessage?: InputMaybe<UserFacingMessageInputSchema>;
  /** Flag to skip hints on the first use. Enterprise admin can enable the system recommendation for apps to skip their user tutorial and other introductory hints on first start-up. */
  skipFirstUseHintsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether sending and receiving SMS messages is disabled. */
  smsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the status bar is disabled. This disables notifications, quick settings, and other screen overlays that allow escape from full-screen mode. DEPRECATED. To disable the status bar on a kiosk device, use InstallType KIOSK or kioskCustomLauncherEnabled. */
  statusBarDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Status reporting settings */
  statusReportingSettings?: InputMaybe<StatusReportingSettingsInputSchema>;
  /** The battery plugged in modes for which the device stays on. When using this setting, it is recommended to clear maximum_time_to_lock so that the device doesn't lock itself while it stays on. */
  stayOnPluggedModes?: InputMaybe<Array<PolicyStayOnPluggedModes>>;
  /** The system update policy, which controls how OS updates are applied. If the update type is WINDOWED, the update window will automatically apply to Play app updates as well. */
  systemUpdate?: InputMaybe<SystemUpdateInputSchema>;
  /** Whether configuring tethering and portable hotspots is disabled. */
  tetheringConfigDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether user uninstallation of applications is disabled. This prevents apps from being uninstalled, even those removed using applications */
  uninstallAppsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If microphone_access is set to any value other than MICROPHONE_ACCESS_UNSPECIFIED, this has no effect. Otherwise this field controls whether microphones are disabled: If true, all microphones are disabled, otherwise they are available. This is available only on fully managed devices. */
  unmuteMicrophoneDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Configuration of device activity logging. */
  usageLog?: InputMaybe<UsageLogInputSchema>;
  /** Whether transferring files over USB is disabled. This is supported only on company-owned devices. */
  usbFileTransferDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether USB storage is enabled. Deprecated. */
  usbMassStorageEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The version of the policy. This is a read-only field. The version is incremented each time the policy is updated. */
  version?: InputMaybe<Scalars['String']['input']>;
  /** Whether configuring VPN is disabled. */
  vpnConfigDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether configuring Wi-Fi networks is disabled. Supported on fully managed devices and work profiles on company-owned devices. For fully managed devices, setting this to true removes all configured networks and retains only the networks configured using openNetworkConfiguration. For work profiles on company-owned devices, existing configured networks are not affected and the user is not allowed to add, remove, or modify Wi-Fi networks. Note: If a network connection can't be made at boot time and configuring Wi-Fi is disabled then network escape hatch will be shown in order to refresh the device policy (see networkEscapeHatchEnabled). */
  wifiConfigDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** DEPRECATED - Use wifi_config_disabled. */
  wifiConfigsLockdownEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PolicyKeyguardDisabledFeatures {
  /** Disable all current and future keyguard customizations. */
  AllFeatures = 'ALL_FEATURES',
  /** Disable all biometric authentication on secure keyguard screens. */
  Biometrics = 'BIOMETRICS',
  /** Disable the camera on secure keyguard screens (e.g. PIN). */
  Camera = 'CAMERA',
  /** Disable fingerprint sensor on secure keyguard screens. */
  DisableFingerprint = 'DISABLE_FINGERPRINT',
  /** On devices running Android 6 and below, disables text entry into notifications on secure keyguard screens. Has no effect on Android 7 and above. */
  DisableRemoteInput = 'DISABLE_REMOTE_INPUT',
  /** Disable face authentication on secure keyguard screens. */
  Face = 'FACE',
  /** Disable iris authentication on secure keyguard screens. */
  Iris = 'IRIS',
  /** This value is ignored. */
  KeyguardDisabledFeatureUnspecified = 'KEYGUARD_DISABLED_FEATURE_UNSPECIFIED',
  /** Disable showing all notifications on secure keyguard screens. */
  Notifications = 'NOTIFICATIONS',
  /** Ignore trust agent state on secure keyguard screens. */
  TrustAgents = 'TRUST_AGENTS',
  /** Disable unredacted notifications on secure keyguard screens. */
  UnredactedNotifications = 'UNREDACTED_NOTIFICATIONS'
}

export enum PolicyLocationMode {
  /** On Android 8 and below, only the network location provider is enabled. On Android 9 and above, this is equivalent to LOCATION_ENFORCED. */
  BatterySaving = 'BATTERY_SAVING',
  /** On Android 8 and below, all location detection methods are enabled, including GPS, networks, and other sensors. On Android 9 and above, this is equivalent to LOCATION_ENFORCED. */
  HighAccuracy = 'HIGH_ACCURACY',
  /** Disable location setting on the device. */
  LocationDisabled = 'LOCATION_DISABLED',
  /** Enable location setting on the device. */
  LocationEnforced = 'LOCATION_ENFORCED',
  /** Defaults to LOCATION_USER_CHOICE. */
  LocationModeUnspecified = 'LOCATION_MODE_UNSPECIFIED',
  /** Location setting is not restricted on the device. No specific behavior is set or enforced. */
  LocationUserChoice = 'LOCATION_USER_CHOICE',
  /** On Android 8 and below, location setting and accuracy are disabled. On Android 9 and above, this is equivalent to LOCATION_DISABLED. */
  Off = 'OFF',
  /** On Android 8 and below, only GPS and other sensors are enabled. On Android 9 and above, this is equivalent to LOCATION_ENFORCED. */
  SensorsOnly = 'SENSORS_ONLY'
}

export enum PolicyMicrophoneAccess {
  /** The field unmute_microphone_disabled is ignored. The microphone on the device is disabled (for fully managed devices, this applies device-wide).The microphone access toggle has no effect as the microphone is disabled. */
  MicrophoneAccessDisabled = 'MICROPHONE_ACCESS_DISABLED',
  /** The field unmute_microphone_disabled is ignored. The microphone on the device is available. On devices running Android 12 and above, the user is unable to use the microphone access toggle. On devices which run Android 11 or below, this is equivalent to MICROPHONE_ACCESS_USER_CHOICE. */
  MicrophoneAccessEnforced = 'MICROPHONE_ACCESS_ENFORCED',
  /** If unmute_microphone_disabled is true, this is equivalent to MICROPHONE_ACCESS_DISABLED. Otherwise, this is equivalent to MICROPHONE_ACCESS_USER_CHOICE. */
  MicrophoneAccessUnspecified = 'MICROPHONE_ACCESS_UNSPECIFIED',
  /** The field unmute_microphone_disabled is ignored. This is the default device behaviour: the microphone on the device is available. On Android 12 and above, the user can use the microphone access toggle. */
  MicrophoneAccessUserChoice = 'MICROPHONE_ACCESS_USER_CHOICE'
}

export enum PolicyPlayStoreMode {
  /** All apps are available and any app that should not be on the device should be explicitly marked as 'BLOCKED' in the applications policy. */
  Blacklist = 'BLACKLIST',
  /** Unspecified. Defaults to WHITELIST. */
  PlayStoreModeUnspecified = 'PLAY_STORE_MODE_UNSPECIFIED',
  /** Only apps that are in the policy are available and any app not in the policy will be automatically uninstalled from the device. */
  Whitelist = 'WHITELIST'
}

export enum PolicyPreferentialNetworkService {
  /** Preferential network service is disabled on the work profile. */
  PreferentialNetworkServiceDisabled = 'PREFERENTIAL_NETWORK_SERVICE_DISABLED',
  /** Preferential network service is enabled on the work profile. */
  PreferentialNetworkServiceEnabled = 'PREFERENTIAL_NETWORK_SERVICE_ENABLED',
  /** Unspecified. Defaults to PREFERENTIAL_NETWORK_SERVICES_DISABLED. */
  PreferentialNetworkServiceUnspecified = 'PREFERENTIAL_NETWORK_SERVICE_UNSPECIFIED'
}

export type PolicyQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

export type PolicySchema = {
  __typename?: 'PolicySchema';
  /** Account types that can't be managed by the user. */
  accountTypesWithManagementDisabled?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether adding new users and profiles is disabled. */
  addUserDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether adjusting the master volume is disabled. Also mutes the device. */
  adjustVolumeDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Security policies set to secure values by default. To maintain the security posture of a device, we don't recommend overriding any of the default values. */
  advancedSecurityOverrides?: Maybe<AdvancedSecurityOverridesSchema>;
  /** Configuration for an always-on VPN connection. Use with vpn_config_disabled to prevent modification of this setting. */
  alwaysOnVpnPackage?: Maybe<AlwaysOnVpnPackageSchema>;
  /** The app tracks for Android Device Policy the device can access. The device receives the latest version among all accessible tracks. If no tracks are specified, then the device only uses the production track. */
  androidDevicePolicyTracks?: Maybe<Array<PolicyAndroidDevicePolicyTracks>>;
  /** Recommended alternative: autoUpdateMode which is set per app, provides greater flexibility around update frequency.When autoUpdateMode is set to AUTO_UPDATE_POSTPONED or AUTO_UPDATE_HIGH_PRIORITY, this field has no effect.The app auto update policy, which controls when automatic app updates can be applied. */
  appAutoUpdatePolicy?: Maybe<PolicyAppAutoUpdatePolicy>;
  /** Policy applied to apps. */
  applications?: Maybe<Array<ApplicationPolicySchema>>;
  /** Whether auto date, time, and time zone are enabled on a company-owned device. If this is set, then autoTimeRequired is ignored. */
  autoDateAndTimeZone?: Maybe<PolicyAutoDateAndTimeZone>;
  /** Whether auto time is required, which prevents the user from manually setting the date and time. If autoDateAndTimeZone is set, this field is ignored. */
  autoTimeRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Whether applications other than the ones configured in applications are blocked from being installed. When set, applications that were installed under a previous policy but no longer appear in the policy are automatically uninstalled. */
  blockApplicationsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether configuring bluetooth is disabled. */
  bluetoothConfigDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether bluetooth contact sharing is disabled. */
  bluetoothContactSharingDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether bluetooth is disabled. Prefer this setting over bluetooth_config_disabled because bluetooth_config_disabled can be bypassed by the user. */
  bluetoothDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the use of the camera and whether the user has access to the camera access toggle. */
  cameraAccess?: Maybe<PolicyCameraAccess>;
  /** If camera_access is set to any value other than CAMERA_ACCESS_UNSPECIFIED, this has no effect. Otherwise this field controls whether cameras are disabled: If true, all cameras are disabled, otherwise they are available. For fully managed devices this field applies for all apps on the device. For work profiles, this field applies only to apps in the work profile, and the camera access of apps outside the work profile is unaffected. */
  cameraDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether configuring cell broadcast is disabled. */
  cellBroadcastsConfigDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Rules for determining apps' access to private keys. See ChoosePrivateKeyRule for details. */
  choosePrivateKeyRules?: Maybe<Array<ChoosePrivateKeyRuleSchema>>;
  /** Rules declaring which mitigating actions to take when a device is not compliant with its policy. When the conditions for multiple rules are satisfied, all of the mitigating actions for the rules are taken. There is a maximum limit of 100 rules. Use policy enforcement rules instead. */
  complianceRules?: Maybe<Array<ComplianceRuleSchema>>;
  /** Whether creating windows besides app windows is disabled. */
  createWindowsDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether configuring user credentials is disabled. */
  credentialsConfigDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Cross-profile policies applied on the device. */
  crossProfilePolicies?: Maybe<CrossProfilePoliciesSchema>;
  /** Whether roaming data services are disabled. */
  dataRoamingDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user is allowed to enable debugging features. */
  debuggingFeaturesAllowed?: Maybe<Scalars['Boolean']['output']>;
  /** The default permission policy for runtime permission requests. */
  defaultPermissionPolicy?: Maybe<PolicyDefaultPermissionPolicy>;
  /** Covers controls for device connectivity such as Wi-Fi, USB data access, keyboard/mouse connections, and more. */
  deviceConnectivityManagement?: Maybe<DeviceConnectivityManagementSchema>;
  /** The device owner information to be shown on the lock screen. */
  deviceOwnerLockScreenInfo?: Maybe<UserFacingMessageSchema>;
  /** Whether encryption is enabled */
  encryptionPolicy?: Maybe<PolicyEncryptionPolicy>;
  /** Whether app verification is force-enabled. */
  ensureVerifyAppsEnabled?: Maybe<Scalars['Boolean']['output']>;
  enterprise: EnterpriseSchema;
  /** Whether factory resetting from settings is disabled. */
  factoryResetDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Email addresses of device administrators for factory reset protection. When the device is factory reset, it will require one of these admins to log in with the Google account email and password to unlock the device. If no admins are specified, the device won't provide factory reset protection. */
  frpAdminEmails?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the user is allowed to have fun. Controls whether the Easter egg game in Settings is disabled. */
  funDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Alias for the name field to preserve madhatter compatibility */
  id: Scalars['String']['output'];
  /** Whether user installation of apps is disabled. */
  installAppsDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** This field has no effect. */
  installUnknownSourcesAllowed?: Maybe<Scalars['Boolean']['output']>;
  /** If true, this disables the Lock Screen (https://source.android.com/docs/core/display/multi_display/lock-screen) for primary and/or secondary displays. */
  keyguardDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Disabled keyguard customizations, such as widgets. */
  keyguardDisabledFeatures?: Maybe<Array<PolicyKeyguardDisabledFeatures>>;
  /** Whether the kiosk custom launcher is enabled. This replaces the home screen with a launcher that locks down the device to the apps installed via the applications setting. Apps appear on a single page in alphabetical order. Use kioskCustomization to further configure the kiosk device behavior. */
  kioskCustomLauncherEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Settings controlling the behavior of a device in kiosk mode. To enable kiosk mode, set kioskCustomLauncherEnabled to true or specify an app in the policy with installType KIOSK. */
  kioskCustomization?: Maybe<KioskCustomizationSchema>;
  /** The degree of location detection enabled. */
  locationMode?: Maybe<PolicyLocationMode>;
  /** A message displayed to the user in the device administators settings screen. */
  longSupportMessage?: Maybe<UserFacingMessageSchema>;
  /** Maximum time in milliseconds for user activity until the device locks. A value of 0 means there is no restriction. */
  maximumTimeToLock?: Maybe<Scalars['String']['output']>;
  /** Controls the use of the microphone and whether the user has access to the microphone access toggle. This applies only on fully managed devices. */
  microphoneAccess?: Maybe<PolicyMicrophoneAccess>;
  /** The minimum allowed Android API level. */
  minimumApiLevel?: Maybe<Scalars['Int']['output']>;
  /** Whether configuring mobile networks is disabled. */
  mobileNetworksConfigDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether adding or removing accounts is disabled. */
  modifyAccountsDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user mounting physical external media is disabled. */
  mountPhysicalMediaDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the policy in the form enterprises/{enterpriseId}/policies/{policyId}. */
  name?: Maybe<Scalars['String']['output']>;
  /** Whether the network escape hatch is enabled. If a network connection can't be made at boot time, the escape hatch prompts the user to temporarily connect to a network in order to refresh the device policy. After applying policy, the temporary network will be forgotten and the device will continue booting. This prevents being unable to connect to a network if there is no suitable network in the last policy and the device boots into an app in lock task mode, or the user is otherwise unable to reach device settings.Note: Setting wifiConfigDisabled to true will override this setting under specific circumstances. Please see wifiConfigDisabled for further details. */
  networkEscapeHatchEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether resetting network settings is disabled. */
  networkResetDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** This feature is not generally available. */
  oncCertificateProviders?: Maybe<Array<OncCertificateProviderSchema>>;
  /** Network configuration for the device. See configure networks for more information. */
  openNetworkConfiguration?: Maybe<Scalars['JSON']['output']>;
  /** Whether using NFC to beam data from apps is disabled. */
  outgoingBeamDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether outgoing calls are disabled. */
  outgoingCallsDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Password requirement policies. Different policies can be set for work profile or fully managed devices by setting the password_scope field in the policy. */
  passwordPolicies?: Maybe<Array<PasswordRequirementsSchema>>;
  /** Password requirements. The field password_requirements.require_password_unlock must not be set. DEPRECATED - Use passwordPolicies.Note:Complexity-based values of PasswordQuality, that is, COMPLEXITY_LOW, COMPLEXITY_MEDIUM, and COMPLEXITY_HIGH, cannot be used here. unified_lock_settings cannot be used here. */
  passwordRequirements?: Maybe<PasswordRequirementsSchema>;
  /** Explicit permission or group grants or denials for all apps. These values override the default_permission_policy. */
  permissionGrants?: Maybe<Array<PermissionGrantSchema>>;
  /** Specifies permitted accessibility services. If the field is not set, any accessibility service can be used. If the field is set, only the accessibility services in this list and the system's built-in accessibility service can be used. In particular, if the field is set to empty, only the system's built-in accessibility servicess can be used. This can be set on fully managed devices and on work profiles. When applied to a work profile, this affects both the personal profile and the work profile. */
  permittedAccessibilityServices?: Maybe<PackageNameListSchema>;
  /** If present, only the input methods provided by packages in this list are permitted. If this field is present, but the list is empty, then only system input methods are permitted. */
  permittedInputMethods?: Maybe<PackageNameListSchema>;
  /** Default intent handler activities. */
  persistentPreferredActivities?: Maybe<Array<PersistentPreferredActivitySchema>>;
  /** Policies managing personal usage on a company-owned device. */
  personalUsagePolicies?: Maybe<PersonalUsagePoliciesSchema>;
  /** This mode controls which apps are available to the user in the Play Store and the behavior on the device when apps are removed from the policy. */
  playStoreMode?: Maybe<PolicyPlayStoreMode>;
  /** Rules that define the behavior when a particular policy can not be applied on device */
  policyEnforcementRules?: Maybe<Array<PolicyEnforcementRuleSchema>>;
  /** Controls whether preferential network service is enabled on the work profile. For example, an organization may have an agreement with a carrier that all of the work data from its employees' devices will be sent via a network service dedicated for enterprise use. An example of a supported preferential network service is the enterprise slice on 5G networks. This has no effect on fully managed devices. */
  preferentialNetworkService?: Maybe<PolicyPreferentialNetworkService>;
  /** Allows showing UI on a device for a user to choose a private key alias if there are no matching rules in ChoosePrivateKeyRules. For devices below Android P, setting this may leave enterprise keys vulnerable. */
  privateKeySelectionEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The network-independent global HTTP proxy. Typically proxies should be configured per-network in open_network_configuration. However for unusual configurations like general internal filtering a global HTTP proxy may be useful. If the proxy is not accessible, network access may break. The global proxy is only a recommendation and some apps may ignore it. */
  recommendedGlobalProxy?: Maybe<ProxyInfoSchema>;
  /** Whether removing other users is disabled. */
  removeUserDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether rebooting the device into safe boot is disabled. */
  safeBootDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether screen capture is disabled. */
  screenCaptureDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether changing the user icon is disabled. */
  setUserIconDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether changing the wallpaper is disabled. */
  setWallpaperDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Action to take during the setup process. At most one action may be specified. */
  setupActions?: Maybe<Array<SetupActionSchema>>;
  /** Whether location sharing is disabled. share_location_disabled is supported for both fully managed devices and personally owned work profiles. */
  shareLocationDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** A message displayed to the user in the settings screen wherever functionality has been disabled by the admin. If the message is longer than 200 characters it may be truncated. */
  shortSupportMessage?: Maybe<UserFacingMessageSchema>;
  /** Flag to skip hints on the first use. Enterprise admin can enable the system recommendation for apps to skip their user tutorial and other introductory hints on first start-up. */
  skipFirstUseHintsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether sending and receiving SMS messages is disabled. */
  smsDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the status bar is disabled. This disables notifications, quick settings, and other screen overlays that allow escape from full-screen mode. DEPRECATED. To disable the status bar on a kiosk device, use InstallType KIOSK or kioskCustomLauncherEnabled. */
  statusBarDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Status reporting settings */
  statusReportingSettings?: Maybe<StatusReportingSettingsSchema>;
  /** The battery plugged in modes for which the device stays on. When using this setting, it is recommended to clear maximum_time_to_lock so that the device doesn't lock itself while it stays on. */
  stayOnPluggedModes?: Maybe<Array<PolicyStayOnPluggedModes>>;
  /** The system update policy, which controls how OS updates are applied. If the update type is WINDOWED, the update window will automatically apply to Play app updates as well. */
  systemUpdate?: Maybe<SystemUpdateSchema>;
  /** Whether configuring tethering and portable hotspots is disabled. */
  tetheringConfigDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether user uninstallation of applications is disabled. This prevents apps from being uninstalled, even those removed using applications */
  uninstallAppsDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** If microphone_access is set to any value other than MICROPHONE_ACCESS_UNSPECIFIED, this has no effect. Otherwise this field controls whether microphones are disabled: If true, all microphones are disabled, otherwise they are available. This is available only on fully managed devices. */
  unmuteMicrophoneDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Configuration of device activity logging. */
  usageLog?: Maybe<UsageLogSchema>;
  /** Whether transferring files over USB is disabled. This is supported only on company-owned devices. */
  usbFileTransferDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether USB storage is enabled. Deprecated. */
  usbMassStorageEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The version of the policy. This is a read-only field. The version is incremented each time the policy is updated. */
  version?: Maybe<Scalars['String']['output']>;
  /** Whether configuring VPN is disabled. */
  vpnConfigDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether configuring Wi-Fi networks is disabled. Supported on fully managed devices and work profiles on company-owned devices. For fully managed devices, setting this to true removes all configured networks and retains only the networks configured using openNetworkConfiguration. For work profiles on company-owned devices, existing configured networks are not affected and the user is not allowed to add, remove, or modify Wi-Fi networks. Note: If a network connection can't be made at boot time and configuring Wi-Fi is disabled then network escape hatch will be shown in order to refresh the device policy (see networkEscapeHatchEnabled). */
  wifiConfigDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** DEPRECATED - Use wifi_config_disabled. */
  wifiConfigsLockdownEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export enum PolicyStayOnPluggedModes {
  /** Power source is an AC charger. */
  Ac = 'AC',
  /** This value is ignored. */
  BatteryPluggedModeUnspecified = 'BATTERY_PLUGGED_MODE_UNSPECIFIED',
  /** Power source is a USB port. */
  Usb = 'USB',
  /** Power source is wireless. */
  Wireless = 'WIRELESS'
}

/** Additional details regarding the security posture of the device. */
export type PostureDetailInputSchema = {
  /** Corresponding admin-facing advice to mitigate this security risk and improve the security posture of the device. */
  advice?: InputMaybe<Array<UserFacingMessageInputSchema>>;
  /** A specific security risk that negatively affects the security posture of the device. */
  securityRisk?: InputMaybe<PostureDetailSecurityRisk>;
};

export type PostureDetailQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Additional details regarding the security posture of the device. */
export type PostureDetailSchema = {
  __typename?: 'PostureDetailSchema';
  /** Corresponding admin-facing advice to mitigate this security risk and improve the security posture of the device. */
  advice?: Maybe<Array<UserFacingMessageSchema>>;
  /** A specific security risk that negatively affects the security posture of the device. */
  securityRisk?: Maybe<PostureDetailSecurityRisk>;
};

export enum PostureDetailSecurityRisk {
  /** SafetyNet detects that the device is running a compromised OS (basicIntegrity check fails). */
  CompromisedOs = 'COMPROMISED_OS',
  /** SafetyNet detects that the device does not have a strong guarantee of system integrity, such as a hardware-backed keystore (https://developer.android.com/training/articles/security-key-attestation). */
  HardwareBackedEvaluationFailed = 'HARDWARE_BACKED_EVALUATION_FAILED',
  /** Unspecified. */
  SecurityRiskUnspecified = 'SECURITY_RISK_UNSPECIFIED',
  /** SafetyNet detects that the device is running an unknown OS (basicIntegrity check succeeds but ctsProfileMatch fails). */
  UnknownOs = 'UNKNOWN_OS'
}

export enum PowerManagementEventEventType {
  /** Battery level was measured. */
  BatteryLevelCollected = 'BATTERY_LEVEL_COLLECTED',
  /** The device entered low-power mode. */
  BatteryLow = 'BATTERY_LOW',
  /** The device exited low-power mode. */
  BatteryOkay = 'BATTERY_OKAY',
  /** The device booted. */
  BootCompleted = 'BOOT_COMPLETED',
  /** The device started charging. */
  PowerConnected = 'POWER_CONNECTED',
  /** The device stopped charging. */
  PowerDisconnected = 'POWER_DISCONNECTED',
  /** Unspecified. No events have this type. */
  PowerManagementEventTypeUnspecified = 'POWER_MANAGEMENT_EVENT_TYPE_UNSPECIFIED',
  /** The device shut down. */
  Shutdown = 'SHUTDOWN'
}

/** A power management event. */
export type PowerManagementEventInputSchema = {
  /** For BATTERY_LEVEL_COLLECTED events, the battery level as a percentage. */
  batteryLevel?: InputMaybe<Scalars['Float']['input']>;
  /** The creation time of the event. */
  createTime?: InputMaybe<Scalars['String']['input']>;
  /** Event type. */
  eventType?: InputMaybe<PowerManagementEventEventType>;
};

export type PowerManagementEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A power management event. */
export type PowerManagementEventSchema = {
  __typename?: 'PowerManagementEventSchema';
  /** For BATTERY_LEVEL_COLLECTED events, the battery level as a percentage. */
  batteryLevel?: Maybe<Scalars['Float']['output']>;
  /** The creation time of the event. */
  createTime?: Maybe<Scalars['String']['output']>;
  /** Event type. */
  eventType?: Maybe<PowerManagementEventEventType>;
};

/** Configuration info for an HTTP proxy. For a direct proxy, set the host, port, and excluded_hosts fields. For a PAC script proxy, set the pac_uri field. */
export type ProxyInfoInputSchema = {
  /** For a direct proxy, the hosts for which the proxy is bypassed. The host names may contain wildcards such as *.example.com. */
  excludedHosts?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The host of the direct proxy. */
  host?: InputMaybe<Scalars['String']['input']>;
  /** The URI of the PAC script used to configure the proxy. */
  pacUri?: InputMaybe<Scalars['String']['input']>;
  /** The port of the direct proxy. */
  port?: InputMaybe<Scalars['Int']['input']>;
};

export type ProxyInfoQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Configuration info for an HTTP proxy. For a direct proxy, set the host, port, and excluded_hosts fields. For a PAC script proxy, set the pac_uri field. */
export type ProxyInfoSchema = {
  __typename?: 'ProxyInfoSchema';
  /** For a direct proxy, the hosts for which the proxy is bypassed. The host names may contain wildcards such as *.example.com. */
  excludedHosts?: Maybe<Array<Scalars['String']['output']>>;
  /** The host of the direct proxy. */
  host?: Maybe<Scalars['String']['output']>;
  /** The URI of the PAC script used to configure the proxy. */
  pacUri?: Maybe<Scalars['String']['output']>;
  /** The port of the direct proxy. */
  port?: Maybe<Scalars['Int']['output']>;
};

export type Query = {
  __typename?: 'Query';
  AdbShellCommandEvent: Array<AdbShellCommandEventSchema>;
  AdbShellInteractiveEvent: Array<AdbShellInteractiveEventSchema>;
  AdvancedSecurityOverrides: Array<AdvancedSecurityOverridesSchema>;
  AlwaysOnVpnPackage: Array<AlwaysOnVpnPackageSchema>;
  ApiLevelCondition: Array<ApiLevelConditionSchema>;
  AppProcessInfo: Array<AppProcessInfoSchema>;
  AppProcessStartEvent: Array<AppProcessStartEventSchema>;
  AppTrackInfo: Array<AppTrackInfoSchema>;
  AppVersion: Array<AppVersionSchema>;
  Application: Array<ApplicationSchema>;
  ApplicationEvent: Array<ApplicationEventSchema>;
  ApplicationPermission: Array<ApplicationPermissionSchema>;
  ApplicationPolicy: Array<ApplicationPolicySchema>;
  ApplicationReport: Array<ApplicationReportSchema>;
  ApplicationReportingSettings: Array<ApplicationReportingSettingsSchema>;
  BaseDevice: Array<BaseDeviceSchema>;
  BaseEnrollmentToken: Array<BaseEnrollmentTokenSchema>;
  BaseEnterprise: Array<BaseEnterpriseSchema>;
  BasePolicy: Array<BasePolicySchema>;
  BaseWebToken: Array<BaseWebTokenSchema>;
  BatchUsageLogEvents: Array<BatchUsageLogEventsSchema>;
  BlockAction: Array<BlockActionSchema>;
  CertAuthorityInstalledEvent: Array<CertAuthorityInstalledEventSchema>;
  CertAuthorityRemovedEvent: Array<CertAuthorityRemovedEventSchema>;
  CertValidationFailureEvent: Array<CertValidationFailureEventSchema>;
  ChoosePrivateKeyRule: Array<ChoosePrivateKeyRuleSchema>;
  ClearAppsDataParams: Array<ClearAppsDataParamsSchema>;
  ClearAppsDataStatus: Array<ClearAppsDataStatusSchema>;
  Command: Array<CommandSchema>;
  CommonCriteriaModeInfo: Array<CommonCriteriaModeInfoSchema>;
  ComplianceRule: Array<ComplianceRuleSchema>;
  ConnectEvent: Array<ConnectEventSchema>;
  ContactInfo: Array<ContactInfoSchema>;
  ContentProviderEndpoint: Array<ContentProviderEndpointSchema>;
  CrossProfilePolicies: Array<CrossProfilePoliciesSchema>;
  CryptoSelfTestCompletedEvent: Array<CryptoSelfTestCompletedEventSchema>;
  Date: Array<DateSchema>;
  DeviceConnectivityManagement: Array<DeviceConnectivityManagementSchema>;
  DeviceSettings: Array<DeviceSettingsSchema>;
  Display: Array<DisplaySchema>;
  DnsEvent: Array<DnsEventSchema>;
  Empty: Array<EmptySchema>;
  ExtensionConfig: Array<ExtensionConfigSchema>;
  ExternalData: Array<ExternalDataSchema>;
  FilePulledEvent: Array<FilePulledEventSchema>;
  FilePushedEvent: Array<FilePushedEventSchema>;
  FreezePeriod: Array<FreezePeriodSchema>;
  HardwareInfo: Array<HardwareInfoSchema>;
  HardwareStatus: Array<HardwareStatusSchema>;
  IssueCommandResponse: Array<IssueCommandResponseSchema>;
  KeyDestructionEvent: Array<KeyDestructionEventSchema>;
  KeyGeneratedEvent: Array<KeyGeneratedEventSchema>;
  KeyImportEvent: Array<KeyImportEventSchema>;
  KeyIntegrityViolationEvent: Array<KeyIntegrityViolationEventSchema>;
  KeyedAppState: Array<KeyedAppStateSchema>;
  KeyguardDismissAuthAttemptEvent: Array<KeyguardDismissAuthAttemptEventSchema>;
  KeyguardDismissedEvent: Array<KeyguardDismissedEventSchema>;
  KeyguardSecuredEvent: Array<KeyguardSecuredEventSchema>;
  KioskCustomization: Array<KioskCustomizationSchema>;
  LaunchAppAction: Array<LaunchAppActionSchema>;
  ListDevicesResponse: Array<ListDevicesResponseSchema>;
  ListEnrollmentTokensResponse: Array<ListEnrollmentTokensResponseSchema>;
  ListEnterprisesResponse: Array<ListEnterprisesResponseSchema>;
  ListOperationsResponse: Array<ListOperationsResponseSchema>;
  ListPoliciesResponse: Array<ListPoliciesResponseSchema>;
  ListWebAppsResponse: Array<ListWebAppsResponseSchema>;
  LogBufferSizeCriticalEvent: Array<LogBufferSizeCriticalEventSchema>;
  LoggingStartedEvent: Array<LoggingStartedEventSchema>;
  LoggingStoppedEvent: Array<LoggingStoppedEventSchema>;
  ManagedConfigurationTemplate: Array<ManagedConfigurationTemplateSchema>;
  ManagedProperty: Array<ManagedPropertySchema>;
  ManagedPropertyEntry: Array<ManagedPropertyEntrySchema>;
  MediaMountEvent: Array<MediaMountEventSchema>;
  MediaUnmountEvent: Array<MediaUnmountEventSchema>;
  MemoryEvent: Array<MemoryEventSchema>;
  MemoryInfo: Array<MemoryInfoSchema>;
  NetworkInfo: Array<NetworkInfoSchema>;
  NonComplianceDetail: Array<NonComplianceDetailSchema>;
  NonComplianceDetailCondition: Array<NonComplianceDetailConditionSchema>;
  OncCertificateProvider: Array<OncCertificateProviderSchema>;
  OncWifiContext: Array<OncWifiContextSchema>;
  Operation: Array<OperationSchema>;
  OsShutdownEvent: Array<OsShutdownEventSchema>;
  OsStartupEvent: Array<OsStartupEventSchema>;
  PackageNameList: Array<PackageNameListSchema>;
  PasswordPoliciesContext: Array<PasswordPoliciesContextSchema>;
  PasswordRequirements: Array<PasswordRequirementsSchema>;
  PerAppResult: Array<PerAppResultSchema>;
  PermissionGrant: Array<PermissionGrantSchema>;
  PersistentPreferredActivity: Array<PersistentPreferredActivitySchema>;
  PersonalApplicationPolicy: Array<PersonalApplicationPolicySchema>;
  PersonalUsagePolicies: Array<PersonalUsagePoliciesSchema>;
  PolicyEnforcementRule: Array<PolicyEnforcementRuleSchema>;
  PostureDetail: Array<PostureDetailSchema>;
  PowerManagementEvent: Array<PowerManagementEventSchema>;
  ProxyInfo: Array<ProxyInfoSchema>;
  RemoteLockEvent: Array<RemoteLockEventSchema>;
  SecurityPosture: Array<SecurityPostureSchema>;
  SetupAction: Array<SetupActionSchema>;
  SigninDetail: Array<SigninDetailSchema>;
  SignupUrl: Array<SignupUrlSchema>;
  SoftwareInfo: Array<SoftwareInfoSchema>;
  SpecificNonComplianceContext: Array<SpecificNonComplianceContextSchema>;
  Status: Array<StatusSchema>;
  StatusReportingSettings: Array<StatusReportingSettingsSchema>;
  SystemUpdate: Array<SystemUpdateSchema>;
  SystemUpdateInfo: Array<SystemUpdateInfoSchema>;
  TelephonyInfo: Array<TelephonyInfoSchema>;
  TermsAndConditions: Array<TermsAndConditionsSchema>;
  UsageLog: Array<UsageLogSchema>;
  UsageLogEvent: Array<UsageLogEventSchema>;
  User: Array<UserSchema>;
  UserFacingMessage: Array<UserFacingMessageSchema>;
  WebApp: Array<WebAppSchema>;
  WebAppIcon: Array<WebAppIconSchema>;
  WipeAction: Array<WipeActionSchema>;
  WipeFailureEvent: Array<WipeFailureEventSchema>;
  count: Scalars['Float']['output'];
  countByGroup: Array<CountByGroupSchema>;
  countMdmDeviceByPolicyByDate: Array<CountByGroupSchema>;
  device: Array<DeviceSchema>;
  enrollmentToken: Array<EnrollmentTokenSchema>;
  enterprise: Array<EnterpriseSchema>;
  file: Array<FileSchema>;
  mdmApplication: Array<MdmApplicationSchema>;
  mdmDevice: Array<MdmDeviceSchema>;
  mdmPolicy: Array<MdmPolicySchema>;
  policy: Array<PolicySchema>;
  switchDevice: Array<SwitchDeviceSchema>;
  tempAuthUrl: Scalars['String']['output'];
  webToken: Array<WebTokenSchema>;
};


export type QueryAdbShellCommandEventArgs = {
  input?: InputMaybe<Array<AdbShellCommandEventInputSchema>>;
  queryArgs?: InputMaybe<AdbShellCommandEventQueryArgs>;
};


export type QueryAdbShellInteractiveEventArgs = {
  input?: InputMaybe<Array<AdbShellInteractiveEventInputSchema>>;
  queryArgs?: InputMaybe<AdbShellInteractiveEventQueryArgs>;
};


export type QueryAdvancedSecurityOverridesArgs = {
  input?: InputMaybe<Array<AdvancedSecurityOverridesInputSchema>>;
  queryArgs?: InputMaybe<AdvancedSecurityOverridesQueryArgs>;
};


export type QueryAlwaysOnVpnPackageArgs = {
  input?: InputMaybe<Array<AlwaysOnVpnPackageInputSchema>>;
  queryArgs?: InputMaybe<AlwaysOnVpnPackageQueryArgs>;
};


export type QueryApiLevelConditionArgs = {
  input?: InputMaybe<Array<ApiLevelConditionInputSchema>>;
  queryArgs?: InputMaybe<ApiLevelConditionQueryArgs>;
};


export type QueryAppProcessInfoArgs = {
  input?: InputMaybe<Array<AppProcessInfoInputSchema>>;
  queryArgs?: InputMaybe<AppProcessInfoQueryArgs>;
};


export type QueryAppProcessStartEventArgs = {
  input?: InputMaybe<Array<AppProcessStartEventInputSchema>>;
  queryArgs?: InputMaybe<AppProcessStartEventQueryArgs>;
};


export type QueryAppTrackInfoArgs = {
  input?: InputMaybe<Array<AppTrackInfoInputSchema>>;
  queryArgs?: InputMaybe<AppTrackInfoQueryArgs>;
};


export type QueryAppVersionArgs = {
  input?: InputMaybe<Array<AppVersionInputSchema>>;
  queryArgs?: InputMaybe<AppVersionQueryArgs>;
};


export type QueryApplicationArgs = {
  input?: InputMaybe<Array<ApplicationInputSchema>>;
  queryArgs?: InputMaybe<ApplicationQueryArgs>;
};


export type QueryApplicationEventArgs = {
  input?: InputMaybe<Array<ApplicationEventInputSchema>>;
  queryArgs?: InputMaybe<ApplicationEventQueryArgs>;
};


export type QueryApplicationPermissionArgs = {
  input?: InputMaybe<Array<ApplicationPermissionInputSchema>>;
  queryArgs?: InputMaybe<ApplicationPermissionQueryArgs>;
};


export type QueryApplicationPolicyArgs = {
  input?: InputMaybe<Array<ApplicationPolicyInputSchema>>;
  queryArgs?: InputMaybe<ApplicationPolicyQueryArgs>;
};


export type QueryApplicationReportArgs = {
  input?: InputMaybe<Array<ApplicationReportInputSchema>>;
  queryArgs?: InputMaybe<ApplicationReportQueryArgs>;
};


export type QueryApplicationReportingSettingsArgs = {
  input?: InputMaybe<Array<ApplicationReportingSettingsInputSchema>>;
  queryArgs?: InputMaybe<ApplicationReportingSettingsQueryArgs>;
};


export type QueryBaseDeviceArgs = {
  input?: InputMaybe<Array<BaseDeviceInputSchema>>;
  queryArgs?: InputMaybe<BaseDeviceQueryArgs>;
};


export type QueryBaseEnrollmentTokenArgs = {
  input?: InputMaybe<Array<BaseEnrollmentTokenInputSchema>>;
  queryArgs?: InputMaybe<BaseEnrollmentTokenQueryArgs>;
};


export type QueryBaseEnterpriseArgs = {
  input?: InputMaybe<Array<BaseEnterpriseInputSchema>>;
  queryArgs?: InputMaybe<BaseEnterpriseQueryArgs>;
};


export type QueryBasePolicyArgs = {
  input?: InputMaybe<Array<BasePolicyInputSchema>>;
  queryArgs?: InputMaybe<BasePolicyQueryArgs>;
};


export type QueryBaseWebTokenArgs = {
  input?: InputMaybe<Array<BaseWebTokenInputSchema>>;
  queryArgs?: InputMaybe<BaseWebTokenQueryArgs>;
};


export type QueryBatchUsageLogEventsArgs = {
  input?: InputMaybe<Array<BatchUsageLogEventsInputSchema>>;
  queryArgs?: InputMaybe<BatchUsageLogEventsQueryArgs>;
};


export type QueryBlockActionArgs = {
  input?: InputMaybe<Array<BlockActionInputSchema>>;
  queryArgs?: InputMaybe<BlockActionQueryArgs>;
};


export type QueryCertAuthorityInstalledEventArgs = {
  input?: InputMaybe<Array<CertAuthorityInstalledEventInputSchema>>;
  queryArgs?: InputMaybe<CertAuthorityInstalledEventQueryArgs>;
};


export type QueryCertAuthorityRemovedEventArgs = {
  input?: InputMaybe<Array<CertAuthorityRemovedEventInputSchema>>;
  queryArgs?: InputMaybe<CertAuthorityRemovedEventQueryArgs>;
};


export type QueryCertValidationFailureEventArgs = {
  input?: InputMaybe<Array<CertValidationFailureEventInputSchema>>;
  queryArgs?: InputMaybe<CertValidationFailureEventQueryArgs>;
};


export type QueryChoosePrivateKeyRuleArgs = {
  input?: InputMaybe<Array<ChoosePrivateKeyRuleInputSchema>>;
  queryArgs?: InputMaybe<ChoosePrivateKeyRuleQueryArgs>;
};


export type QueryClearAppsDataParamsArgs = {
  input?: InputMaybe<Array<ClearAppsDataParamsInputSchema>>;
  queryArgs?: InputMaybe<ClearAppsDataParamsQueryArgs>;
};


export type QueryClearAppsDataStatusArgs = {
  input?: InputMaybe<Array<ClearAppsDataStatusInputSchema>>;
  queryArgs?: InputMaybe<ClearAppsDataStatusQueryArgs>;
};


export type QueryCommandArgs = {
  input?: InputMaybe<Array<CommandInputSchema>>;
  queryArgs?: InputMaybe<CommandQueryArgs>;
};


export type QueryCommonCriteriaModeInfoArgs = {
  input?: InputMaybe<Array<CommonCriteriaModeInfoInputSchema>>;
  queryArgs?: InputMaybe<CommonCriteriaModeInfoQueryArgs>;
};


export type QueryComplianceRuleArgs = {
  input?: InputMaybe<Array<ComplianceRuleInputSchema>>;
  queryArgs?: InputMaybe<ComplianceRuleQueryArgs>;
};


export type QueryConnectEventArgs = {
  input?: InputMaybe<Array<ConnectEventInputSchema>>;
  queryArgs?: InputMaybe<ConnectEventQueryArgs>;
};


export type QueryContactInfoArgs = {
  input?: InputMaybe<Array<ContactInfoInputSchema>>;
  queryArgs?: InputMaybe<ContactInfoQueryArgs>;
};


export type QueryContentProviderEndpointArgs = {
  input?: InputMaybe<Array<ContentProviderEndpointInputSchema>>;
  queryArgs?: InputMaybe<ContentProviderEndpointQueryArgs>;
};


export type QueryCrossProfilePoliciesArgs = {
  input?: InputMaybe<Array<CrossProfilePoliciesInputSchema>>;
  queryArgs?: InputMaybe<CrossProfilePoliciesQueryArgs>;
};


export type QueryCryptoSelfTestCompletedEventArgs = {
  input?: InputMaybe<Array<CryptoSelfTestCompletedEventInputSchema>>;
  queryArgs?: InputMaybe<CryptoSelfTestCompletedEventQueryArgs>;
};


export type QueryDateArgs = {
  input?: InputMaybe<Array<DateInputSchema>>;
  queryArgs?: InputMaybe<DateQueryArgs>;
};


export type QueryDeviceConnectivityManagementArgs = {
  input?: InputMaybe<Array<DeviceConnectivityManagementInputSchema>>;
  queryArgs?: InputMaybe<DeviceConnectivityManagementQueryArgs>;
};


export type QueryDeviceSettingsArgs = {
  input?: InputMaybe<Array<DeviceSettingsInputSchema>>;
  queryArgs?: InputMaybe<DeviceSettingsQueryArgs>;
};


export type QueryDisplayArgs = {
  input?: InputMaybe<Array<DisplayInputSchema>>;
  queryArgs?: InputMaybe<DisplayQueryArgs>;
};


export type QueryDnsEventArgs = {
  input?: InputMaybe<Array<DnsEventInputSchema>>;
  queryArgs?: InputMaybe<DnsEventQueryArgs>;
};


export type QueryEmptyArgs = {
  input?: InputMaybe<Array<EmptyInputSchema>>;
  queryArgs?: InputMaybe<EmptyQueryArgs>;
};


export type QueryExtensionConfigArgs = {
  input?: InputMaybe<Array<ExtensionConfigInputSchema>>;
  queryArgs?: InputMaybe<ExtensionConfigQueryArgs>;
};


export type QueryExternalDataArgs = {
  input?: InputMaybe<Array<ExternalDataInputSchema>>;
  queryArgs?: InputMaybe<ExternalDataQueryArgs>;
};


export type QueryFilePulledEventArgs = {
  input?: InputMaybe<Array<FilePulledEventInputSchema>>;
  queryArgs?: InputMaybe<FilePulledEventQueryArgs>;
};


export type QueryFilePushedEventArgs = {
  input?: InputMaybe<Array<FilePushedEventInputSchema>>;
  queryArgs?: InputMaybe<FilePushedEventQueryArgs>;
};


export type QueryFreezePeriodArgs = {
  input?: InputMaybe<Array<FreezePeriodInputSchema>>;
  queryArgs?: InputMaybe<FreezePeriodQueryArgs>;
};


export type QueryHardwareInfoArgs = {
  input?: InputMaybe<Array<HardwareInfoInputSchema>>;
  queryArgs?: InputMaybe<HardwareInfoQueryArgs>;
};


export type QueryHardwareStatusArgs = {
  input?: InputMaybe<Array<HardwareStatusInputSchema>>;
  queryArgs?: InputMaybe<HardwareStatusQueryArgs>;
};


export type QueryIssueCommandResponseArgs = {
  input?: InputMaybe<Array<IssueCommandResponseInputSchema>>;
  queryArgs?: InputMaybe<IssueCommandResponseQueryArgs>;
};


export type QueryKeyDestructionEventArgs = {
  input?: InputMaybe<Array<KeyDestructionEventInputSchema>>;
  queryArgs?: InputMaybe<KeyDestructionEventQueryArgs>;
};


export type QueryKeyGeneratedEventArgs = {
  input?: InputMaybe<Array<KeyGeneratedEventInputSchema>>;
  queryArgs?: InputMaybe<KeyGeneratedEventQueryArgs>;
};


export type QueryKeyImportEventArgs = {
  input?: InputMaybe<Array<KeyImportEventInputSchema>>;
  queryArgs?: InputMaybe<KeyImportEventQueryArgs>;
};


export type QueryKeyIntegrityViolationEventArgs = {
  input?: InputMaybe<Array<KeyIntegrityViolationEventInputSchema>>;
  queryArgs?: InputMaybe<KeyIntegrityViolationEventQueryArgs>;
};


export type QueryKeyedAppStateArgs = {
  input?: InputMaybe<Array<KeyedAppStateInputSchema>>;
  queryArgs?: InputMaybe<KeyedAppStateQueryArgs>;
};


export type QueryKeyguardDismissAuthAttemptEventArgs = {
  input?: InputMaybe<Array<KeyguardDismissAuthAttemptEventInputSchema>>;
  queryArgs?: InputMaybe<KeyguardDismissAuthAttemptEventQueryArgs>;
};


export type QueryKeyguardDismissedEventArgs = {
  input?: InputMaybe<Array<KeyguardDismissedEventInputSchema>>;
  queryArgs?: InputMaybe<KeyguardDismissedEventQueryArgs>;
};


export type QueryKeyguardSecuredEventArgs = {
  input?: InputMaybe<Array<KeyguardSecuredEventInputSchema>>;
  queryArgs?: InputMaybe<KeyguardSecuredEventQueryArgs>;
};


export type QueryKioskCustomizationArgs = {
  input?: InputMaybe<Array<KioskCustomizationInputSchema>>;
  queryArgs?: InputMaybe<KioskCustomizationQueryArgs>;
};


export type QueryLaunchAppActionArgs = {
  input?: InputMaybe<Array<LaunchAppActionInputSchema>>;
  queryArgs?: InputMaybe<LaunchAppActionQueryArgs>;
};


export type QueryListDevicesResponseArgs = {
  input?: InputMaybe<Array<ListDevicesResponseInputSchema>>;
  queryArgs?: InputMaybe<ListDevicesResponseQueryArgs>;
};


export type QueryListEnrollmentTokensResponseArgs = {
  input?: InputMaybe<Array<ListEnrollmentTokensResponseInputSchema>>;
  queryArgs?: InputMaybe<ListEnrollmentTokensResponseQueryArgs>;
};


export type QueryListEnterprisesResponseArgs = {
  input?: InputMaybe<Array<ListEnterprisesResponseInputSchema>>;
  queryArgs?: InputMaybe<ListEnterprisesResponseQueryArgs>;
};


export type QueryListOperationsResponseArgs = {
  input?: InputMaybe<Array<ListOperationsResponseInputSchema>>;
  queryArgs?: InputMaybe<ListOperationsResponseQueryArgs>;
};


export type QueryListPoliciesResponseArgs = {
  input?: InputMaybe<Array<ListPoliciesResponseInputSchema>>;
  queryArgs?: InputMaybe<ListPoliciesResponseQueryArgs>;
};


export type QueryListWebAppsResponseArgs = {
  input?: InputMaybe<Array<ListWebAppsResponseInputSchema>>;
  queryArgs?: InputMaybe<ListWebAppsResponseQueryArgs>;
};


export type QueryLogBufferSizeCriticalEventArgs = {
  input?: InputMaybe<Array<LogBufferSizeCriticalEventInputSchema>>;
  queryArgs?: InputMaybe<LogBufferSizeCriticalEventQueryArgs>;
};


export type QueryLoggingStartedEventArgs = {
  input?: InputMaybe<Array<LoggingStartedEventInputSchema>>;
  queryArgs?: InputMaybe<LoggingStartedEventQueryArgs>;
};


export type QueryLoggingStoppedEventArgs = {
  input?: InputMaybe<Array<LoggingStoppedEventInputSchema>>;
  queryArgs?: InputMaybe<LoggingStoppedEventQueryArgs>;
};


export type QueryManagedConfigurationTemplateArgs = {
  input?: InputMaybe<Array<ManagedConfigurationTemplateInputSchema>>;
  queryArgs?: InputMaybe<ManagedConfigurationTemplateQueryArgs>;
};


export type QueryManagedPropertyArgs = {
  input?: InputMaybe<Array<ManagedPropertyInputSchema>>;
  queryArgs?: InputMaybe<ManagedPropertyQueryArgs>;
};


export type QueryManagedPropertyEntryArgs = {
  input?: InputMaybe<Array<ManagedPropertyEntryInputSchema>>;
  queryArgs?: InputMaybe<ManagedPropertyEntryQueryArgs>;
};


export type QueryMediaMountEventArgs = {
  input?: InputMaybe<Array<MediaMountEventInputSchema>>;
  queryArgs?: InputMaybe<MediaMountEventQueryArgs>;
};


export type QueryMediaUnmountEventArgs = {
  input?: InputMaybe<Array<MediaUnmountEventInputSchema>>;
  queryArgs?: InputMaybe<MediaUnmountEventQueryArgs>;
};


export type QueryMemoryEventArgs = {
  input?: InputMaybe<Array<MemoryEventInputSchema>>;
  queryArgs?: InputMaybe<MemoryEventQueryArgs>;
};


export type QueryMemoryInfoArgs = {
  input?: InputMaybe<Array<MemoryInfoInputSchema>>;
  queryArgs?: InputMaybe<MemoryInfoQueryArgs>;
};


export type QueryNetworkInfoArgs = {
  input?: InputMaybe<Array<NetworkInfoInputSchema>>;
  queryArgs?: InputMaybe<NetworkInfoQueryArgs>;
};


export type QueryNonComplianceDetailArgs = {
  input?: InputMaybe<Array<NonComplianceDetailInputSchema>>;
  queryArgs?: InputMaybe<NonComplianceDetailQueryArgs>;
};


export type QueryNonComplianceDetailConditionArgs = {
  input?: InputMaybe<Array<NonComplianceDetailConditionInputSchema>>;
  queryArgs?: InputMaybe<NonComplianceDetailConditionQueryArgs>;
};


export type QueryOncCertificateProviderArgs = {
  input?: InputMaybe<Array<OncCertificateProviderInputSchema>>;
  queryArgs?: InputMaybe<OncCertificateProviderQueryArgs>;
};


export type QueryOncWifiContextArgs = {
  input?: InputMaybe<Array<OncWifiContextInputSchema>>;
  queryArgs?: InputMaybe<OncWifiContextQueryArgs>;
};


export type QueryOperationArgs = {
  input?: InputMaybe<Array<OperationInputSchema>>;
  queryArgs?: InputMaybe<OperationQueryArgs>;
};


export type QueryOsShutdownEventArgs = {
  input?: InputMaybe<Array<OsShutdownEventInputSchema>>;
  queryArgs?: InputMaybe<OsShutdownEventQueryArgs>;
};


export type QueryOsStartupEventArgs = {
  input?: InputMaybe<Array<OsStartupEventInputSchema>>;
  queryArgs?: InputMaybe<OsStartupEventQueryArgs>;
};


export type QueryPackageNameListArgs = {
  input?: InputMaybe<Array<PackageNameListInputSchema>>;
  queryArgs?: InputMaybe<PackageNameListQueryArgs>;
};


export type QueryPasswordPoliciesContextArgs = {
  input?: InputMaybe<Array<PasswordPoliciesContextInputSchema>>;
  queryArgs?: InputMaybe<PasswordPoliciesContextQueryArgs>;
};


export type QueryPasswordRequirementsArgs = {
  input?: InputMaybe<Array<PasswordRequirementsInputSchema>>;
  queryArgs?: InputMaybe<PasswordRequirementsQueryArgs>;
};


export type QueryPerAppResultArgs = {
  input?: InputMaybe<Array<PerAppResultInputSchema>>;
  queryArgs?: InputMaybe<PerAppResultQueryArgs>;
};


export type QueryPermissionGrantArgs = {
  input?: InputMaybe<Array<PermissionGrantInputSchema>>;
  queryArgs?: InputMaybe<PermissionGrantQueryArgs>;
};


export type QueryPersistentPreferredActivityArgs = {
  input?: InputMaybe<Array<PersistentPreferredActivityInputSchema>>;
  queryArgs?: InputMaybe<PersistentPreferredActivityQueryArgs>;
};


export type QueryPersonalApplicationPolicyArgs = {
  input?: InputMaybe<Array<PersonalApplicationPolicyInputSchema>>;
  queryArgs?: InputMaybe<PersonalApplicationPolicyQueryArgs>;
};


export type QueryPersonalUsagePoliciesArgs = {
  input?: InputMaybe<Array<PersonalUsagePoliciesInputSchema>>;
  queryArgs?: InputMaybe<PersonalUsagePoliciesQueryArgs>;
};


export type QueryPolicyEnforcementRuleArgs = {
  input?: InputMaybe<Array<PolicyEnforcementRuleInputSchema>>;
  queryArgs?: InputMaybe<PolicyEnforcementRuleQueryArgs>;
};


export type QueryPostureDetailArgs = {
  input?: InputMaybe<Array<PostureDetailInputSchema>>;
  queryArgs?: InputMaybe<PostureDetailQueryArgs>;
};


export type QueryPowerManagementEventArgs = {
  input?: InputMaybe<Array<PowerManagementEventInputSchema>>;
  queryArgs?: InputMaybe<PowerManagementEventQueryArgs>;
};


export type QueryProxyInfoArgs = {
  input?: InputMaybe<Array<ProxyInfoInputSchema>>;
  queryArgs?: InputMaybe<ProxyInfoQueryArgs>;
};


export type QueryRemoteLockEventArgs = {
  input?: InputMaybe<Array<RemoteLockEventInputSchema>>;
  queryArgs?: InputMaybe<RemoteLockEventQueryArgs>;
};


export type QuerySecurityPostureArgs = {
  input?: InputMaybe<Array<SecurityPostureInputSchema>>;
  queryArgs?: InputMaybe<SecurityPostureQueryArgs>;
};


export type QuerySetupActionArgs = {
  input?: InputMaybe<Array<SetupActionInputSchema>>;
  queryArgs?: InputMaybe<SetupActionQueryArgs>;
};


export type QuerySigninDetailArgs = {
  input?: InputMaybe<Array<SigninDetailInputSchema>>;
  queryArgs?: InputMaybe<SigninDetailQueryArgs>;
};


export type QuerySignupUrlArgs = {
  input?: InputMaybe<Array<SignupUrlInputSchema>>;
  queryArgs?: InputMaybe<SignupUrlQueryArgs>;
};


export type QuerySoftwareInfoArgs = {
  input?: InputMaybe<Array<SoftwareInfoInputSchema>>;
  queryArgs?: InputMaybe<SoftwareInfoQueryArgs>;
};


export type QuerySpecificNonComplianceContextArgs = {
  input?: InputMaybe<Array<SpecificNonComplianceContextInputSchema>>;
  queryArgs?: InputMaybe<SpecificNonComplianceContextQueryArgs>;
};


export type QueryStatusArgs = {
  input?: InputMaybe<Array<StatusInputSchema>>;
  queryArgs?: InputMaybe<StatusQueryArgs>;
};


export type QueryStatusReportingSettingsArgs = {
  input?: InputMaybe<Array<StatusReportingSettingsInputSchema>>;
  queryArgs?: InputMaybe<StatusReportingSettingsQueryArgs>;
};


export type QuerySystemUpdateArgs = {
  input?: InputMaybe<Array<SystemUpdateInputSchema>>;
  queryArgs?: InputMaybe<SystemUpdateQueryArgs>;
};


export type QuerySystemUpdateInfoArgs = {
  input?: InputMaybe<Array<SystemUpdateInfoInputSchema>>;
  queryArgs?: InputMaybe<SystemUpdateInfoQueryArgs>;
};


export type QueryTelephonyInfoArgs = {
  input?: InputMaybe<Array<TelephonyInfoInputSchema>>;
  queryArgs?: InputMaybe<TelephonyInfoQueryArgs>;
};


export type QueryTermsAndConditionsArgs = {
  input?: InputMaybe<Array<TermsAndConditionsInputSchema>>;
  queryArgs?: InputMaybe<TermsAndConditionsQueryArgs>;
};


export type QueryUsageLogArgs = {
  input?: InputMaybe<Array<UsageLogInputSchema>>;
  queryArgs?: InputMaybe<UsageLogQueryArgs>;
};


export type QueryUsageLogEventArgs = {
  input?: InputMaybe<Array<UsageLogEventInputSchema>>;
  queryArgs?: InputMaybe<UsageLogEventQueryArgs>;
};


export type QueryUserArgs = {
  input?: InputMaybe<Array<UserInputSchema>>;
  queryArgs?: InputMaybe<UserQueryArgs>;
};


export type QueryUserFacingMessageArgs = {
  input?: InputMaybe<Array<UserFacingMessageInputSchema>>;
  queryArgs?: InputMaybe<UserFacingMessageQueryArgs>;
};


export type QueryWebAppArgs = {
  input?: InputMaybe<Array<WebAppInputSchema>>;
  queryArgs?: InputMaybe<WebAppQueryArgs>;
};


export type QueryWebAppIconArgs = {
  input?: InputMaybe<Array<WebAppIconInputSchema>>;
  queryArgs?: InputMaybe<WebAppIconQueryArgs>;
};


export type QueryWipeActionArgs = {
  input?: InputMaybe<Array<WipeActionInputSchema>>;
  queryArgs?: InputMaybe<WipeActionQueryArgs>;
};


export type QueryWipeFailureEventArgs = {
  input?: InputMaybe<Array<WipeFailureEventInputSchema>>;
  queryArgs?: InputMaybe<WipeFailureEventQueryArgs>;
};


export type QueryCountArgs = {
  model: Scalars['String']['input'];
};


export type QueryCountByGroupArgs = {
  group: Scalars['String']['input'];
  model: Scalars['String']['input'];
};


export type QueryDeviceArgs = {
  input?: InputMaybe<Array<DeviceInputSchema>>;
  queryArgs?: InputMaybe<DeviceQueryArgs>;
};


export type QueryEnrollmentTokenArgs = {
  input?: InputMaybe<Array<EnrollmentTokenInputSchema>>;
  queryArgs?: InputMaybe<EnrollmentTokenQueryArgs>;
};


export type QueryEnterpriseArgs = {
  input?: InputMaybe<Array<EnterpriseInputSchema>>;
  queryArgs?: InputMaybe<EnterpriseQueryArgs>;
};


export type QueryFileArgs = {
  input?: InputMaybe<Array<FileInputSchema>>;
  queryArgs?: InputMaybe<FileArgs>;
};


export type QueryMdmApplicationArgs = {
  input?: InputMaybe<Array<MdmApplicationInputSchema>>;
  queryArgs?: InputMaybe<MdmApplicationQueryArgs>;
};


export type QueryMdmDeviceArgs = {
  input?: InputMaybe<Array<MdmDeviceInputSchema>>;
  queryArgs?: InputMaybe<MdmDeviceArgs>;
};


export type QueryMdmPolicyArgs = {
  input?: InputMaybe<Array<MdmPolicyInputSchema>>;
  queryArgs?: InputMaybe<MdmPolicyArgs>;
};


export type QueryPolicyArgs = {
  input?: InputMaybe<Array<PolicyInputSchema>>;
  queryArgs?: InputMaybe<PolicyQueryArgs>;
};


export type QuerySwitchDeviceArgs = {
  input?: InputMaybe<Array<SwitchDeviceInputSchema>>;
  queryArgs?: InputMaybe<SwitchDeviceArgs>;
};


export type QueryTempAuthUrlArgs = {
  redirectUri: Scalars['String']['input'];
};


export type QueryWebTokenArgs = {
  input?: InputMaybe<Array<WebTokenInputSchema>>;
  queryArgs?: InputMaybe<WebTokenQueryArgs>;
};

/** The device or profile has been remotely locked via the LOCK command. */
export type RemoteLockEventInputSchema = {
  /** Package name of the admin app requesting the change. */
  adminPackageName?: InputMaybe<Scalars['String']['input']>;
  /** User ID of the admin app from the which the change was requested. */
  adminUserId?: InputMaybe<Scalars['Int']['input']>;
  /** User ID in which the change was requested in. */
  targetUserId?: InputMaybe<Scalars['Int']['input']>;
};

export type RemoteLockEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** The device or profile has been remotely locked via the LOCK command. */
export type RemoteLockEventSchema = {
  __typename?: 'RemoteLockEventSchema';
  /** Package name of the admin app requesting the change. */
  adminPackageName?: Maybe<Scalars['String']['output']>;
  /** User ID of the admin app from the which the change was requested. */
  adminUserId?: Maybe<Scalars['Int']['output']>;
  /** User ID in which the change was requested in. */
  targetUserId?: Maybe<Scalars['Int']['output']>;
};

export enum SecurityPostureDevicePosture {
  /** This device may be more vulnerable to malicious actors than is recommended for use with corporate data. */
  AtRisk = 'AT_RISK',
  /** Unspecified. There is no posture detail for this posture value. */
  PostureUnspecified = 'POSTURE_UNSPECIFIED',
  /** This device may be compromised and corporate data may be accessible to unauthorized actors. */
  PotentiallyCompromised = 'POTENTIALLY_COMPROMISED',
  /** This device is secure. */
  Secure = 'SECURE'
}

/** The security posture of the device, as determined by the current device state and the policies applied. */
export type SecurityPostureInputSchema = {
  /** Device's security posture value. */
  devicePosture?: InputMaybe<SecurityPostureDevicePosture>;
  /** Additional details regarding the security posture of the device. */
  postureDetails?: InputMaybe<Array<PostureDetailInputSchema>>;
};

export type SecurityPostureQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** The security posture of the device, as determined by the current device state and the policies applied. */
export type SecurityPostureSchema = {
  __typename?: 'SecurityPostureSchema';
  /** Device's security posture value. */
  devicePosture?: Maybe<SecurityPostureDevicePosture>;
  /** Additional details regarding the security posture of the device. */
  postureDetails?: Maybe<Array<PostureDetailSchema>>;
};

/** An action executed during setup. */
export type SetupActionInputSchema = {
  /** Description of this action. */
  description?: InputMaybe<UserFacingMessageInputSchema>;
  /** An action to launch an app. The app will be launched with an intent containing an extra with key com.google.android.apps.work.clouddpc.EXTRA_LAUNCHED_AS_SETUP_ACTION set to the boolean value true to indicate that this is a setup action flow. If SetupAction references an app, the corresponding installType in the application policy must be set as REQUIRED_FOR_SETUP or said setup will fail. */
  launchApp?: InputMaybe<LaunchAppActionInputSchema>;
  /** Title of this action. */
  title?: InputMaybe<UserFacingMessageInputSchema>;
};

export type SetupActionQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** An action executed during setup. */
export type SetupActionSchema = {
  __typename?: 'SetupActionSchema';
  /** Description of this action. */
  description?: Maybe<UserFacingMessageSchema>;
  /** An action to launch an app. The app will be launched with an intent containing an extra with key com.google.android.apps.work.clouddpc.EXTRA_LAUNCHED_AS_SETUP_ACTION set to the boolean value true to indicate that this is a setup action flow. If SetupAction references an app, the corresponding installType in the application policy must be set as REQUIRED_FOR_SETUP or said setup will fail. */
  launchApp?: Maybe<LaunchAppActionSchema>;
  /** Title of this action. */
  title?: Maybe<UserFacingMessageSchema>;
};

export enum SigninDetailAllowPersonalUsage {
  /** Personal usage restriction is not specified */
  AllowPersonalUsageUnspecified = 'ALLOW_PERSONAL_USAGE_UNSPECIFIED',
  /** Personal usage is allowed */
  PersonalUsageAllowed = 'PERSONAL_USAGE_ALLOWED',
  /** Personal usage is disallowed */
  PersonalUsageDisallowed = 'PERSONAL_USAGE_DISALLOWED'
}

/** A resource containing sign in details for an enterprise. */
export type SigninDetailInputSchema = {
  /** Controls whether personal usage is allowed on a device provisioned with this enrollment token.For company-owned devices: Enabling personal usage allows the user to set up a work profile on the device. Disabling personal usage requires the user provision the device as a fully managed device.For personally-owned devices: Enabling personal usage allows the user to set up a work profile on the device. Disabling personal usage will prevent the device from provisioning. Personal usage cannot be disabled on personally-owned device. */
  allowPersonalUsage?: InputMaybe<SigninDetailAllowPersonalUsage>;
  /** A JSON string whose UTF-8 representation can be used to generate a QR code to enroll a device with this enrollment token. To enroll a device using NFC, the NFC record must contain a serialized java.util.Properties representation of the properties in the JSON. This is a read-only field generated by the server. */
  qrCode?: InputMaybe<Scalars['String']['input']>;
  /** An enterprise wide enrollment token used to trigger custom sign-in flow. This is a read-only field generated by the server. */
  signinEnrollmentToken?: InputMaybe<Scalars['String']['input']>;
  /** Sign-in URL for authentication when device is provisioned with a sign-in enrollment token. The sign-in endpoint should finish authentication flow with a URL in the form of https://enterprise.google.com/android/enroll?et= for a successful login, or https://enterprise.google.com/android/enroll/invalid for a failed login. */
  signinUrl?: InputMaybe<Scalars['String']['input']>;
};

export type SigninDetailQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A resource containing sign in details for an enterprise. */
export type SigninDetailSchema = {
  __typename?: 'SigninDetailSchema';
  /** Controls whether personal usage is allowed on a device provisioned with this enrollment token.For company-owned devices: Enabling personal usage allows the user to set up a work profile on the device. Disabling personal usage requires the user provision the device as a fully managed device.For personally-owned devices: Enabling personal usage allows the user to set up a work profile on the device. Disabling personal usage will prevent the device from provisioning. Personal usage cannot be disabled on personally-owned device. */
  allowPersonalUsage?: Maybe<SigninDetailAllowPersonalUsage>;
  /** A JSON string whose UTF-8 representation can be used to generate a QR code to enroll a device with this enrollment token. To enroll a device using NFC, the NFC record must contain a serialized java.util.Properties representation of the properties in the JSON. This is a read-only field generated by the server. */
  qrCode?: Maybe<Scalars['String']['output']>;
  /** An enterprise wide enrollment token used to trigger custom sign-in flow. This is a read-only field generated by the server. */
  signinEnrollmentToken?: Maybe<Scalars['String']['output']>;
  /** Sign-in URL for authentication when device is provisioned with a sign-in enrollment token. The sign-in endpoint should finish authentication flow with a URL in the form of https://enterprise.google.com/android/enroll?et= for a successful login, or https://enterprise.google.com/android/enroll/invalid for a failed login. */
  signinUrl?: Maybe<Scalars['String']['output']>;
};

/** An enterprise signup URL. */
export type SignupUrlInputSchema = {
  /** The name of the resource. Use this value in the signupUrl field when calling enterprises.create to complete the enterprise signup flow. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** A URL where an enterprise admin can register their enterprise. The page can't be rendered in an iframe. */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SignupUrlQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** An enterprise signup URL. */
export type SignupUrlSchema = {
  __typename?: 'SignupUrlSchema';
  /** The name of the resource. Use this value in the signupUrl field when calling enterprises.create to complete the enterprise signup flow. */
  name?: Maybe<Scalars['String']['output']>;
  /** A URL where an enterprise admin can register their enterprise. The page can't be rendered in an iframe. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Information about device software. */
export type SoftwareInfoInputSchema = {
  /** Android build ID string meant for displaying to the user. For example, shamu-userdebug 6.0.1 MOB30I 2756745 dev-keys. */
  androidBuildNumber?: InputMaybe<Scalars['String']['input']>;
  /** Build time. */
  androidBuildTime?: InputMaybe<Scalars['String']['input']>;
  /** The Android Device Policy app version code. */
  androidDevicePolicyVersionCode?: InputMaybe<Scalars['Int']['input']>;
  /** The Android Device Policy app version as displayed to the user. */
  androidDevicePolicyVersionName?: InputMaybe<Scalars['String']['input']>;
  /** The user-visible Android version string. For example, 6.0.1. */
  androidVersion?: InputMaybe<Scalars['String']['input']>;
  /** The system bootloader version number, e.g. 0.6.7. */
  bootloaderVersion?: InputMaybe<Scalars['String']['input']>;
  /** SHA-256 hash of android.content.pm.Signature (https://developer.android.com/reference/android/content/pm/Signature.html) associated with the system package, which can be used to verify that the system build hasn't been modified. */
  deviceBuildSignature?: InputMaybe<Scalars['String']['input']>;
  /** Kernel version, for example, 2.6.32.9-g103d848. */
  deviceKernelVersion?: InputMaybe<Scalars['String']['input']>;
  /** An IETF BCP 47 language code for the primary locale on the device. */
  primaryLanguageCode?: InputMaybe<Scalars['String']['input']>;
  /** Security patch level, e.g. 2016-05-01. */
  securityPatchLevel?: InputMaybe<Scalars['String']['input']>;
  /** Information about a potential pending system update. */
  systemUpdateInfo?: InputMaybe<SystemUpdateInfoInputSchema>;
};

export type SoftwareInfoQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Information about device software. */
export type SoftwareInfoSchema = {
  __typename?: 'SoftwareInfoSchema';
  /** Android build ID string meant for displaying to the user. For example, shamu-userdebug 6.0.1 MOB30I 2756745 dev-keys. */
  androidBuildNumber?: Maybe<Scalars['String']['output']>;
  /** Build time. */
  androidBuildTime?: Maybe<Scalars['String']['output']>;
  /** The Android Device Policy app version code. */
  androidDevicePolicyVersionCode?: Maybe<Scalars['Int']['output']>;
  /** The Android Device Policy app version as displayed to the user. */
  androidDevicePolicyVersionName?: Maybe<Scalars['String']['output']>;
  /** The user-visible Android version string. For example, 6.0.1. */
  androidVersion?: Maybe<Scalars['String']['output']>;
  /** The system bootloader version number, e.g. 0.6.7. */
  bootloaderVersion?: Maybe<Scalars['String']['output']>;
  /** SHA-256 hash of android.content.pm.Signature (https://developer.android.com/reference/android/content/pm/Signature.html) associated with the system package, which can be used to verify that the system build hasn't been modified. */
  deviceBuildSignature?: Maybe<Scalars['String']['output']>;
  /** Kernel version, for example, 2.6.32.9-g103d848. */
  deviceKernelVersion?: Maybe<Scalars['String']['output']>;
  /** An IETF BCP 47 language code for the primary locale on the device. */
  primaryLanguageCode?: Maybe<Scalars['String']['output']>;
  /** Security patch level, e.g. 2016-05-01. */
  securityPatchLevel?: Maybe<Scalars['String']['output']>;
  /** Information about a potential pending system update. */
  systemUpdateInfo?: Maybe<SystemUpdateInfoSchema>;
};

export type SortArg = {
  fieldName: Scalars['String']['input'];
  order: MadhatterSortOrder;
};

/** Additional context for SpecificNonComplianceReason. */
export type SpecificNonComplianceContextInputSchema = {
  /** Additional context for non-compliance related to Wi-Fi configuration. See ONC_WIFI_INVALID_VALUE and ONC_WIFI_API_LEVEL */
  oncWifiContext?: InputMaybe<OncWifiContextInputSchema>;
  /** Additional context for non-compliance related to password policies. See PASSWORD_POLICIES_PASSWORD_EXPIRED and PASSWORD_POLICIES_PASSWORD_NOT_SUFFICIENT. */
  passwordPoliciesContext?: InputMaybe<PasswordPoliciesContextInputSchema>;
};

export type SpecificNonComplianceContextQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Additional context for SpecificNonComplianceReason. */
export type SpecificNonComplianceContextSchema = {
  __typename?: 'SpecificNonComplianceContextSchema';
  /** Additional context for non-compliance related to Wi-Fi configuration. See ONC_WIFI_INVALID_VALUE and ONC_WIFI_API_LEVEL */
  oncWifiContext?: Maybe<OncWifiContextSchema>;
  /** Additional context for non-compliance related to password policies. See PASSWORD_POLICIES_PASSWORD_EXPIRED and PASSWORD_POLICIES_PASSWORD_NOT_SUFFICIENT. */
  passwordPoliciesContext?: Maybe<PasswordPoliciesContextSchema>;
};

/** The Status type defines a logical error model that is suitable for different programming environments, including REST APIs and RPC APIs. It is used by gRPC (https://github.com/grpc). Each Status message contains three pieces of data: error code, error message, and error details.You can find out more about this error model and how to work with it in the API Design Guide (https://cloud.google.com/apis/design/errors). */
export type StatusInputSchema = {
  /** The status code, which should be an enum value of google.rpc.Code. */
  code?: InputMaybe<Scalars['Int']['input']>;
  /** A list of messages that carry the error details. There is a common set of message types for APIs to use. */
  details?: InputMaybe<Scalars['JSON']['input']>;
  /** A developer-facing error message, which should be in English. Any user-facing error message should be localized and sent in the google.rpc.Status.details field, or localized by the client. */
  message?: InputMaybe<Scalars['String']['input']>;
};

export type StatusQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Settings controlling the behavior of status reports. */
export type StatusReportingSettingsInputSchema = {
  /** Application reporting settings. Only applicable if application_reports_enabled is true. */
  applicationReportingSettings?: InputMaybe<ApplicationReportingSettingsInputSchema>;
  /** Whether app reports are enabled. */
  applicationReportsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether Common Criteria Mode reporting is enabled. */
  commonCriteriaModeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether device settings reporting is enabled. */
  deviceSettingsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether displays reporting is enabled. Report data is not available for personally owned devices with work profiles. */
  displayInfoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether hardware status reporting is enabled. Report data is not available for personally owned devices with work profiles. */
  hardwareStatusEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether memory event reporting is enabled. */
  memoryInfoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether network info reporting is enabled. */
  networkInfoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether power management event reporting is enabled. Report data is not available for personally owned devices with work profiles. */
  powerManagementEventsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether software info reporting is enabled. */
  softwareInfoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether system properties reporting is enabled. */
  systemPropertiesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StatusReportingSettingsQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Settings controlling the behavior of status reports. */
export type StatusReportingSettingsSchema = {
  __typename?: 'StatusReportingSettingsSchema';
  /** Application reporting settings. Only applicable if application_reports_enabled is true. */
  applicationReportingSettings?: Maybe<ApplicationReportingSettingsSchema>;
  /** Whether app reports are enabled. */
  applicationReportsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether Common Criteria Mode reporting is enabled. */
  commonCriteriaModeEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether device settings reporting is enabled. */
  deviceSettingsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether displays reporting is enabled. Report data is not available for personally owned devices with work profiles. */
  displayInfoEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether hardware status reporting is enabled. Report data is not available for personally owned devices with work profiles. */
  hardwareStatusEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether memory event reporting is enabled. */
  memoryInfoEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether network info reporting is enabled. */
  networkInfoEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether power management event reporting is enabled. Report data is not available for personally owned devices with work profiles. */
  powerManagementEventsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether software info reporting is enabled. */
  softwareInfoEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether system properties reporting is enabled. */
  systemPropertiesEnabled?: Maybe<Scalars['Boolean']['output']>;
};

/** The Status type defines a logical error model that is suitable for different programming environments, including REST APIs and RPC APIs. It is used by gRPC (https://github.com/grpc). Each Status message contains three pieces of data: error code, error message, and error details.You can find out more about this error model and how to work with it in the API Design Guide (https://cloud.google.com/apis/design/errors). */
export type StatusSchema = {
  __typename?: 'StatusSchema';
  /** The status code, which should be an enum value of google.rpc.Code. */
  code?: Maybe<Scalars['Int']['output']>;
  /** A list of messages that carry the error details. There is a common set of message types for APIs to use. */
  details?: Maybe<Scalars['JSON']['output']>;
  /** A developer-facing error message, which should be in English. Any user-facing error message should be localized and sent in the google.rpc.Status.details field, or localized by the client. */
  message?: Maybe<Scalars['String']['output']>;
};

export type SwitchDeviceArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

export type SwitchDeviceInputSchema = {
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imei?: InputMaybe<Scalars['String']['input']>;
  kioskPolicy?: InputMaybe<Scalars['String']['input']>;
  normalPolicy?: InputMaybe<Scalars['String']['input']>;
};

export type SwitchDeviceSchema = {
  __typename?: 'SwitchDeviceSchema';
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  device?: Maybe<DeviceSchema>;
  enterpriseId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imei?: Maybe<Scalars['String']['output']>;
  kioskPolicy?: Maybe<Scalars['String']['output']>;
  normalPolicy?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

/** Information about a potential pending system update. */
export type SystemUpdateInfoInputSchema = {
  /** The time when the update was first available. A zero value indicates that this field is not set. This field is set only if an update is available (that is, updateStatus is neither UPDATE_STATUS_UNKNOWN nor UP_TO_DATE). */
  updateReceivedTime?: InputMaybe<Scalars['String']['input']>;
  /** The status of an update: whether an update exists and what type it is. */
  updateStatus?: InputMaybe<SystemUpdateInfoUpdateStatus>;
};

export type SystemUpdateInfoQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Information about a potential pending system update. */
export type SystemUpdateInfoSchema = {
  __typename?: 'SystemUpdateInfoSchema';
  /** The time when the update was first available. A zero value indicates that this field is not set. This field is set only if an update is available (that is, updateStatus is neither UPDATE_STATUS_UNKNOWN nor UP_TO_DATE). */
  updateReceivedTime?: Maybe<Scalars['String']['output']>;
  /** The status of an update: whether an update exists and what type it is. */
  updateStatus?: Maybe<SystemUpdateInfoUpdateStatus>;
};

export enum SystemUpdateInfoUpdateStatus {
  /** There is a pending OS update available. */
  OsUpdateAvailable = 'OS_UPDATE_AVAILABLE',
  /** There is a pending security update available. */
  SecurityUpdateAvailable = 'SECURITY_UPDATE_AVAILABLE',
  /** There is a pending system update available, but its type is not known. */
  UnknownUpdateAvailable = 'UNKNOWN_UPDATE_AVAILABLE',
  /** It is unknown whether there is a pending system update. This happens when, for example, the device API level is less than 26, or if the version of Android Device Policy is outdated. */
  UpdateStatusUnknown = 'UPDATE_STATUS_UNKNOWN',
  /** There is no pending system update available on the device. */
  UpToDate = 'UP_TO_DATE'
}

/** Configuration for managing system updates */
export type SystemUpdateInputSchema = {
  /** If the type is WINDOWED, the end of the maintenance window, measured as the number of minutes after midnight in device's local time. This value must be between 0 and 1439, inclusive. If this value is less than start_minutes, then the maintenance window spans midnight. If the maintenance window specified is smaller than 30 minutes, the actual window is extended to 30 minutes beyond the start time. */
  endMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** An annually repeating time period in which over-the-air (OTA) system updates are postponed to freeze the OS version running on a device. To prevent freezing the device indefinitely, each freeze period must be separated by at least 60 days. */
  freezePeriods?: InputMaybe<Array<FreezePeriodInputSchema>>;
  /** If the type is WINDOWED, the start of the maintenance window, measured as the number of minutes after midnight in the device's local time. This value must be between 0 and 1439, inclusive. */
  startMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** The type of system update to configure. */
  type?: InputMaybe<SystemUpdateType>;
};

export type SystemUpdateQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Configuration for managing system updates */
export type SystemUpdateSchema = {
  __typename?: 'SystemUpdateSchema';
  /** If the type is WINDOWED, the end of the maintenance window, measured as the number of minutes after midnight in device's local time. This value must be between 0 and 1439, inclusive. If this value is less than start_minutes, then the maintenance window spans midnight. If the maintenance window specified is smaller than 30 minutes, the actual window is extended to 30 minutes beyond the start time. */
  endMinutes?: Maybe<Scalars['Int']['output']>;
  /** An annually repeating time period in which over-the-air (OTA) system updates are postponed to freeze the OS version running on a device. To prevent freezing the device indefinitely, each freeze period must be separated by at least 60 days. */
  freezePeriods?: Maybe<Array<FreezePeriodSchema>>;
  /** If the type is WINDOWED, the start of the maintenance window, measured as the number of minutes after midnight in the device's local time. This value must be between 0 and 1439, inclusive. */
  startMinutes?: Maybe<Scalars['Int']['output']>;
  /** The type of system update to configure. */
  type?: Maybe<SystemUpdateType>;
};

export enum SystemUpdateType {
  /** Install automatically as soon as an update is available. */
  Automatic = 'AUTOMATIC',
  /** Postpone automatic install up to a maximum of 30 days. */
  Postpone = 'POSTPONE',
  /** Follow the default update behavior for the device, which typically requires the user to accept system updates. */
  SystemUpdateTypeUnspecified = 'SYSTEM_UPDATE_TYPE_UNSPECIFIED',
  /** Install automatically within a daily maintenance window. This also configures Play apps to be updated within the window. This is strongly recommended for kiosk devices because this is the only way apps persistently pinned to the foreground can be updated by Play.If autoUpdateMode is set to AUTO_UPDATE_HIGH_PRIORITY for an app, then the maintenance window is ignored for that app and it is updated as soon as possible even outside of the maintenance window. */
  Windowed = 'WINDOWED'
}

/** Telephony information associated with a given SIM card on the device. Only supported on fully managed devices starting from Android API level 23. */
export type TelephonyInfoInputSchema = {
  /** The carrier name associated with this SIM card. */
  carrierName?: InputMaybe<Scalars['String']['input']>;
  /** The phone number associated with this SIM card. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TelephonyInfoQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Telephony information associated with a given SIM card on the device. Only supported on fully managed devices starting from Android API level 23. */
export type TelephonyInfoSchema = {
  __typename?: 'TelephonyInfoSchema';
  /** The carrier name associated with this SIM card. */
  carrierName?: Maybe<Scalars['String']['output']>;
  /** The phone number associated with this SIM card. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

/** A terms and conditions page to be accepted during provisioning. */
export type TermsAndConditionsInputSchema = {
  /** A well-formatted HTML string. It will be parsed on the client with android.text.Html#fromHtml. */
  content?: InputMaybe<UserFacingMessageInputSchema>;
  /** A short header which appears above the HTML content. */
  header?: InputMaybe<UserFacingMessageInputSchema>;
};

export type TermsAndConditionsQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A terms and conditions page to be accepted during provisioning. */
export type TermsAndConditionsSchema = {
  __typename?: 'TermsAndConditionsSchema';
  /** A well-formatted HTML string. It will be parsed on the client with android.text.Html#fromHtml. */
  content?: Maybe<UserFacingMessageSchema>;
  /** A short header which appears above the HTML content. */
  header?: Maybe<UserFacingMessageSchema>;
};

export enum UsageLogEnabledLogTypes {
  /** This value is not used. */
  LogTypeUnspecified = 'LOG_TYPE_UNSPECIFIED',
  /** Enable logging of on-device network events, like DNS lookups and TCP connections. See UsageLogEvent for a complete description of the logged network events. Supported for fully managed devices on Android 8 and above. Supported for company-owned devices with a work profile on Android 12 and above, on which only network events from the work profile are logged. Can be overridden by the application delegated scope NETWORK_ACTIVITY_LOGS */
  NetworkActivityLogs = 'NETWORK_ACTIVITY_LOGS',
  /** Enable logging of on-device security events, like when the device password is incorrectly entered or removable storage is mounted. See UsageLogEvent for a complete description of the logged security events. Supported for fully managed devices on Android 7 and above. Supported for company-owned devices with a work profile on Android 12 and above, on which only security events from the work profile are logged. Can be overridden by the application delegated scope SECURITY_LOGS */
  SecurityLogs = 'SECURITY_LOGS'
}

export enum UsageLogEventEventType {
  /** Indicates adb_shell_command_event has been set. */
  AdbShellCommand = 'ADB_SHELL_COMMAND',
  /** Indicates adb_shell_interactive_event has been set. */
  AdbShellInteractive = 'ADB_SHELL_INTERACTIVE',
  /** Indicates app_process_start_event has been set. */
  AppProcessStart = 'APP_PROCESS_START',
  /** Indicates cert_authority_installed_event has been set. */
  CertAuthorityInstalled = 'CERT_AUTHORITY_INSTALLED',
  /** Indicates cert_authority_removed_event has been set. */
  CertAuthorityRemoved = 'CERT_AUTHORITY_REMOVED',
  /** Indicates cert_validation_failure_event has been set. */
  CertValidationFailure = 'CERT_VALIDATION_FAILURE',
  /** Indicates connect_event has been set. */
  Connect = 'CONNECT',
  /** Indicates crypto_self_test_completed_event has been set. */
  CryptoSelfTestCompleted = 'CRYPTO_SELF_TEST_COMPLETED',
  /** Indicates dns_event has been set. */
  Dns = 'DNS',
  /** This value is not used */
  EventTypeUnspecified = 'EVENT_TYPE_UNSPECIFIED',
  /** Indicates file_pulled_event has been set. */
  FilePulled = 'FILE_PULLED',
  /** Indicates file_pushed_event has been set. */
  FilePushed = 'FILE_PUSHED',
  /** Indicates keyguard_dismissed_event has been set. */
  KeyguardDismissed = 'KEYGUARD_DISMISSED',
  /** Indicates keyguard_dismiss_auth_attempt_event has been set. */
  KeyguardDismissAuthAttempt = 'KEYGUARD_DISMISS_AUTH_ATTEMPT',
  /** Indicates keyguard_secured_event has been set. */
  KeyguardSecured = 'KEYGUARD_SECURED',
  /** Indicates key_destruction_event has been set. */
  KeyDestruction = 'KEY_DESTRUCTION',
  /** Indicates key_generated_event has been set. */
  KeyGenerated = 'KEY_GENERATED',
  /** Indicates key_import_event has been set. */
  KeyImport = 'KEY_IMPORT',
  /** Indicates key_integrity_violation_event has been set. */
  KeyIntegrityViolation = 'KEY_INTEGRITY_VIOLATION',
  /** Indicates logging_started_event has been set. */
  LoggingStarted = 'LOGGING_STARTED',
  /** Indicates logging_stopped_event has been set. */
  LoggingStopped = 'LOGGING_STOPPED',
  /** Indicates log_buffer_size_critical_event has been set. */
  LogBufferSizeCritical = 'LOG_BUFFER_SIZE_CRITICAL',
  /** Indicates media_mount_event has been set. */
  MediaMount = 'MEDIA_MOUNT',
  /** Indicates media_unmount_event has been set. */
  MediaUnmount = 'MEDIA_UNMOUNT',
  /** Indicates os_shutdown_event has been set. */
  OsShutdown = 'OS_SHUTDOWN',
  /** Indicates os_startup_event has been set. */
  OsStartup = 'OS_STARTUP',
  /** Indicates remote_lock_event has been set. */
  RemoteLock = 'REMOTE_LOCK',
  /** Indicates wipe_failure_event has been set. */
  WipeFailure = 'WIPE_FAILURE'
}

/** An event logged on the device. */
export type UsageLogEventInputSchema = {
  /** A shell command was issued over ADB via “adb shell command”. Part of SECURITY_LOGS. */
  adbShellCommandEvent?: InputMaybe<AdbShellCommandEventInputSchema>;
  /** An ADB interactive shell was opened via “adb shell”. Part of SECURITY_LOGS. */
  adbShellInteractiveEvent?: InputMaybe<AdbShellInteractiveEventInputSchema>;
  /** An app process was started. Part of SECURITY_LOGS. */
  appProcessStartEvent?: InputMaybe<AppProcessStartEventInputSchema>;
  /** A new root certificate was installed into the system's trusted credential storage. Part of SECURITY_LOGS. */
  certAuthorityInstalledEvent?: InputMaybe<CertAuthorityInstalledEventInputSchema>;
  /** A root certificate was removed from the system's trusted credential storage. Part of SECURITY_LOGS. */
  certAuthorityRemovedEvent?: InputMaybe<CertAuthorityRemovedEventInputSchema>;
  /** An X.509v3 certificate failed to validate, currently this validation is performed on the Wi-FI access point and failure may be due to a mismatch upon server certificate validation. However it may in the future include other validation events of an X.509v3 certificate. Part of SECURITY_LOGS. */
  certValidationFailureEvent?: InputMaybe<CertValidationFailureEventInputSchema>;
  /** A TCP connect event was initiated through the standard network stack. Part of NETWORK_ACTIVITY_LOGS. */
  connectEvent?: InputMaybe<ConnectEventInputSchema>;
  /** Validates whether Android’s built-in cryptographic library (BoringSSL) is valid. Should always succeed on device boot, if it fails, the device should be considered untrusted. Part of SECURITY_LOGS. */
  cryptoSelfTestCompletedEvent?: InputMaybe<CryptoSelfTestCompletedEventInputSchema>;
  /** A DNS lookup event was initiated through the standard network stack. Part of NETWORK_ACTIVITY_LOGS. */
  dnsEvent?: InputMaybe<DnsEventInputSchema>;
  /** Unique id of the event. */
  eventId?: InputMaybe<Scalars['String']['input']>;
  /** Device timestamp when the event was logged. */
  eventTime?: InputMaybe<Scalars['String']['input']>;
  /** The particular usage log event type that was reported on the device. Use this to determine which event field to access. */
  eventType?: InputMaybe<UsageLogEventEventType>;
  /** A file was downloaded from the device. Part of SECURITY_LOGS. */
  filePulledEvent?: InputMaybe<FilePulledEventInputSchema>;
  /** A file was uploaded onto the device. Part of SECURITY_LOGS. */
  filePushedEvent?: InputMaybe<FilePushedEventInputSchema>;
  /** A cryptographic key including user installed, admin installed and system maintained private key is removed from the device either by the user or management. Part of SECURITY_LOGS. */
  keyDestructionEvent?: InputMaybe<KeyDestructionEventInputSchema>;
  /** A cryptographic key including user installed, admin installed and system maintained private key is installed on the device either by the user or management. Part of SECURITY_LOGS. */
  keyGeneratedEvent?: InputMaybe<KeyGeneratedEventInputSchema>;
  /** A cryptographic key including user installed, admin installed and system maintained private key is imported on the device either by the user or management. Part of SECURITY_LOGS. */
  keyImportEvent?: InputMaybe<KeyImportEventInputSchema>;
  /** A cryptographic key including user installed, admin installed and system maintained private key is determined to be corrupted due to storage corruption, hardware failure or some OS issue. Part of SECURITY_LOGS. */
  keyIntegrityViolationEvent?: InputMaybe<KeyIntegrityViolationEventInputSchema>;
  /** An attempt was made to unlock the device. Part of SECURITY_LOGS. */
  keyguardDismissAuthAttemptEvent?: InputMaybe<KeyguardDismissAuthAttemptEventInputSchema>;
  /** The keyguard was dismissed. Part of SECURITY_LOGS. */
  keyguardDismissedEvent?: InputMaybe<KeyguardDismissedEventInputSchema>;
  /** The device was locked either by user or timeout. Part of SECURITY_LOGS. */
  keyguardSecuredEvent?: InputMaybe<KeyguardSecuredEventInputSchema>;
  /** The audit log buffer has reached 90% of its capacity, therefore older events may be dropped. Part of SECURITY_LOGS. */
  logBufferSizeCriticalEvent?: InputMaybe<LogBufferSizeCriticalEventInputSchema>;
  /** usageLog policy has been enabled. Part of SECURITY_LOGS. */
  loggingStartedEvent?: InputMaybe<LoggingStartedEventInputSchema>;
  /** usageLog policy has been disabled. Part of SECURITY_LOGS. */
  loggingStoppedEvent?: InputMaybe<LoggingStoppedEventInputSchema>;
  /** Removable media was mounted. Part of SECURITY_LOGS. */
  mediaMountEvent?: InputMaybe<MediaMountEventInputSchema>;
  /** Removable media was unmounted. Part of SECURITY_LOGS. */
  mediaUnmountEvent?: InputMaybe<MediaUnmountEventInputSchema>;
  /** Device was shutdown. Part of SECURITY_LOGS. */
  osShutdownEvent?: InputMaybe<OsShutdownEventInputSchema>;
  /** Device was started. Part of SECURITY_LOGS. */
  osStartupEvent?: InputMaybe<OsStartupEventInputSchema>;
  /** The device or profile has been remotely locked via the LOCK command. Part of SECURITY_LOGS. */
  remoteLockEvent?: InputMaybe<RemoteLockEventInputSchema>;
  /** The work profile or company-owned device failed to wipe when requested. This could be user initiated or admin initiated e.g. delete was received. Part of SECURITY_LOGS. */
  wipeFailureEvent?: InputMaybe<WipeFailureEventInputSchema>;
};

export type UsageLogEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** An event logged on the device. */
export type UsageLogEventSchema = {
  __typename?: 'UsageLogEventSchema';
  /** A shell command was issued over ADB via “adb shell command”. Part of SECURITY_LOGS. */
  adbShellCommandEvent?: Maybe<AdbShellCommandEventSchema>;
  /** An ADB interactive shell was opened via “adb shell”. Part of SECURITY_LOGS. */
  adbShellInteractiveEvent?: Maybe<AdbShellInteractiveEventSchema>;
  /** An app process was started. Part of SECURITY_LOGS. */
  appProcessStartEvent?: Maybe<AppProcessStartEventSchema>;
  /** A new root certificate was installed into the system's trusted credential storage. Part of SECURITY_LOGS. */
  certAuthorityInstalledEvent?: Maybe<CertAuthorityInstalledEventSchema>;
  /** A root certificate was removed from the system's trusted credential storage. Part of SECURITY_LOGS. */
  certAuthorityRemovedEvent?: Maybe<CertAuthorityRemovedEventSchema>;
  /** An X.509v3 certificate failed to validate, currently this validation is performed on the Wi-FI access point and failure may be due to a mismatch upon server certificate validation. However it may in the future include other validation events of an X.509v3 certificate. Part of SECURITY_LOGS. */
  certValidationFailureEvent?: Maybe<CertValidationFailureEventSchema>;
  /** A TCP connect event was initiated through the standard network stack. Part of NETWORK_ACTIVITY_LOGS. */
  connectEvent?: Maybe<ConnectEventSchema>;
  /** Validates whether Android’s built-in cryptographic library (BoringSSL) is valid. Should always succeed on device boot, if it fails, the device should be considered untrusted. Part of SECURITY_LOGS. */
  cryptoSelfTestCompletedEvent?: Maybe<CryptoSelfTestCompletedEventSchema>;
  /** A DNS lookup event was initiated through the standard network stack. Part of NETWORK_ACTIVITY_LOGS. */
  dnsEvent?: Maybe<DnsEventSchema>;
  /** Unique id of the event. */
  eventId?: Maybe<Scalars['String']['output']>;
  /** Device timestamp when the event was logged. */
  eventTime?: Maybe<Scalars['String']['output']>;
  /** The particular usage log event type that was reported on the device. Use this to determine which event field to access. */
  eventType?: Maybe<UsageLogEventEventType>;
  /** A file was downloaded from the device. Part of SECURITY_LOGS. */
  filePulledEvent?: Maybe<FilePulledEventSchema>;
  /** A file was uploaded onto the device. Part of SECURITY_LOGS. */
  filePushedEvent?: Maybe<FilePushedEventSchema>;
  /** A cryptographic key including user installed, admin installed and system maintained private key is removed from the device either by the user or management. Part of SECURITY_LOGS. */
  keyDestructionEvent?: Maybe<KeyDestructionEventSchema>;
  /** A cryptographic key including user installed, admin installed and system maintained private key is installed on the device either by the user or management. Part of SECURITY_LOGS. */
  keyGeneratedEvent?: Maybe<KeyGeneratedEventSchema>;
  /** A cryptographic key including user installed, admin installed and system maintained private key is imported on the device either by the user or management. Part of SECURITY_LOGS. */
  keyImportEvent?: Maybe<KeyImportEventSchema>;
  /** A cryptographic key including user installed, admin installed and system maintained private key is determined to be corrupted due to storage corruption, hardware failure or some OS issue. Part of SECURITY_LOGS. */
  keyIntegrityViolationEvent?: Maybe<KeyIntegrityViolationEventSchema>;
  /** An attempt was made to unlock the device. Part of SECURITY_LOGS. */
  keyguardDismissAuthAttemptEvent?: Maybe<KeyguardDismissAuthAttemptEventSchema>;
  /** The keyguard was dismissed. Part of SECURITY_LOGS. */
  keyguardDismissedEvent?: Maybe<KeyguardDismissedEventSchema>;
  /** The device was locked either by user or timeout. Part of SECURITY_LOGS. */
  keyguardSecuredEvent?: Maybe<KeyguardSecuredEventSchema>;
  /** The audit log buffer has reached 90% of its capacity, therefore older events may be dropped. Part of SECURITY_LOGS. */
  logBufferSizeCriticalEvent?: Maybe<LogBufferSizeCriticalEventSchema>;
  /** usageLog policy has been enabled. Part of SECURITY_LOGS. */
  loggingStartedEvent?: Maybe<LoggingStartedEventSchema>;
  /** usageLog policy has been disabled. Part of SECURITY_LOGS. */
  loggingStoppedEvent?: Maybe<LoggingStoppedEventSchema>;
  /** Removable media was mounted. Part of SECURITY_LOGS. */
  mediaMountEvent?: Maybe<MediaMountEventSchema>;
  /** Removable media was unmounted. Part of SECURITY_LOGS. */
  mediaUnmountEvent?: Maybe<MediaUnmountEventSchema>;
  /** Device was shutdown. Part of SECURITY_LOGS. */
  osShutdownEvent?: Maybe<OsShutdownEventSchema>;
  /** Device was started. Part of SECURITY_LOGS. */
  osStartupEvent?: Maybe<OsStartupEventSchema>;
  /** The device or profile has been remotely locked via the LOCK command. Part of SECURITY_LOGS. */
  remoteLockEvent?: Maybe<RemoteLockEventSchema>;
  /** The work profile or company-owned device failed to wipe when requested. This could be user initiated or admin initiated e.g. delete was received. Part of SECURITY_LOGS. */
  wipeFailureEvent?: Maybe<WipeFailureEventSchema>;
};

/** Controls types of device activity logs collected from the device and reported via Pub/Sub notification (https://developers.google.com/android/management/notifications). */
export type UsageLogInputSchema = {
  /** Specifies which log types are enabled. Note that users will receive on-device messaging when usage logging is enabled. */
  enabledLogTypes?: InputMaybe<Array<UsageLogEnabledLogTypes>>;
  /** Specifies which of the enabled log types can be uploaded over mobile data. By default logs are queued for upload when the device connects to WiFi. */
  uploadOnCellularAllowed?: InputMaybe<Array<UsageLogUploadOnCellularAllowed>>;
};

export type UsageLogQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Controls types of device activity logs collected from the device and reported via Pub/Sub notification (https://developers.google.com/android/management/notifications). */
export type UsageLogSchema = {
  __typename?: 'UsageLogSchema';
  /** Specifies which log types are enabled. Note that users will receive on-device messaging when usage logging is enabled. */
  enabledLogTypes?: Maybe<Array<UsageLogEnabledLogTypes>>;
  /** Specifies which of the enabled log types can be uploaded over mobile data. By default logs are queued for upload when the device connects to WiFi. */
  uploadOnCellularAllowed?: Maybe<Array<UsageLogUploadOnCellularAllowed>>;
};

export enum UsageLogUploadOnCellularAllowed {
  /** This value is not used. */
  LogTypeUnspecified = 'LOG_TYPE_UNSPECIFIED',
  /** Enable logging of on-device network events, like DNS lookups and TCP connections. See UsageLogEvent for a complete description of the logged network events. Supported for fully managed devices on Android 8 and above. Supported for company-owned devices with a work profile on Android 12 and above, on which only network events from the work profile are logged. Can be overridden by the application delegated scope NETWORK_ACTIVITY_LOGS */
  NetworkActivityLogs = 'NETWORK_ACTIVITY_LOGS',
  /** Enable logging of on-device security events, like when the device password is incorrectly entered or removable storage is mounted. See UsageLogEvent for a complete description of the logged security events. Supported for fully managed devices on Android 7 and above. Supported for company-owned devices with a work profile on Android 12 and above, on which only security events from the work profile are logged. Can be overridden by the application delegated scope SECURITY_LOGS */
  SecurityLogs = 'SECURITY_LOGS'
}

/** Provides a user-facing message with locale info. The maximum message length is 4096 characters. */
export type UserFacingMessageInputSchema = {
  /** The default message displayed if no localized message is specified or the user's locale doesn't match with any of the localized messages. A default message must be provided if any localized messages are provided. */
  defaultMessage?: InputMaybe<Scalars['String']['input']>;
  /** A map containing pairs, where locale is a well-formed BCP 47 language (https://www.w3.org/International/articles/language-tags/) code, such as en-US, es-ES, or fr. */
  localizedMessages?: InputMaybe<Scalars['JSON']['input']>;
};

export type UserFacingMessageQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** Provides a user-facing message with locale info. The maximum message length is 4096 characters. */
export type UserFacingMessageSchema = {
  __typename?: 'UserFacingMessageSchema';
  /** The default message displayed if no localized message is specified or the user's locale doesn't match with any of the localized messages. A default message must be provided if any localized messages are provided. */
  defaultMessage?: Maybe<Scalars['String']['output']>;
  /** A map containing pairs, where locale is a well-formed BCP 47 language (https://www.w3.org/International/articles/language-tags/) code, such as en-US, es-ES, or fr. */
  localizedMessages?: Maybe<Scalars['JSON']['output']>;
};

/** A user belonging to an enterprise. */
export type UserInputSchema = {
  /** A unique identifier you create for this user, such as user342 or asset#44418. This field must be set when the user is created and can't be updated. This field must not contain personally identifiable information (PII). This identifier must be 1024 characters or less; otherwise, the update policy request will fail. */
  accountIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type UserQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A user belonging to an enterprise. */
export type UserSchema = {
  __typename?: 'UserSchema';
  /** A unique identifier you create for this user, such as user342 or asset#44418. This field must be set when the user is created and can't be updated. This field must not contain personally identifiable information (PII). This identifier must be 1024 characters or less; otherwise, the update policy request will fail. */
  accountIdentifier?: Maybe<Scalars['String']['output']>;
};

export enum WebAppDisplayMode {
  /** Not used. */
  DisplayModeUnspecified = 'DISPLAY_MODE_UNSPECIFIED',
  /** Opens the web app in full screen without any visible controls. The browser UI elements, page URL, system status bar and back button are not visible, and the web app takes up the entirety of the available display area. */
  FullScreen = 'FULL_SCREEN',
  /** Opens the web app with a minimal set of browser UI elements for controlling navigation and viewing the page URL. */
  MinimalUi = 'MINIMAL_UI',
  /** Opens the web app to look and feel like a standalone native application. The browser UI elements and page URL are not visible, however the system status bar and back button are visible. */
  Standalone = 'STANDALONE'
}

/** An icon for a web app. Supported formats are: png, jpg and webp. */
export type WebAppIconInputSchema = {
  /** The actual bytes of the image in a base64url encoded string (c.f. RFC4648, section 5 "Base 64 Encoding with URL and Filename Safe Alphabet"). - The image type can be png or jpg. - The image should ideally be square. - The image should ideally have a size of 512x512.  */
  imageData?: InputMaybe<Scalars['String']['input']>;
};

export type WebAppIconQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** An icon for a web app. Supported formats are: png, jpg and webp. */
export type WebAppIconSchema = {
  __typename?: 'WebAppIconSchema';
  /** The actual bytes of the image in a base64url encoded string (c.f. RFC4648, section 5 "Base 64 Encoding with URL and Filename Safe Alphabet"). - The image type can be png or jpg. - The image should ideally be square. - The image should ideally have a size of 512x512.  */
  imageData?: Maybe<Scalars['String']['output']>;
};

/** A web app. */
export type WebAppInputSchema = {
  /** The display mode of the web app. */
  displayMode?: InputMaybe<WebAppDisplayMode>;
  /** A list of icons for the web app. Must have at least one element. */
  icons?: InputMaybe<Array<WebAppIconInputSchema>>;
  /** The name of the web app, which is generated by the server during creation in the form enterprises/{enterpriseId}/webApps/{packageName}. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The start URL, i.e. the URL that should load when the user opens the application. */
  startUrl?: InputMaybe<Scalars['String']['input']>;
  /** The title of the web app as displayed to the user (e.g., amongst a list of other applications, or as a label for an icon). */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The current version of the app.Note that the version can automatically increase during the lifetime of the web app, while Google does internal housekeeping to keep the web app up-to-date. */
  versionCode?: InputMaybe<Scalars['String']['input']>;
};

export type WebAppQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** A web app. */
export type WebAppSchema = {
  __typename?: 'WebAppSchema';
  /** The display mode of the web app. */
  displayMode?: Maybe<WebAppDisplayMode>;
  /** A list of icons for the web app. Must have at least one element. */
  icons?: Maybe<Array<WebAppIconSchema>>;
  /** The name of the web app, which is generated by the server during creation in the form enterprises/{enterpriseId}/webApps/{packageName}. */
  name?: Maybe<Scalars['String']['output']>;
  /** The start URL, i.e. the URL that should load when the user opens the application. */
  startUrl?: Maybe<Scalars['String']['output']>;
  /** The title of the web app as displayed to the user (e.g., amongst a list of other applications, or as a label for an icon). */
  title?: Maybe<Scalars['String']['output']>;
  /** The current version of the app.Note that the version can automatically increase during the lifetime of the web app, while Google does internal housekeeping to keep the web app up-to-date. */
  versionCode?: Maybe<Scalars['String']['output']>;
};

export enum WebTokenEnabledFeatures {
  /** Unspecified feature. */
  FeatureUnspecified = 'FEATURE_UNSPECIFIED',
  /** The managed configurations page (https://developers.google.com/android/management/managed-configurations-iframe). */
  ManagedConfigurations = 'MANAGED_CONFIGURATIONS',
  /** The Managed Play search apps page (https://developers.google.com/android/management/apps#search-apps). */
  PlaySearch = 'PLAY_SEARCH',
  /** The private apps page (https://developers.google.com/android/management/apps#private-apps). */
  PrivateApps = 'PRIVATE_APPS',
  /** The organize apps page (https://developers.google.com/android/management/apps#organize-apps). */
  StoreBuilder = 'STORE_BUILDER',
  /** The Web Apps page (https://developers.google.com/android/management/apps#web-apps). */
  WebApps = 'WEB_APPS',
  /** The zero-touch iframe (https://developers.google.com/android/management/zero-touch-iframe). */
  ZeroTouchCustomerManagement = 'ZERO_TOUCH_CUSTOMER_MANAGEMENT'
}

export type WebTokenInputSchema = {
  /** The features to enable. Use this if you want to control exactly which feature(s) will be activated; leave empty to allow all features.Restrictions / things to note: - If no features are listed here, all features are enabled — this is the default behavior where you give access to all features to your admins. - This must not contain any FEATURE_UNSPECIFIED values. - Repeated values are ignored  */
  enabledFeatures?: InputMaybe<Array<WebTokenEnabledFeatures>>;
  enterprise: EnterpriseInputSchema;
  /** Alias for the name field to preserve madhatter compatibility */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The name of the web token, which is generated by the server during creation in the form enterprises/{enterpriseId}/webTokens/{webTokenId}. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The URL of the parent frame hosting the iframe with the embedded UI. To prevent XSS, the iframe may not be hosted at other URLs. The URL must use the https scheme. */
  parentFrameUrl?: InputMaybe<Scalars['String']['input']>;
  /** Permissions available to an admin in the embedded UI. An admin must have all of these permissions in order to view the UI. This field is deprecated. */
  permissions?: InputMaybe<Array<WebTokenPermissions>>;
  /** The token value which is used in the hosting page to generate the iframe with the embedded UI. This is a read-only field generated by the server. */
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum WebTokenPermissions {
  /** The permission to approve apps for the enterprise. */
  ApproveApps = 'APPROVE_APPS',
  /** This value is ignored. */
  WebTokenPermissionUnspecified = 'WEB_TOKEN_PERMISSION_UNSPECIFIED'
}

export type WebTokenQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

export type WebTokenSchema = {
  __typename?: 'WebTokenSchema';
  /** The features to enable. Use this if you want to control exactly which feature(s) will be activated; leave empty to allow all features.Restrictions / things to note: - If no features are listed here, all features are enabled — this is the default behavior where you give access to all features to your admins. - This must not contain any FEATURE_UNSPECIFIED values. - Repeated values are ignored  */
  enabledFeatures?: Maybe<Array<WebTokenEnabledFeatures>>;
  enterprise: EnterpriseSchema;
  /** Alias for the name field to preserve madhatter compatibility */
  id: Scalars['String']['output'];
  /** The name of the web token, which is generated by the server during creation in the form enterprises/{enterpriseId}/webTokens/{webTokenId}. */
  name?: Maybe<Scalars['String']['output']>;
  /** The URL of the parent frame hosting the iframe with the embedded UI. To prevent XSS, the iframe may not be hosted at other URLs. The URL must use the https scheme. */
  parentFrameUrl?: Maybe<Scalars['String']['output']>;
  /** Permissions available to an admin in the embedded UI. An admin must have all of these permissions in order to view the UI. This field is deprecated. */
  permissions?: Maybe<Array<WebTokenPermissions>>;
  /** The token value which is used in the hosting page to generate the iframe with the embedded UI. This is a read-only field generated by the server. */
  value?: Maybe<Scalars['String']['output']>;
};

/** An action to reset a company owned device or delete a work profile. Note: blockAction must also be specified. */
export type WipeActionInputSchema = {
  /** Whether the factory-reset protection data is preserved on the device. This setting doesn’t apply to work profiles. */
  preserveFrp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of days the policy is non-compliant before the device or work profile is wiped. wipeAfterDays must be greater than blockAfterDays. */
  wipeAfterDays?: InputMaybe<Scalars['Int']['input']>;
};

export type WipeActionQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** An action to reset a company owned device or delete a work profile. Note: blockAction must also be specified. */
export type WipeActionSchema = {
  __typename?: 'WipeActionSchema';
  /** Whether the factory-reset protection data is preserved on the device. This setting doesn’t apply to work profiles. */
  preserveFrp?: Maybe<Scalars['Boolean']['output']>;
  /** Number of days the policy is non-compliant before the device or work profile is wiped. wipeAfterDays must be greater than blockAfterDays. */
  wipeAfterDays?: Maybe<Scalars['Int']['output']>;
};

/** The work profile or company-owned device failed to wipe when requested. This could be user initiated or admin initiated e.g. delete was received. Intentionally empty. */
export type WipeFailureEventInputSchema = {
  /** Placeholder field to prevent empty schema. */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type WipeFailureEventQueryArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<SortArg>>;
};

/** The work profile or company-owned device failed to wipe when requested. This could be user initiated or admin initiated e.g. delete was received. Intentionally empty. */
export type WipeFailureEventSchema = {
  __typename?: 'WipeFailureEventSchema';
  /** Placeholder field to prevent empty schema. */
  _?: Maybe<Scalars['String']['output']>;
};

export type PolicyFieldsFragment = { __typename?: 'PolicySchema', id: string, playStoreMode?: PolicyPlayStoreMode | null, openNetworkConfiguration?: any | null, screenCaptureDisabled?: boolean | null, factoryResetDisabled?: boolean | null, cameraAccess?: PolicyCameraAccess | null, microphoneAccess?: PolicyMicrophoneAccess | null, networkEscapeHatchEnabled?: boolean | null, kioskCustomLauncherEnabled?: boolean | null, setWallpaperDisabled?: boolean | null, frpAdminEmails?: Array<string> | null, keyguardDisabled?: boolean | null, installAppsDisabled?: boolean | null, mobileNetworksConfigDisabled?: boolean | null, privateKeySelectionEnabled?: boolean | null, outgoingCallsDisabled?: boolean | null, smsDisabled?: boolean | null, mountPhysicalMediaDisabled?: boolean | null, autoDateAndTimeZone?: PolicyAutoDateAndTimeZone | null, setUserIconDisabled?: boolean | null, removeUserDisabled?: boolean | null, appAutoUpdatePolicy?: PolicyAppAutoUpdatePolicy | null, locationMode?: PolicyLocationMode | null, skipFirstUseHintsEnabled?: boolean | null, adjustVolumeDisabled?: boolean | null, keyguardDisabledFeatures?: Array<PolicyKeyguardDisabledFeatures> | null, shareLocationDisabled?: boolean | null, credentialsConfigDisabled?: boolean | null, networkResetDisabled?: boolean | null, defaultPermissionPolicy?: PolicyDefaultPermissionPolicy | null, addUserDisabled?: boolean | null, dataRoamingDisabled?: boolean | null, accountTypesWithManagementDisabled?: Array<string> | null, androidDevicePolicyTracks?: Array<PolicyAndroidDevicePolicyTracks> | null, createWindowsDisabled?: boolean | null, preferentialNetworkService?: PolicyPreferentialNetworkService | null, stayOnPluggedModes?: Array<PolicyStayOnPluggedModes> | null, bluetoothConfigDisabled?: boolean | null, outgoingBeamDisabled?: boolean | null, minimumApiLevel?: number | null, uninstallAppsDisabled?: boolean | null, encryptionPolicy?: PolicyEncryptionPolicy | null, bluetoothContactSharingDisabled?: boolean | null, bluetoothDisabled?: boolean | null, vpnConfigDisabled?: boolean | null, maximumTimeToLock?: string | null, modifyAccountsDisabled?: boolean | null, cellBroadcastsConfigDisabled?: boolean | null, funDisabled?: boolean | null, statusReportingSettings?: { __typename?: 'StatusReportingSettingsSchema', networkInfoEnabled?: boolean | null } | null, deviceOwnerLockScreenInfo?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, kioskCustomization?: { __typename?: 'KioskCustomizationSchema', systemNavigation?: KioskCustomizationSystemNavigation | null, systemErrorWarnings?: KioskCustomizationSystemErrorWarnings | null, statusBar?: KioskCustomizationStatusBar | null, powerButtonActions?: KioskCustomizationPowerButtonActions | null, deviceSettings?: KioskCustomizationDeviceSettings | null } | null, applications?: Array<{ __typename?: 'ApplicationPolicySchema', packageName?: string | null, installType?: ApplicationPolicyInstallType | null, defaultPermissionPolicy?: ApplicationPolicyDefaultPermissionPolicy | null, managedConfiguration?: any | null, disabled?: boolean | null, minimumVersionCode?: number | null, delegatedScopes?: Array<ApplicationPolicyDelegatedScopes> | null, accessibleTrackIds?: Array<string> | null, connectedWorkAndPersonalApp?: ApplicationPolicyConnectedWorkAndPersonalApp | null, autoUpdateMode?: ApplicationPolicyAutoUpdateMode | null, alwaysOnVpnLockdownExemption?: ApplicationPolicyAlwaysOnVpnLockdownExemption | null, workProfileWidgets?: ApplicationPolicyWorkProfileWidgets | null, permissionGrants?: Array<{ __typename?: 'PermissionGrantSchema', permission?: string | null, policy?: PermissionGrantPolicy | null }> | null, managedConfigurationTemplate?: { __typename?: 'ManagedConfigurationTemplateSchema', templateId?: string | null } | null, extensionConfig?: { __typename?: 'ExtensionConfigSchema', signingKeyFingerprintsSha256?: Array<string> | null, notificationReceiver?: string | null } | null }> | null, setupActions?: Array<{ __typename?: 'SetupActionSchema', description?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, title?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, launchApp?: { __typename?: 'LaunchAppActionSchema', packageName?: string | null } | null }> | null, advancedSecurityOverrides?: { __typename?: 'AdvancedSecurityOverridesSchema', developerSettings?: AdvancedSecurityOverridesDeveloperSettings | null, untrustedAppsPolicy?: AdvancedSecurityOverridesUntrustedAppsPolicy | null, googlePlayProtectVerifyApps?: AdvancedSecurityOverridesGooglePlayProtectVerifyApps | null } | null, policyEnforcementRules?: Array<{ __typename?: 'PolicyEnforcementRuleSchema', settingName?: string | null, blockAction?: { __typename?: 'BlockActionSchema', blockAfterDays?: number | null, blockScope?: BlockActionBlockScope | null } | null, wipeAction?: { __typename?: 'WipeActionSchema', preserveFrp?: boolean | null, wipeAfterDays?: number | null } | null }> | null, permittedAccessibilityServices?: { __typename?: 'PackageNameListSchema', packageNames?: Array<string> | null } | null, persistentPreferredActivities?: Array<{ __typename?: 'PersistentPreferredActivitySchema', actions?: Array<string> | null, categories?: Array<string> | null, receiverActivity?: string | null }> | null, choosePrivateKeyRules?: Array<{ __typename?: 'ChoosePrivateKeyRuleSchema', packageNames?: Array<string> | null, privateKeyAlias?: string | null, urlPattern?: string | null }> | null, deviceConnectivityManagement?: { __typename?: 'DeviceConnectivityManagementSchema', usbDataAccess?: DeviceConnectivityManagementUsbDataAccess | null } | null, shortSupportMessage?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null, localizedMessages?: any | null } | null, usageLog?: { __typename?: 'UsageLogSchema', enabledLogTypes?: Array<UsageLogEnabledLogTypes> | null, uploadOnCellularAllowed?: Array<UsageLogUploadOnCellularAllowed> | null } | null, longSupportMessage?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null, localizedMessages?: any | null } | null, permittedInputMethods?: { __typename?: 'PackageNameListSchema', packageNames?: Array<string> | null } | null, personalUsagePolicies?: { __typename?: 'PersonalUsagePoliciesSchema', accountTypesWithManagementDisabled?: Array<string> | null, cameraDisabled?: boolean | null, maxDaysWithWorkOff?: number | null, personalPlayStoreMode?: PersonalUsagePoliciesPersonalPlayStoreMode | null, screenCaptureDisabled?: boolean | null, personalApplications?: Array<{ __typename?: 'PersonalApplicationPolicySchema', installType?: PersonalApplicationPolicyInstallType | null, packageName?: string | null }> | null } | null, recommendedGlobalProxy?: { __typename?: 'ProxyInfoSchema', excludedHosts?: Array<string> | null, host?: string | null, pacUri?: string | null, port?: number | null } | null, systemUpdate?: { __typename?: 'SystemUpdateSchema', endMinutes?: number | null, startMinutes?: number | null, type?: SystemUpdateType | null, freezePeriods?: Array<{ __typename?: 'FreezePeriodSchema', endDate?: { __typename?: 'DateSchema', day?: number | null, month?: number | null, year?: number | null } | null, startDate?: { __typename?: 'DateSchema', day?: number | null, month?: number | null, year?: number | null } | null }> | null } | null, permissionGrants?: Array<{ __typename?: 'PermissionGrantSchema', permission?: string | null, policy?: PermissionGrantPolicy | null }> | null, oncCertificateProviders?: Array<{ __typename?: 'OncCertificateProviderSchema', certificateReferences?: Array<string> | null, contentProviderEndpoint?: { __typename?: 'ContentProviderEndpointSchema', packageName?: string | null, signingCertsSha256?: Array<string> | null, uri?: string | null } | null }> | null, alwaysOnVpnPackage?: { __typename?: 'AlwaysOnVpnPackageSchema', lockdownEnabled?: boolean | null, packageName?: string | null } | null, passwordPolicies?: Array<{ __typename?: 'PasswordRequirementsSchema', maximumFailedPasswordsForWipe?: number | null, passwordExpirationTimeout?: string | null, passwordHistoryLength?: number | null, passwordMinimumLength?: number | null, passwordMinimumLetters?: number | null, passwordMinimumLowerCase?: number | null, passwordMinimumNonLetter?: number | null, passwordMinimumNumeric?: number | null, passwordMinimumSymbols?: number | null, passwordMinimumUpperCase?: number | null, passwordQuality?: PasswordRequirementsPasswordQuality | null, passwordScope?: PasswordRequirementsPasswordScope | null, requirePasswordUnlock?: PasswordRequirementsRequirePasswordUnlock | null, unifiedLockSettings?: PasswordRequirementsUnifiedLockSettings | null }> | null, crossProfilePolicies?: { __typename?: 'CrossProfilePoliciesSchema', crossProfileCopyPaste?: CrossProfilePoliciesCrossProfileCopyPaste | null, crossProfileDataSharing?: CrossProfilePoliciesCrossProfileDataSharing | null, showWorkContactsInPersonalProfile?: CrossProfilePoliciesShowWorkContactsInPersonalProfile | null, workProfileWidgetsDefault?: CrossProfilePoliciesWorkProfileWidgetsDefault | null } | null };

export type MdmPolicyFieldsFragment = { __typename?: 'MdmPolicySchema', id: string, enterpriseId: string, googleId: string, configGoogleId: string, name: string, policy?: { __typename?: 'PolicySchema', id: string, playStoreMode?: PolicyPlayStoreMode | null, openNetworkConfiguration?: any | null, screenCaptureDisabled?: boolean | null, factoryResetDisabled?: boolean | null, cameraAccess?: PolicyCameraAccess | null, microphoneAccess?: PolicyMicrophoneAccess | null, networkEscapeHatchEnabled?: boolean | null, kioskCustomLauncherEnabled?: boolean | null, setWallpaperDisabled?: boolean | null, frpAdminEmails?: Array<string> | null, keyguardDisabled?: boolean | null, installAppsDisabled?: boolean | null, mobileNetworksConfigDisabled?: boolean | null, privateKeySelectionEnabled?: boolean | null, outgoingCallsDisabled?: boolean | null, smsDisabled?: boolean | null, mountPhysicalMediaDisabled?: boolean | null, autoDateAndTimeZone?: PolicyAutoDateAndTimeZone | null, setUserIconDisabled?: boolean | null, removeUserDisabled?: boolean | null, appAutoUpdatePolicy?: PolicyAppAutoUpdatePolicy | null, locationMode?: PolicyLocationMode | null, skipFirstUseHintsEnabled?: boolean | null, adjustVolumeDisabled?: boolean | null, keyguardDisabledFeatures?: Array<PolicyKeyguardDisabledFeatures> | null, shareLocationDisabled?: boolean | null, credentialsConfigDisabled?: boolean | null, networkResetDisabled?: boolean | null, defaultPermissionPolicy?: PolicyDefaultPermissionPolicy | null, addUserDisabled?: boolean | null, dataRoamingDisabled?: boolean | null, accountTypesWithManagementDisabled?: Array<string> | null, androidDevicePolicyTracks?: Array<PolicyAndroidDevicePolicyTracks> | null, createWindowsDisabled?: boolean | null, preferentialNetworkService?: PolicyPreferentialNetworkService | null, stayOnPluggedModes?: Array<PolicyStayOnPluggedModes> | null, bluetoothConfigDisabled?: boolean | null, outgoingBeamDisabled?: boolean | null, minimumApiLevel?: number | null, uninstallAppsDisabled?: boolean | null, encryptionPolicy?: PolicyEncryptionPolicy | null, bluetoothContactSharingDisabled?: boolean | null, bluetoothDisabled?: boolean | null, vpnConfigDisabled?: boolean | null, maximumTimeToLock?: string | null, modifyAccountsDisabled?: boolean | null, cellBroadcastsConfigDisabled?: boolean | null, funDisabled?: boolean | null, statusReportingSettings?: { __typename?: 'StatusReportingSettingsSchema', networkInfoEnabled?: boolean | null } | null, deviceOwnerLockScreenInfo?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, kioskCustomization?: { __typename?: 'KioskCustomizationSchema', systemNavigation?: KioskCustomizationSystemNavigation | null, systemErrorWarnings?: KioskCustomizationSystemErrorWarnings | null, statusBar?: KioskCustomizationStatusBar | null, powerButtonActions?: KioskCustomizationPowerButtonActions | null, deviceSettings?: KioskCustomizationDeviceSettings | null } | null, applications?: Array<{ __typename?: 'ApplicationPolicySchema', packageName?: string | null, installType?: ApplicationPolicyInstallType | null, defaultPermissionPolicy?: ApplicationPolicyDefaultPermissionPolicy | null, managedConfiguration?: any | null, disabled?: boolean | null, minimumVersionCode?: number | null, delegatedScopes?: Array<ApplicationPolicyDelegatedScopes> | null, accessibleTrackIds?: Array<string> | null, connectedWorkAndPersonalApp?: ApplicationPolicyConnectedWorkAndPersonalApp | null, autoUpdateMode?: ApplicationPolicyAutoUpdateMode | null, alwaysOnVpnLockdownExemption?: ApplicationPolicyAlwaysOnVpnLockdownExemption | null, workProfileWidgets?: ApplicationPolicyWorkProfileWidgets | null, permissionGrants?: Array<{ __typename?: 'PermissionGrantSchema', permission?: string | null, policy?: PermissionGrantPolicy | null }> | null, managedConfigurationTemplate?: { __typename?: 'ManagedConfigurationTemplateSchema', templateId?: string | null } | null, extensionConfig?: { __typename?: 'ExtensionConfigSchema', signingKeyFingerprintsSha256?: Array<string> | null, notificationReceiver?: string | null } | null }> | null, setupActions?: Array<{ __typename?: 'SetupActionSchema', description?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, title?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, launchApp?: { __typename?: 'LaunchAppActionSchema', packageName?: string | null } | null }> | null, advancedSecurityOverrides?: { __typename?: 'AdvancedSecurityOverridesSchema', developerSettings?: AdvancedSecurityOverridesDeveloperSettings | null, untrustedAppsPolicy?: AdvancedSecurityOverridesUntrustedAppsPolicy | null, googlePlayProtectVerifyApps?: AdvancedSecurityOverridesGooglePlayProtectVerifyApps | null } | null, policyEnforcementRules?: Array<{ __typename?: 'PolicyEnforcementRuleSchema', settingName?: string | null, blockAction?: { __typename?: 'BlockActionSchema', blockAfterDays?: number | null, blockScope?: BlockActionBlockScope | null } | null, wipeAction?: { __typename?: 'WipeActionSchema', preserveFrp?: boolean | null, wipeAfterDays?: number | null } | null }> | null, permittedAccessibilityServices?: { __typename?: 'PackageNameListSchema', packageNames?: Array<string> | null } | null, persistentPreferredActivities?: Array<{ __typename?: 'PersistentPreferredActivitySchema', actions?: Array<string> | null, categories?: Array<string> | null, receiverActivity?: string | null }> | null, choosePrivateKeyRules?: Array<{ __typename?: 'ChoosePrivateKeyRuleSchema', packageNames?: Array<string> | null, privateKeyAlias?: string | null, urlPattern?: string | null }> | null, deviceConnectivityManagement?: { __typename?: 'DeviceConnectivityManagementSchema', usbDataAccess?: DeviceConnectivityManagementUsbDataAccess | null } | null, shortSupportMessage?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null, localizedMessages?: any | null } | null, usageLog?: { __typename?: 'UsageLogSchema', enabledLogTypes?: Array<UsageLogEnabledLogTypes> | null, uploadOnCellularAllowed?: Array<UsageLogUploadOnCellularAllowed> | null } | null, longSupportMessage?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null, localizedMessages?: any | null } | null, permittedInputMethods?: { __typename?: 'PackageNameListSchema', packageNames?: Array<string> | null } | null, personalUsagePolicies?: { __typename?: 'PersonalUsagePoliciesSchema', accountTypesWithManagementDisabled?: Array<string> | null, cameraDisabled?: boolean | null, maxDaysWithWorkOff?: number | null, personalPlayStoreMode?: PersonalUsagePoliciesPersonalPlayStoreMode | null, screenCaptureDisabled?: boolean | null, personalApplications?: Array<{ __typename?: 'PersonalApplicationPolicySchema', installType?: PersonalApplicationPolicyInstallType | null, packageName?: string | null }> | null } | null, recommendedGlobalProxy?: { __typename?: 'ProxyInfoSchema', excludedHosts?: Array<string> | null, host?: string | null, pacUri?: string | null, port?: number | null } | null, systemUpdate?: { __typename?: 'SystemUpdateSchema', endMinutes?: number | null, startMinutes?: number | null, type?: SystemUpdateType | null, freezePeriods?: Array<{ __typename?: 'FreezePeriodSchema', endDate?: { __typename?: 'DateSchema', day?: number | null, month?: number | null, year?: number | null } | null, startDate?: { __typename?: 'DateSchema', day?: number | null, month?: number | null, year?: number | null } | null }> | null } | null, permissionGrants?: Array<{ __typename?: 'PermissionGrantSchema', permission?: string | null, policy?: PermissionGrantPolicy | null }> | null, oncCertificateProviders?: Array<{ __typename?: 'OncCertificateProviderSchema', certificateReferences?: Array<string> | null, contentProviderEndpoint?: { __typename?: 'ContentProviderEndpointSchema', packageName?: string | null, signingCertsSha256?: Array<string> | null, uri?: string | null } | null }> | null, alwaysOnVpnPackage?: { __typename?: 'AlwaysOnVpnPackageSchema', lockdownEnabled?: boolean | null, packageName?: string | null } | null, passwordPolicies?: Array<{ __typename?: 'PasswordRequirementsSchema', maximumFailedPasswordsForWipe?: number | null, passwordExpirationTimeout?: string | null, passwordHistoryLength?: number | null, passwordMinimumLength?: number | null, passwordMinimumLetters?: number | null, passwordMinimumLowerCase?: number | null, passwordMinimumNonLetter?: number | null, passwordMinimumNumeric?: number | null, passwordMinimumSymbols?: number | null, passwordMinimumUpperCase?: number | null, passwordQuality?: PasswordRequirementsPasswordQuality | null, passwordScope?: PasswordRequirementsPasswordScope | null, requirePasswordUnlock?: PasswordRequirementsRequirePasswordUnlock | null, unifiedLockSettings?: PasswordRequirementsUnifiedLockSettings | null }> | null, crossProfilePolicies?: { __typename?: 'CrossProfilePoliciesSchema', crossProfileCopyPaste?: CrossProfilePoliciesCrossProfileCopyPaste | null, crossProfileDataSharing?: CrossProfilePoliciesCrossProfileDataSharing | null, showWorkContactsInPersonalProfile?: CrossProfilePoliciesShowWorkContactsInPersonalProfile | null, workProfileWidgetsDefault?: CrossProfilePoliciesWorkProfileWidgetsDefault | null } | null } | null, configPolicy?: { __typename?: 'PolicySchema', id: string, playStoreMode?: PolicyPlayStoreMode | null, openNetworkConfiguration?: any | null, screenCaptureDisabled?: boolean | null, factoryResetDisabled?: boolean | null, cameraAccess?: PolicyCameraAccess | null, microphoneAccess?: PolicyMicrophoneAccess | null, networkEscapeHatchEnabled?: boolean | null, kioskCustomLauncherEnabled?: boolean | null, setWallpaperDisabled?: boolean | null, frpAdminEmails?: Array<string> | null, keyguardDisabled?: boolean | null, installAppsDisabled?: boolean | null, mobileNetworksConfigDisabled?: boolean | null, privateKeySelectionEnabled?: boolean | null, outgoingCallsDisabled?: boolean | null, smsDisabled?: boolean | null, mountPhysicalMediaDisabled?: boolean | null, autoDateAndTimeZone?: PolicyAutoDateAndTimeZone | null, setUserIconDisabled?: boolean | null, removeUserDisabled?: boolean | null, appAutoUpdatePolicy?: PolicyAppAutoUpdatePolicy | null, locationMode?: PolicyLocationMode | null, skipFirstUseHintsEnabled?: boolean | null, adjustVolumeDisabled?: boolean | null, keyguardDisabledFeatures?: Array<PolicyKeyguardDisabledFeatures> | null, shareLocationDisabled?: boolean | null, credentialsConfigDisabled?: boolean | null, networkResetDisabled?: boolean | null, defaultPermissionPolicy?: PolicyDefaultPermissionPolicy | null, addUserDisabled?: boolean | null, dataRoamingDisabled?: boolean | null, accountTypesWithManagementDisabled?: Array<string> | null, androidDevicePolicyTracks?: Array<PolicyAndroidDevicePolicyTracks> | null, createWindowsDisabled?: boolean | null, preferentialNetworkService?: PolicyPreferentialNetworkService | null, stayOnPluggedModes?: Array<PolicyStayOnPluggedModes> | null, bluetoothConfigDisabled?: boolean | null, outgoingBeamDisabled?: boolean | null, minimumApiLevel?: number | null, uninstallAppsDisabled?: boolean | null, encryptionPolicy?: PolicyEncryptionPolicy | null, bluetoothContactSharingDisabled?: boolean | null, bluetoothDisabled?: boolean | null, vpnConfigDisabled?: boolean | null, maximumTimeToLock?: string | null, modifyAccountsDisabled?: boolean | null, cellBroadcastsConfigDisabled?: boolean | null, funDisabled?: boolean | null, statusReportingSettings?: { __typename?: 'StatusReportingSettingsSchema', networkInfoEnabled?: boolean | null } | null, deviceOwnerLockScreenInfo?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, kioskCustomization?: { __typename?: 'KioskCustomizationSchema', systemNavigation?: KioskCustomizationSystemNavigation | null, systemErrorWarnings?: KioskCustomizationSystemErrorWarnings | null, statusBar?: KioskCustomizationStatusBar | null, powerButtonActions?: KioskCustomizationPowerButtonActions | null, deviceSettings?: KioskCustomizationDeviceSettings | null } | null, applications?: Array<{ __typename?: 'ApplicationPolicySchema', packageName?: string | null, installType?: ApplicationPolicyInstallType | null, defaultPermissionPolicy?: ApplicationPolicyDefaultPermissionPolicy | null, managedConfiguration?: any | null, disabled?: boolean | null, minimumVersionCode?: number | null, delegatedScopes?: Array<ApplicationPolicyDelegatedScopes> | null, accessibleTrackIds?: Array<string> | null, connectedWorkAndPersonalApp?: ApplicationPolicyConnectedWorkAndPersonalApp | null, autoUpdateMode?: ApplicationPolicyAutoUpdateMode | null, alwaysOnVpnLockdownExemption?: ApplicationPolicyAlwaysOnVpnLockdownExemption | null, workProfileWidgets?: ApplicationPolicyWorkProfileWidgets | null, permissionGrants?: Array<{ __typename?: 'PermissionGrantSchema', permission?: string | null, policy?: PermissionGrantPolicy | null }> | null, managedConfigurationTemplate?: { __typename?: 'ManagedConfigurationTemplateSchema', templateId?: string | null } | null, extensionConfig?: { __typename?: 'ExtensionConfigSchema', signingKeyFingerprintsSha256?: Array<string> | null, notificationReceiver?: string | null } | null }> | null, setupActions?: Array<{ __typename?: 'SetupActionSchema', description?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, title?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, launchApp?: { __typename?: 'LaunchAppActionSchema', packageName?: string | null } | null }> | null, advancedSecurityOverrides?: { __typename?: 'AdvancedSecurityOverridesSchema', developerSettings?: AdvancedSecurityOverridesDeveloperSettings | null, untrustedAppsPolicy?: AdvancedSecurityOverridesUntrustedAppsPolicy | null, googlePlayProtectVerifyApps?: AdvancedSecurityOverridesGooglePlayProtectVerifyApps | null } | null, policyEnforcementRules?: Array<{ __typename?: 'PolicyEnforcementRuleSchema', settingName?: string | null, blockAction?: { __typename?: 'BlockActionSchema', blockAfterDays?: number | null, blockScope?: BlockActionBlockScope | null } | null, wipeAction?: { __typename?: 'WipeActionSchema', preserveFrp?: boolean | null, wipeAfterDays?: number | null } | null }> | null, permittedAccessibilityServices?: { __typename?: 'PackageNameListSchema', packageNames?: Array<string> | null } | null, persistentPreferredActivities?: Array<{ __typename?: 'PersistentPreferredActivitySchema', actions?: Array<string> | null, categories?: Array<string> | null, receiverActivity?: string | null }> | null, choosePrivateKeyRules?: Array<{ __typename?: 'ChoosePrivateKeyRuleSchema', packageNames?: Array<string> | null, privateKeyAlias?: string | null, urlPattern?: string | null }> | null, deviceConnectivityManagement?: { __typename?: 'DeviceConnectivityManagementSchema', usbDataAccess?: DeviceConnectivityManagementUsbDataAccess | null } | null, shortSupportMessage?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null, localizedMessages?: any | null } | null, usageLog?: { __typename?: 'UsageLogSchema', enabledLogTypes?: Array<UsageLogEnabledLogTypes> | null, uploadOnCellularAllowed?: Array<UsageLogUploadOnCellularAllowed> | null } | null, longSupportMessage?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null, localizedMessages?: any | null } | null, permittedInputMethods?: { __typename?: 'PackageNameListSchema', packageNames?: Array<string> | null } | null, personalUsagePolicies?: { __typename?: 'PersonalUsagePoliciesSchema', accountTypesWithManagementDisabled?: Array<string> | null, cameraDisabled?: boolean | null, maxDaysWithWorkOff?: number | null, personalPlayStoreMode?: PersonalUsagePoliciesPersonalPlayStoreMode | null, screenCaptureDisabled?: boolean | null, personalApplications?: Array<{ __typename?: 'PersonalApplicationPolicySchema', installType?: PersonalApplicationPolicyInstallType | null, packageName?: string | null }> | null } | null, recommendedGlobalProxy?: { __typename?: 'ProxyInfoSchema', excludedHosts?: Array<string> | null, host?: string | null, pacUri?: string | null, port?: number | null } | null, systemUpdate?: { __typename?: 'SystemUpdateSchema', endMinutes?: number | null, startMinutes?: number | null, type?: SystemUpdateType | null, freezePeriods?: Array<{ __typename?: 'FreezePeriodSchema', endDate?: { __typename?: 'DateSchema', day?: number | null, month?: number | null, year?: number | null } | null, startDate?: { __typename?: 'DateSchema', day?: number | null, month?: number | null, year?: number | null } | null }> | null } | null, permissionGrants?: Array<{ __typename?: 'PermissionGrantSchema', permission?: string | null, policy?: PermissionGrantPolicy | null }> | null, oncCertificateProviders?: Array<{ __typename?: 'OncCertificateProviderSchema', certificateReferences?: Array<string> | null, contentProviderEndpoint?: { __typename?: 'ContentProviderEndpointSchema', packageName?: string | null, signingCertsSha256?: Array<string> | null, uri?: string | null } | null }> | null, alwaysOnVpnPackage?: { __typename?: 'AlwaysOnVpnPackageSchema', lockdownEnabled?: boolean | null, packageName?: string | null } | null, passwordPolicies?: Array<{ __typename?: 'PasswordRequirementsSchema', maximumFailedPasswordsForWipe?: number | null, passwordExpirationTimeout?: string | null, passwordHistoryLength?: number | null, passwordMinimumLength?: number | null, passwordMinimumLetters?: number | null, passwordMinimumLowerCase?: number | null, passwordMinimumNonLetter?: number | null, passwordMinimumNumeric?: number | null, passwordMinimumSymbols?: number | null, passwordMinimumUpperCase?: number | null, passwordQuality?: PasswordRequirementsPasswordQuality | null, passwordScope?: PasswordRequirementsPasswordScope | null, requirePasswordUnlock?: PasswordRequirementsRequirePasswordUnlock | null, unifiedLockSettings?: PasswordRequirementsUnifiedLockSettings | null }> | null, crossProfilePolicies?: { __typename?: 'CrossProfilePoliciesSchema', crossProfileCopyPaste?: CrossProfilePoliciesCrossProfileCopyPaste | null, crossProfileDataSharing?: CrossProfilePoliciesCrossProfileDataSharing | null, showWorkContactsInPersonalProfile?: CrossProfilePoliciesShowWorkContactsInPersonalProfile | null, workProfileWidgetsDefault?: CrossProfilePoliciesWorkProfileWidgetsDefault | null } | null } | null, parent?: { __typename?: 'MdmPolicySchema', id: string } | null };

export type DeviceFieldsFragment = { __typename?: 'DeviceSchema', id: string, name?: string | null, userName?: string | null, ownership?: DeviceOwnership | null, state?: DeviceState | null, appliedState?: DeviceAppliedState | null, previousDeviceNames?: Array<string> | null, policyCompliant?: boolean | null, enrollmentTime?: string | null, enrollmentTokenData?: string | null, enrollmentTokenName?: string | null, lastPolicySyncTime?: string | null, lastPolicyComplianceReportTime?: string | null, lastStatusReportTime?: string | null, appliedPolicyVersion?: string | null, apiLevel?: number | null, systemProperties?: any | null, managementMode?: DeviceManagementMode | null, user?: { __typename?: 'UserSchema', accountIdentifier?: string | null } | null, hardwareInfo?: { __typename?: 'HardwareInfoSchema', batteryShutdownTemperatures?: Array<number> | null, batteryThrottlingTemperatures?: Array<number> | null, brand?: string | null, cpuShutdownTemperatures?: Array<number> | null, cpuThrottlingTemperatures?: Array<number> | null, deviceBasebandVersion?: string | null, enterpriseSpecificId?: string | null, gpuShutdownTemperatures?: Array<number> | null, gpuThrottlingTemperatures?: Array<number> | null, hardware?: string | null, manufacturer?: string | null, model?: string | null, serialNumber?: string | null, skinShutdownTemperatures?: Array<number> | null, skinThrottlingTemperatures?: Array<number> | null } | null, hardwareStatusSamples?: Array<{ __typename?: 'HardwareStatusSchema', batteryTemperatures?: Array<number> | null, cpuTemperatures?: Array<number> | null, cpuUsages?: Array<number> | null, createTime?: string | null, fanSpeeds?: Array<number> | null, gpuTemperatures?: Array<number> | null, skinTemperatures?: Array<number> | null }> | null, memoryInfo?: { __typename?: 'MemoryInfoSchema', totalInternalStorage?: string | null, totalRam?: string | null } | null, memoryEvents?: Array<{ __typename?: 'MemoryEventSchema', byteCount?: string | null, createTime?: string | null, eventType?: MemoryEventEventType | null }> | null, powerManagementEvents?: Array<{ __typename?: 'PowerManagementEventSchema', batteryLevel?: number | null, createTime?: string | null, eventType?: PowerManagementEventEventType | null }> | null, displays?: Array<{ __typename?: 'DisplaySchema', density?: number | null, displayId?: number | null, height?: number | null, name?: string | null, refreshRate?: number | null, state?: DisplayState | null, width?: number | null }> | null, nonComplianceDetails?: Array<{ __typename?: 'NonComplianceDetailSchema', packageName?: string | null, settingName?: string | null, fieldPath?: string | null, nonComplianceReason?: NonComplianceDetailNonComplianceReason | null, specificNonComplianceReason?: NonComplianceDetailSpecificNonComplianceReason | null, installationFailureReason?: NonComplianceDetailInstallationFailureReason | null, specificNonComplianceContext?: { __typename?: 'SpecificNonComplianceContextSchema', oncWifiContext?: { __typename?: 'OncWifiContextSchema', wifiGuid?: string | null } | null, passwordPoliciesContext?: { __typename?: 'PasswordPoliciesContextSchema', passwordPolicyScope?: PasswordPoliciesContextPasswordPolicyScope | null } | null } | null }> | null, applicationReports?: Array<{ __typename?: 'ApplicationReportSchema', applicationSource?: ApplicationReportApplicationSource | null, displayName?: string | null, installerPackageName?: string | null, packageName?: string | null, packageSha256Hash?: string | null, signingKeyCertFingerprints?: Array<string> | null, state?: ApplicationReportState | null, versionCode?: number | null, versionName?: string | null, events?: Array<{ __typename?: 'ApplicationEventSchema', createTime?: string | null, eventType?: ApplicationEventEventType | null }> | null, keyedAppStates?: Array<{ __typename?: 'KeyedAppStateSchema', createTime?: string | null, data?: string | null, key?: string | null, lastUpdateTime?: string | null, message?: string | null, severity?: KeyedAppStateSeverity | null }> | null }> | null, softwareInfo?: { __typename?: 'SoftwareInfoSchema', androidBuildNumber?: string | null, androidBuildTime?: string | null, androidDevicePolicyVersionCode?: number | null, androidDevicePolicyVersionName?: string | null, androidVersion?: string | null, bootloaderVersion?: string | null, deviceBuildSignature?: string | null, deviceKernelVersion?: string | null, primaryLanguageCode?: string | null, securityPatchLevel?: string | null, systemUpdateInfo?: { __typename?: 'SystemUpdateInfoSchema', updateReceivedTime?: string | null, updateStatus?: SystemUpdateInfoUpdateStatus | null } | null } | null, networkInfo?: { __typename?: 'NetworkInfoSchema', imei?: string | null, meid?: string | null, networkOperatorName?: string | null, wifiMacAddress?: string | null, telephonyInfos?: Array<{ __typename?: 'TelephonyInfoSchema', carrierName?: string | null, phoneNumber?: string | null }> | null } | null, appliedPasswordPolicies?: Array<{ __typename?: 'PasswordRequirementsSchema', maximumFailedPasswordsForWipe?: number | null, passwordExpirationTimeout?: string | null, passwordHistoryLength?: number | null, passwordMinimumLength?: number | null, passwordMinimumLetters?: number | null, passwordMinimumLowerCase?: number | null, passwordMinimumNonLetter?: number | null, passwordMinimumNumeric?: number | null, passwordMinimumSymbols?: number | null, passwordMinimumUpperCase?: number | null, passwordQuality?: PasswordRequirementsPasswordQuality | null, passwordScope?: PasswordRequirementsPasswordScope | null, requirePasswordUnlock?: PasswordRequirementsRequirePasswordUnlock | null, unifiedLockSettings?: PasswordRequirementsUnifiedLockSettings | null }> | null, commonCriteriaModeInfo?: { __typename?: 'CommonCriteriaModeInfoSchema', commonCriteriaModeStatus?: CommonCriteriaModeInfoCommonCriteriaModeStatus | null } | null, deviceSettings?: { __typename?: 'DeviceSettingsSchema', adbEnabled?: boolean | null, developmentSettingsEnabled?: boolean | null, encryptionStatus?: DeviceSettingsEncryptionStatus | null, isDeviceSecure?: boolean | null, isEncrypted?: boolean | null, unknownSourcesEnabled?: boolean | null, verifyAppsEnabled?: boolean | null } | null, disabledReason?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null, localizedMessages?: any | null } | null, securityPosture?: { __typename?: 'SecurityPostureSchema', devicePosture?: SecurityPostureDevicePosture | null, postureDetails?: Array<{ __typename?: 'PostureDetailSchema', securityRisk?: PostureDetailSecurityRisk | null, advice?: Array<{ __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null }> | null }> | null } | null };

export type SwitchDeviceFieldsFragment = { __typename?: 'SwitchDeviceSchema', id: string, imei?: string | null, kioskPolicy?: string | null, normalPolicy?: string | null, device?: { __typename?: 'DeviceSchema', id: string, name?: string | null, userName?: string | null, ownership?: DeviceOwnership | null, state?: DeviceState | null, appliedState?: DeviceAppliedState | null, previousDeviceNames?: Array<string> | null, policyCompliant?: boolean | null, enrollmentTime?: string | null, enrollmentTokenData?: string | null, enrollmentTokenName?: string | null, lastPolicySyncTime?: string | null, lastPolicyComplianceReportTime?: string | null, lastStatusReportTime?: string | null, appliedPolicyVersion?: string | null, apiLevel?: number | null, systemProperties?: any | null, managementMode?: DeviceManagementMode | null, user?: { __typename?: 'UserSchema', accountIdentifier?: string | null } | null, hardwareInfo?: { __typename?: 'HardwareInfoSchema', batteryShutdownTemperatures?: Array<number> | null, batteryThrottlingTemperatures?: Array<number> | null, brand?: string | null, cpuShutdownTemperatures?: Array<number> | null, cpuThrottlingTemperatures?: Array<number> | null, deviceBasebandVersion?: string | null, enterpriseSpecificId?: string | null, gpuShutdownTemperatures?: Array<number> | null, gpuThrottlingTemperatures?: Array<number> | null, hardware?: string | null, manufacturer?: string | null, model?: string | null, serialNumber?: string | null, skinShutdownTemperatures?: Array<number> | null, skinThrottlingTemperatures?: Array<number> | null } | null, hardwareStatusSamples?: Array<{ __typename?: 'HardwareStatusSchema', batteryTemperatures?: Array<number> | null, cpuTemperatures?: Array<number> | null, cpuUsages?: Array<number> | null, createTime?: string | null, fanSpeeds?: Array<number> | null, gpuTemperatures?: Array<number> | null, skinTemperatures?: Array<number> | null }> | null, memoryInfo?: { __typename?: 'MemoryInfoSchema', totalInternalStorage?: string | null, totalRam?: string | null } | null, memoryEvents?: Array<{ __typename?: 'MemoryEventSchema', byteCount?: string | null, createTime?: string | null, eventType?: MemoryEventEventType | null }> | null, powerManagementEvents?: Array<{ __typename?: 'PowerManagementEventSchema', batteryLevel?: number | null, createTime?: string | null, eventType?: PowerManagementEventEventType | null }> | null, displays?: Array<{ __typename?: 'DisplaySchema', density?: number | null, displayId?: number | null, height?: number | null, name?: string | null, refreshRate?: number | null, state?: DisplayState | null, width?: number | null }> | null, nonComplianceDetails?: Array<{ __typename?: 'NonComplianceDetailSchema', packageName?: string | null, settingName?: string | null, fieldPath?: string | null, nonComplianceReason?: NonComplianceDetailNonComplianceReason | null, specificNonComplianceReason?: NonComplianceDetailSpecificNonComplianceReason | null, installationFailureReason?: NonComplianceDetailInstallationFailureReason | null, specificNonComplianceContext?: { __typename?: 'SpecificNonComplianceContextSchema', oncWifiContext?: { __typename?: 'OncWifiContextSchema', wifiGuid?: string | null } | null, passwordPoliciesContext?: { __typename?: 'PasswordPoliciesContextSchema', passwordPolicyScope?: PasswordPoliciesContextPasswordPolicyScope | null } | null } | null }> | null, applicationReports?: Array<{ __typename?: 'ApplicationReportSchema', applicationSource?: ApplicationReportApplicationSource | null, displayName?: string | null, installerPackageName?: string | null, packageName?: string | null, packageSha256Hash?: string | null, signingKeyCertFingerprints?: Array<string> | null, state?: ApplicationReportState | null, versionCode?: number | null, versionName?: string | null, events?: Array<{ __typename?: 'ApplicationEventSchema', createTime?: string | null, eventType?: ApplicationEventEventType | null }> | null, keyedAppStates?: Array<{ __typename?: 'KeyedAppStateSchema', createTime?: string | null, data?: string | null, key?: string | null, lastUpdateTime?: string | null, message?: string | null, severity?: KeyedAppStateSeverity | null }> | null }> | null, softwareInfo?: { __typename?: 'SoftwareInfoSchema', androidBuildNumber?: string | null, androidBuildTime?: string | null, androidDevicePolicyVersionCode?: number | null, androidDevicePolicyVersionName?: string | null, androidVersion?: string | null, bootloaderVersion?: string | null, deviceBuildSignature?: string | null, deviceKernelVersion?: string | null, primaryLanguageCode?: string | null, securityPatchLevel?: string | null, systemUpdateInfo?: { __typename?: 'SystemUpdateInfoSchema', updateReceivedTime?: string | null, updateStatus?: SystemUpdateInfoUpdateStatus | null } | null } | null, networkInfo?: { __typename?: 'NetworkInfoSchema', imei?: string | null, meid?: string | null, networkOperatorName?: string | null, wifiMacAddress?: string | null, telephonyInfos?: Array<{ __typename?: 'TelephonyInfoSchema', carrierName?: string | null, phoneNumber?: string | null }> | null } | null, appliedPasswordPolicies?: Array<{ __typename?: 'PasswordRequirementsSchema', maximumFailedPasswordsForWipe?: number | null, passwordExpirationTimeout?: string | null, passwordHistoryLength?: number | null, passwordMinimumLength?: number | null, passwordMinimumLetters?: number | null, passwordMinimumLowerCase?: number | null, passwordMinimumNonLetter?: number | null, passwordMinimumNumeric?: number | null, passwordMinimumSymbols?: number | null, passwordMinimumUpperCase?: number | null, passwordQuality?: PasswordRequirementsPasswordQuality | null, passwordScope?: PasswordRequirementsPasswordScope | null, requirePasswordUnlock?: PasswordRequirementsRequirePasswordUnlock | null, unifiedLockSettings?: PasswordRequirementsUnifiedLockSettings | null }> | null, commonCriteriaModeInfo?: { __typename?: 'CommonCriteriaModeInfoSchema', commonCriteriaModeStatus?: CommonCriteriaModeInfoCommonCriteriaModeStatus | null } | null, deviceSettings?: { __typename?: 'DeviceSettingsSchema', adbEnabled?: boolean | null, developmentSettingsEnabled?: boolean | null, encryptionStatus?: DeviceSettingsEncryptionStatus | null, isDeviceSecure?: boolean | null, isEncrypted?: boolean | null, unknownSourcesEnabled?: boolean | null, verifyAppsEnabled?: boolean | null } | null, disabledReason?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null, localizedMessages?: any | null } | null, securityPosture?: { __typename?: 'SecurityPostureSchema', devicePosture?: SecurityPostureDevicePosture | null, postureDetails?: Array<{ __typename?: 'PostureDetailSchema', securityRisk?: PostureDetailSecurityRisk | null, advice?: Array<{ __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null }> | null }> | null } | null } | null };

export type MdmDeviceFieldsFragment = { __typename?: 'MdmDeviceSchema', id: string, imei?: string | null, googleId?: string | null, policyName?: string | null, expectedPolicyName?: string | null, lastPolicySyncTime?: string | null, lastStatusReportTime?: string | null, enrollmentTime?: string | null, serial?: string | null };

export type CreateEnrollmentTokenForPolicyMutationVariables = Exact<{
  policyId: Scalars['String']['input'];
}>;


export type CreateEnrollmentTokenForPolicyMutation = { __typename?: 'Mutation', createEnrollmentToken: { __typename?: 'EnrollmentTokenSchema', id: string, qrCode?: string | null } };

export type CreateEnrollmentTokenForEnterpriseMutationVariables = Exact<{
  enterpriseId: Scalars['String']['input'];
}>;


export type CreateEnrollmentTokenForEnterpriseMutation = { __typename?: 'Mutation', createEnrollmentToken: { __typename?: 'EnrollmentTokenSchema', id: string, qrCode?: string | null } };

export type EnterprisesQueryVariables = Exact<{ [key: string]: never; }>;


export type EnterprisesQuery = { __typename?: 'Query', enterprise: Array<{ __typename?: 'EnterpriseSchema', id: string, name?: string | null, enterpriseDisplayName?: string | null }> };

export type CreateWebTokenMutationVariables = Exact<{
  enterpriseId: Scalars['String']['input'];
  parentFrameUrl: Scalars['String']['input'];
}>;


export type CreateWebTokenMutation = { __typename?: 'Mutation', createWebToken: { __typename?: 'WebTokenSchema', id: string, value?: string | null } };

export type CreatePolicyMutationVariables = Exact<{
  input: PolicyInputSchema;
}>;


export type CreatePolicyMutation = { __typename?: 'Mutation', createPolicy: { __typename?: 'PolicySchema', id: string, playStoreMode?: PolicyPlayStoreMode | null, openNetworkConfiguration?: any | null, screenCaptureDisabled?: boolean | null, factoryResetDisabled?: boolean | null, cameraAccess?: PolicyCameraAccess | null, microphoneAccess?: PolicyMicrophoneAccess | null, networkEscapeHatchEnabled?: boolean | null, kioskCustomLauncherEnabled?: boolean | null, setWallpaperDisabled?: boolean | null, frpAdminEmails?: Array<string> | null, keyguardDisabled?: boolean | null, installAppsDisabled?: boolean | null, mobileNetworksConfigDisabled?: boolean | null, privateKeySelectionEnabled?: boolean | null, outgoingCallsDisabled?: boolean | null, smsDisabled?: boolean | null, mountPhysicalMediaDisabled?: boolean | null, autoDateAndTimeZone?: PolicyAutoDateAndTimeZone | null, setUserIconDisabled?: boolean | null, removeUserDisabled?: boolean | null, appAutoUpdatePolicy?: PolicyAppAutoUpdatePolicy | null, locationMode?: PolicyLocationMode | null, skipFirstUseHintsEnabled?: boolean | null, adjustVolumeDisabled?: boolean | null, keyguardDisabledFeatures?: Array<PolicyKeyguardDisabledFeatures> | null, shareLocationDisabled?: boolean | null, credentialsConfigDisabled?: boolean | null, networkResetDisabled?: boolean | null, defaultPermissionPolicy?: PolicyDefaultPermissionPolicy | null, addUserDisabled?: boolean | null, dataRoamingDisabled?: boolean | null, accountTypesWithManagementDisabled?: Array<string> | null, androidDevicePolicyTracks?: Array<PolicyAndroidDevicePolicyTracks> | null, createWindowsDisabled?: boolean | null, preferentialNetworkService?: PolicyPreferentialNetworkService | null, stayOnPluggedModes?: Array<PolicyStayOnPluggedModes> | null, bluetoothConfigDisabled?: boolean | null, outgoingBeamDisabled?: boolean | null, minimumApiLevel?: number | null, uninstallAppsDisabled?: boolean | null, encryptionPolicy?: PolicyEncryptionPolicy | null, bluetoothContactSharingDisabled?: boolean | null, bluetoothDisabled?: boolean | null, vpnConfigDisabled?: boolean | null, maximumTimeToLock?: string | null, modifyAccountsDisabled?: boolean | null, cellBroadcastsConfigDisabled?: boolean | null, funDisabled?: boolean | null, statusReportingSettings?: { __typename?: 'StatusReportingSettingsSchema', networkInfoEnabled?: boolean | null } | null, deviceOwnerLockScreenInfo?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, kioskCustomization?: { __typename?: 'KioskCustomizationSchema', systemNavigation?: KioskCustomizationSystemNavigation | null, systemErrorWarnings?: KioskCustomizationSystemErrorWarnings | null, statusBar?: KioskCustomizationStatusBar | null, powerButtonActions?: KioskCustomizationPowerButtonActions | null, deviceSettings?: KioskCustomizationDeviceSettings | null } | null, applications?: Array<{ __typename?: 'ApplicationPolicySchema', packageName?: string | null, installType?: ApplicationPolicyInstallType | null, defaultPermissionPolicy?: ApplicationPolicyDefaultPermissionPolicy | null, managedConfiguration?: any | null, disabled?: boolean | null, minimumVersionCode?: number | null, delegatedScopes?: Array<ApplicationPolicyDelegatedScopes> | null, accessibleTrackIds?: Array<string> | null, connectedWorkAndPersonalApp?: ApplicationPolicyConnectedWorkAndPersonalApp | null, autoUpdateMode?: ApplicationPolicyAutoUpdateMode | null, alwaysOnVpnLockdownExemption?: ApplicationPolicyAlwaysOnVpnLockdownExemption | null, workProfileWidgets?: ApplicationPolicyWorkProfileWidgets | null, permissionGrants?: Array<{ __typename?: 'PermissionGrantSchema', permission?: string | null, policy?: PermissionGrantPolicy | null }> | null, managedConfigurationTemplate?: { __typename?: 'ManagedConfigurationTemplateSchema', templateId?: string | null } | null, extensionConfig?: { __typename?: 'ExtensionConfigSchema', signingKeyFingerprintsSha256?: Array<string> | null, notificationReceiver?: string | null } | null }> | null, setupActions?: Array<{ __typename?: 'SetupActionSchema', description?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, title?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, launchApp?: { __typename?: 'LaunchAppActionSchema', packageName?: string | null } | null }> | null, advancedSecurityOverrides?: { __typename?: 'AdvancedSecurityOverridesSchema', developerSettings?: AdvancedSecurityOverridesDeveloperSettings | null, untrustedAppsPolicy?: AdvancedSecurityOverridesUntrustedAppsPolicy | null, googlePlayProtectVerifyApps?: AdvancedSecurityOverridesGooglePlayProtectVerifyApps | null } | null, policyEnforcementRules?: Array<{ __typename?: 'PolicyEnforcementRuleSchema', settingName?: string | null, blockAction?: { __typename?: 'BlockActionSchema', blockAfterDays?: number | null, blockScope?: BlockActionBlockScope | null } | null, wipeAction?: { __typename?: 'WipeActionSchema', preserveFrp?: boolean | null, wipeAfterDays?: number | null } | null }> | null, permittedAccessibilityServices?: { __typename?: 'PackageNameListSchema', packageNames?: Array<string> | null } | null, persistentPreferredActivities?: Array<{ __typename?: 'PersistentPreferredActivitySchema', actions?: Array<string> | null, categories?: Array<string> | null, receiverActivity?: string | null }> | null, choosePrivateKeyRules?: Array<{ __typename?: 'ChoosePrivateKeyRuleSchema', packageNames?: Array<string> | null, privateKeyAlias?: string | null, urlPattern?: string | null }> | null, deviceConnectivityManagement?: { __typename?: 'DeviceConnectivityManagementSchema', usbDataAccess?: DeviceConnectivityManagementUsbDataAccess | null } | null, shortSupportMessage?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null, localizedMessages?: any | null } | null, usageLog?: { __typename?: 'UsageLogSchema', enabledLogTypes?: Array<UsageLogEnabledLogTypes> | null, uploadOnCellularAllowed?: Array<UsageLogUploadOnCellularAllowed> | null } | null, longSupportMessage?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null, localizedMessages?: any | null } | null, permittedInputMethods?: { __typename?: 'PackageNameListSchema', packageNames?: Array<string> | null } | null, personalUsagePolicies?: { __typename?: 'PersonalUsagePoliciesSchema', accountTypesWithManagementDisabled?: Array<string> | null, cameraDisabled?: boolean | null, maxDaysWithWorkOff?: number | null, personalPlayStoreMode?: PersonalUsagePoliciesPersonalPlayStoreMode | null, screenCaptureDisabled?: boolean | null, personalApplications?: Array<{ __typename?: 'PersonalApplicationPolicySchema', installType?: PersonalApplicationPolicyInstallType | null, packageName?: string | null }> | null } | null, recommendedGlobalProxy?: { __typename?: 'ProxyInfoSchema', excludedHosts?: Array<string> | null, host?: string | null, pacUri?: string | null, port?: number | null } | null, systemUpdate?: { __typename?: 'SystemUpdateSchema', endMinutes?: number | null, startMinutes?: number | null, type?: SystemUpdateType | null, freezePeriods?: Array<{ __typename?: 'FreezePeriodSchema', endDate?: { __typename?: 'DateSchema', day?: number | null, month?: number | null, year?: number | null } | null, startDate?: { __typename?: 'DateSchema', day?: number | null, month?: number | null, year?: number | null } | null }> | null } | null, permissionGrants?: Array<{ __typename?: 'PermissionGrantSchema', permission?: string | null, policy?: PermissionGrantPolicy | null }> | null, oncCertificateProviders?: Array<{ __typename?: 'OncCertificateProviderSchema', certificateReferences?: Array<string> | null, contentProviderEndpoint?: { __typename?: 'ContentProviderEndpointSchema', packageName?: string | null, signingCertsSha256?: Array<string> | null, uri?: string | null } | null }> | null, alwaysOnVpnPackage?: { __typename?: 'AlwaysOnVpnPackageSchema', lockdownEnabled?: boolean | null, packageName?: string | null } | null, passwordPolicies?: Array<{ __typename?: 'PasswordRequirementsSchema', maximumFailedPasswordsForWipe?: number | null, passwordExpirationTimeout?: string | null, passwordHistoryLength?: number | null, passwordMinimumLength?: number | null, passwordMinimumLetters?: number | null, passwordMinimumLowerCase?: number | null, passwordMinimumNonLetter?: number | null, passwordMinimumNumeric?: number | null, passwordMinimumSymbols?: number | null, passwordMinimumUpperCase?: number | null, passwordQuality?: PasswordRequirementsPasswordQuality | null, passwordScope?: PasswordRequirementsPasswordScope | null, requirePasswordUnlock?: PasswordRequirementsRequirePasswordUnlock | null, unifiedLockSettings?: PasswordRequirementsUnifiedLockSettings | null }> | null, crossProfilePolicies?: { __typename?: 'CrossProfilePoliciesSchema', crossProfileCopyPaste?: CrossProfilePoliciesCrossProfileCopyPaste | null, crossProfileDataSharing?: CrossProfilePoliciesCrossProfileDataSharing | null, showWorkContactsInPersonalProfile?: CrossProfilePoliciesShowWorkContactsInPersonalProfile | null, workProfileWidgetsDefault?: CrossProfilePoliciesWorkProfileWidgetsDefault | null } | null } };

export type UpdatePolicyMutationVariables = Exact<{
  input: PolicyInputSchema;
}>;


export type UpdatePolicyMutation = { __typename?: 'Mutation', updatePolicy: { __typename?: 'PolicySchema', id: string, playStoreMode?: PolicyPlayStoreMode | null, openNetworkConfiguration?: any | null, screenCaptureDisabled?: boolean | null, factoryResetDisabled?: boolean | null, cameraAccess?: PolicyCameraAccess | null, microphoneAccess?: PolicyMicrophoneAccess | null, networkEscapeHatchEnabled?: boolean | null, kioskCustomLauncherEnabled?: boolean | null, setWallpaperDisabled?: boolean | null, frpAdminEmails?: Array<string> | null, keyguardDisabled?: boolean | null, installAppsDisabled?: boolean | null, mobileNetworksConfigDisabled?: boolean | null, privateKeySelectionEnabled?: boolean | null, outgoingCallsDisabled?: boolean | null, smsDisabled?: boolean | null, mountPhysicalMediaDisabled?: boolean | null, autoDateAndTimeZone?: PolicyAutoDateAndTimeZone | null, setUserIconDisabled?: boolean | null, removeUserDisabled?: boolean | null, appAutoUpdatePolicy?: PolicyAppAutoUpdatePolicy | null, locationMode?: PolicyLocationMode | null, skipFirstUseHintsEnabled?: boolean | null, adjustVolumeDisabled?: boolean | null, keyguardDisabledFeatures?: Array<PolicyKeyguardDisabledFeatures> | null, shareLocationDisabled?: boolean | null, credentialsConfigDisabled?: boolean | null, networkResetDisabled?: boolean | null, defaultPermissionPolicy?: PolicyDefaultPermissionPolicy | null, addUserDisabled?: boolean | null, dataRoamingDisabled?: boolean | null, accountTypesWithManagementDisabled?: Array<string> | null, androidDevicePolicyTracks?: Array<PolicyAndroidDevicePolicyTracks> | null, createWindowsDisabled?: boolean | null, preferentialNetworkService?: PolicyPreferentialNetworkService | null, stayOnPluggedModes?: Array<PolicyStayOnPluggedModes> | null, bluetoothConfigDisabled?: boolean | null, outgoingBeamDisabled?: boolean | null, minimumApiLevel?: number | null, uninstallAppsDisabled?: boolean | null, encryptionPolicy?: PolicyEncryptionPolicy | null, bluetoothContactSharingDisabled?: boolean | null, bluetoothDisabled?: boolean | null, vpnConfigDisabled?: boolean | null, maximumTimeToLock?: string | null, modifyAccountsDisabled?: boolean | null, cellBroadcastsConfigDisabled?: boolean | null, funDisabled?: boolean | null, statusReportingSettings?: { __typename?: 'StatusReportingSettingsSchema', networkInfoEnabled?: boolean | null } | null, deviceOwnerLockScreenInfo?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, kioskCustomization?: { __typename?: 'KioskCustomizationSchema', systemNavigation?: KioskCustomizationSystemNavigation | null, systemErrorWarnings?: KioskCustomizationSystemErrorWarnings | null, statusBar?: KioskCustomizationStatusBar | null, powerButtonActions?: KioskCustomizationPowerButtonActions | null, deviceSettings?: KioskCustomizationDeviceSettings | null } | null, applications?: Array<{ __typename?: 'ApplicationPolicySchema', packageName?: string | null, installType?: ApplicationPolicyInstallType | null, defaultPermissionPolicy?: ApplicationPolicyDefaultPermissionPolicy | null, managedConfiguration?: any | null, disabled?: boolean | null, minimumVersionCode?: number | null, delegatedScopes?: Array<ApplicationPolicyDelegatedScopes> | null, accessibleTrackIds?: Array<string> | null, connectedWorkAndPersonalApp?: ApplicationPolicyConnectedWorkAndPersonalApp | null, autoUpdateMode?: ApplicationPolicyAutoUpdateMode | null, alwaysOnVpnLockdownExemption?: ApplicationPolicyAlwaysOnVpnLockdownExemption | null, workProfileWidgets?: ApplicationPolicyWorkProfileWidgets | null, permissionGrants?: Array<{ __typename?: 'PermissionGrantSchema', permission?: string | null, policy?: PermissionGrantPolicy | null }> | null, managedConfigurationTemplate?: { __typename?: 'ManagedConfigurationTemplateSchema', templateId?: string | null } | null, extensionConfig?: { __typename?: 'ExtensionConfigSchema', signingKeyFingerprintsSha256?: Array<string> | null, notificationReceiver?: string | null } | null }> | null, setupActions?: Array<{ __typename?: 'SetupActionSchema', description?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, title?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, launchApp?: { __typename?: 'LaunchAppActionSchema', packageName?: string | null } | null }> | null, advancedSecurityOverrides?: { __typename?: 'AdvancedSecurityOverridesSchema', developerSettings?: AdvancedSecurityOverridesDeveloperSettings | null, untrustedAppsPolicy?: AdvancedSecurityOverridesUntrustedAppsPolicy | null, googlePlayProtectVerifyApps?: AdvancedSecurityOverridesGooglePlayProtectVerifyApps | null } | null, policyEnforcementRules?: Array<{ __typename?: 'PolicyEnforcementRuleSchema', settingName?: string | null, blockAction?: { __typename?: 'BlockActionSchema', blockAfterDays?: number | null, blockScope?: BlockActionBlockScope | null } | null, wipeAction?: { __typename?: 'WipeActionSchema', preserveFrp?: boolean | null, wipeAfterDays?: number | null } | null }> | null, permittedAccessibilityServices?: { __typename?: 'PackageNameListSchema', packageNames?: Array<string> | null } | null, persistentPreferredActivities?: Array<{ __typename?: 'PersistentPreferredActivitySchema', actions?: Array<string> | null, categories?: Array<string> | null, receiverActivity?: string | null }> | null, choosePrivateKeyRules?: Array<{ __typename?: 'ChoosePrivateKeyRuleSchema', packageNames?: Array<string> | null, privateKeyAlias?: string | null, urlPattern?: string | null }> | null, deviceConnectivityManagement?: { __typename?: 'DeviceConnectivityManagementSchema', usbDataAccess?: DeviceConnectivityManagementUsbDataAccess | null } | null, shortSupportMessage?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null, localizedMessages?: any | null } | null, usageLog?: { __typename?: 'UsageLogSchema', enabledLogTypes?: Array<UsageLogEnabledLogTypes> | null, uploadOnCellularAllowed?: Array<UsageLogUploadOnCellularAllowed> | null } | null, longSupportMessage?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null, localizedMessages?: any | null } | null, permittedInputMethods?: { __typename?: 'PackageNameListSchema', packageNames?: Array<string> | null } | null, personalUsagePolicies?: { __typename?: 'PersonalUsagePoliciesSchema', accountTypesWithManagementDisabled?: Array<string> | null, cameraDisabled?: boolean | null, maxDaysWithWorkOff?: number | null, personalPlayStoreMode?: PersonalUsagePoliciesPersonalPlayStoreMode | null, screenCaptureDisabled?: boolean | null, personalApplications?: Array<{ __typename?: 'PersonalApplicationPolicySchema', installType?: PersonalApplicationPolicyInstallType | null, packageName?: string | null }> | null } | null, recommendedGlobalProxy?: { __typename?: 'ProxyInfoSchema', excludedHosts?: Array<string> | null, host?: string | null, pacUri?: string | null, port?: number | null } | null, systemUpdate?: { __typename?: 'SystemUpdateSchema', endMinutes?: number | null, startMinutes?: number | null, type?: SystemUpdateType | null, freezePeriods?: Array<{ __typename?: 'FreezePeriodSchema', endDate?: { __typename?: 'DateSchema', day?: number | null, month?: number | null, year?: number | null } | null, startDate?: { __typename?: 'DateSchema', day?: number | null, month?: number | null, year?: number | null } | null }> | null } | null, permissionGrants?: Array<{ __typename?: 'PermissionGrantSchema', permission?: string | null, policy?: PermissionGrantPolicy | null }> | null, oncCertificateProviders?: Array<{ __typename?: 'OncCertificateProviderSchema', certificateReferences?: Array<string> | null, contentProviderEndpoint?: { __typename?: 'ContentProviderEndpointSchema', packageName?: string | null, signingCertsSha256?: Array<string> | null, uri?: string | null } | null }> | null, alwaysOnVpnPackage?: { __typename?: 'AlwaysOnVpnPackageSchema', lockdownEnabled?: boolean | null, packageName?: string | null } | null, passwordPolicies?: Array<{ __typename?: 'PasswordRequirementsSchema', maximumFailedPasswordsForWipe?: number | null, passwordExpirationTimeout?: string | null, passwordHistoryLength?: number | null, passwordMinimumLength?: number | null, passwordMinimumLetters?: number | null, passwordMinimumLowerCase?: number | null, passwordMinimumNonLetter?: number | null, passwordMinimumNumeric?: number | null, passwordMinimumSymbols?: number | null, passwordMinimumUpperCase?: number | null, passwordQuality?: PasswordRequirementsPasswordQuality | null, passwordScope?: PasswordRequirementsPasswordScope | null, requirePasswordUnlock?: PasswordRequirementsRequirePasswordUnlock | null, unifiedLockSettings?: PasswordRequirementsUnifiedLockSettings | null }> | null, crossProfilePolicies?: { __typename?: 'CrossProfilePoliciesSchema', crossProfileCopyPaste?: CrossProfilePoliciesCrossProfileCopyPaste | null, crossProfileDataSharing?: CrossProfilePoliciesCrossProfileDataSharing | null, showWorkContactsInPersonalProfile?: CrossProfilePoliciesShowWorkContactsInPersonalProfile | null, workProfileWidgetsDefault?: CrossProfilePoliciesWorkProfileWidgetsDefault | null } | null } };

export type UpdateMdmPolicyMutationVariables = Exact<{
  input: MdmPolicyInputSchema;
}>;


export type UpdateMdmPolicyMutation = { __typename?: 'Mutation', updateMdmPolicy: { __typename?: 'MdmPolicySchema', id: string, enterpriseId: string, googleId: string, configGoogleId: string, name: string, policy?: { __typename?: 'PolicySchema', id: string, playStoreMode?: PolicyPlayStoreMode | null, openNetworkConfiguration?: any | null, screenCaptureDisabled?: boolean | null, factoryResetDisabled?: boolean | null, cameraAccess?: PolicyCameraAccess | null, microphoneAccess?: PolicyMicrophoneAccess | null, networkEscapeHatchEnabled?: boolean | null, kioskCustomLauncherEnabled?: boolean | null, setWallpaperDisabled?: boolean | null, frpAdminEmails?: Array<string> | null, keyguardDisabled?: boolean | null, installAppsDisabled?: boolean | null, mobileNetworksConfigDisabled?: boolean | null, privateKeySelectionEnabled?: boolean | null, outgoingCallsDisabled?: boolean | null, smsDisabled?: boolean | null, mountPhysicalMediaDisabled?: boolean | null, autoDateAndTimeZone?: PolicyAutoDateAndTimeZone | null, setUserIconDisabled?: boolean | null, removeUserDisabled?: boolean | null, appAutoUpdatePolicy?: PolicyAppAutoUpdatePolicy | null, locationMode?: PolicyLocationMode | null, skipFirstUseHintsEnabled?: boolean | null, adjustVolumeDisabled?: boolean | null, keyguardDisabledFeatures?: Array<PolicyKeyguardDisabledFeatures> | null, shareLocationDisabled?: boolean | null, credentialsConfigDisabled?: boolean | null, networkResetDisabled?: boolean | null, defaultPermissionPolicy?: PolicyDefaultPermissionPolicy | null, addUserDisabled?: boolean | null, dataRoamingDisabled?: boolean | null, accountTypesWithManagementDisabled?: Array<string> | null, androidDevicePolicyTracks?: Array<PolicyAndroidDevicePolicyTracks> | null, createWindowsDisabled?: boolean | null, preferentialNetworkService?: PolicyPreferentialNetworkService | null, stayOnPluggedModes?: Array<PolicyStayOnPluggedModes> | null, bluetoothConfigDisabled?: boolean | null, outgoingBeamDisabled?: boolean | null, minimumApiLevel?: number | null, uninstallAppsDisabled?: boolean | null, encryptionPolicy?: PolicyEncryptionPolicy | null, bluetoothContactSharingDisabled?: boolean | null, bluetoothDisabled?: boolean | null, vpnConfigDisabled?: boolean | null, maximumTimeToLock?: string | null, modifyAccountsDisabled?: boolean | null, cellBroadcastsConfigDisabled?: boolean | null, funDisabled?: boolean | null, statusReportingSettings?: { __typename?: 'StatusReportingSettingsSchema', networkInfoEnabled?: boolean | null } | null, deviceOwnerLockScreenInfo?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, kioskCustomization?: { __typename?: 'KioskCustomizationSchema', systemNavigation?: KioskCustomizationSystemNavigation | null, systemErrorWarnings?: KioskCustomizationSystemErrorWarnings | null, statusBar?: KioskCustomizationStatusBar | null, powerButtonActions?: KioskCustomizationPowerButtonActions | null, deviceSettings?: KioskCustomizationDeviceSettings | null } | null, applications?: Array<{ __typename?: 'ApplicationPolicySchema', packageName?: string | null, installType?: ApplicationPolicyInstallType | null, defaultPermissionPolicy?: ApplicationPolicyDefaultPermissionPolicy | null, managedConfiguration?: any | null, disabled?: boolean | null, minimumVersionCode?: number | null, delegatedScopes?: Array<ApplicationPolicyDelegatedScopes> | null, accessibleTrackIds?: Array<string> | null, connectedWorkAndPersonalApp?: ApplicationPolicyConnectedWorkAndPersonalApp | null, autoUpdateMode?: ApplicationPolicyAutoUpdateMode | null, alwaysOnVpnLockdownExemption?: ApplicationPolicyAlwaysOnVpnLockdownExemption | null, workProfileWidgets?: ApplicationPolicyWorkProfileWidgets | null, permissionGrants?: Array<{ __typename?: 'PermissionGrantSchema', permission?: string | null, policy?: PermissionGrantPolicy | null }> | null, managedConfigurationTemplate?: { __typename?: 'ManagedConfigurationTemplateSchema', templateId?: string | null } | null, extensionConfig?: { __typename?: 'ExtensionConfigSchema', signingKeyFingerprintsSha256?: Array<string> | null, notificationReceiver?: string | null } | null }> | null, setupActions?: Array<{ __typename?: 'SetupActionSchema', description?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, title?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, launchApp?: { __typename?: 'LaunchAppActionSchema', packageName?: string | null } | null }> | null, advancedSecurityOverrides?: { __typename?: 'AdvancedSecurityOverridesSchema', developerSettings?: AdvancedSecurityOverridesDeveloperSettings | null, untrustedAppsPolicy?: AdvancedSecurityOverridesUntrustedAppsPolicy | null, googlePlayProtectVerifyApps?: AdvancedSecurityOverridesGooglePlayProtectVerifyApps | null } | null, policyEnforcementRules?: Array<{ __typename?: 'PolicyEnforcementRuleSchema', settingName?: string | null, blockAction?: { __typename?: 'BlockActionSchema', blockAfterDays?: number | null, blockScope?: BlockActionBlockScope | null } | null, wipeAction?: { __typename?: 'WipeActionSchema', preserveFrp?: boolean | null, wipeAfterDays?: number | null } | null }> | null, permittedAccessibilityServices?: { __typename?: 'PackageNameListSchema', packageNames?: Array<string> | null } | null, persistentPreferredActivities?: Array<{ __typename?: 'PersistentPreferredActivitySchema', actions?: Array<string> | null, categories?: Array<string> | null, receiverActivity?: string | null }> | null, choosePrivateKeyRules?: Array<{ __typename?: 'ChoosePrivateKeyRuleSchema', packageNames?: Array<string> | null, privateKeyAlias?: string | null, urlPattern?: string | null }> | null, deviceConnectivityManagement?: { __typename?: 'DeviceConnectivityManagementSchema', usbDataAccess?: DeviceConnectivityManagementUsbDataAccess | null } | null, shortSupportMessage?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null, localizedMessages?: any | null } | null, usageLog?: { __typename?: 'UsageLogSchema', enabledLogTypes?: Array<UsageLogEnabledLogTypes> | null, uploadOnCellularAllowed?: Array<UsageLogUploadOnCellularAllowed> | null } | null, longSupportMessage?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null, localizedMessages?: any | null } | null, permittedInputMethods?: { __typename?: 'PackageNameListSchema', packageNames?: Array<string> | null } | null, personalUsagePolicies?: { __typename?: 'PersonalUsagePoliciesSchema', accountTypesWithManagementDisabled?: Array<string> | null, cameraDisabled?: boolean | null, maxDaysWithWorkOff?: number | null, personalPlayStoreMode?: PersonalUsagePoliciesPersonalPlayStoreMode | null, screenCaptureDisabled?: boolean | null, personalApplications?: Array<{ __typename?: 'PersonalApplicationPolicySchema', installType?: PersonalApplicationPolicyInstallType | null, packageName?: string | null }> | null } | null, recommendedGlobalProxy?: { __typename?: 'ProxyInfoSchema', excludedHosts?: Array<string> | null, host?: string | null, pacUri?: string | null, port?: number | null } | null, systemUpdate?: { __typename?: 'SystemUpdateSchema', endMinutes?: number | null, startMinutes?: number | null, type?: SystemUpdateType | null, freezePeriods?: Array<{ __typename?: 'FreezePeriodSchema', endDate?: { __typename?: 'DateSchema', day?: number | null, month?: number | null, year?: number | null } | null, startDate?: { __typename?: 'DateSchema', day?: number | null, month?: number | null, year?: number | null } | null }> | null } | null, permissionGrants?: Array<{ __typename?: 'PermissionGrantSchema', permission?: string | null, policy?: PermissionGrantPolicy | null }> | null, oncCertificateProviders?: Array<{ __typename?: 'OncCertificateProviderSchema', certificateReferences?: Array<string> | null, contentProviderEndpoint?: { __typename?: 'ContentProviderEndpointSchema', packageName?: string | null, signingCertsSha256?: Array<string> | null, uri?: string | null } | null }> | null, alwaysOnVpnPackage?: { __typename?: 'AlwaysOnVpnPackageSchema', lockdownEnabled?: boolean | null, packageName?: string | null } | null, passwordPolicies?: Array<{ __typename?: 'PasswordRequirementsSchema', maximumFailedPasswordsForWipe?: number | null, passwordExpirationTimeout?: string | null, passwordHistoryLength?: number | null, passwordMinimumLength?: number | null, passwordMinimumLetters?: number | null, passwordMinimumLowerCase?: number | null, passwordMinimumNonLetter?: number | null, passwordMinimumNumeric?: number | null, passwordMinimumSymbols?: number | null, passwordMinimumUpperCase?: number | null, passwordQuality?: PasswordRequirementsPasswordQuality | null, passwordScope?: PasswordRequirementsPasswordScope | null, requirePasswordUnlock?: PasswordRequirementsRequirePasswordUnlock | null, unifiedLockSettings?: PasswordRequirementsUnifiedLockSettings | null }> | null, crossProfilePolicies?: { __typename?: 'CrossProfilePoliciesSchema', crossProfileCopyPaste?: CrossProfilePoliciesCrossProfileCopyPaste | null, crossProfileDataSharing?: CrossProfilePoliciesCrossProfileDataSharing | null, showWorkContactsInPersonalProfile?: CrossProfilePoliciesShowWorkContactsInPersonalProfile | null, workProfileWidgetsDefault?: CrossProfilePoliciesWorkProfileWidgetsDefault | null } | null } | null, configPolicy?: { __typename?: 'PolicySchema', id: string, playStoreMode?: PolicyPlayStoreMode | null, openNetworkConfiguration?: any | null, screenCaptureDisabled?: boolean | null, factoryResetDisabled?: boolean | null, cameraAccess?: PolicyCameraAccess | null, microphoneAccess?: PolicyMicrophoneAccess | null, networkEscapeHatchEnabled?: boolean | null, kioskCustomLauncherEnabled?: boolean | null, setWallpaperDisabled?: boolean | null, frpAdminEmails?: Array<string> | null, keyguardDisabled?: boolean | null, installAppsDisabled?: boolean | null, mobileNetworksConfigDisabled?: boolean | null, privateKeySelectionEnabled?: boolean | null, outgoingCallsDisabled?: boolean | null, smsDisabled?: boolean | null, mountPhysicalMediaDisabled?: boolean | null, autoDateAndTimeZone?: PolicyAutoDateAndTimeZone | null, setUserIconDisabled?: boolean | null, removeUserDisabled?: boolean | null, appAutoUpdatePolicy?: PolicyAppAutoUpdatePolicy | null, locationMode?: PolicyLocationMode | null, skipFirstUseHintsEnabled?: boolean | null, adjustVolumeDisabled?: boolean | null, keyguardDisabledFeatures?: Array<PolicyKeyguardDisabledFeatures> | null, shareLocationDisabled?: boolean | null, credentialsConfigDisabled?: boolean | null, networkResetDisabled?: boolean | null, defaultPermissionPolicy?: PolicyDefaultPermissionPolicy | null, addUserDisabled?: boolean | null, dataRoamingDisabled?: boolean | null, accountTypesWithManagementDisabled?: Array<string> | null, androidDevicePolicyTracks?: Array<PolicyAndroidDevicePolicyTracks> | null, createWindowsDisabled?: boolean | null, preferentialNetworkService?: PolicyPreferentialNetworkService | null, stayOnPluggedModes?: Array<PolicyStayOnPluggedModes> | null, bluetoothConfigDisabled?: boolean | null, outgoingBeamDisabled?: boolean | null, minimumApiLevel?: number | null, uninstallAppsDisabled?: boolean | null, encryptionPolicy?: PolicyEncryptionPolicy | null, bluetoothContactSharingDisabled?: boolean | null, bluetoothDisabled?: boolean | null, vpnConfigDisabled?: boolean | null, maximumTimeToLock?: string | null, modifyAccountsDisabled?: boolean | null, cellBroadcastsConfigDisabled?: boolean | null, funDisabled?: boolean | null, statusReportingSettings?: { __typename?: 'StatusReportingSettingsSchema', networkInfoEnabled?: boolean | null } | null, deviceOwnerLockScreenInfo?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, kioskCustomization?: { __typename?: 'KioskCustomizationSchema', systemNavigation?: KioskCustomizationSystemNavigation | null, systemErrorWarnings?: KioskCustomizationSystemErrorWarnings | null, statusBar?: KioskCustomizationStatusBar | null, powerButtonActions?: KioskCustomizationPowerButtonActions | null, deviceSettings?: KioskCustomizationDeviceSettings | null } | null, applications?: Array<{ __typename?: 'ApplicationPolicySchema', packageName?: string | null, installType?: ApplicationPolicyInstallType | null, defaultPermissionPolicy?: ApplicationPolicyDefaultPermissionPolicy | null, managedConfiguration?: any | null, disabled?: boolean | null, minimumVersionCode?: number | null, delegatedScopes?: Array<ApplicationPolicyDelegatedScopes> | null, accessibleTrackIds?: Array<string> | null, connectedWorkAndPersonalApp?: ApplicationPolicyConnectedWorkAndPersonalApp | null, autoUpdateMode?: ApplicationPolicyAutoUpdateMode | null, alwaysOnVpnLockdownExemption?: ApplicationPolicyAlwaysOnVpnLockdownExemption | null, workProfileWidgets?: ApplicationPolicyWorkProfileWidgets | null, permissionGrants?: Array<{ __typename?: 'PermissionGrantSchema', permission?: string | null, policy?: PermissionGrantPolicy | null }> | null, managedConfigurationTemplate?: { __typename?: 'ManagedConfigurationTemplateSchema', templateId?: string | null } | null, extensionConfig?: { __typename?: 'ExtensionConfigSchema', signingKeyFingerprintsSha256?: Array<string> | null, notificationReceiver?: string | null } | null }> | null, setupActions?: Array<{ __typename?: 'SetupActionSchema', description?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, title?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, launchApp?: { __typename?: 'LaunchAppActionSchema', packageName?: string | null } | null }> | null, advancedSecurityOverrides?: { __typename?: 'AdvancedSecurityOverridesSchema', developerSettings?: AdvancedSecurityOverridesDeveloperSettings | null, untrustedAppsPolicy?: AdvancedSecurityOverridesUntrustedAppsPolicy | null, googlePlayProtectVerifyApps?: AdvancedSecurityOverridesGooglePlayProtectVerifyApps | null } | null, policyEnforcementRules?: Array<{ __typename?: 'PolicyEnforcementRuleSchema', settingName?: string | null, blockAction?: { __typename?: 'BlockActionSchema', blockAfterDays?: number | null, blockScope?: BlockActionBlockScope | null } | null, wipeAction?: { __typename?: 'WipeActionSchema', preserveFrp?: boolean | null, wipeAfterDays?: number | null } | null }> | null, permittedAccessibilityServices?: { __typename?: 'PackageNameListSchema', packageNames?: Array<string> | null } | null, persistentPreferredActivities?: Array<{ __typename?: 'PersistentPreferredActivitySchema', actions?: Array<string> | null, categories?: Array<string> | null, receiverActivity?: string | null }> | null, choosePrivateKeyRules?: Array<{ __typename?: 'ChoosePrivateKeyRuleSchema', packageNames?: Array<string> | null, privateKeyAlias?: string | null, urlPattern?: string | null }> | null, deviceConnectivityManagement?: { __typename?: 'DeviceConnectivityManagementSchema', usbDataAccess?: DeviceConnectivityManagementUsbDataAccess | null } | null, shortSupportMessage?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null, localizedMessages?: any | null } | null, usageLog?: { __typename?: 'UsageLogSchema', enabledLogTypes?: Array<UsageLogEnabledLogTypes> | null, uploadOnCellularAllowed?: Array<UsageLogUploadOnCellularAllowed> | null } | null, longSupportMessage?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null, localizedMessages?: any | null } | null, permittedInputMethods?: { __typename?: 'PackageNameListSchema', packageNames?: Array<string> | null } | null, personalUsagePolicies?: { __typename?: 'PersonalUsagePoliciesSchema', accountTypesWithManagementDisabled?: Array<string> | null, cameraDisabled?: boolean | null, maxDaysWithWorkOff?: number | null, personalPlayStoreMode?: PersonalUsagePoliciesPersonalPlayStoreMode | null, screenCaptureDisabled?: boolean | null, personalApplications?: Array<{ __typename?: 'PersonalApplicationPolicySchema', installType?: PersonalApplicationPolicyInstallType | null, packageName?: string | null }> | null } | null, recommendedGlobalProxy?: { __typename?: 'ProxyInfoSchema', excludedHosts?: Array<string> | null, host?: string | null, pacUri?: string | null, port?: number | null } | null, systemUpdate?: { __typename?: 'SystemUpdateSchema', endMinutes?: number | null, startMinutes?: number | null, type?: SystemUpdateType | null, freezePeriods?: Array<{ __typename?: 'FreezePeriodSchema', endDate?: { __typename?: 'DateSchema', day?: number | null, month?: number | null, year?: number | null } | null, startDate?: { __typename?: 'DateSchema', day?: number | null, month?: number | null, year?: number | null } | null }> | null } | null, permissionGrants?: Array<{ __typename?: 'PermissionGrantSchema', permission?: string | null, policy?: PermissionGrantPolicy | null }> | null, oncCertificateProviders?: Array<{ __typename?: 'OncCertificateProviderSchema', certificateReferences?: Array<string> | null, contentProviderEndpoint?: { __typename?: 'ContentProviderEndpointSchema', packageName?: string | null, signingCertsSha256?: Array<string> | null, uri?: string | null } | null }> | null, alwaysOnVpnPackage?: { __typename?: 'AlwaysOnVpnPackageSchema', lockdownEnabled?: boolean | null, packageName?: string | null } | null, passwordPolicies?: Array<{ __typename?: 'PasswordRequirementsSchema', maximumFailedPasswordsForWipe?: number | null, passwordExpirationTimeout?: string | null, passwordHistoryLength?: number | null, passwordMinimumLength?: number | null, passwordMinimumLetters?: number | null, passwordMinimumLowerCase?: number | null, passwordMinimumNonLetter?: number | null, passwordMinimumNumeric?: number | null, passwordMinimumSymbols?: number | null, passwordMinimumUpperCase?: number | null, passwordQuality?: PasswordRequirementsPasswordQuality | null, passwordScope?: PasswordRequirementsPasswordScope | null, requirePasswordUnlock?: PasswordRequirementsRequirePasswordUnlock | null, unifiedLockSettings?: PasswordRequirementsUnifiedLockSettings | null }> | null, crossProfilePolicies?: { __typename?: 'CrossProfilePoliciesSchema', crossProfileCopyPaste?: CrossProfilePoliciesCrossProfileCopyPaste | null, crossProfileDataSharing?: CrossProfilePoliciesCrossProfileDataSharing | null, showWorkContactsInPersonalProfile?: CrossProfilePoliciesShowWorkContactsInPersonalProfile | null, workProfileWidgetsDefault?: CrossProfilePoliciesWorkProfileWidgetsDefault | null } | null } | null, parent?: { __typename?: 'MdmPolicySchema', id: string } | null } };

export type CreateMdmPolicyMutationVariables = Exact<{
  input: MdmPolicyInputSchema;
}>;


export type CreateMdmPolicyMutation = { __typename?: 'Mutation', createMdmPolicy: { __typename?: 'MdmPolicySchema', id: string, enterpriseId: string, googleId: string, configGoogleId: string, name: string, policy?: { __typename?: 'PolicySchema', id: string, playStoreMode?: PolicyPlayStoreMode | null, openNetworkConfiguration?: any | null, screenCaptureDisabled?: boolean | null, factoryResetDisabled?: boolean | null, cameraAccess?: PolicyCameraAccess | null, microphoneAccess?: PolicyMicrophoneAccess | null, networkEscapeHatchEnabled?: boolean | null, kioskCustomLauncherEnabled?: boolean | null, setWallpaperDisabled?: boolean | null, frpAdminEmails?: Array<string> | null, keyguardDisabled?: boolean | null, installAppsDisabled?: boolean | null, mobileNetworksConfigDisabled?: boolean | null, privateKeySelectionEnabled?: boolean | null, outgoingCallsDisabled?: boolean | null, smsDisabled?: boolean | null, mountPhysicalMediaDisabled?: boolean | null, autoDateAndTimeZone?: PolicyAutoDateAndTimeZone | null, setUserIconDisabled?: boolean | null, removeUserDisabled?: boolean | null, appAutoUpdatePolicy?: PolicyAppAutoUpdatePolicy | null, locationMode?: PolicyLocationMode | null, skipFirstUseHintsEnabled?: boolean | null, adjustVolumeDisabled?: boolean | null, keyguardDisabledFeatures?: Array<PolicyKeyguardDisabledFeatures> | null, shareLocationDisabled?: boolean | null, credentialsConfigDisabled?: boolean | null, networkResetDisabled?: boolean | null, defaultPermissionPolicy?: PolicyDefaultPermissionPolicy | null, addUserDisabled?: boolean | null, dataRoamingDisabled?: boolean | null, accountTypesWithManagementDisabled?: Array<string> | null, androidDevicePolicyTracks?: Array<PolicyAndroidDevicePolicyTracks> | null, createWindowsDisabled?: boolean | null, preferentialNetworkService?: PolicyPreferentialNetworkService | null, stayOnPluggedModes?: Array<PolicyStayOnPluggedModes> | null, bluetoothConfigDisabled?: boolean | null, outgoingBeamDisabled?: boolean | null, minimumApiLevel?: number | null, uninstallAppsDisabled?: boolean | null, encryptionPolicy?: PolicyEncryptionPolicy | null, bluetoothContactSharingDisabled?: boolean | null, bluetoothDisabled?: boolean | null, vpnConfigDisabled?: boolean | null, maximumTimeToLock?: string | null, modifyAccountsDisabled?: boolean | null, cellBroadcastsConfigDisabled?: boolean | null, funDisabled?: boolean | null, statusReportingSettings?: { __typename?: 'StatusReportingSettingsSchema', networkInfoEnabled?: boolean | null } | null, deviceOwnerLockScreenInfo?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, kioskCustomization?: { __typename?: 'KioskCustomizationSchema', systemNavigation?: KioskCustomizationSystemNavigation | null, systemErrorWarnings?: KioskCustomizationSystemErrorWarnings | null, statusBar?: KioskCustomizationStatusBar | null, powerButtonActions?: KioskCustomizationPowerButtonActions | null, deviceSettings?: KioskCustomizationDeviceSettings | null } | null, applications?: Array<{ __typename?: 'ApplicationPolicySchema', packageName?: string | null, installType?: ApplicationPolicyInstallType | null, defaultPermissionPolicy?: ApplicationPolicyDefaultPermissionPolicy | null, managedConfiguration?: any | null, disabled?: boolean | null, minimumVersionCode?: number | null, delegatedScopes?: Array<ApplicationPolicyDelegatedScopes> | null, accessibleTrackIds?: Array<string> | null, connectedWorkAndPersonalApp?: ApplicationPolicyConnectedWorkAndPersonalApp | null, autoUpdateMode?: ApplicationPolicyAutoUpdateMode | null, alwaysOnVpnLockdownExemption?: ApplicationPolicyAlwaysOnVpnLockdownExemption | null, workProfileWidgets?: ApplicationPolicyWorkProfileWidgets | null, permissionGrants?: Array<{ __typename?: 'PermissionGrantSchema', permission?: string | null, policy?: PermissionGrantPolicy | null }> | null, managedConfigurationTemplate?: { __typename?: 'ManagedConfigurationTemplateSchema', templateId?: string | null } | null, extensionConfig?: { __typename?: 'ExtensionConfigSchema', signingKeyFingerprintsSha256?: Array<string> | null, notificationReceiver?: string | null } | null }> | null, setupActions?: Array<{ __typename?: 'SetupActionSchema', description?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, title?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, launchApp?: { __typename?: 'LaunchAppActionSchema', packageName?: string | null } | null }> | null, advancedSecurityOverrides?: { __typename?: 'AdvancedSecurityOverridesSchema', developerSettings?: AdvancedSecurityOverridesDeveloperSettings | null, untrustedAppsPolicy?: AdvancedSecurityOverridesUntrustedAppsPolicy | null, googlePlayProtectVerifyApps?: AdvancedSecurityOverridesGooglePlayProtectVerifyApps | null } | null, policyEnforcementRules?: Array<{ __typename?: 'PolicyEnforcementRuleSchema', settingName?: string | null, blockAction?: { __typename?: 'BlockActionSchema', blockAfterDays?: number | null, blockScope?: BlockActionBlockScope | null } | null, wipeAction?: { __typename?: 'WipeActionSchema', preserveFrp?: boolean | null, wipeAfterDays?: number | null } | null }> | null, permittedAccessibilityServices?: { __typename?: 'PackageNameListSchema', packageNames?: Array<string> | null } | null, persistentPreferredActivities?: Array<{ __typename?: 'PersistentPreferredActivitySchema', actions?: Array<string> | null, categories?: Array<string> | null, receiverActivity?: string | null }> | null, choosePrivateKeyRules?: Array<{ __typename?: 'ChoosePrivateKeyRuleSchema', packageNames?: Array<string> | null, privateKeyAlias?: string | null, urlPattern?: string | null }> | null, deviceConnectivityManagement?: { __typename?: 'DeviceConnectivityManagementSchema', usbDataAccess?: DeviceConnectivityManagementUsbDataAccess | null } | null, shortSupportMessage?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null, localizedMessages?: any | null } | null, usageLog?: { __typename?: 'UsageLogSchema', enabledLogTypes?: Array<UsageLogEnabledLogTypes> | null, uploadOnCellularAllowed?: Array<UsageLogUploadOnCellularAllowed> | null } | null, longSupportMessage?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null, localizedMessages?: any | null } | null, permittedInputMethods?: { __typename?: 'PackageNameListSchema', packageNames?: Array<string> | null } | null, personalUsagePolicies?: { __typename?: 'PersonalUsagePoliciesSchema', accountTypesWithManagementDisabled?: Array<string> | null, cameraDisabled?: boolean | null, maxDaysWithWorkOff?: number | null, personalPlayStoreMode?: PersonalUsagePoliciesPersonalPlayStoreMode | null, screenCaptureDisabled?: boolean | null, personalApplications?: Array<{ __typename?: 'PersonalApplicationPolicySchema', installType?: PersonalApplicationPolicyInstallType | null, packageName?: string | null }> | null } | null, recommendedGlobalProxy?: { __typename?: 'ProxyInfoSchema', excludedHosts?: Array<string> | null, host?: string | null, pacUri?: string | null, port?: number | null } | null, systemUpdate?: { __typename?: 'SystemUpdateSchema', endMinutes?: number | null, startMinutes?: number | null, type?: SystemUpdateType | null, freezePeriods?: Array<{ __typename?: 'FreezePeriodSchema', endDate?: { __typename?: 'DateSchema', day?: number | null, month?: number | null, year?: number | null } | null, startDate?: { __typename?: 'DateSchema', day?: number | null, month?: number | null, year?: number | null } | null }> | null } | null, permissionGrants?: Array<{ __typename?: 'PermissionGrantSchema', permission?: string | null, policy?: PermissionGrantPolicy | null }> | null, oncCertificateProviders?: Array<{ __typename?: 'OncCertificateProviderSchema', certificateReferences?: Array<string> | null, contentProviderEndpoint?: { __typename?: 'ContentProviderEndpointSchema', packageName?: string | null, signingCertsSha256?: Array<string> | null, uri?: string | null } | null }> | null, alwaysOnVpnPackage?: { __typename?: 'AlwaysOnVpnPackageSchema', lockdownEnabled?: boolean | null, packageName?: string | null } | null, passwordPolicies?: Array<{ __typename?: 'PasswordRequirementsSchema', maximumFailedPasswordsForWipe?: number | null, passwordExpirationTimeout?: string | null, passwordHistoryLength?: number | null, passwordMinimumLength?: number | null, passwordMinimumLetters?: number | null, passwordMinimumLowerCase?: number | null, passwordMinimumNonLetter?: number | null, passwordMinimumNumeric?: number | null, passwordMinimumSymbols?: number | null, passwordMinimumUpperCase?: number | null, passwordQuality?: PasswordRequirementsPasswordQuality | null, passwordScope?: PasswordRequirementsPasswordScope | null, requirePasswordUnlock?: PasswordRequirementsRequirePasswordUnlock | null, unifiedLockSettings?: PasswordRequirementsUnifiedLockSettings | null }> | null, crossProfilePolicies?: { __typename?: 'CrossProfilePoliciesSchema', crossProfileCopyPaste?: CrossProfilePoliciesCrossProfileCopyPaste | null, crossProfileDataSharing?: CrossProfilePoliciesCrossProfileDataSharing | null, showWorkContactsInPersonalProfile?: CrossProfilePoliciesShowWorkContactsInPersonalProfile | null, workProfileWidgetsDefault?: CrossProfilePoliciesWorkProfileWidgetsDefault | null } | null } | null, configPolicy?: { __typename?: 'PolicySchema', id: string, playStoreMode?: PolicyPlayStoreMode | null, openNetworkConfiguration?: any | null, screenCaptureDisabled?: boolean | null, factoryResetDisabled?: boolean | null, cameraAccess?: PolicyCameraAccess | null, microphoneAccess?: PolicyMicrophoneAccess | null, networkEscapeHatchEnabled?: boolean | null, kioskCustomLauncherEnabled?: boolean | null, setWallpaperDisabled?: boolean | null, frpAdminEmails?: Array<string> | null, keyguardDisabled?: boolean | null, installAppsDisabled?: boolean | null, mobileNetworksConfigDisabled?: boolean | null, privateKeySelectionEnabled?: boolean | null, outgoingCallsDisabled?: boolean | null, smsDisabled?: boolean | null, mountPhysicalMediaDisabled?: boolean | null, autoDateAndTimeZone?: PolicyAutoDateAndTimeZone | null, setUserIconDisabled?: boolean | null, removeUserDisabled?: boolean | null, appAutoUpdatePolicy?: PolicyAppAutoUpdatePolicy | null, locationMode?: PolicyLocationMode | null, skipFirstUseHintsEnabled?: boolean | null, adjustVolumeDisabled?: boolean | null, keyguardDisabledFeatures?: Array<PolicyKeyguardDisabledFeatures> | null, shareLocationDisabled?: boolean | null, credentialsConfigDisabled?: boolean | null, networkResetDisabled?: boolean | null, defaultPermissionPolicy?: PolicyDefaultPermissionPolicy | null, addUserDisabled?: boolean | null, dataRoamingDisabled?: boolean | null, accountTypesWithManagementDisabled?: Array<string> | null, androidDevicePolicyTracks?: Array<PolicyAndroidDevicePolicyTracks> | null, createWindowsDisabled?: boolean | null, preferentialNetworkService?: PolicyPreferentialNetworkService | null, stayOnPluggedModes?: Array<PolicyStayOnPluggedModes> | null, bluetoothConfigDisabled?: boolean | null, outgoingBeamDisabled?: boolean | null, minimumApiLevel?: number | null, uninstallAppsDisabled?: boolean | null, encryptionPolicy?: PolicyEncryptionPolicy | null, bluetoothContactSharingDisabled?: boolean | null, bluetoothDisabled?: boolean | null, vpnConfigDisabled?: boolean | null, maximumTimeToLock?: string | null, modifyAccountsDisabled?: boolean | null, cellBroadcastsConfigDisabled?: boolean | null, funDisabled?: boolean | null, statusReportingSettings?: { __typename?: 'StatusReportingSettingsSchema', networkInfoEnabled?: boolean | null } | null, deviceOwnerLockScreenInfo?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, kioskCustomization?: { __typename?: 'KioskCustomizationSchema', systemNavigation?: KioskCustomizationSystemNavigation | null, systemErrorWarnings?: KioskCustomizationSystemErrorWarnings | null, statusBar?: KioskCustomizationStatusBar | null, powerButtonActions?: KioskCustomizationPowerButtonActions | null, deviceSettings?: KioskCustomizationDeviceSettings | null } | null, applications?: Array<{ __typename?: 'ApplicationPolicySchema', packageName?: string | null, installType?: ApplicationPolicyInstallType | null, defaultPermissionPolicy?: ApplicationPolicyDefaultPermissionPolicy | null, managedConfiguration?: any | null, disabled?: boolean | null, minimumVersionCode?: number | null, delegatedScopes?: Array<ApplicationPolicyDelegatedScopes> | null, accessibleTrackIds?: Array<string> | null, connectedWorkAndPersonalApp?: ApplicationPolicyConnectedWorkAndPersonalApp | null, autoUpdateMode?: ApplicationPolicyAutoUpdateMode | null, alwaysOnVpnLockdownExemption?: ApplicationPolicyAlwaysOnVpnLockdownExemption | null, workProfileWidgets?: ApplicationPolicyWorkProfileWidgets | null, permissionGrants?: Array<{ __typename?: 'PermissionGrantSchema', permission?: string | null, policy?: PermissionGrantPolicy | null }> | null, managedConfigurationTemplate?: { __typename?: 'ManagedConfigurationTemplateSchema', templateId?: string | null } | null, extensionConfig?: { __typename?: 'ExtensionConfigSchema', signingKeyFingerprintsSha256?: Array<string> | null, notificationReceiver?: string | null } | null }> | null, setupActions?: Array<{ __typename?: 'SetupActionSchema', description?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, title?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, launchApp?: { __typename?: 'LaunchAppActionSchema', packageName?: string | null } | null }> | null, advancedSecurityOverrides?: { __typename?: 'AdvancedSecurityOverridesSchema', developerSettings?: AdvancedSecurityOverridesDeveloperSettings | null, untrustedAppsPolicy?: AdvancedSecurityOverridesUntrustedAppsPolicy | null, googlePlayProtectVerifyApps?: AdvancedSecurityOverridesGooglePlayProtectVerifyApps | null } | null, policyEnforcementRules?: Array<{ __typename?: 'PolicyEnforcementRuleSchema', settingName?: string | null, blockAction?: { __typename?: 'BlockActionSchema', blockAfterDays?: number | null, blockScope?: BlockActionBlockScope | null } | null, wipeAction?: { __typename?: 'WipeActionSchema', preserveFrp?: boolean | null, wipeAfterDays?: number | null } | null }> | null, permittedAccessibilityServices?: { __typename?: 'PackageNameListSchema', packageNames?: Array<string> | null } | null, persistentPreferredActivities?: Array<{ __typename?: 'PersistentPreferredActivitySchema', actions?: Array<string> | null, categories?: Array<string> | null, receiverActivity?: string | null }> | null, choosePrivateKeyRules?: Array<{ __typename?: 'ChoosePrivateKeyRuleSchema', packageNames?: Array<string> | null, privateKeyAlias?: string | null, urlPattern?: string | null }> | null, deviceConnectivityManagement?: { __typename?: 'DeviceConnectivityManagementSchema', usbDataAccess?: DeviceConnectivityManagementUsbDataAccess | null } | null, shortSupportMessage?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null, localizedMessages?: any | null } | null, usageLog?: { __typename?: 'UsageLogSchema', enabledLogTypes?: Array<UsageLogEnabledLogTypes> | null, uploadOnCellularAllowed?: Array<UsageLogUploadOnCellularAllowed> | null } | null, longSupportMessage?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null, localizedMessages?: any | null } | null, permittedInputMethods?: { __typename?: 'PackageNameListSchema', packageNames?: Array<string> | null } | null, personalUsagePolicies?: { __typename?: 'PersonalUsagePoliciesSchema', accountTypesWithManagementDisabled?: Array<string> | null, cameraDisabled?: boolean | null, maxDaysWithWorkOff?: number | null, personalPlayStoreMode?: PersonalUsagePoliciesPersonalPlayStoreMode | null, screenCaptureDisabled?: boolean | null, personalApplications?: Array<{ __typename?: 'PersonalApplicationPolicySchema', installType?: PersonalApplicationPolicyInstallType | null, packageName?: string | null }> | null } | null, recommendedGlobalProxy?: { __typename?: 'ProxyInfoSchema', excludedHosts?: Array<string> | null, host?: string | null, pacUri?: string | null, port?: number | null } | null, systemUpdate?: { __typename?: 'SystemUpdateSchema', endMinutes?: number | null, startMinutes?: number | null, type?: SystemUpdateType | null, freezePeriods?: Array<{ __typename?: 'FreezePeriodSchema', endDate?: { __typename?: 'DateSchema', day?: number | null, month?: number | null, year?: number | null } | null, startDate?: { __typename?: 'DateSchema', day?: number | null, month?: number | null, year?: number | null } | null }> | null } | null, permissionGrants?: Array<{ __typename?: 'PermissionGrantSchema', permission?: string | null, policy?: PermissionGrantPolicy | null }> | null, oncCertificateProviders?: Array<{ __typename?: 'OncCertificateProviderSchema', certificateReferences?: Array<string> | null, contentProviderEndpoint?: { __typename?: 'ContentProviderEndpointSchema', packageName?: string | null, signingCertsSha256?: Array<string> | null, uri?: string | null } | null }> | null, alwaysOnVpnPackage?: { __typename?: 'AlwaysOnVpnPackageSchema', lockdownEnabled?: boolean | null, packageName?: string | null } | null, passwordPolicies?: Array<{ __typename?: 'PasswordRequirementsSchema', maximumFailedPasswordsForWipe?: number | null, passwordExpirationTimeout?: string | null, passwordHistoryLength?: number | null, passwordMinimumLength?: number | null, passwordMinimumLetters?: number | null, passwordMinimumLowerCase?: number | null, passwordMinimumNonLetter?: number | null, passwordMinimumNumeric?: number | null, passwordMinimumSymbols?: number | null, passwordMinimumUpperCase?: number | null, passwordQuality?: PasswordRequirementsPasswordQuality | null, passwordScope?: PasswordRequirementsPasswordScope | null, requirePasswordUnlock?: PasswordRequirementsRequirePasswordUnlock | null, unifiedLockSettings?: PasswordRequirementsUnifiedLockSettings | null }> | null, crossProfilePolicies?: { __typename?: 'CrossProfilePoliciesSchema', crossProfileCopyPaste?: CrossProfilePoliciesCrossProfileCopyPaste | null, crossProfileDataSharing?: CrossProfilePoliciesCrossProfileDataSharing | null, showWorkContactsInPersonalProfile?: CrossProfilePoliciesShowWorkContactsInPersonalProfile | null, workProfileWidgetsDefault?: CrossProfilePoliciesWorkProfileWidgetsDefault | null } | null } | null, parent?: { __typename?: 'MdmPolicySchema', id: string } | null } };

export type CreateMdmDeviceMutationVariables = Exact<{
  input: MdmDeviceInputSchema;
}>;


export type CreateMdmDeviceMutation = { __typename?: 'Mutation', createMdmDevice: { __typename?: 'MdmDeviceSchema', id: string, imei?: string | null, googleId?: string | null, policyName?: string | null, expectedPolicyName?: string | null, lastPolicySyncTime?: string | null, lastStatusReportTime?: string | null, enrollmentTime?: string | null, serial?: string | null } };

export type UpdateDevicePolicyMutationVariables = Exact<{
  mdmDeviceUpdate: MdmDeviceInputSchema;
  deviceUpdate: DeviceInputSchema;
}>;


export type UpdateDevicePolicyMutation = { __typename?: 'Mutation', updateMdmDevice: { __typename?: 'MdmDeviceSchema', id: string, imei?: string | null, googleId?: string | null, policyName?: string | null, expectedPolicyName?: string | null, lastPolicySyncTime?: string | null, lastStatusReportTime?: string | null, enrollmentTime?: string | null, serial?: string | null }, updateDevice: { __typename?: 'DeviceSchema', id: string, name?: string | null, userName?: string | null, ownership?: DeviceOwnership | null, state?: DeviceState | null, appliedState?: DeviceAppliedState | null, previousDeviceNames?: Array<string> | null, policyCompliant?: boolean | null, enrollmentTime?: string | null, enrollmentTokenData?: string | null, enrollmentTokenName?: string | null, lastPolicySyncTime?: string | null, lastPolicyComplianceReportTime?: string | null, lastStatusReportTime?: string | null, appliedPolicyVersion?: string | null, apiLevel?: number | null, systemProperties?: any | null, managementMode?: DeviceManagementMode | null, user?: { __typename?: 'UserSchema', accountIdentifier?: string | null } | null, hardwareInfo?: { __typename?: 'HardwareInfoSchema', batteryShutdownTemperatures?: Array<number> | null, batteryThrottlingTemperatures?: Array<number> | null, brand?: string | null, cpuShutdownTemperatures?: Array<number> | null, cpuThrottlingTemperatures?: Array<number> | null, deviceBasebandVersion?: string | null, enterpriseSpecificId?: string | null, gpuShutdownTemperatures?: Array<number> | null, gpuThrottlingTemperatures?: Array<number> | null, hardware?: string | null, manufacturer?: string | null, model?: string | null, serialNumber?: string | null, skinShutdownTemperatures?: Array<number> | null, skinThrottlingTemperatures?: Array<number> | null } | null, hardwareStatusSamples?: Array<{ __typename?: 'HardwareStatusSchema', batteryTemperatures?: Array<number> | null, cpuTemperatures?: Array<number> | null, cpuUsages?: Array<number> | null, createTime?: string | null, fanSpeeds?: Array<number> | null, gpuTemperatures?: Array<number> | null, skinTemperatures?: Array<number> | null }> | null, memoryInfo?: { __typename?: 'MemoryInfoSchema', totalInternalStorage?: string | null, totalRam?: string | null } | null, memoryEvents?: Array<{ __typename?: 'MemoryEventSchema', byteCount?: string | null, createTime?: string | null, eventType?: MemoryEventEventType | null }> | null, powerManagementEvents?: Array<{ __typename?: 'PowerManagementEventSchema', batteryLevel?: number | null, createTime?: string | null, eventType?: PowerManagementEventEventType | null }> | null, displays?: Array<{ __typename?: 'DisplaySchema', density?: number | null, displayId?: number | null, height?: number | null, name?: string | null, refreshRate?: number | null, state?: DisplayState | null, width?: number | null }> | null, nonComplianceDetails?: Array<{ __typename?: 'NonComplianceDetailSchema', packageName?: string | null, settingName?: string | null, fieldPath?: string | null, nonComplianceReason?: NonComplianceDetailNonComplianceReason | null, specificNonComplianceReason?: NonComplianceDetailSpecificNonComplianceReason | null, installationFailureReason?: NonComplianceDetailInstallationFailureReason | null, specificNonComplianceContext?: { __typename?: 'SpecificNonComplianceContextSchema', oncWifiContext?: { __typename?: 'OncWifiContextSchema', wifiGuid?: string | null } | null, passwordPoliciesContext?: { __typename?: 'PasswordPoliciesContextSchema', passwordPolicyScope?: PasswordPoliciesContextPasswordPolicyScope | null } | null } | null }> | null, applicationReports?: Array<{ __typename?: 'ApplicationReportSchema', applicationSource?: ApplicationReportApplicationSource | null, displayName?: string | null, installerPackageName?: string | null, packageName?: string | null, packageSha256Hash?: string | null, signingKeyCertFingerprints?: Array<string> | null, state?: ApplicationReportState | null, versionCode?: number | null, versionName?: string | null, events?: Array<{ __typename?: 'ApplicationEventSchema', createTime?: string | null, eventType?: ApplicationEventEventType | null }> | null, keyedAppStates?: Array<{ __typename?: 'KeyedAppStateSchema', createTime?: string | null, data?: string | null, key?: string | null, lastUpdateTime?: string | null, message?: string | null, severity?: KeyedAppStateSeverity | null }> | null }> | null, softwareInfo?: { __typename?: 'SoftwareInfoSchema', androidBuildNumber?: string | null, androidBuildTime?: string | null, androidDevicePolicyVersionCode?: number | null, androidDevicePolicyVersionName?: string | null, androidVersion?: string | null, bootloaderVersion?: string | null, deviceBuildSignature?: string | null, deviceKernelVersion?: string | null, primaryLanguageCode?: string | null, securityPatchLevel?: string | null, systemUpdateInfo?: { __typename?: 'SystemUpdateInfoSchema', updateReceivedTime?: string | null, updateStatus?: SystemUpdateInfoUpdateStatus | null } | null } | null, networkInfo?: { __typename?: 'NetworkInfoSchema', imei?: string | null, meid?: string | null, networkOperatorName?: string | null, wifiMacAddress?: string | null, telephonyInfos?: Array<{ __typename?: 'TelephonyInfoSchema', carrierName?: string | null, phoneNumber?: string | null }> | null } | null, appliedPasswordPolicies?: Array<{ __typename?: 'PasswordRequirementsSchema', maximumFailedPasswordsForWipe?: number | null, passwordExpirationTimeout?: string | null, passwordHistoryLength?: number | null, passwordMinimumLength?: number | null, passwordMinimumLetters?: number | null, passwordMinimumLowerCase?: number | null, passwordMinimumNonLetter?: number | null, passwordMinimumNumeric?: number | null, passwordMinimumSymbols?: number | null, passwordMinimumUpperCase?: number | null, passwordQuality?: PasswordRequirementsPasswordQuality | null, passwordScope?: PasswordRequirementsPasswordScope | null, requirePasswordUnlock?: PasswordRequirementsRequirePasswordUnlock | null, unifiedLockSettings?: PasswordRequirementsUnifiedLockSettings | null }> | null, commonCriteriaModeInfo?: { __typename?: 'CommonCriteriaModeInfoSchema', commonCriteriaModeStatus?: CommonCriteriaModeInfoCommonCriteriaModeStatus | null } | null, deviceSettings?: { __typename?: 'DeviceSettingsSchema', adbEnabled?: boolean | null, developmentSettingsEnabled?: boolean | null, encryptionStatus?: DeviceSettingsEncryptionStatus | null, isDeviceSecure?: boolean | null, isEncrypted?: boolean | null, unknownSourcesEnabled?: boolean | null, verifyAppsEnabled?: boolean | null } | null, disabledReason?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null, localizedMessages?: any | null } | null, securityPosture?: { __typename?: 'SecurityPostureSchema', devicePosture?: SecurityPostureDevicePosture | null, postureDetails?: Array<{ __typename?: 'PostureDetailSchema', securityRisk?: PostureDetailSecurityRisk | null, advice?: Array<{ __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null }> | null }> | null } | null } };

export type DeleteMdmDeviceMutationVariables = Exact<{
  mdmDeviceId: Scalars['String']['input'];
}>;


export type DeleteMdmDeviceMutation = { __typename?: 'Mutation', deleteMdmDevice: boolean };

export type DeleteDeviceMutationVariables = Exact<{
  deviceId: Scalars['String']['input'];
}>;


export type DeleteDeviceMutation = { __typename?: 'Mutation', deleteDevice: boolean };

export type SwitchesQueryVariables = Exact<{
  input?: InputMaybe<Array<SwitchDeviceInputSchema> | SwitchDeviceInputSchema>;
  queryArgs: SwitchDeviceArgs;
}>;


export type SwitchesQuery = { __typename?: 'Query', switchDevice: Array<{ __typename?: 'SwitchDeviceSchema', id: string, imei?: string | null, kioskPolicy?: string | null, normalPolicy?: string | null, device?: { __typename?: 'DeviceSchema', id: string, name?: string | null, userName?: string | null, ownership?: DeviceOwnership | null, state?: DeviceState | null, appliedState?: DeviceAppliedState | null, previousDeviceNames?: Array<string> | null, policyCompliant?: boolean | null, enrollmentTime?: string | null, enrollmentTokenData?: string | null, enrollmentTokenName?: string | null, lastPolicySyncTime?: string | null, lastPolicyComplianceReportTime?: string | null, lastStatusReportTime?: string | null, appliedPolicyVersion?: string | null, apiLevel?: number | null, systemProperties?: any | null, managementMode?: DeviceManagementMode | null, user?: { __typename?: 'UserSchema', accountIdentifier?: string | null } | null, hardwareInfo?: { __typename?: 'HardwareInfoSchema', batteryShutdownTemperatures?: Array<number> | null, batteryThrottlingTemperatures?: Array<number> | null, brand?: string | null, cpuShutdownTemperatures?: Array<number> | null, cpuThrottlingTemperatures?: Array<number> | null, deviceBasebandVersion?: string | null, enterpriseSpecificId?: string | null, gpuShutdownTemperatures?: Array<number> | null, gpuThrottlingTemperatures?: Array<number> | null, hardware?: string | null, manufacturer?: string | null, model?: string | null, serialNumber?: string | null, skinShutdownTemperatures?: Array<number> | null, skinThrottlingTemperatures?: Array<number> | null } | null, hardwareStatusSamples?: Array<{ __typename?: 'HardwareStatusSchema', batteryTemperatures?: Array<number> | null, cpuTemperatures?: Array<number> | null, cpuUsages?: Array<number> | null, createTime?: string | null, fanSpeeds?: Array<number> | null, gpuTemperatures?: Array<number> | null, skinTemperatures?: Array<number> | null }> | null, memoryInfo?: { __typename?: 'MemoryInfoSchema', totalInternalStorage?: string | null, totalRam?: string | null } | null, memoryEvents?: Array<{ __typename?: 'MemoryEventSchema', byteCount?: string | null, createTime?: string | null, eventType?: MemoryEventEventType | null }> | null, powerManagementEvents?: Array<{ __typename?: 'PowerManagementEventSchema', batteryLevel?: number | null, createTime?: string | null, eventType?: PowerManagementEventEventType | null }> | null, displays?: Array<{ __typename?: 'DisplaySchema', density?: number | null, displayId?: number | null, height?: number | null, name?: string | null, refreshRate?: number | null, state?: DisplayState | null, width?: number | null }> | null, nonComplianceDetails?: Array<{ __typename?: 'NonComplianceDetailSchema', packageName?: string | null, settingName?: string | null, fieldPath?: string | null, nonComplianceReason?: NonComplianceDetailNonComplianceReason | null, specificNonComplianceReason?: NonComplianceDetailSpecificNonComplianceReason | null, installationFailureReason?: NonComplianceDetailInstallationFailureReason | null, specificNonComplianceContext?: { __typename?: 'SpecificNonComplianceContextSchema', oncWifiContext?: { __typename?: 'OncWifiContextSchema', wifiGuid?: string | null } | null, passwordPoliciesContext?: { __typename?: 'PasswordPoliciesContextSchema', passwordPolicyScope?: PasswordPoliciesContextPasswordPolicyScope | null } | null } | null }> | null, applicationReports?: Array<{ __typename?: 'ApplicationReportSchema', applicationSource?: ApplicationReportApplicationSource | null, displayName?: string | null, installerPackageName?: string | null, packageName?: string | null, packageSha256Hash?: string | null, signingKeyCertFingerprints?: Array<string> | null, state?: ApplicationReportState | null, versionCode?: number | null, versionName?: string | null, events?: Array<{ __typename?: 'ApplicationEventSchema', createTime?: string | null, eventType?: ApplicationEventEventType | null }> | null, keyedAppStates?: Array<{ __typename?: 'KeyedAppStateSchema', createTime?: string | null, data?: string | null, key?: string | null, lastUpdateTime?: string | null, message?: string | null, severity?: KeyedAppStateSeverity | null }> | null }> | null, softwareInfo?: { __typename?: 'SoftwareInfoSchema', androidBuildNumber?: string | null, androidBuildTime?: string | null, androidDevicePolicyVersionCode?: number | null, androidDevicePolicyVersionName?: string | null, androidVersion?: string | null, bootloaderVersion?: string | null, deviceBuildSignature?: string | null, deviceKernelVersion?: string | null, primaryLanguageCode?: string | null, securityPatchLevel?: string | null, systemUpdateInfo?: { __typename?: 'SystemUpdateInfoSchema', updateReceivedTime?: string | null, updateStatus?: SystemUpdateInfoUpdateStatus | null } | null } | null, networkInfo?: { __typename?: 'NetworkInfoSchema', imei?: string | null, meid?: string | null, networkOperatorName?: string | null, wifiMacAddress?: string | null, telephonyInfos?: Array<{ __typename?: 'TelephonyInfoSchema', carrierName?: string | null, phoneNumber?: string | null }> | null } | null, appliedPasswordPolicies?: Array<{ __typename?: 'PasswordRequirementsSchema', maximumFailedPasswordsForWipe?: number | null, passwordExpirationTimeout?: string | null, passwordHistoryLength?: number | null, passwordMinimumLength?: number | null, passwordMinimumLetters?: number | null, passwordMinimumLowerCase?: number | null, passwordMinimumNonLetter?: number | null, passwordMinimumNumeric?: number | null, passwordMinimumSymbols?: number | null, passwordMinimumUpperCase?: number | null, passwordQuality?: PasswordRequirementsPasswordQuality | null, passwordScope?: PasswordRequirementsPasswordScope | null, requirePasswordUnlock?: PasswordRequirementsRequirePasswordUnlock | null, unifiedLockSettings?: PasswordRequirementsUnifiedLockSettings | null }> | null, commonCriteriaModeInfo?: { __typename?: 'CommonCriteriaModeInfoSchema', commonCriteriaModeStatus?: CommonCriteriaModeInfoCommonCriteriaModeStatus | null } | null, deviceSettings?: { __typename?: 'DeviceSettingsSchema', adbEnabled?: boolean | null, developmentSettingsEnabled?: boolean | null, encryptionStatus?: DeviceSettingsEncryptionStatus | null, isDeviceSecure?: boolean | null, isEncrypted?: boolean | null, unknownSourcesEnabled?: boolean | null, verifyAppsEnabled?: boolean | null } | null, disabledReason?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null, localizedMessages?: any | null } | null, securityPosture?: { __typename?: 'SecurityPostureSchema', devicePosture?: SecurityPostureDevicePosture | null, postureDetails?: Array<{ __typename?: 'PostureDetailSchema', securityRisk?: PostureDetailSecurityRisk | null, advice?: Array<{ __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null }> | null }> | null } | null } | null }> };

export type MdmDevicesQueryVariables = Exact<{
  input?: InputMaybe<Array<MdmDeviceInputSchema> | MdmDeviceInputSchema>;
  queryArgs?: InputMaybe<MdmDeviceArgs>;
}>;


export type MdmDevicesQuery = { __typename?: 'Query', mdmDevice: Array<{ __typename?: 'MdmDeviceSchema', id: string, imei?: string | null, googleId?: string | null, policyName?: string | null, expectedPolicyName?: string | null, lastPolicySyncTime?: string | null, lastStatusReportTime?: string | null, enrollmentTime?: string | null, serial?: string | null }> };

export type GoogleDeviceQueryVariables = Exact<{
  deviceId: Scalars['String']['input'];
}>;


export type GoogleDeviceQuery = { __typename?: 'Query', device: Array<{ __typename?: 'DeviceSchema', id: string, name?: string | null, userName?: string | null, ownership?: DeviceOwnership | null, state?: DeviceState | null, appliedState?: DeviceAppliedState | null, previousDeviceNames?: Array<string> | null, policyCompliant?: boolean | null, enrollmentTime?: string | null, enrollmentTokenData?: string | null, enrollmentTokenName?: string | null, lastPolicySyncTime?: string | null, lastPolicyComplianceReportTime?: string | null, lastStatusReportTime?: string | null, appliedPolicyVersion?: string | null, apiLevel?: number | null, systemProperties?: any | null, managementMode?: DeviceManagementMode | null, user?: { __typename?: 'UserSchema', accountIdentifier?: string | null } | null, hardwareInfo?: { __typename?: 'HardwareInfoSchema', batteryShutdownTemperatures?: Array<number> | null, batteryThrottlingTemperatures?: Array<number> | null, brand?: string | null, cpuShutdownTemperatures?: Array<number> | null, cpuThrottlingTemperatures?: Array<number> | null, deviceBasebandVersion?: string | null, enterpriseSpecificId?: string | null, gpuShutdownTemperatures?: Array<number> | null, gpuThrottlingTemperatures?: Array<number> | null, hardware?: string | null, manufacturer?: string | null, model?: string | null, serialNumber?: string | null, skinShutdownTemperatures?: Array<number> | null, skinThrottlingTemperatures?: Array<number> | null } | null, hardwareStatusSamples?: Array<{ __typename?: 'HardwareStatusSchema', batteryTemperatures?: Array<number> | null, cpuTemperatures?: Array<number> | null, cpuUsages?: Array<number> | null, createTime?: string | null, fanSpeeds?: Array<number> | null, gpuTemperatures?: Array<number> | null, skinTemperatures?: Array<number> | null }> | null, memoryInfo?: { __typename?: 'MemoryInfoSchema', totalInternalStorage?: string | null, totalRam?: string | null } | null, memoryEvents?: Array<{ __typename?: 'MemoryEventSchema', byteCount?: string | null, createTime?: string | null, eventType?: MemoryEventEventType | null }> | null, powerManagementEvents?: Array<{ __typename?: 'PowerManagementEventSchema', batteryLevel?: number | null, createTime?: string | null, eventType?: PowerManagementEventEventType | null }> | null, displays?: Array<{ __typename?: 'DisplaySchema', density?: number | null, displayId?: number | null, height?: number | null, name?: string | null, refreshRate?: number | null, state?: DisplayState | null, width?: number | null }> | null, nonComplianceDetails?: Array<{ __typename?: 'NonComplianceDetailSchema', packageName?: string | null, settingName?: string | null, fieldPath?: string | null, nonComplianceReason?: NonComplianceDetailNonComplianceReason | null, specificNonComplianceReason?: NonComplianceDetailSpecificNonComplianceReason | null, installationFailureReason?: NonComplianceDetailInstallationFailureReason | null, specificNonComplianceContext?: { __typename?: 'SpecificNonComplianceContextSchema', oncWifiContext?: { __typename?: 'OncWifiContextSchema', wifiGuid?: string | null } | null, passwordPoliciesContext?: { __typename?: 'PasswordPoliciesContextSchema', passwordPolicyScope?: PasswordPoliciesContextPasswordPolicyScope | null } | null } | null }> | null, applicationReports?: Array<{ __typename?: 'ApplicationReportSchema', applicationSource?: ApplicationReportApplicationSource | null, displayName?: string | null, installerPackageName?: string | null, packageName?: string | null, packageSha256Hash?: string | null, signingKeyCertFingerprints?: Array<string> | null, state?: ApplicationReportState | null, versionCode?: number | null, versionName?: string | null, events?: Array<{ __typename?: 'ApplicationEventSchema', createTime?: string | null, eventType?: ApplicationEventEventType | null }> | null, keyedAppStates?: Array<{ __typename?: 'KeyedAppStateSchema', createTime?: string | null, data?: string | null, key?: string | null, lastUpdateTime?: string | null, message?: string | null, severity?: KeyedAppStateSeverity | null }> | null }> | null, softwareInfo?: { __typename?: 'SoftwareInfoSchema', androidBuildNumber?: string | null, androidBuildTime?: string | null, androidDevicePolicyVersionCode?: number | null, androidDevicePolicyVersionName?: string | null, androidVersion?: string | null, bootloaderVersion?: string | null, deviceBuildSignature?: string | null, deviceKernelVersion?: string | null, primaryLanguageCode?: string | null, securityPatchLevel?: string | null, systemUpdateInfo?: { __typename?: 'SystemUpdateInfoSchema', updateReceivedTime?: string | null, updateStatus?: SystemUpdateInfoUpdateStatus | null } | null } | null, networkInfo?: { __typename?: 'NetworkInfoSchema', imei?: string | null, meid?: string | null, networkOperatorName?: string | null, wifiMacAddress?: string | null, telephonyInfos?: Array<{ __typename?: 'TelephonyInfoSchema', carrierName?: string | null, phoneNumber?: string | null }> | null } | null, appliedPasswordPolicies?: Array<{ __typename?: 'PasswordRequirementsSchema', maximumFailedPasswordsForWipe?: number | null, passwordExpirationTimeout?: string | null, passwordHistoryLength?: number | null, passwordMinimumLength?: number | null, passwordMinimumLetters?: number | null, passwordMinimumLowerCase?: number | null, passwordMinimumNonLetter?: number | null, passwordMinimumNumeric?: number | null, passwordMinimumSymbols?: number | null, passwordMinimumUpperCase?: number | null, passwordQuality?: PasswordRequirementsPasswordQuality | null, passwordScope?: PasswordRequirementsPasswordScope | null, requirePasswordUnlock?: PasswordRequirementsRequirePasswordUnlock | null, unifiedLockSettings?: PasswordRequirementsUnifiedLockSettings | null }> | null, commonCriteriaModeInfo?: { __typename?: 'CommonCriteriaModeInfoSchema', commonCriteriaModeStatus?: CommonCriteriaModeInfoCommonCriteriaModeStatus | null } | null, deviceSettings?: { __typename?: 'DeviceSettingsSchema', adbEnabled?: boolean | null, developmentSettingsEnabled?: boolean | null, encryptionStatus?: DeviceSettingsEncryptionStatus | null, isDeviceSecure?: boolean | null, isEncrypted?: boolean | null, unknownSourcesEnabled?: boolean | null, verifyAppsEnabled?: boolean | null } | null, disabledReason?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null, localizedMessages?: any | null } | null, securityPosture?: { __typename?: 'SecurityPostureSchema', devicePosture?: SecurityPostureDevicePosture | null, postureDetails?: Array<{ __typename?: 'PostureDetailSchema', securityRisk?: PostureDetailSecurityRisk | null, advice?: Array<{ __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null }> | null }> | null } | null }> };

export type MdmPoliciesQueryVariables = Exact<{
  input?: InputMaybe<Array<MdmPolicyInputSchema> | MdmPolicyInputSchema>;
  queryArgs?: InputMaybe<MdmPolicyArgs>;
}>;


export type MdmPoliciesQuery = { __typename?: 'Query', mdmPolicy: Array<{ __typename?: 'MdmPolicySchema', id: string, enterpriseId: string, googleId: string, configGoogleId: string, name: string, policy?: { __typename?: 'PolicySchema', id: string, playStoreMode?: PolicyPlayStoreMode | null, openNetworkConfiguration?: any | null, screenCaptureDisabled?: boolean | null, factoryResetDisabled?: boolean | null, cameraAccess?: PolicyCameraAccess | null, microphoneAccess?: PolicyMicrophoneAccess | null, networkEscapeHatchEnabled?: boolean | null, kioskCustomLauncherEnabled?: boolean | null, setWallpaperDisabled?: boolean | null, frpAdminEmails?: Array<string> | null, keyguardDisabled?: boolean | null, installAppsDisabled?: boolean | null, mobileNetworksConfigDisabled?: boolean | null, privateKeySelectionEnabled?: boolean | null, outgoingCallsDisabled?: boolean | null, smsDisabled?: boolean | null, mountPhysicalMediaDisabled?: boolean | null, autoDateAndTimeZone?: PolicyAutoDateAndTimeZone | null, setUserIconDisabled?: boolean | null, removeUserDisabled?: boolean | null, appAutoUpdatePolicy?: PolicyAppAutoUpdatePolicy | null, locationMode?: PolicyLocationMode | null, skipFirstUseHintsEnabled?: boolean | null, adjustVolumeDisabled?: boolean | null, keyguardDisabledFeatures?: Array<PolicyKeyguardDisabledFeatures> | null, shareLocationDisabled?: boolean | null, credentialsConfigDisabled?: boolean | null, networkResetDisabled?: boolean | null, defaultPermissionPolicy?: PolicyDefaultPermissionPolicy | null, addUserDisabled?: boolean | null, dataRoamingDisabled?: boolean | null, accountTypesWithManagementDisabled?: Array<string> | null, androidDevicePolicyTracks?: Array<PolicyAndroidDevicePolicyTracks> | null, createWindowsDisabled?: boolean | null, preferentialNetworkService?: PolicyPreferentialNetworkService | null, stayOnPluggedModes?: Array<PolicyStayOnPluggedModes> | null, bluetoothConfigDisabled?: boolean | null, outgoingBeamDisabled?: boolean | null, minimumApiLevel?: number | null, uninstallAppsDisabled?: boolean | null, encryptionPolicy?: PolicyEncryptionPolicy | null, bluetoothContactSharingDisabled?: boolean | null, bluetoothDisabled?: boolean | null, vpnConfigDisabled?: boolean | null, maximumTimeToLock?: string | null, modifyAccountsDisabled?: boolean | null, cellBroadcastsConfigDisabled?: boolean | null, funDisabled?: boolean | null, statusReportingSettings?: { __typename?: 'StatusReportingSettingsSchema', networkInfoEnabled?: boolean | null } | null, deviceOwnerLockScreenInfo?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, kioskCustomization?: { __typename?: 'KioskCustomizationSchema', systemNavigation?: KioskCustomizationSystemNavigation | null, systemErrorWarnings?: KioskCustomizationSystemErrorWarnings | null, statusBar?: KioskCustomizationStatusBar | null, powerButtonActions?: KioskCustomizationPowerButtonActions | null, deviceSettings?: KioskCustomizationDeviceSettings | null } | null, applications?: Array<{ __typename?: 'ApplicationPolicySchema', packageName?: string | null, installType?: ApplicationPolicyInstallType | null, defaultPermissionPolicy?: ApplicationPolicyDefaultPermissionPolicy | null, managedConfiguration?: any | null, disabled?: boolean | null, minimumVersionCode?: number | null, delegatedScopes?: Array<ApplicationPolicyDelegatedScopes> | null, accessibleTrackIds?: Array<string> | null, connectedWorkAndPersonalApp?: ApplicationPolicyConnectedWorkAndPersonalApp | null, autoUpdateMode?: ApplicationPolicyAutoUpdateMode | null, alwaysOnVpnLockdownExemption?: ApplicationPolicyAlwaysOnVpnLockdownExemption | null, workProfileWidgets?: ApplicationPolicyWorkProfileWidgets | null, permissionGrants?: Array<{ __typename?: 'PermissionGrantSchema', permission?: string | null, policy?: PermissionGrantPolicy | null }> | null, managedConfigurationTemplate?: { __typename?: 'ManagedConfigurationTemplateSchema', templateId?: string | null } | null, extensionConfig?: { __typename?: 'ExtensionConfigSchema', signingKeyFingerprintsSha256?: Array<string> | null, notificationReceiver?: string | null } | null }> | null, setupActions?: Array<{ __typename?: 'SetupActionSchema', description?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, title?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, launchApp?: { __typename?: 'LaunchAppActionSchema', packageName?: string | null } | null }> | null, advancedSecurityOverrides?: { __typename?: 'AdvancedSecurityOverridesSchema', developerSettings?: AdvancedSecurityOverridesDeveloperSettings | null, untrustedAppsPolicy?: AdvancedSecurityOverridesUntrustedAppsPolicy | null, googlePlayProtectVerifyApps?: AdvancedSecurityOverridesGooglePlayProtectVerifyApps | null } | null, policyEnforcementRules?: Array<{ __typename?: 'PolicyEnforcementRuleSchema', settingName?: string | null, blockAction?: { __typename?: 'BlockActionSchema', blockAfterDays?: number | null, blockScope?: BlockActionBlockScope | null } | null, wipeAction?: { __typename?: 'WipeActionSchema', preserveFrp?: boolean | null, wipeAfterDays?: number | null } | null }> | null, permittedAccessibilityServices?: { __typename?: 'PackageNameListSchema', packageNames?: Array<string> | null } | null, persistentPreferredActivities?: Array<{ __typename?: 'PersistentPreferredActivitySchema', actions?: Array<string> | null, categories?: Array<string> | null, receiverActivity?: string | null }> | null, choosePrivateKeyRules?: Array<{ __typename?: 'ChoosePrivateKeyRuleSchema', packageNames?: Array<string> | null, privateKeyAlias?: string | null, urlPattern?: string | null }> | null, deviceConnectivityManagement?: { __typename?: 'DeviceConnectivityManagementSchema', usbDataAccess?: DeviceConnectivityManagementUsbDataAccess | null } | null, shortSupportMessage?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null, localizedMessages?: any | null } | null, usageLog?: { __typename?: 'UsageLogSchema', enabledLogTypes?: Array<UsageLogEnabledLogTypes> | null, uploadOnCellularAllowed?: Array<UsageLogUploadOnCellularAllowed> | null } | null, longSupportMessage?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null, localizedMessages?: any | null } | null, permittedInputMethods?: { __typename?: 'PackageNameListSchema', packageNames?: Array<string> | null } | null, personalUsagePolicies?: { __typename?: 'PersonalUsagePoliciesSchema', accountTypesWithManagementDisabled?: Array<string> | null, cameraDisabled?: boolean | null, maxDaysWithWorkOff?: number | null, personalPlayStoreMode?: PersonalUsagePoliciesPersonalPlayStoreMode | null, screenCaptureDisabled?: boolean | null, personalApplications?: Array<{ __typename?: 'PersonalApplicationPolicySchema', installType?: PersonalApplicationPolicyInstallType | null, packageName?: string | null }> | null } | null, recommendedGlobalProxy?: { __typename?: 'ProxyInfoSchema', excludedHosts?: Array<string> | null, host?: string | null, pacUri?: string | null, port?: number | null } | null, systemUpdate?: { __typename?: 'SystemUpdateSchema', endMinutes?: number | null, startMinutes?: number | null, type?: SystemUpdateType | null, freezePeriods?: Array<{ __typename?: 'FreezePeriodSchema', endDate?: { __typename?: 'DateSchema', day?: number | null, month?: number | null, year?: number | null } | null, startDate?: { __typename?: 'DateSchema', day?: number | null, month?: number | null, year?: number | null } | null }> | null } | null, permissionGrants?: Array<{ __typename?: 'PermissionGrantSchema', permission?: string | null, policy?: PermissionGrantPolicy | null }> | null, oncCertificateProviders?: Array<{ __typename?: 'OncCertificateProviderSchema', certificateReferences?: Array<string> | null, contentProviderEndpoint?: { __typename?: 'ContentProviderEndpointSchema', packageName?: string | null, signingCertsSha256?: Array<string> | null, uri?: string | null } | null }> | null, alwaysOnVpnPackage?: { __typename?: 'AlwaysOnVpnPackageSchema', lockdownEnabled?: boolean | null, packageName?: string | null } | null, passwordPolicies?: Array<{ __typename?: 'PasswordRequirementsSchema', maximumFailedPasswordsForWipe?: number | null, passwordExpirationTimeout?: string | null, passwordHistoryLength?: number | null, passwordMinimumLength?: number | null, passwordMinimumLetters?: number | null, passwordMinimumLowerCase?: number | null, passwordMinimumNonLetter?: number | null, passwordMinimumNumeric?: number | null, passwordMinimumSymbols?: number | null, passwordMinimumUpperCase?: number | null, passwordQuality?: PasswordRequirementsPasswordQuality | null, passwordScope?: PasswordRequirementsPasswordScope | null, requirePasswordUnlock?: PasswordRequirementsRequirePasswordUnlock | null, unifiedLockSettings?: PasswordRequirementsUnifiedLockSettings | null }> | null, crossProfilePolicies?: { __typename?: 'CrossProfilePoliciesSchema', crossProfileCopyPaste?: CrossProfilePoliciesCrossProfileCopyPaste | null, crossProfileDataSharing?: CrossProfilePoliciesCrossProfileDataSharing | null, showWorkContactsInPersonalProfile?: CrossProfilePoliciesShowWorkContactsInPersonalProfile | null, workProfileWidgetsDefault?: CrossProfilePoliciesWorkProfileWidgetsDefault | null } | null } | null, configPolicy?: { __typename?: 'PolicySchema', id: string, playStoreMode?: PolicyPlayStoreMode | null, openNetworkConfiguration?: any | null, screenCaptureDisabled?: boolean | null, factoryResetDisabled?: boolean | null, cameraAccess?: PolicyCameraAccess | null, microphoneAccess?: PolicyMicrophoneAccess | null, networkEscapeHatchEnabled?: boolean | null, kioskCustomLauncherEnabled?: boolean | null, setWallpaperDisabled?: boolean | null, frpAdminEmails?: Array<string> | null, keyguardDisabled?: boolean | null, installAppsDisabled?: boolean | null, mobileNetworksConfigDisabled?: boolean | null, privateKeySelectionEnabled?: boolean | null, outgoingCallsDisabled?: boolean | null, smsDisabled?: boolean | null, mountPhysicalMediaDisabled?: boolean | null, autoDateAndTimeZone?: PolicyAutoDateAndTimeZone | null, setUserIconDisabled?: boolean | null, removeUserDisabled?: boolean | null, appAutoUpdatePolicy?: PolicyAppAutoUpdatePolicy | null, locationMode?: PolicyLocationMode | null, skipFirstUseHintsEnabled?: boolean | null, adjustVolumeDisabled?: boolean | null, keyguardDisabledFeatures?: Array<PolicyKeyguardDisabledFeatures> | null, shareLocationDisabled?: boolean | null, credentialsConfigDisabled?: boolean | null, networkResetDisabled?: boolean | null, defaultPermissionPolicy?: PolicyDefaultPermissionPolicy | null, addUserDisabled?: boolean | null, dataRoamingDisabled?: boolean | null, accountTypesWithManagementDisabled?: Array<string> | null, androidDevicePolicyTracks?: Array<PolicyAndroidDevicePolicyTracks> | null, createWindowsDisabled?: boolean | null, preferentialNetworkService?: PolicyPreferentialNetworkService | null, stayOnPluggedModes?: Array<PolicyStayOnPluggedModes> | null, bluetoothConfigDisabled?: boolean | null, outgoingBeamDisabled?: boolean | null, minimumApiLevel?: number | null, uninstallAppsDisabled?: boolean | null, encryptionPolicy?: PolicyEncryptionPolicy | null, bluetoothContactSharingDisabled?: boolean | null, bluetoothDisabled?: boolean | null, vpnConfigDisabled?: boolean | null, maximumTimeToLock?: string | null, modifyAccountsDisabled?: boolean | null, cellBroadcastsConfigDisabled?: boolean | null, funDisabled?: boolean | null, statusReportingSettings?: { __typename?: 'StatusReportingSettingsSchema', networkInfoEnabled?: boolean | null } | null, deviceOwnerLockScreenInfo?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, kioskCustomization?: { __typename?: 'KioskCustomizationSchema', systemNavigation?: KioskCustomizationSystemNavigation | null, systemErrorWarnings?: KioskCustomizationSystemErrorWarnings | null, statusBar?: KioskCustomizationStatusBar | null, powerButtonActions?: KioskCustomizationPowerButtonActions | null, deviceSettings?: KioskCustomizationDeviceSettings | null } | null, applications?: Array<{ __typename?: 'ApplicationPolicySchema', packageName?: string | null, installType?: ApplicationPolicyInstallType | null, defaultPermissionPolicy?: ApplicationPolicyDefaultPermissionPolicy | null, managedConfiguration?: any | null, disabled?: boolean | null, minimumVersionCode?: number | null, delegatedScopes?: Array<ApplicationPolicyDelegatedScopes> | null, accessibleTrackIds?: Array<string> | null, connectedWorkAndPersonalApp?: ApplicationPolicyConnectedWorkAndPersonalApp | null, autoUpdateMode?: ApplicationPolicyAutoUpdateMode | null, alwaysOnVpnLockdownExemption?: ApplicationPolicyAlwaysOnVpnLockdownExemption | null, workProfileWidgets?: ApplicationPolicyWorkProfileWidgets | null, permissionGrants?: Array<{ __typename?: 'PermissionGrantSchema', permission?: string | null, policy?: PermissionGrantPolicy | null }> | null, managedConfigurationTemplate?: { __typename?: 'ManagedConfigurationTemplateSchema', templateId?: string | null } | null, extensionConfig?: { __typename?: 'ExtensionConfigSchema', signingKeyFingerprintsSha256?: Array<string> | null, notificationReceiver?: string | null } | null }> | null, setupActions?: Array<{ __typename?: 'SetupActionSchema', description?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, title?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null } | null, launchApp?: { __typename?: 'LaunchAppActionSchema', packageName?: string | null } | null }> | null, advancedSecurityOverrides?: { __typename?: 'AdvancedSecurityOverridesSchema', developerSettings?: AdvancedSecurityOverridesDeveloperSettings | null, untrustedAppsPolicy?: AdvancedSecurityOverridesUntrustedAppsPolicy | null, googlePlayProtectVerifyApps?: AdvancedSecurityOverridesGooglePlayProtectVerifyApps | null } | null, policyEnforcementRules?: Array<{ __typename?: 'PolicyEnforcementRuleSchema', settingName?: string | null, blockAction?: { __typename?: 'BlockActionSchema', blockAfterDays?: number | null, blockScope?: BlockActionBlockScope | null } | null, wipeAction?: { __typename?: 'WipeActionSchema', preserveFrp?: boolean | null, wipeAfterDays?: number | null } | null }> | null, permittedAccessibilityServices?: { __typename?: 'PackageNameListSchema', packageNames?: Array<string> | null } | null, persistentPreferredActivities?: Array<{ __typename?: 'PersistentPreferredActivitySchema', actions?: Array<string> | null, categories?: Array<string> | null, receiverActivity?: string | null }> | null, choosePrivateKeyRules?: Array<{ __typename?: 'ChoosePrivateKeyRuleSchema', packageNames?: Array<string> | null, privateKeyAlias?: string | null, urlPattern?: string | null }> | null, deviceConnectivityManagement?: { __typename?: 'DeviceConnectivityManagementSchema', usbDataAccess?: DeviceConnectivityManagementUsbDataAccess | null } | null, shortSupportMessage?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null, localizedMessages?: any | null } | null, usageLog?: { __typename?: 'UsageLogSchema', enabledLogTypes?: Array<UsageLogEnabledLogTypes> | null, uploadOnCellularAllowed?: Array<UsageLogUploadOnCellularAllowed> | null } | null, longSupportMessage?: { __typename?: 'UserFacingMessageSchema', defaultMessage?: string | null, localizedMessages?: any | null } | null, permittedInputMethods?: { __typename?: 'PackageNameListSchema', packageNames?: Array<string> | null } | null, personalUsagePolicies?: { __typename?: 'PersonalUsagePoliciesSchema', accountTypesWithManagementDisabled?: Array<string> | null, cameraDisabled?: boolean | null, maxDaysWithWorkOff?: number | null, personalPlayStoreMode?: PersonalUsagePoliciesPersonalPlayStoreMode | null, screenCaptureDisabled?: boolean | null, personalApplications?: Array<{ __typename?: 'PersonalApplicationPolicySchema', installType?: PersonalApplicationPolicyInstallType | null, packageName?: string | null }> | null } | null, recommendedGlobalProxy?: { __typename?: 'ProxyInfoSchema', excludedHosts?: Array<string> | null, host?: string | null, pacUri?: string | null, port?: number | null } | null, systemUpdate?: { __typename?: 'SystemUpdateSchema', endMinutes?: number | null, startMinutes?: number | null, type?: SystemUpdateType | null, freezePeriods?: Array<{ __typename?: 'FreezePeriodSchema', endDate?: { __typename?: 'DateSchema', day?: number | null, month?: number | null, year?: number | null } | null, startDate?: { __typename?: 'DateSchema', day?: number | null, month?: number | null, year?: number | null } | null }> | null } | null, permissionGrants?: Array<{ __typename?: 'PermissionGrantSchema', permission?: string | null, policy?: PermissionGrantPolicy | null }> | null, oncCertificateProviders?: Array<{ __typename?: 'OncCertificateProviderSchema', certificateReferences?: Array<string> | null, contentProviderEndpoint?: { __typename?: 'ContentProviderEndpointSchema', packageName?: string | null, signingCertsSha256?: Array<string> | null, uri?: string | null } | null }> | null, alwaysOnVpnPackage?: { __typename?: 'AlwaysOnVpnPackageSchema', lockdownEnabled?: boolean | null, packageName?: string | null } | null, passwordPolicies?: Array<{ __typename?: 'PasswordRequirementsSchema', maximumFailedPasswordsForWipe?: number | null, passwordExpirationTimeout?: string | null, passwordHistoryLength?: number | null, passwordMinimumLength?: number | null, passwordMinimumLetters?: number | null, passwordMinimumLowerCase?: number | null, passwordMinimumNonLetter?: number | null, passwordMinimumNumeric?: number | null, passwordMinimumSymbols?: number | null, passwordMinimumUpperCase?: number | null, passwordQuality?: PasswordRequirementsPasswordQuality | null, passwordScope?: PasswordRequirementsPasswordScope | null, requirePasswordUnlock?: PasswordRequirementsRequirePasswordUnlock | null, unifiedLockSettings?: PasswordRequirementsUnifiedLockSettings | null }> | null, crossProfilePolicies?: { __typename?: 'CrossProfilePoliciesSchema', crossProfileCopyPaste?: CrossProfilePoliciesCrossProfileCopyPaste | null, crossProfileDataSharing?: CrossProfilePoliciesCrossProfileDataSharing | null, showWorkContactsInPersonalProfile?: CrossProfilePoliciesShowWorkContactsInPersonalProfile | null, workProfileWidgetsDefault?: CrossProfilePoliciesWorkProfileWidgetsDefault | null } | null } | null, parent?: { __typename?: 'MdmPolicySchema', id: string } | null }> };

export type StatsQueryVariables = Exact<{ [key: string]: never; }>;


export type StatsQuery = { __typename?: 'Query', countMdmDevice: number, countSwitchDevice: number, countPolicy: number, countPerPolicy: Array<{ __typename?: 'CountByGroupSchema', group?: string | null, count: number }>, countMdmDeviceByPolicyByDate: Array<{ __typename?: 'CountByGroupSchema', group?: string | null, count: number }> };

export type TempAuthUrlQueryVariables = Exact<{
  redirectUri: Scalars['String']['input'];
}>;


export type TempAuthUrlQuery = { __typename?: 'Query', tempAuthUrl: string };

export type TempSetTokenMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type TempSetTokenMutation = { __typename?: 'Mutation', tempSetToken: boolean };

export type SyncMutationVariables = Exact<{
  mdmPolicyId: Scalars['String']['input'];
  preserveSystemApps: Scalars['Boolean']['input'];
}>;


export type SyncMutation = { __typename?: 'Mutation', sync: boolean };

export type MdmApplicationQueryVariables = Exact<{
  input?: InputMaybe<Array<MdmApplicationInputSchema> | MdmApplicationInputSchema>;
}>;


export type MdmApplicationQuery = { __typename?: 'Query', mdmApplication: Array<{ __typename?: 'MdmApplicationSchema', title?: string | null, iconUrl?: string | null }> };

export const PolicyFieldsFragmentDoc = gql`
    fragment PolicyFields on PolicySchema {
  id
  statusReportingSettings {
    networkInfoEnabled
  }
  playStoreMode
  deviceOwnerLockScreenInfo {
    defaultMessage
  }
  kioskCustomization {
    systemNavigation
    systemErrorWarnings
    statusBar
    powerButtonActions
    deviceSettings
  }
  applications {
    packageName
    installType
    defaultPermissionPolicy
    permissionGrants {
      permission
      policy
    }
    managedConfiguration
    disabled
    minimumVersionCode
    delegatedScopes
    managedConfigurationTemplate {
      templateId
    }
    accessibleTrackIds
    connectedWorkAndPersonalApp
    autoUpdateMode
    extensionConfig {
      signingKeyFingerprintsSha256
      notificationReceiver
    }
    alwaysOnVpnLockdownExemption
    workProfileWidgets
  }
  setupActions {
    description {
      defaultMessage
    }
    title {
      defaultMessage
    }
    launchApp {
      packageName
    }
  }
  advancedSecurityOverrides {
    developerSettings
    untrustedAppsPolicy
    googlePlayProtectVerifyApps
  }
  openNetworkConfiguration
  screenCaptureDisabled
  factoryResetDisabled
  cameraAccess
  microphoneAccess
  networkEscapeHatchEnabled
  kioskCustomLauncherEnabled
  setWallpaperDisabled
  frpAdminEmails
  keyguardDisabled
  policyEnforcementRules {
    blockAction {
      blockAfterDays
      blockScope
    }
    settingName
    wipeAction {
      preserveFrp
      wipeAfterDays
    }
  }
  permittedAccessibilityServices {
    packageNames
  }
  installAppsDisabled
  persistentPreferredActivities {
    actions
    categories
    receiverActivity
  }
  mobileNetworksConfigDisabled
  privateKeySelectionEnabled
  outgoingCallsDisabled
  choosePrivateKeyRules {
    packageNames
    privateKeyAlias
    urlPattern
  }
  deviceConnectivityManagement {
    usbDataAccess
  }
  smsDisabled
  shortSupportMessage {
    defaultMessage
    localizedMessages
  }
  mountPhysicalMediaDisabled
  usageLog {
    enabledLogTypes
    uploadOnCellularAllowed
  }
  longSupportMessage {
    defaultMessage
    localizedMessages
  }
  permittedInputMethods {
    packageNames
  }
  autoDateAndTimeZone
  setUserIconDisabled
  removeUserDisabled
  appAutoUpdatePolicy
  personalUsagePolicies {
    accountTypesWithManagementDisabled
    cameraDisabled
    maxDaysWithWorkOff
    personalApplications {
      installType
      packageName
    }
    personalPlayStoreMode
    screenCaptureDisabled
  }
  locationMode
  skipFirstUseHintsEnabled
  recommendedGlobalProxy {
    excludedHosts
    host
    pacUri
    port
  }
  adjustVolumeDisabled
  keyguardDisabledFeatures
  shareLocationDisabled
  credentialsConfigDisabled
  networkResetDisabled
  defaultPermissionPolicy
  addUserDisabled
  systemUpdate {
    endMinutes
    freezePeriods {
      endDate {
        day
        month
        year
      }
      startDate {
        day
        month
        year
      }
    }
    startMinutes
    type
  }
  dataRoamingDisabled
  permissionGrants {
    permission
    policy
  }
  accountTypesWithManagementDisabled
  androidDevicePolicyTracks
  oncCertificateProviders {
    certificateReferences
    contentProviderEndpoint {
      packageName
      signingCertsSha256
      uri
    }
  }
  createWindowsDisabled
  preferentialNetworkService
  stayOnPluggedModes
  bluetoothConfigDisabled
  outgoingBeamDisabled
  minimumApiLevel
  uninstallAppsDisabled
  encryptionPolicy
  alwaysOnVpnPackage {
    lockdownEnabled
    packageName
  }
  bluetoothContactSharingDisabled
  bluetoothDisabled
  vpnConfigDisabled
  passwordPolicies {
    maximumFailedPasswordsForWipe
    passwordExpirationTimeout
    passwordHistoryLength
    passwordMinimumLength
    passwordMinimumLetters
    passwordMinimumLowerCase
    passwordMinimumNonLetter
    passwordMinimumNumeric
    passwordMinimumSymbols
    passwordMinimumUpperCase
    passwordQuality
    passwordScope
    requirePasswordUnlock
    unifiedLockSettings
  }
  maximumTimeToLock
  crossProfilePolicies {
    crossProfileCopyPaste
    crossProfileDataSharing
    showWorkContactsInPersonalProfile
    workProfileWidgetsDefault
  }
  modifyAccountsDisabled
  cellBroadcastsConfigDisabled
  funDisabled
}
    `;
export const MdmPolicyFieldsFragmentDoc = gql`
    fragment MdmPolicyFields on MdmPolicySchema {
  id
  enterpriseId
  googleId
  policy {
    ...PolicyFields
  }
  configGoogleId
  configPolicy {
    ...PolicyFields
  }
  name
  parent {
    id
  }
}
    ${PolicyFieldsFragmentDoc}`;
export const DeviceFieldsFragmentDoc = gql`
    fragment DeviceFields on DeviceSchema {
  id
  name
  userName
  user {
    accountIdentifier
  }
  ownership
  state
  appliedState
  previousDeviceNames
  policyCompliant
  enrollmentTime
  enrollmentTokenData
  enrollmentTokenName
  lastPolicySyncTime
  lastPolicyComplianceReportTime
  lastStatusReportTime
  appliedPolicyVersion
  hardwareInfo {
    batteryShutdownTemperatures
    batteryThrottlingTemperatures
    brand
    cpuShutdownTemperatures
    cpuThrottlingTemperatures
    deviceBasebandVersion
    enterpriseSpecificId
    gpuShutdownTemperatures
    gpuThrottlingTemperatures
    hardware
    manufacturer
    model
    serialNumber
    skinShutdownTemperatures
    skinThrottlingTemperatures
  }
  hardwareStatusSamples {
    batteryTemperatures
    cpuTemperatures
    cpuUsages
    createTime
    fanSpeeds
    gpuTemperatures
    skinTemperatures
  }
  memoryInfo {
    totalInternalStorage
    totalRam
  }
  memoryEvents {
    byteCount
    createTime
    eventType
  }
  powerManagementEvents {
    batteryLevel
    createTime
    eventType
  }
  displays {
    density
    displayId
    height
    name
    refreshRate
    state
    width
  }
  apiLevel
  nonComplianceDetails {
    packageName
    settingName
    fieldPath
    nonComplianceReason
    specificNonComplianceReason
    installationFailureReason
    specificNonComplianceContext {
      oncWifiContext {
        wifiGuid
      }
      passwordPoliciesContext {
        passwordPolicyScope
      }
    }
  }
  applicationReports {
    applicationSource
    displayName
    events {
      createTime
      eventType
    }
    installerPackageName
    keyedAppStates {
      createTime
      data
      key
      lastUpdateTime
      message
      severity
    }
    packageName
    packageSha256Hash
    signingKeyCertFingerprints
    state
    versionCode
    versionName
  }
  softwareInfo {
    androidBuildNumber
    androidBuildTime
    androidDevicePolicyVersionCode
    androidDevicePolicyVersionName
    androidVersion
    bootloaderVersion
    deviceBuildSignature
    deviceKernelVersion
    primaryLanguageCode
    securityPatchLevel
    systemUpdateInfo {
      updateReceivedTime
      updateStatus
    }
  }
  systemProperties
  networkInfo {
    imei
    meid
    networkOperatorName
    telephonyInfos {
      carrierName
      phoneNumber
    }
    wifiMacAddress
  }
  appliedPasswordPolicies {
    maximumFailedPasswordsForWipe
    passwordExpirationTimeout
    passwordHistoryLength
    passwordMinimumLength
    passwordMinimumLetters
    passwordMinimumLowerCase
    passwordMinimumNonLetter
    passwordMinimumNumeric
    passwordMinimumSymbols
    passwordMinimumUpperCase
    passwordQuality
    passwordScope
    requirePasswordUnlock
    unifiedLockSettings
  }
  commonCriteriaModeInfo {
    commonCriteriaModeStatus
  }
  deviceSettings {
    adbEnabled
    developmentSettingsEnabled
    encryptionStatus
    isDeviceSecure
    isEncrypted
    unknownSourcesEnabled
    verifyAppsEnabled
  }
  disabledReason {
    defaultMessage
    localizedMessages
  }
  managementMode
  securityPosture {
    devicePosture
    postureDetails {
      advice {
        defaultMessage
      }
      securityRisk
    }
  }
}
    `;
export const SwitchDeviceFieldsFragmentDoc = gql`
    fragment SwitchDeviceFields on SwitchDeviceSchema {
  id
  imei
  kioskPolicy
  normalPolicy
  device {
    ...DeviceFields
  }
}
    ${DeviceFieldsFragmentDoc}`;
export const MdmDeviceFieldsFragmentDoc = gql`
    fragment MdmDeviceFields on MdmDeviceSchema {
  id
  imei
  googleId
  policyName
  expectedPolicyName
  lastPolicySyncTime
  lastStatusReportTime
  enrollmentTime
  imei
  serial
}
    `;
export const CreateEnrollmentTokenForPolicyDocument = gql`
    mutation createEnrollmentTokenForPolicy($policyId: String!) {
  createEnrollmentToken(input: {policy: {id: $policyId}, duration: "7776000s"}) {
    id
    qrCode
  }
}
    `;
export const CreateEnrollmentTokenForEnterpriseDocument = gql`
    mutation createEnrollmentTokenForEnterprise($enterpriseId: String!) {
  createEnrollmentToken(
    input: {enterprise: {id: $enterpriseId}, duration: "7776000s"}
  ) {
    id
    qrCode
  }
}
    `;
export const EnterprisesDocument = gql`
    query enterprises {
  enterprise(queryArgs: {size: 1000}) {
    id
    name
    enterpriseDisplayName
  }
}
    `;
export const CreateWebTokenDocument = gql`
    mutation createWebToken($enterpriseId: String!, $parentFrameUrl: String!) {
  createWebToken(
    input: {enterprise: {id: $enterpriseId}, parentFrameUrl: $parentFrameUrl}
  ) {
    id
    value
  }
}
    `;
export const CreatePolicyDocument = gql`
    mutation createPolicy($input: PolicyInputSchema!) {
  createPolicy(input: $input) {
    ...PolicyFields
  }
}
    ${PolicyFieldsFragmentDoc}`;
export const UpdatePolicyDocument = gql`
    mutation updatePolicy($input: PolicyInputSchema!) {
  updatePolicy(input: $input) {
    ...PolicyFields
  }
}
    ${PolicyFieldsFragmentDoc}`;
export const UpdateMdmPolicyDocument = gql`
    mutation updateMdmPolicy($input: MdmPolicyInputSchema!) {
  updateMdmPolicy(input: $input) {
    ...MdmPolicyFields
  }
}
    ${MdmPolicyFieldsFragmentDoc}`;
export const CreateMdmPolicyDocument = gql`
    mutation createMdmPolicy($input: MdmPolicyInputSchema!) {
  createMdmPolicy(input: $input) {
    ...MdmPolicyFields
  }
}
    ${MdmPolicyFieldsFragmentDoc}`;
export const CreateMdmDeviceDocument = gql`
    mutation createMdmDevice($input: MdmDeviceInputSchema!) {
  createMdmDevice(input: $input) {
    ...MdmDeviceFields
  }
}
    ${MdmDeviceFieldsFragmentDoc}`;
export const UpdateDevicePolicyDocument = gql`
    mutation updateDevicePolicy($mdmDeviceUpdate: MdmDeviceInputSchema!, $deviceUpdate: DeviceInputSchema!) {
  updateMdmDevice(input: $mdmDeviceUpdate) {
    ...MdmDeviceFields
  }
  updateDevice(input: $deviceUpdate) {
    ...DeviceFields
  }
}
    ${MdmDeviceFieldsFragmentDoc}
${DeviceFieldsFragmentDoc}`;
export const DeleteMdmDeviceDocument = gql`
    mutation deleteMdmDevice($mdmDeviceId: String!) {
  deleteMdmDevice(input: $mdmDeviceId)
}
    `;
export const DeleteDeviceDocument = gql`
    mutation deleteDevice($deviceId: String!) {
  deleteDevice(input: $deviceId)
}
    `;
export const SwitchesDocument = gql`
    query switches($input: [SwitchDeviceInputSchema!], $queryArgs: SwitchDeviceArgs!) {
  switchDevice(input: $input, queryArgs: $queryArgs) {
    ...SwitchDeviceFields
  }
}
    ${SwitchDeviceFieldsFragmentDoc}`;
export const MdmDevicesDocument = gql`
    query mdmDevices($input: [MdmDeviceInputSchema!], $queryArgs: MdmDeviceArgs) {
  mdmDevice(input: $input, queryArgs: $queryArgs) {
    ...MdmDeviceFields
  }
}
    ${MdmDeviceFieldsFragmentDoc}`;
export const GoogleDeviceDocument = gql`
    query googleDevice($deviceId: String!) {
  device(input: {id: $deviceId}) {
    ...DeviceFields
  }
}
    ${DeviceFieldsFragmentDoc}`;
export const MdmPoliciesDocument = gql`
    query mdmPolicies($input: [MdmPolicyInputSchema!], $queryArgs: MdmPolicyArgs) {
  mdmPolicy(input: $input, queryArgs: $queryArgs) {
    ...MdmPolicyFields
  }
}
    ${MdmPolicyFieldsFragmentDoc}`;
export const StatsDocument = gql`
    query stats {
  countMdmDevice: count(model: "MdmDevice")
  countSwitchDevice: count(model: "SwitchDevice")
  countPolicy: count(model: "MdmPolicy")
  countPerPolicy: countByGroup(model: "MdmDevice", group: "policyName") {
    group
    count
  }
  countMdmDeviceByPolicyByDate: countMdmDeviceByPolicyByDate {
    group
    count
  }
}
    `;
export const TempAuthUrlDocument = gql`
    query tempAuthUrl($redirectUri: String!) {
  tempAuthUrl(redirectUri: $redirectUri)
}
    `;
export const TempSetTokenDocument = gql`
    mutation tempSetToken($code: String!) {
  tempSetToken(code: $code)
}
    `;
export const SyncDocument = gql`
    mutation sync($mdmPolicyId: String!, $preserveSystemApps: Boolean!) {
  sync(mdmPolicyId: $mdmPolicyId, preserveSystemApps: $preserveSystemApps)
}
    `;
export const MdmApplicationDocument = gql`
    query mdmApplication($input: [MdmApplicationInputSchema!]) {
  mdmApplication(input: $input) {
    title
    iconUrl
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    createEnrollmentTokenForPolicy(variables: CreateEnrollmentTokenForPolicyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateEnrollmentTokenForPolicyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateEnrollmentTokenForPolicyMutation>(CreateEnrollmentTokenForPolicyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createEnrollmentTokenForPolicy', 'mutation');
    },
    createEnrollmentTokenForEnterprise(variables: CreateEnrollmentTokenForEnterpriseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateEnrollmentTokenForEnterpriseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateEnrollmentTokenForEnterpriseMutation>(CreateEnrollmentTokenForEnterpriseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createEnrollmentTokenForEnterprise', 'mutation');
    },
    enterprises(variables?: EnterprisesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EnterprisesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EnterprisesQuery>(EnterprisesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'enterprises', 'query');
    },
    createWebToken(variables: CreateWebTokenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateWebTokenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateWebTokenMutation>(CreateWebTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createWebToken', 'mutation');
    },
    createPolicy(variables: CreatePolicyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreatePolicyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePolicyMutation>(CreatePolicyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createPolicy', 'mutation');
    },
    updatePolicy(variables: UpdatePolicyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePolicyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePolicyMutation>(UpdatePolicyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePolicy', 'mutation');
    },
    updateMdmPolicy(variables: UpdateMdmPolicyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateMdmPolicyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMdmPolicyMutation>(UpdateMdmPolicyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMdmPolicy', 'mutation');
    },
    createMdmPolicy(variables: CreateMdmPolicyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateMdmPolicyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateMdmPolicyMutation>(CreateMdmPolicyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createMdmPolicy', 'mutation');
    },
    createMdmDevice(variables: CreateMdmDeviceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateMdmDeviceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateMdmDeviceMutation>(CreateMdmDeviceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createMdmDevice', 'mutation');
    },
    updateDevicePolicy(variables: UpdateDevicePolicyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDevicePolicyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDevicePolicyMutation>(UpdateDevicePolicyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateDevicePolicy', 'mutation');
    },
    deleteMdmDevice(variables: DeleteMdmDeviceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteMdmDeviceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteMdmDeviceMutation>(DeleteMdmDeviceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteMdmDevice', 'mutation');
    },
    deleteDevice(variables: DeleteDeviceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteDeviceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteDeviceMutation>(DeleteDeviceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteDevice', 'mutation');
    },
    switches(variables: SwitchesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SwitchesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SwitchesQuery>(SwitchesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'switches', 'query');
    },
    mdmDevices(variables?: MdmDevicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MdmDevicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MdmDevicesQuery>(MdmDevicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'mdmDevices', 'query');
    },
    googleDevice(variables: GoogleDeviceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GoogleDeviceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GoogleDeviceQuery>(GoogleDeviceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'googleDevice', 'query');
    },
    mdmPolicies(variables?: MdmPoliciesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MdmPoliciesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MdmPoliciesQuery>(MdmPoliciesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'mdmPolicies', 'query');
    },
    stats(variables?: StatsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StatsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StatsQuery>(StatsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'stats', 'query');
    },
    tempAuthUrl(variables: TempAuthUrlQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TempAuthUrlQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TempAuthUrlQuery>(TempAuthUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tempAuthUrl', 'query');
    },
    tempSetToken(variables: TempSetTokenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TempSetTokenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TempSetTokenMutation>(TempSetTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tempSetToken', 'mutation');
    },
    sync(variables: SyncMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SyncMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SyncMutation>(SyncDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sync', 'mutation');
    },
    mdmApplication(variables?: MdmApplicationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MdmApplicationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MdmApplicationQuery>(MdmApplicationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'mdmApplication', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;